/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _config = __webpack_require__(2);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _dataProviders = __webpack_require__(3);
	
	var _dataProviders2 = _interopRequireDefault(_dataProviders);
	
	var _apiServices = __webpack_require__(29);
	
	var _apiServices2 = _interopRequireDefault(_apiServices);
	
	var _filters = __webpack_require__(44);
	
	var _filters2 = _interopRequireDefault(_filters);
	
	var _layoutComponents = __webpack_require__(47);
	
	var _layoutComponents2 = _interopRequireDefault(_layoutComponents);
	
	var _pages = __webpack_require__(106);
	
	var _pages2 = _interopRequireDefault(_pages);
	
	var _cuiRoutes = __webpack_require__(142);
	
	var _cuiRoutes2 = _interopRequireDefault(_cuiRoutes);
	
	var _marketplace = __webpack_require__(144);
	
	var _marketplace2 = _interopRequireDefault(_marketplace);
	
	var _openShop = __webpack_require__(148);
	
	var _openShop2 = _interopRequireDefault(_openShop);
	
	var _cobrand = __webpack_require__(150);
	
	var _cobrand2 = _interopRequireDefault(_cobrand);
	
	var _facebookAuth = __webpack_require__(154);
	
	var _facebookAuth2 = _interopRequireDefault(_facebookAuth);
	
	var _sentryFilter = __webpack_require__(155);
	
	var _sentryFilter2 = _interopRequireDefault(_sentryFilter);
	
	var _analytics = __webpack_require__(13);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	Raven.config(_config2.default.ErrorReporting.sentryURI, (0, _sentryFilter2.default)(_config2.default.ErrorReporting.sentryConfig)).addPlugin(Raven.Plugins.Angular, angular).install();
	
	angular.module('cui', ['cui.data', 'cui.apiServices', 'cui.filters', 'cui.layoutComponents', 'cui.pages', 'cui.marketplace', 'cui.openShop', 'cui.cobrand', 'ui.router', 'ui.bootstrap', 'ui.validate', 'ui.mask', 'ngAnimate', 'ngCookies', 'ngSanitize', 'ngRaven', 'jcf', 'rzModule', 'angular-md5', 'credit-cards', 'ngAria']).config(_cuiRoutes2.default).run(['$window', '$location', '$rootScope', function ($window, $location, $rootScope) {
	  var analytics = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : new _analytics2.default();
	
	
	  function _historyApiAvailable() {
	    return $window.history && $window.history.pushState && $window.history.replaceState;
	  }
	
	  function _inTestMode() {
	    return !!navigator.userAgent.indexOf('PhantomJS') && _config2.default.Environment !== 'Production';
	  }
	
	  if (!_inTestMode() && !_historyApiAvailable() && $location.path().indexOf('unsupported-browser') === -1) {
	    $window.location.href = '/unsupported-browser';
	    throw 'Unsupported Browser';
	  }
	
	  $rootScope.$on('$stateChangeSuccess', function (e, to, toParams, from, fromParams) {
	    if (!_inTestMode()) $window.scrollTo(0, 0);
	
	    analytics.pageView(to);
	  });
	
	  if ($window.paypal) {
	    $window.paypal.checkout.setup(_config2.default.PayPal.merchantID, {
	      environment: _config2.default.PayPal.environment,
	      container: 'main',
	      buttons: [{
	        button: 'paypal'
	      }]
	    });
	  }
	}]);
	
	(0, _facebookAuth2.default)();

/***/ }),
/* 1 */,
/* 2 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	    'Environment': 'Development',
	    'API_BASE': '',
	    'DOMAIN': 'viralstyle.com',
	    'CLIENT_SUBDOMAIN': 'client-admin.stg',
	
	    'OAuth_Required': true,
	    'OAuth': {
	        'grant_type': 'client_credentials',
	        'client_id': 'frontend',
	        'client_secret': 'frontend',
	        'scope': 'public'
	    },
	    'ImagesUrl': 'assets/customer-ui/images',
	    'TemplatesUrl': '/assets/customer-ui/templates',
	
	    'Marketplace': {
	        'MIN_PRICE': 0,
	        'MAX_PRICE': 80,
	        'LIMIT': 50
	    },
	
	    // Payments
	    'Amazon': {
	        'sandbox': true,
	        'clientID': 'amzn1.application-oa2-client.3e40f479b3b74c9f831e5954ca0d88b8',
	        'sellerID': 'ACM4MDNPXTZGE'
	    },
	    'PayPal': {
	        'merchantID': 'matt-facilitator_api1.obscurelogic.com',
	        'environment': 'sandbox'
	    },
	
	    'Analytics': {
	        'enabled': true,
	        'domain': 'viral-tees.app',
	        'googleID': 'UA-73140867-1',
	        'facebookPixelID': '581319138682569',
	        'facebookAcquisitionID': 'ACQ581319138682569',
	        'googleRetargetID': 123456789,
	        'googleAdwordsID': 112233445
	    },
	
	    'ClientAnalytics': {
	        'enabled': true
	    },
	
	    'SmartyStreets': {
	        'enabled': false,
	        'ID': '18226769276996505'
	    },
	
	    'SocialAuth': {
	        'facebookID': '362850150556822'
	    },
	
	    'ErrorReporting': {
	        'sentryURI': 'https://2c9e5ec753c042afac5288769ec12b25@app.getsentry.com/74360', // TODO: Personal trial project, change to real project later
	        'sentryConfig': {}
	    },
	
	    'VWO': {
	        'id': 12345,
	        'enabled': true
	    },
	
	    'GTM_ID': 'GTM-KTS5SHQ',
	
	    'GOOGLE_PLACES_API_KEY': 'AIzaSyANmRdeyE6Y1fb7OF4XZ8SmACOjB4YI2ug',
	
	    'GOOGLE_RECAPTCHA_SITEKEY': '6Ldd70wUAAAAAHAZL5V9j4iF4WhRDTCuDZzeo3k4'
	};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _states = __webpack_require__(4);
	
	var _states2 = _interopRequireDefault(_states);
	
	var _config = __webpack_require__(5);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _urlHashParams = __webpack_require__(6);
	
	var _urlHashParams2 = _interopRequireDefault(_urlHashParams);
	
	var _cartService = __webpack_require__(9);
	
	var _cartService2 = _interopRequireDefault(_cartService);
	
	var _upsellCartService = __webpack_require__(23);
	
	var _upsellCartService2 = _interopRequireDefault(_upsellCartService);
	
	var _errorHandler = __webpack_require__(24);
	
	var _errorHandler2 = _interopRequireDefault(_errorHandler);
	
	var _campaignHistory = __webpack_require__(25);
	
	var _campaignHistory2 = _interopRequireDefault(_campaignHistory);
	
	var _userDataService = __webpack_require__(26);
	
	var _userDataService2 = _interopRequireDefault(_userDataService);
	
	var _currencyService = __webpack_require__(27);
	
	var _currencyService2 = _interopRequireDefault(_currencyService);
	
	var _abandonedCart = __webpack_require__(28);
	
	var _abandonedCart2 = _interopRequireDefault(_abandonedCart);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('cui.data', []).service('CampaignHistory', _campaignHistory2.default).service('UserDataService', _userDataService2.default).service('CurrencyService', _currencyService2.default).factory('StateTerritoryData', _states2.default).factory('ApplicationConfigData', _config2.default).factory('UrlHashParams', _urlHashParams2.default).service('CartService', _cartService2.default).service('UpsellCartService', _upsellCartService2.default).factory('ErrorHandler', _errorHandler2.default).service('UserDataService', _userDataService2.default).service('AbandonedCartService', _abandonedCart2.default);

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = StateTerritoryFactory;
	function StateTerritoryFactory() {
	  var us_states = [{ 'StateCode': 'AL', 'Name': 'Alabama (AL)' }, { 'StateCode': 'AK', 'Name': 'Alaska (AK)' }, { 'StateCode': 'AZ', 'Name': 'Arizona (AZ)' }, { 'StateCode': 'AR', 'Name': 'Arkansas (AR)' }, { 'StateCode': 'CA', 'Name': 'California (CA)' }, { 'StateCode': 'CO', 'Name': 'Colorado (CO)' }, { 'StateCode': 'CT', 'Name': 'Connecticut (CT)' }, { 'StateCode': 'DE', 'Name': 'Delaware (DE)' }, { 'StateCode': 'DC', 'Name': 'District of Columbia (DC)' }, { 'StateCode': 'FL', 'Name': 'Florida (FL)' }, { 'StateCode': 'GA', 'Name': 'Georgia (GA)' }, { 'StateCode': 'HI', 'Name': 'Hawaii (HI)' }, { 'StateCode': 'ID', 'Name': 'Idaho (ID)' }, { 'StateCode': 'IL', 'Name': 'Illinois (IL)' }, { 'StateCode': 'IN', 'Name': 'Indiana (IN)' }, { 'StateCode': 'IA', 'Name': 'Iowa (IA)' }, { 'StateCode': 'KS', 'Name': 'Kansas (KS)' }, { 'StateCode': 'KY', 'Name': 'Kentucky (KY)' }, { 'StateCode': 'LA', 'Name': 'Louisiana (LA)' }, { 'StateCode': 'ME', 'Name': 'Maine (ME)' }, { 'StateCode': 'MD', 'Name': 'Maryland (MD)' }, { 'StateCode': 'MA', 'Name': 'Massachusetts (MA)' }, { 'StateCode': 'MI', 'Name': 'Michigan (MI)' }, { 'StateCode': 'MN', 'Name': 'Minnesota (MN)' }, { 'StateCode': 'MS', 'Name': 'Mississippi (MS)' }, { 'StateCode': 'MO', 'Name': 'Missouri (MO)' }, { 'StateCode': 'MT', 'Name': 'Montana (MT)' }, { 'StateCode': 'NE', 'Name': 'Nebraska (NE)' }, { 'StateCode': 'NV', 'Name': 'Nevada (NV)' }, { 'StateCode': 'NH', 'Name': 'New Hampshire (NH)' }, { 'StateCode': 'NJ', 'Name': 'New Jersey (NJ)' }, { 'StateCode': 'NM', 'Name': 'New Mexico (NM)' }, { 'StateCode': 'NY', 'Name': 'New York (NY)' }, { 'StateCode': 'NC', 'Name': 'North Carolina (NC)' }, { 'StateCode': 'ND', 'Name': 'North Dakota (ND)' }, { 'StateCode': 'OH', 'Name': 'Ohio (OH)' }, { 'StateCode': 'OK', 'Name': 'Oklahoma (OK)' }, { 'StateCode': 'OR', 'Name': 'Oregon (OR)' }, { 'StateCode': 'PA', 'Name': 'Pennsylvania (PA)' }, { 'StateCode': 'PR', 'Name': 'Puerto Rico (PR)' }, { 'StateCode': 'RI', 'Name': 'Rhode Island (RI)' }, { 'StateCode': 'SC', 'Name': 'South Carolina (SC)' }, { 'StateCode': 'SD', 'Name': 'South Dakota (SD)' }, { 'StateCode': 'TN', 'Name': 'Tennessee (TN)' }, { 'StateCode': 'TX', 'Name': 'Texas (TX)' }, { 'StateCode': 'UT', 'Name': 'Utah (UT)' }, { 'StateCode': 'VT', 'Name': 'Vermont (VT)' }, { 'StateCode': 'VA', 'Name': 'Virginia (VA)' }, { 'StateCode': 'WA', 'Name': 'Washington (WA)' }, { 'StateCode': 'WV', 'Name': 'West Virginia (WV)' }, { 'StateCode': 'WI', 'Name': 'Wisconsin (WI)' }, { 'StateCode': 'WY', 'Name': 'Wyoming (WY)' }, { 'StateCode': 'AA', 'Name': 'Armed Forces Americas (AA)' }, { 'StateCode': 'AE', 'Name': 'Armed Forces Europe (AE)' }, { 'StateCode': 'AP', 'Name': 'Armed Forces Pacific (AP)' }];
	
	  var us_states_extended = us_states.concat([{ 'StateCode': 'AS', 'Name': 'American Samoa (AS)' }, { 'StateCode': 'FM', 'Name': 'Federated States of Micronesia (FM)' }, { 'StateCode': 'GU', 'Name': 'Guam (GU)' }, { 'StateCode': 'MP', 'Name': 'Northern Mariana Islands (MP)' }, { 'StateCode': 'PW', 'Name': 'Palau (PW)' }, { 'StateCode': 'MH', 'Name': 'Republic of Marshall Islands (MH)' }, { 'StateCode': 'VI', 'Name': 'Virgin Islands of the U.S. (VI)' }]);
	
	  var ca_provinces = [{ 'StateCode': 'AB', 'Name': 'Alberta' }, { 'StateCode': 'BC', 'Name': 'British Columbia' }, { 'StateCode': 'MB', 'Name': 'Manitoba' }, { 'StateCode': 'NB', 'Name': 'New Brunswick' }, { 'StateCode': 'NL', 'Name': 'Newfoundland and Labrador' }, { 'StateCode': 'NS', 'Name': 'Nova Scotia' }, { 'StateCode': 'ON', 'Name': 'Ontario' }, { 'StateCode': 'PE', 'Name': 'Prince Edward Island' }, { 'StateCode': 'QC', 'Name': 'Quebec' }, { 'StateCode': 'SK', 'Name': 'Saskatchewan' }, { 'StateCode': 'NT', 'Name': 'Northwest Territories' }, { 'StateCode': 'NU', 'Name': 'Nunavut' }, { 'StateCode': 'YT', 'Name': 'Yukon' }];
	
	  var countries = [{ country: 'Afghanistan', code: 'AF' }, { country: 'Aland Islands', code: 'AX' }, { country: 'Albania', code: 'AL' }, { country: 'Algeria', code: 'DZ' }, { country: 'American Samoa', code: 'AS' }, { country: 'Andorra', code: 'AD' }, { country: 'Angola', code: 'AO' }, { country: 'Anguilla', code: 'AI' }, { country: 'Antarctica', code: 'AQ' }, { country: 'Antigua and Barbuda', code: 'AG' },
	  // {country: 'Argentina', code: 'AR'},
	  { country: 'Armenia', code: 'AM' }, { country: 'Aruba', code: 'AW' }, { country: 'Australia', code: 'AU' }, { country: 'Austria', code: 'AT' }, { country: 'Azerbaijan', code: 'AZ' }, { country: 'Bahamas', code: 'BS' }, { country: 'Bahrain', code: 'BH' }, { country: 'Bangladesh', code: 'BD' }, { country: 'Barbados', code: 'BB' }, { country: 'Belarus', code: 'BY' }, { country: 'Belgium', code: 'BE' }, { country: 'Belize', code: 'BZ' }, { country: 'Benin', code: 'BJ' }, { country: 'Bermuda', code: 'BM' }, { country: 'Bhutan', code: 'BT' }, { country: 'Bolivia', code: 'BO' }, { country: 'Bosnia and Herzegovina', code: 'BA' }, { country: 'Botswana', code: 'BW' }, { country: 'Bouvet Island', code: 'BV' }, { country: 'Brazil', code: 'BR' }, { country: 'British Indian Ocean Territory', code: 'IO' }, { country: 'Brunei Darussalam', code: 'BN' }, { country: 'Bulgaria', code: 'BG' }, { country: 'Burkina Faso', code: 'BF' }, { country: 'Burundi', code: 'BI' },
	  // {country: 'Cambodia', code: 'KH'},
	  { country: 'Cameroon', code: 'CM' }, { country: 'Canada', code: 'CA' }, { country: 'Cape Verde', code: 'CV' }, { country: 'Cayman Islands', code: 'KY' }, { country: 'Central African Republic', code: 'CF' }, { country: 'Chad', code: 'TD' },
	  // {country: 'Chile', code: 'CL'},
	  { country: 'China', code: 'CN' }, { country: 'Christmas Island', code: 'CX' }, { country: 'Cocos (Keeling) Islands', code: 'CC' }, { country: 'Colombia', code: 'CO' }, { country: 'Comoros', code: 'KM' }, { country: 'Congo', code: 'CG' }, { country: 'Congo, The Democratic Republic of the', code: 'CD' }, { country: 'Cook Islands', code: 'CK' }, { country: 'Costa Rica', code: 'CR' }, { country: 'Cote D\'Ivoire', code: 'CI' },
	  // {country: 'Croatia', code: 'HR'},
	  { country: 'Cuba', code: 'CU' }, { country: 'Curaçao / Netherlands Antilles', code: 'CW' }, { country: 'Cyprus', code: 'CY' }, { country: 'Czech Republic', code: 'CZ' }, { country: 'Denmark', code: 'DK' }, { country: 'Djibouti', code: 'DJ' }, { country: 'Dominica', code: 'DM' }, { country: 'Dominican Republic', code: 'DO' }, { country: 'Ecuador', code: 'EC' },
	  // {country: 'Egypt', code: 'EG'},
	  { country: 'El Salvador', code: 'SV' }, { country: 'Equatorial Guinea', code: 'GQ' }, { country: 'Eritrea', code: 'ER' }, { country: 'Estonia', code: 'EE' }, { country: 'Ethiopia', code: 'ET' }, { country: 'Falkland Islands (Malvinas)', code: 'FK' }, { country: 'Faroe Islands', code: 'FO' }, { country: 'Fiji', code: 'FJ' }, { country: 'Finland', code: 'FI' }, { country: 'France', code: 'FR' }, { country: 'French Guiana', code: 'GF' }, { country: 'French Polynesia', code: 'PF' }, { country: 'French Southern Territories', code: 'TF' }, { country: 'Gabon', code: 'GA' }, { country: 'Gambia', code: 'GM' }, { country: 'Georgia', code: 'GE' }, { country: 'Germany', code: 'DE' }, { country: 'Ghana', code: 'GH' }, { country: 'Gibraltar', code: 'GI' }, { country: 'Greece', code: 'GR' }, { country: 'Greenland', code: 'GL' }, { country: 'Grenada', code: 'GD' }, { country: 'Guadeloupe', code: 'GP' }, { country: 'Guam', code: 'GU' }, { country: 'Guatemala', code: 'GT' }, { country: 'Guernsey', code: 'GG' }, { country: 'Guinea', code: 'GN' }, { country: 'Guinea-Bissau', code: 'GW' }, { country: 'Guyana', code: 'GY' }, { country: 'Haiti', code: 'HT' }, { country: 'Heard Island and Mcdonald Islands', code: 'HM' }, { country: 'Holy See (Vatican City State)', code: 'VA' }, { country: 'Honduras', code: 'HN' }, { country: 'Hong Kong', code: 'HK' }, { country: 'Hungary', code: 'HU' }, { country: 'Iceland', code: 'IS' }, { country: 'India', code: 'IN' }, { country: 'Indonesia', code: 'ID' }, { country: 'Iran, Islamic Republic Of', code: 'IR' }, { country: 'Iraq', code: 'IQ' }, { country: 'Ireland', code: 'IE' }, { country: 'Isle of Man', code: 'IM' }, { country: 'Israel', code: 'IL' }, { country: 'Italy', code: 'IT' }, { country: 'Jamaica', code: 'JM' }, { country: 'Japan', code: 'JP' }, { country: 'Jersey', code: 'JE' }, { country: 'Jordan', code: 'JO' }, { country: 'Kazakhstan', code: 'KZ' }, { country: 'Kenya', code: 'KE' }, { country: 'Kiribati', code: 'KI' }, { country: 'Korea, Democratic People\'S Republic of', code: 'KP' }, { country: 'Korea, Republic of', code: 'KR' },
	  // {country: 'Kuwait', code: 'KW'},
	  { country: 'Kyrgyzstan', code: 'KG' }, { country: 'Lao People\'S Democratic Republic', code: 'LA' }, { country: 'Latvia', code: 'LV' }, { country: 'Lebanon', code: 'LB' }, { country: 'Lesotho', code: 'LS' }, { country: 'Liberia', code: 'LR' }, { country: 'Libyan Arab Jamahiriya', code: 'LY' }, { country: 'Liechtenstein', code: 'LI' }, { country: 'Lithuania', code: 'LT' }, { country: 'Luxembourg', code: 'LU' }, { country: 'Macao', code: 'MO' },
	  // {country: 'Macedonia, The Former Yugoslav Republic of', code: 'MK'},
	  { country: 'Madagascar', code: 'MG' }, { country: 'Malawi', code: 'MW' }, { country: 'Malaysia', code: 'MY' }, { country: 'Maldives', code: 'MV' }, { country: 'Mali', code: 'ML' }, { country: 'Malta', code: 'MT' }, { country: 'Marshall Islands', code: 'MH' }, { country: 'Martinique', code: 'MQ' }, { country: 'Mauritania', code: 'MR' }, { country: 'Mauritius', code: 'MU' }, { country: 'Mayotte', code: 'YT' }, { country: 'Mexico', code: 'MX' }, { country: 'Micronesia, Federated States of', code: 'FM' }, { country: 'Moldova, Republic of', code: 'MD' }, { country: 'Monaco', code: 'MC' }, { country: 'Mongolia', code: 'MN' }, { country: 'Montenegro', code: 'ME' }, { country: 'Montserrat', code: 'MS' }, { country: 'Morocco', code: 'MA' }, { country: 'Mozambique', code: 'MZ' }, { country: 'Myanmar', code: 'MM' }, { country: 'Namibia', code: 'NA' }, { country: 'Nauru', code: 'NR' }, { country: 'Nepal', code: 'NP' }, { country: 'Netherlands', code: 'NL' }, { country: 'New Caledonia', code: 'NC' }, { country: 'New Zealand', code: 'NZ' }, { country: 'Nicaragua', code: 'NI' }, { country: 'Niger', code: 'NE' },
	  // {country: 'Nigeria', code: 'NG'},
	  { country: 'Niue', code: 'NU' }, { country: 'Norfolk Island', code: 'NF' }, { country: 'Northern Mariana Islands', code: 'MP' }, { country: 'Norway', code: 'NO' },
	  // {country: 'Oman', code: 'OM'},
	  { country: 'Pakistan', code: 'PK' }, { country: 'Palau', code: 'PW' }, { country: 'Palestinian Territory, Occupied', code: 'PS' }, { country: 'Panama', code: 'PA' }, { country: 'Papua New Guinea', code: 'PG' }, { country: 'Paraguay', code: 'PY' }, { country: 'Peru', code: 'PE' }, { country: 'Philippines', code: 'PH' }, { country: 'Pitcairn', code: 'PN' }, { country: 'Poland', code: 'PL' }, { country: 'Portugal', code: 'PT' }, { country: 'Qatar', code: 'QA' }, { country: 'Reunion', code: 'RE' }, { country: 'Romania', code: 'RO' }, { country: 'Russian Federation', code: 'RU' }, { country: 'RWANDA', code: 'RW' }, { country: 'Saint Helena', code: 'SH' }, { country: 'Saint Kitts and Nevis', code: 'KN' }, { country: 'Saint Lucia', code: 'LC' }, { country: 'Saint Pierre and Miquelon', code: 'PM' }, { country: 'Saint Vincent and the Grenadines', code: 'VC' }, { country: 'Samoa', code: 'WS' }, { country: 'San Marino', code: 'SM' }, { country: 'Sao Tome and Principe', code: 'ST' }, { country: 'Saudi Arabia', code: 'SA' }, { country: 'Senegal', code: 'SN' }, { country: 'Serbia', code: 'RS' }, { country: 'Seychelles', code: 'SC' }, { country: 'Sierra Leone', code: 'SL' }, { country: 'Singapore', code: 'SG' },
	  // {country: 'Slovakia', code: 'SK'},
	  { country: 'Slovenia', code: 'SI' }, { country: 'Solomon Islands', code: 'SB' }, { country: 'Somalia', code: 'SO' },
	  // {country: 'South Africa', code: 'ZA'},
	  { country: 'South Georgia and the South Sandwich Islands', code: 'GS' }, { country: 'Spain', code: 'ES' },
	  // {country: 'Sri Lanka', code: 'LK'},
	  { country: 'Sudan', code: 'SD' }, { country: 'Suriname', code: 'SR' }, { country: 'Svalbard and Jan Mayen', code: 'SJ' }, { country: 'Swaziland', code: 'SZ' }, { country: 'Sweden', code: 'SE' }, { country: 'Switzerland', code: 'CH' }, { country: 'Syrian Arab Republic', code: 'SY' }, { country: 'Taiwan, Province of China', code: 'TW' }, { country: 'Tajikistan', code: 'TJ' }, { country: 'Tanzania, United Republic of', code: 'TZ' }, { country: 'Thailand', code: 'TH' }, { country: 'Timor-Leste', code: 'TL' }, { country: 'Togo', code: 'TG' }, { country: 'Tokelau', code: 'TK' }, { country: 'Tonga', code: 'TO' }, { country: 'Trinidad and Tobago', code: 'TT' }, { country: 'Tunisia', code: 'TN' }, { country: 'Turkey', code: 'TR' }, { country: 'Turkmenistan', code: 'TM' }, { country: 'Turks and Caicos Islands', code: 'TC' }, { country: 'Tuvalu', code: 'TV' }, { country: 'Uganda', code: 'UG' }, { country: 'Ukraine', code: 'UA' },
	  // {country: 'United Arab Emirates', code: 'AE'},
	  { country: 'United Kingdom', code: 'GB' }, { country: 'United States', code: 'US' }, { country: 'United States Minor Outlying Islands', code: 'UM' }, { country: 'Uruguay', code: 'UY' }, { country: 'Uzbekistan', code: 'UZ' }, { country: 'Vanuatu', code: 'VU' }, { country: 'Venezuela', code: 'VE' }, { country: 'Viet Nam', code: 'VN' }, { country: 'Virgin Islands, British', code: 'VG' }, { country: 'Virgin Islands, U.S.', code: 'VI' }, { country: 'Wallis and Futuna', code: 'WF' }, { country: 'Western Sahara', code: 'EH' }, { country: 'Yemen', code: 'YE' }, { country: 'Zambia', code: 'ZM' }, { country: 'Zimbabwe', code: 'ZW' }];
	
	  return {
	    getStates: function getStates() {
	      return us_states;
	    },
	    getExtendedStates: function getExtendedStates() {
	      return us_states_extended;
	    },
	    getProvinces: function getProvinces() {
	      return ca_provinces;
	    },
	    getCountries: function getCountries() {
	      return countries;
	    }
	  };
	}

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ApplicationConfigFactory;
	function ApplicationConfigFactory() {
	  var config = {
	    'emailSupport': 'support@viralstyle.com',
	    'clientSupport': 'clientsupport@viralstyle.com',
	    'shopifySupport': 'shopify@viralstyle.com',
	    'legalEmail': 'legal@viralstyle.com',
	
	    'phone': '1-888-491-8876',
	
	    'viralstyleShippingAddress': '601 N Ashley Drive Suite 500',
	    'viralstyleShippingCity': 'Tampa',
	    'viralstyleShippingState': 'FL',
	    'viralstyleShippingZip': '33602',
	
	    'viralstyleMailingAddress': '301 W. Platt Street Suite 47',
	    'viralstyleMailingCity': 'Tampa',
	    'viralstyleMailingState': 'FL',
	    'viralstyleMailingZip': '33606-2292'
	
	  };
	
	  return {
	    getConfig: function getconfig() {
	      return config;
	    }
	  };
	}

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(7);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = ['$location', function UrlHashParams($location) {
	  var get = function GetHashParams() {
	    var pairs = $location.hash().split('&');
	    var paramObj = {};
	
	    _lodash2.default.forEach(pairs, function (pair) {
	      pair = pair.split('=');
	      if (!pair[0] || !pair[1]) return;
	      paramObj[pair[0]] = pair[1];
	    });
	
	    return paramObj;
	  };
	
	  var set = function SetHashParam(name, value) {
	    var pairs = [];
	    var params = get();
	
	    if (value === null || typeof value === 'undefined') {
	      delete params[name];
	    } else params[name] = value;
	
	    _lodash2.default.forEach(Object.keys(params), function (key) {
	      pairs.push(key + '=' + params[key]);
	    });
	
	    $location.hash(pairs.join('&'));
	    $location.replace();
	  };
	
	  return {
	    get: get,
	    set: set
	  };
	}];

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/**
	 * @license
	 * lodash 3.10.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern -o ./lodash.js`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '3.10.1';
	
	  /** Used to compose bitmasks for wrapper metadata. */
	  var BIND_FLAG = 1,
	      BIND_KEY_FLAG = 2,
	      CURRY_BOUND_FLAG = 4,
	      CURRY_FLAG = 8,
	      CURRY_RIGHT_FLAG = 16,
	      PARTIAL_FLAG = 32,
	      PARTIAL_RIGHT_FLAG = 64,
	      ARY_FLAG = 128,
	      REARG_FLAG = 256;
	
	  /** Used as default options for `_.trunc`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect when a function becomes hot. */
	  var HOT_COUNT = 150,
	      HOT_SPAN = 16;
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2;
	
	  /** Used as the `TypeError` message for "Functions" methods. */
	  var FUNC_ERROR_TEXT = 'Expected a function';
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      objectTag = '[object Object]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      weakMapTag = '[object WeakMap]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39|#96);/g,
	      reUnescapedHtml = /[&<>"'`]/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\n\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\n\\]|\\.)*?)\2)\]/g;
	
	  /**
	   * Used to match `RegExp` [syntax characters](http://ecma-international.org/ecma-262/6.0/#sec-patterns)
	   * and those outlined by [`EscapeRegExpPattern`](http://ecma-international.org/ecma-262/6.0/#sec-escaperegexppattern).
	   */
	  var reRegExpChars = /^[:!,]|[\\^$.*+?()[\]{}|\/]|(^[0-9a-fA-Fnrtuvx])|([\n\r\u2028\u2029])/g,
	      reHasRegExpChars = RegExp(reRegExpChars.source);
	
	  /** Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks). */
	  var reComboMark = /[\u0300-\u036f\ufe20-\ufe23]/g;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /** Used to match [ES template delimiters](http://ecma-international.org/ecma-262/6.0/#sec-template-literal-lexical-components). */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect hexadecimal string values. */
	  var reHasHexPrefix = /^0[xX]/;
	
	  /** Used to detect host constructors (Safari > 5). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^\d+$/;
	
	  /** Used to match latin-1 supplementary letters (excluding mathematical operators). */
	  var reLatin1 = /[\xc0-\xd6\xd8-\xde\xdf-\xf6\xf8-\xff]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to match words to create compound words. */
	  var reWords = (function() {
	    var upper = '[A-Z\\xc0-\\xd6\\xd8-\\xde]',
	        lower = '[a-z\\xdf-\\xf6\\xf8-\\xff]+';
	
	    return RegExp(upper + '+(?=' + upper + lower + ')|' + upper + '?' + lower + '|' + upper + '+|[0-9]+', 'g');
	  }());
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'ArrayBuffer', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Math', 'Number',
	    'Object', 'RegExp', 'Set', 'String', '_', 'clearTimeout', 'isFinite',
	    'parseFloat', 'parseInt', 'setTimeout', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dateTag] = typedArrayTags[errorTag] =
	  typedArrayTags[funcTag] = typedArrayTags[mapTag] =
	  typedArrayTags[numberTag] = typedArrayTags[objectTag] =
	  typedArrayTags[regexpTag] = typedArrayTags[setTag] =
	  typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[boolTag] =
	  cloneableTags[dateTag] = cloneableTags[float32Tag] =
	  cloneableTags[float64Tag] = cloneableTags[int8Tag] =
	  cloneableTags[int16Tag] = cloneableTags[int32Tag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[stringTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[mapTag] = cloneableTags[setTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map latin-1 supplementary letters to basic latin letters. */
	  var deburredLetters = {
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcC': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xeC': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;',
	    '`': '&#96;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'",
	    '&#96;': '`'
	  };
	
	  /** Used to determine if values are of the language type `Object`. */
	  var objectTypes = {
	    'function': true,
	    'object': true
	  };
	
	  /** Used to escape characters for inclusion in compiled regexes. */
	  var regexpEscapes = {
	    '0': 'x30', '1': 'x31', '2': 'x32', '3': 'x33', '4': 'x34',
	    '5': 'x35', '6': 'x36', '7': 'x37', '8': 'x38', '9': 'x39',
	    'A': 'x41', 'B': 'x42', 'C': 'x43', 'D': 'x44', 'E': 'x45', 'F': 'x46',
	    'a': 'x61', 'b': 'x62', 'c': 'x63', 'd': 'x64', 'e': 'x65', 'f': 'x66',
	    'n': 'x6e', 'r': 'x72', 't': 'x74', 'u': 'x75', 'v': 'x76', 'x': 'x78'
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Detect free variable `exports`. */
	  var freeExports = objectTypes[typeof exports] && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = objectTypes[typeof module] && module && !module.nodeType && module;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = freeExports && freeModule && typeof global == 'object' && global && global.Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = objectTypes[typeof self] && self && self.Object && self;
	
	  /** Detect free variable `window`. */
	  var freeWindow = objectTypes[typeof window] && window && window.Object && window;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports && freeExports;
	
	  /**
	   * Used as a reference to the global object.
	   *
	   * The `this` value is used if it's the global object to avoid Greasemonkey's
	   * restricted `window` object, otherwise the `window` object is used.
	   */
	  var root = freeGlobal || ((freeWindow !== (this && this.window)) && freeWindow) || freeSelf || this;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * The base implementation of `compareAscending` which compares values and
	   * sorts them in ascending order without guaranteeing a stable sort.
	   *
	   * @private
	   * @param {*} value The value to compare.
	   * @param {*} other The other value to compare.
	   * @returns {number} Returns the sort order indicator for `value`.
	   */
	  function baseCompareAscending(value, other) {
	    if (value !== other) {
	      var valIsNull = value === null,
	          valIsUndef = value === undefined,
	          valIsReflexive = value === value;
	
	      var othIsNull = other === null,
	          othIsUndef = other === undefined,
	          othIsReflexive = other === other;
	
	      if ((value > other && !othIsNull) || !valIsReflexive ||
	          (valIsNull && !othIsUndef && othIsReflexive) ||
	          (valIsUndef && othIsReflexive)) {
	        return 1;
	      }
	      if ((value < other && !valIsNull) || !othIsReflexive ||
	          (othIsNull && !valIsUndef && valIsReflexive) ||
	          (othIsUndef && valIsReflexive)) {
	        return -1;
	      }
	    }
	    return 0;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for callback shorthands and `this` binding.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromRight) {
	    var length = array.length,
	        index = fromRight ? length : -1;
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without support for binary searches.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    if (value !== value) {
	      return indexOfNaN(array, fromIndex);
	    }
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isFunction` without support for environments
	   * with incorrect `typeof` results.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	   */
	  function baseIsFunction(value) {
	    // Avoid a Chakra JIT bug in compatibility modes of IE 11.
	    // See https://github.com/jashkenas/underscore/issues/1621 for more details.
	    return typeof value == 'function' || false;
	  }
	
	  /**
	   * Converts `value` to a string if it's not one. An empty string is returned
	   * for `null` or `undefined` values.
	   *
	   * @private
	   * @param {*} value The value to process.
	   * @returns {string} Returns the string.
	   */
	  function baseToString(value) {
	    return value == null ? '' : (value + '');
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimLeft` to get the index of the first character
	   * of `string` that is not found in `chars`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @param {string} chars The characters to find.
	   * @returns {number} Returns the index of the first character not found in `chars`.
	   */
	  function charsLeftIndex(string, chars) {
	    var index = -1,
	        length = string.length;
	
	    while (++index < length && chars.indexOf(string.charAt(index)) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimRight` to get the index of the last character
	   * of `string` that is not found in `chars`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @param {string} chars The characters to find.
	   * @returns {number} Returns the index of the last character not found in `chars`.
	   */
	  function charsRightIndex(string, chars) {
	    var index = string.length;
	
	    while (index-- && chars.indexOf(string.charAt(index)) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.sortBy` to compare transformed elements of a collection and stable
	   * sort them in ascending order.
	   *
	   * @private
	   * @param {Object} object The object to compare.
	   * @param {Object} other The other object to compare.
	   * @returns {number} Returns the sort order indicator for `object`.
	   */
	  function compareAscending(object, other) {
	    return baseCompareAscending(object.criteria, other.criteria) || (object.index - other.index);
	  }
	
	  /**
	   * Used by `_.sortByOrder` to compare multiple properties of a value to another
	   * and stable sort them.
	   *
	   * If `orders` is unspecified, all valuess are sorted in ascending order. Otherwise,
	   * a value is sorted in ascending order if its corresponding order is "asc", and
	   * descending if "desc".
	   *
	   * @private
	   * @param {Object} object The object to compare.
	   * @param {Object} other The other object to compare.
	   * @param {boolean[]} orders The order to sort by for each property.
	   * @returns {number} Returns the sort order indicator for `object`.
	   */
	  function compareMultiple(object, other, orders) {
	    var index = -1,
	        objCriteria = object.criteria,
	        othCriteria = other.criteria,
	        length = objCriteria.length,
	        ordersLength = orders.length;
	
	    while (++index < length) {
	      var result = baseCompareAscending(objCriteria[index], othCriteria[index]);
	      if (result) {
	        if (index >= ordersLength) {
	          return result;
	        }
	        var order = orders[index];
	        return result * ((order === 'asc' || order === true) ? 1 : -1);
	      }
	    }
	    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	    // that causes it, under certain circumstances, to provide the same value for
	    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	    // for more details.
	    //
	    // This also ensures a stable sort in V8 and other engines.
	    // See https://code.google.com/p/v8/issues/detail?id=90 for more details.
	    return object.index - other.index;
	  }
	
	  /**
	   * Used by `_.deburr` to convert latin-1 supplementary letters to basic latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  function deburrLetter(letter) {
	    return deburredLetters[letter];
	  }
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeHtmlChar(chr) {
	    return htmlEscapes[chr];
	  }
	
	  /**
	   * Used by `_.escapeRegExp` to escape characters for inclusion in compiled regexes.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @param {string} leadingChar The capture group for a leading character.
	   * @param {string} whitespaceChar The capture group for a whitespace character.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeRegExpChar(chr, leadingChar, whitespaceChar) {
	    if (leadingChar) {
	      chr = regexpEscapes[chr];
	    } else if (whitespaceChar) {
	      chr = stringEscapes[chr];
	    }
	    return '\\' + chr;
	  }
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the index at which the first occurrence of `NaN` is found in `array`.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched `NaN`, else `-1`.
	   */
	  function indexOfNaN(array, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 0 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      var other = array[index];
	      if (other !== other) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * Checks if `value` is object-like.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	   */
	  function isObjectLike(value) {
	    return !!value && typeof value == 'object';
	  }
	
	  /**
	   * Used by `trimmedLeftIndex` and `trimmedRightIndex` to determine if a
	   * character code is whitespace.
	   *
	   * @private
	   * @param {number} charCode The character code to inspect.
	   * @returns {boolean} Returns `true` if `charCode` is whitespace, else `false`.
	   */
	  function isSpace(charCode) {
	    return ((charCode <= 160 && (charCode >= 9 && charCode <= 13) || charCode == 32 || charCode == 160) || charCode == 5760 || charCode == 6158 ||
	      (charCode >= 8192 && (charCode <= 8202 || charCode == 8232 || charCode == 8233 || charCode == 8239 || charCode == 8287 || charCode == 12288 || charCode == 65279)));
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = -1,
	        result = [];
	
	    while (++index < length) {
	      if (array[index] === placeholder) {
	        array[index] = PLACEHOLDER;
	        result[++resIndex] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * An implementation of `_.uniq` optimized for sorted arrays without support
	   * for callback shorthands and `this` binding.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} [iteratee] The function invoked per iteration.
	   * @returns {Array} Returns the new duplicate free array.
	   */
	  function sortedUniq(array, iteratee) {
	    var seen,
	        index = -1,
	        length = array.length,
	        resIndex = -1,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index],
	          computed = iteratee ? iteratee(value, index, array) : value;
	
	      if (!index || seen !== computed) {
	        seen = computed;
	        result[++resIndex] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimLeft` to get the index of the first non-whitespace
	   * character of `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the index of the first non-whitespace character.
	   */
	  function trimmedLeftIndex(string) {
	    var index = -1,
	        length = string.length;
	
	    while (++index < length && isSpace(string.charCodeAt(index))) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimRight` to get the index of the last non-whitespace
	   * character of `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the index of the last non-whitespace character.
	   */
	  function trimmedRightIndex(string) {
	    var index = string.length;
	
	    while (index-- && isSpace(string.charCodeAt(index))) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  function unescapeHtmlChar(chr) {
	    return htmlUnescapes[chr];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the given `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @category Utility
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // using `context` to mock `Date#getTime` use in `_.now`
	   * var mock = _.runInContext({
	   *   'Date': function() {
	   *     return { 'getTime': getTimeMock };
	   *   }
	   * });
	   *
	   * // or creating a suped-up `defer` in Node.js
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  function runInContext(context) {
	    // Avoid issues with some ES3 environments that attempt to use values, named
	    // after built-in constructors like `Object`, for the creation of literals.
	    // ES5 clears this up by stating that literals must use built-in constructors.
	    // See https://es5.github.io/#x11.1.5 for more details.
	    context = context ? _.defaults(root.Object(), context, _.pick(root, contextProps)) : root;
	
	    /** Native constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Number = context.Number,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for native method references. */
	    var arrayProto = Array.prototype,
	        objectProto = Object.prototype,
	        stringProto = String.prototype;
	
	    /** Used to resolve the decompiled source of functions. */
	    var fnToString = Function.prototype.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /**
	     * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var objToString = objectProto.toString;
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Native method references. */
	    var ArrayBuffer = context.ArrayBuffer,
	        clearTimeout = context.clearTimeout,
	        parseFloat = context.parseFloat,
	        pow = Math.pow,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        Set = getNative(context, 'Set'),
	        setTimeout = context.setTimeout,
	        splice = arrayProto.splice,
	        Uint8Array = context.Uint8Array,
	        WeakMap = getNative(context, 'WeakMap');
	
	    /* Native method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeCreate = getNative(Object, 'create'),
	        nativeFloor = Math.floor,
	        nativeIsArray = getNative(Array, 'isArray'),
	        nativeIsFinite = context.isFinite,
	        nativeKeys = getNative(Object, 'keys'),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = getNative(Date, 'now'),
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random;
	
	    /** Used as references for `-Infinity` and `Infinity`. */
	    var NEGATIVE_INFINITY = Number.NEGATIVE_INFINITY,
	        POSITIVE_INFINITY = Number.POSITIVE_INFINITY;
	
	    /** Used as references for the maximum length and index of an array. */
	    var MAX_ARRAY_LENGTH = 4294967295,
	        MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	        HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	    /**
	     * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	     * of an array-like value.
	     */
	    var MAX_SAFE_INTEGER = 9007199254740991;
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit chaining.
	     * Methods that operate on and return arrays, collections, and functions can
	     * be chained together. Methods that retrieve a single value or may return a
	     * primitive value will automatically end the chain returning the unwrapped
	     * value. Explicit chaining may be enabled using `_.chain`. The execution of
	     * chained methods is lazy, that is, execution is deferred until `_#value`
	     * is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion. Shortcut
	     * fusion is an optimization strategy which merge iteratee calls; this can help
	     * to avoid the creation of intermediate data structures and greatly reduce the
	     * number of iteratee executions.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `reverse`, `shift`, `slice`, `sort`,
	     * `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `compact`, `drop`, `dropRight`, `dropRightWhile`, `dropWhile`, `filter`,
	     * `first`, `initial`, `last`, `map`, `pluck`, `reject`, `rest`, `reverse`,
	     * `slice`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, `toArray`,
	     * and `where`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `at`, `before`, `bind`, `bindAll`, `bindKey`,
	     * `callback`, `chain`, `chunk`, `commit`, `compact`, `concat`, `constant`,
	     * `countBy`, `create`, `curry`, `debounce`, `defaults`, `defaultsDeep`,
	     * `defer`, `delay`, `difference`, `drop`, `dropRight`, `dropRightWhile`,
	     * `dropWhile`, `fill`, `filter`, `flatten`, `flattenDeep`, `flow`, `flowRight`,
	     * `forEach`, `forEachRight`, `forIn`, `forInRight`, `forOwn`, `forOwnRight`,
	     * `functions`, `groupBy`, `indexBy`, `initial`, `intersection`, `invert`,
	     * `invoke`, `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`,
	     * `matchesProperty`, `memoize`, `merge`, `method`, `methodOf`, `mixin`,
	     * `modArgs`, `negate`, `omit`, `once`, `pairs`, `partial`, `partialRight`,
	     * `partition`, `pick`, `plant`, `pluck`, `property`, `propertyOf`, `pull`,
	     * `pullAt`, `push`, `range`, `rearg`, `reject`, `remove`, `rest`, `restParam`,
	     * `reverse`, `set`, `shuffle`, `slice`, `sort`, `sortBy`, `sortByAll`,
	     * `sortByOrder`, `splice`, `spread`, `take`, `takeRight`, `takeRightWhile`,
	     * `takeWhile`, `tap`, `throttle`, `thru`, `times`, `toArray`, `toPlainObject`,
	     * `transform`, `union`, `uniq`, `unshift`, `unzip`, `unzipWith`, `values`,
	     * `valuesIn`, `where`, `without`, `wrap`, `xor`, `zip`, `zipObject`, `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clone`, `cloneDeep`,
	     * `deburr`, `endsWith`, `escape`, `escapeRegExp`, `every`, `find`, `findIndex`,
	     * `findKey`, `findLast`, `findLastIndex`, `findLastKey`, `findWhere`, `first`,
	     * `floor`, `get`, `gt`, `gte`, `has`, `identity`, `includes`, `indexOf`,
	     * `inRange`, `isArguments`, `isArray`, `isBoolean`, `isDate`, `isElement`,
	     * `isEmpty`, `isEqual`, `isError`, `isFinite` `isFunction`, `isMatch`,
	     * `isNative`, `isNaN`, `isNull`, `isNumber`, `isObject`, `isPlainObject`,
	     * `isRegExp`, `isString`, `isUndefined`, `isTypedArray`, `join`, `kebabCase`,
	     * `last`, `lastIndexOf`, `lt`, `lte`, `max`, `min`, `noConflict`, `noop`,
	     * `now`, `pad`, `padLeft`, `padRight`, `parseInt`, `pop`, `random`, `reduce`,
	     * `reduceRight`, `repeat`, `result`, `round`, `runInContext`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedLastIndex`, `startCase`,
	     * `startsWith`, `sum`, `template`, `trim`, `trimLeft`, `trimRight`, `trunc`,
	     * `unescape`, `uniqueId`, `value`, and `words`
	     *
	     * The wrapper method `sample` will return a wrapped value when `n` is provided,
	     * otherwise an unwrapped value is returned.
	     *
	     * @name _
	     * @constructor
	     * @category Chain
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // returns an unwrapped value
	     * wrapped.reduce(function(total, n) {
	     *   return total + n;
	     * });
	     * // => 6
	     *
	     * // returns a wrapped value
	     * var squares = wrapped.map(function(n) {
	     *   return n * n;
	     * });
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__chain__') && hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The function whose prototype all chaining wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable chaining for all wrapper methods.
	     * @param {Array} [actions=[]] Actions to peform to resolve the unwrapped value.
	     */
	    function LodashWrapper(value, chainAll, actions) {
	      this.__wrapped__ = value;
	      this.__actions__ = actions || [];
	      this.__chain__ = !!chainAll;
	    }
	
	    /**
	     * An object environment feature flags.
	     *
	     * @static
	     * @memberOf _
	     * @type Object
	     */
	    var support = lodash.support = {};
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB). Change the following template settings to use
	     * alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type Object
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type RegExp
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type RegExp
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type RegExp
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type string
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type Object
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type Function
	         */
	        '_': lodash
	      }
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = POSITIVE_INFINITY;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = arrayCopy(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = arrayCopy(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = arrayCopy(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || arrLength < LARGE_ARRAY_SIZE || (arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a cache object to store key/value pairs.
	     *
	     * @private
	     * @static
	     * @name Cache
	     * @memberOf _.memoize
	     */
	    function MapCache() {
	      this.__data__ = {};
	    }
	
	    /**
	     * Removes `key` and its value from the cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf _.memoize.Cache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed successfully, else `false`.
	     */
	    function mapDelete(key) {
	      return this.has(key) && delete this.__data__[key];
	    }
	
	    /**
	     * Gets the cached value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf _.memoize.Cache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the cached value.
	     */
	    function mapGet(key) {
	      return key == '__proto__' ? undefined : this.__data__[key];
	    }
	
	    /**
	     * Checks if a cached value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf _.memoize.Cache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapHas(key) {
	      return key != '__proto__' && hasOwnProperty.call(this.__data__, key);
	    }
	
	    /**
	     * Sets `value` to `key` of the cache.
	     *
	     * @private
	     * @name set
	     * @memberOf _.memoize.Cache
	     * @param {string} key The key of the value to cache.
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache object.
	     */
	    function mapSet(key, value) {
	      if (key != '__proto__') {
	        this.__data__[key] = value;
	      }
	      return this;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates a cache object to store unique values.
	     *
	     * @private
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var length = values ? values.length : 0;
	
	      this.data = { 'hash': nativeCreate(null), 'set': new Set };
	      while (length--) {
	        this.push(values[length]);
	      }
	    }
	
	    /**
	     * Checks if `value` is in `cache` mimicking the return signature of
	     * `_.indexOf` by returning `0` if the value is found, else `-1`.
	     *
	     * @private
	     * @param {Object} cache The cache to search.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `0` if `value` is found, else `-1`.
	     */
	    function cacheIndexOf(cache, value) {
	      var data = cache.data,
	          result = (typeof value == 'string' || isObject(value)) ? data.set.has(value) : data.hash[value];
	
	      return result ? 0 : -1;
	    }
	
	    /**
	     * Adds `value` to the cache.
	     *
	     * @private
	     * @name push
	     * @memberOf SetCache
	     * @param {*} value The value to cache.
	     */
	    function cachePush(value) {
	      var data = this.data;
	      if (typeof value == 'string' || isObject(value)) {
	        data.set.add(value);
	      } else {
	        data.hash[value] = true;
	      }
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a new array joining `array` with `other`.
	     *
	     * @private
	     * @param {Array} array The array to join.
	     * @param {Array} other The other array to join.
	     * @returns {Array} Returns the new concatenated array.
	     */
	    function arrayConcat(array, other) {
	      var index = -1,
	          length = array.length,
	          othIndex = -1,
	          othLength = other.length,
	          result = Array(length + othLength);
	
	      while (++index < length) {
	        result[index] = array[index];
	      }
	      while (++othIndex < othLength) {
	        result[index++] = other[othIndex];
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function arrayCopy(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * A specialized version of `_.forEach` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns `array`.
	     */
	    function arrayEach(array, iteratee) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        if (iteratee(array[index], index, array) === false) {
	          break;
	        }
	      }
	      return array;
	    }
	
	    /**
	     * A specialized version of `_.forEachRight` for arrays without support for
	     * callback shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns `array`.
	     */
	    function arrayEachRight(array, iteratee) {
	      var length = array.length;
	
	      while (length--) {
	        if (iteratee(array[length], length, array) === false) {
	          break;
	        }
	      }
	      return array;
	    }
	
	    /**
	     * A specialized version of `_.every` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     */
	    function arrayEvery(array, predicate) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        if (!predicate(array[index], index, array)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * A specialized version of `baseExtremum` for arrays which invokes `iteratee`
	     * with one argument: (value).
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} comparator The function used to compare values.
	     * @param {*} exValue The initial extremum value.
	     * @returns {*} Returns the extremum value.
	     */
	    function arrayExtremum(array, iteratee, comparator, exValue) {
	      var index = -1,
	          length = array.length,
	          computed = exValue,
	          result = computed;
	
	      while (++index < length) {
	        var value = array[index],
	            current = +iteratee(value);
	
	        if (comparator(current, computed)) {
	          computed = current;
	          result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.filter` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function arrayFilter(array, predicate) {
	      var index = -1,
	          length = array.length,
	          resIndex = -1,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result[++resIndex] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.map` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function arrayMap(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          result = Array(length);
	
	      while (++index < length) {
	        result[index] = iteratee(array[index], index, array);
	      }
	      return result;
	    }
	
	    /**
	     * Appends the elements of `values` to `array`.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to append.
	     * @returns {Array} Returns `array`.
	     */
	    function arrayPush(array, values) {
	      var index = -1,
	          length = values.length,
	          offset = array.length;
	
	      while (++index < length) {
	        array[offset + index] = values[index];
	      }
	      return array;
	    }
	
	    /**
	     * A specialized version of `_.reduce` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @param {boolean} [initFromArray] Specify using the first element of `array`
	     *  as the initial value.
	     * @returns {*} Returns the accumulated value.
	     */
	    function arrayReduce(array, iteratee, accumulator, initFromArray) {
	      var index = -1,
	          length = array.length;
	
	      if (initFromArray && length) {
	        accumulator = array[++index];
	      }
	      while (++index < length) {
	        accumulator = iteratee(accumulator, array[index], index, array);
	      }
	      return accumulator;
	    }
	
	    /**
	     * A specialized version of `_.reduceRight` for arrays without support for
	     * callback shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @param {boolean} [initFromArray] Specify using the last element of `array`
	     *  as the initial value.
	     * @returns {*} Returns the accumulated value.
	     */
	    function arrayReduceRight(array, iteratee, accumulator, initFromArray) {
	      var length = array.length;
	      if (initFromArray && length) {
	        accumulator = array[--length];
	      }
	      while (length--) {
	        accumulator = iteratee(accumulator, array[length], length, array);
	      }
	      return accumulator;
	    }
	
	    /**
	     * A specialized version of `_.some` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function arraySome(array, predicate) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        if (predicate(array[index], index, array)) {
	          return true;
	        }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `_.sum` for arrays without support for callback
	     * shorthands and `this` binding..
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {number} Returns the sum.
	     */
	    function arraySum(array, iteratee) {
	      var length = array.length,
	          result = 0;
	
	      while (length--) {
	        result += +iteratee(array[length]) || 0;
	      }
	      return result;
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assign` use.
	     *
	     * @private
	     * @param {*} objectValue The destination object property value.
	     * @param {*} sourceValue The source object property value.
	     * @returns {*} Returns the value to assign to the destination object.
	     */
	    function assignDefaults(objectValue, sourceValue) {
	      return objectValue === undefined ? sourceValue : objectValue;
	    }
	
	    /**
	     * Used by `_.template` to customize its `_.assign` use.
	     *
	     * **Note:** This function is like `assignDefaults` except that it ignores
	     * inherited property values when checking if a property is `undefined`.
	     *
	     * @private
	     * @param {*} objectValue The destination object property value.
	     * @param {*} sourceValue The source object property value.
	     * @param {string} key The key associated with the object and source values.
	     * @param {Object} object The destination object.
	     * @returns {*} Returns the value to assign to the destination object.
	     */
	    function assignOwnDefaults(objectValue, sourceValue, key, object) {
	      return (objectValue === undefined || !hasOwnProperty.call(object, key))
	        ? sourceValue
	        : objectValue;
	    }
	
	    /**
	     * A specialized version of `_.assign` for customizing assigned values without
	     * support for argument juggling, multiple sources, and `this` binding `customizer`
	     * functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     */
	    function assignWith(object, source, customizer) {
	      var index = -1,
	          props = keys(source),
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index],
	            value = object[key],
	            result = customizer(value, source[key], key, object, source);
	
	        if ((result === result ? (result !== value) : (value === value)) ||
	            (value === undefined && !(key in object))) {
	          object[key] = result;
	        }
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for argument juggling,
	     * multiple sources, and `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return source == null
	        ? object
	        : baseCopy(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.at` without support for string collections
	     * and individual key arguments.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {number[]|string[]} props The property names or indexes of elements to pick.
	     * @returns {Array} Returns the new array of picked elements.
	     */
	    function baseAt(collection, props) {
	      var index = -1,
	          isNil = collection == null,
	          isArr = !isNil && isArrayLike(collection),
	          length = isArr ? collection.length : 0,
	          propsLength = props.length,
	          result = Array(propsLength);
	
	      while(++index < propsLength) {
	        var key = props[index];
	        if (isArr) {
	          result[index] = isIndex(key, length) ? collection[key] : undefined;
	        } else {
	          result[index] = isNil ? undefined : collection[key];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property names to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @returns {Object} Returns `object`.
	     */
	    function baseCopy(source, props, object) {
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	        object[key] = source[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `_.callback` which supports specifying the
	     * number of arguments to provide to `func`.
	     *
	     * @private
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {number} [argCount] The number of arguments to provide to `func`.
	     * @returns {Function} Returns the callback.
	     */
	    function baseCallback(func, thisArg, argCount) {
	      var type = typeof func;
	      if (type == 'function') {
	        return thisArg === undefined
	          ? func
	          : bindCallback(func, thisArg, argCount);
	      }
	      if (func == null) {
	        return identity;
	      }
	      if (type == 'object') {
	        return baseMatches(func);
	      }
	      return thisArg === undefined
	        ? property(func)
	        : baseMatchesProperty(func, thisArg);
	    }
	
	    /**
	     * The base implementation of `_.clone` without support for argument juggling
	     * and `this` binding `customizer` functions.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @param {Function} [customizer] The function to customize cloning values.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The object `value` belongs to.
	     * @param {Array} [stackA=[]] Tracks traversed source objects.
	     * @param {Array} [stackB=[]] Associates clones with source counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, isDeep, customizer, key, object, stackA, stackB) {
	      var result;
	      if (customizer) {
	        result = object ? customizer(value, key, object) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return arrayCopy(value, result);
	        }
	      } else {
	        var tag = objToString.call(value),
	            isFunc = tag == funcTag;
	
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = initCloneObject(isFunc ? {} : value);
	          if (!isDeep) {
	            return baseAssign(result, value);
	          }
	        } else {
	          return cloneableTags[tag]
	            ? initCloneByTag(value, tag, isDeep)
	            : (object ? value : {});
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stackA || (stackA = []);
	      stackB || (stackB = []);
	
	      var length = stackA.length;
	      while (length--) {
	        if (stackA[length] == value) {
	          return stackB[length];
	        }
	      }
	      // Add the source value to the stack of traversed objects and associate it with its clone.
	      stackA.push(value);
	      stackB.push(result);
	
	      // Recursively populate clone (susceptible to call stack limits).
	      (isArr ? arrayEach : baseForOwn)(value, function(subValue, key) {
	        result[key] = baseClone(subValue, isDeep, customizer, key, value, stackA, stackB);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} prototype The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(prototype) {
	        if (isObject(prototype)) {
	          object.prototype = prototype;
	          var result = new object;
	          object.prototype = undefined;
	        }
	        return result || {};
	      };
	    }());
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts an index
	     * of where to slice the arguments to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Object} args The arguments provide to `func`.
	     * @returns {number} Returns the timer id.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of `_.difference` which accepts a single array
	     * of values to exclude.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values) {
	      var length = array ? array.length : 0,
	          result = [];
	
	      if (!length) {
	        return result;
	      }
	      var index = -1,
	          indexOf = getIndexOf(),
	          isCommon = indexOf === baseIndexOf,
	          cache = (isCommon && values.length >= LARGE_ARRAY_SIZE) ? createCache(values) : null,
	          valuesLength = values.length;
	
	      if (cache) {
	        indexOf = cacheIndexOf;
	        isCommon = false;
	        values = cache;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index];
	
	        if (isCommon && value === value) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === value) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (indexOf(values, value, 0) < 0) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object|string} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object|string} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * Gets the extremum value of `collection` invoking `iteratee` for each value
	     * in `collection` to generate the criterion by which the value is ranked.
	     * The `iteratee` is invoked with three arguments: (value, index|key, collection).
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} comparator The function used to compare values.
	     * @param {*} exValue The initial extremum value.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(collection, iteratee, comparator, exValue) {
	      var computed = exValue,
	          result = computed;
	
	      baseEach(collection, function(value, index, collection) {
	        var current = +iteratee(value, index, collection);
	        if (comparator(current, computed) || (current === exValue && current === result)) {
	          computed = current;
	          result = value;
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = start == null ? 0 : (+start || 0);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : (+end || 0);
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : (end >>> 0);
	      start >>>= 0;
	
	      while (start < length) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.find`, `_.findLast`, `_.findKey`, and `_.findLastKey`,
	     * without support for callback shorthands and `this` binding, which iterates
	     * over `collection` using the provided `eachFunc`.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {Function} eachFunc The function to iterate over `collection`.
	     * @param {boolean} [retKey] Specify returning the key of the found element
	     *  instead of the element itself.
	     * @returns {*} Returns the found element or its key, else `undefined`.
	     */
	    function baseFind(collection, predicate, eachFunc, retKey) {
	      var result;
	      eachFunc(collection, function(value, key, collection) {
	        if (predicate(value, key, collection)) {
	          result = retKey ? key : value;
	          return false;
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with added support for restricting
	     * flattening and specifying the start index.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {boolean} [isDeep] Specify a deep flatten.
	     * @param {boolean} [isStrict] Restrict flattening to arrays-like objects.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, isDeep, isStrict, result) {
	      result || (result = []);
	
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index];
	        if (isObjectLike(value) && isArrayLike(value) &&
	            (isStrict || isArray(value) || isArguments(value))) {
	          if (isDeep) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, isDeep, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForIn` and `baseForOwn` which iterates
	     * over `object` properties returned by `keysFunc` invoking `iteratee` for
	     * each property. Iteratee functions may exit iteration early by explicitly
	     * returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forIn` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForIn(object, iteratee) {
	      return baseFor(object, iteratee, keysIn);
	    }
	
	    /**
	     * The base implementation of `_.forOwn` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from those provided.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the new array of filtered property names.
	     */
	    function baseFunctions(object, props) {
	      var index = -1,
	          length = props.length,
	          resIndex = -1,
	          result = [];
	
	      while (++index < length) {
	        var key = props[index];
	        if (isFunction(object[key])) {
	          result[++resIndex] = key;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `get` without support for string paths
	     * and default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path of the property to get.
	     * @param {string} [pathKey] The key representation of path.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path, pathKey) {
	      if (object == null) {
	        return;
	      }
	      if (pathKey !== undefined && pathKey in toObject(object)) {
	        path = [pathKey];
	      }
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[path[index++]];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` without support for `this` binding
	     * `customizer` functions.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparing values.
	     * @param {boolean} [isLoose] Specify performing partial comparisons.
	     * @param {Array} [stackA] Tracks traversed `value` objects.
	     * @param {Array} [stackB] Tracks traversed `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, customizer, isLoose, stackA, stackB) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, baseIsEqual, customizer, isLoose, stackA, stackB);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} [customizer] The function to customize comparing objects.
	     * @param {boolean} [isLoose] Specify performing partial comparisons.
	     * @param {Array} [stackA=[]] Tracks traversed `value` objects.
	     * @param {Array} [stackB=[]] Tracks traversed `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = arrayTag,
	          othTag = arrayTag;
	
	      if (!objIsArr) {
	        objTag = objToString.call(object);
	        if (objTag == argsTag) {
	          objTag = objectTag;
	        } else if (objTag != objectTag) {
	          objIsArr = isTypedArray(object);
	        }
	      }
	      if (!othIsArr) {
	        othTag = objToString.call(other);
	        if (othTag == argsTag) {
	          othTag = objectTag;
	        } else if (othTag != objectTag) {
	          othIsArr = isTypedArray(other);
	        }
	      }
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && !(objIsArr || objIsObj)) {
	        return equalByTag(object, other, objTag);
	      }
	      if (!isLoose) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          return equalFunc(objIsWrapped ? object.value() : object, othIsWrapped ? other.value() : other, customizer, isLoose, stackA, stackB);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      // For more information on detecting circular references see https://es5.github.io/#JO.
	      stackA || (stackA = []);
	      stackB || (stackB = []);
	
	      var length = stackA.length;
	      while (length--) {
	        if (stackA[length] == object) {
	          return stackB[length] == other;
	        }
	      }
	      // Add `object` and `other` to the stack of traversed objects.
	      stackA.push(object);
	      stackB.push(other);
	
	      var result = (objIsArr ? equalArrays : equalObjects)(object, other, equalFunc, customizer, isLoose, stackA, stackB);
	
	      stackA.pop();
	      stackB.pop();
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} matchData The propery names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparing objects.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = toObject(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var result = customizer ? customizer(objValue, srcValue, key) : undefined;
	          if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, true) : result)) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for callback shorthands
	     * and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which does not clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        var key = matchData[0][0],
	            value = matchData[0][1];
	
	        return function(object) {
	          if (object == null) {
	            return false;
	          }
	          return object[key] === value && (value !== undefined || (key in toObject(object)));
	        };
	      }
	      return function(object) {
	        return baseIsMatch(object, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which does not clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to compare.
	     * @returns {Function} Returns the new function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      var isArr = isArray(path),
	          isCommon = isKey(path) && isStrictComparable(srcValue),
	          pathKey = (path + '');
	
	      path = toPath(path);
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        var key = pathKey;
	        object = toObject(object);
	        if ((isArr || !isCommon) && !(key in object)) {
	          object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	          if (object == null) {
	            return false;
	          }
	          key = last(path);
	          object = toObject(object);
	        }
	        return object[key] === srcValue
	          ? (srcValue !== undefined || (key in object))
	          : baseIsEqual(srcValue, object[key], undefined, true);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for argument juggling,
	     * multiple sources, and `this` binding `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Array} [stackA=[]] Tracks traversed source objects.
	     * @param {Array} [stackB=[]] Associates values with source counterparts.
	     * @returns {Object} Returns `object`.
	     */
	    function baseMerge(object, source, customizer, stackA, stackB) {
	      if (!isObject(object)) {
	        return object;
	      }
	      var isSrcArr = isArrayLike(source) && (isArray(source) || isTypedArray(source)),
	          props = isSrcArr ? undefined : keys(source);
	
	      arrayEach(props || source, function(srcValue, key) {
	        if (props) {
	          key = srcValue;
	          srcValue = source[key];
	        }
	        if (isObjectLike(srcValue)) {
	          stackA || (stackA = []);
	          stackB || (stackB = []);
	          baseMergeDeep(object, source, key, baseMerge, customizer, stackA, stackB);
	        }
	        else {
	          var value = object[key],
	              result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
	              isCommon = result === undefined;
	
	          if (isCommon) {
	            result = srcValue;
	          }
	          if ((result !== undefined || (isSrcArr && !(key in object))) &&
	              (isCommon || (result === result ? (result !== value) : (value === value)))) {
	            object[key] = result;
	          }
	        }
	      });
	      return object;
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Array} [stackA=[]] Tracks traversed source objects.
	     * @param {Array} [stackB=[]] Associates values with source counterparts.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseMergeDeep(object, source, key, mergeFunc, customizer, stackA, stackB) {
	      var length = stackA.length,
	          srcValue = source[key];
	
	      while (length--) {
	        if (stackA[length] == srcValue) {
	          object[key] = stackB[length];
	          return;
	        }
	      }
	      var value = object[key],
	          result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
	          isCommon = result === undefined;
	
	      if (isCommon) {
	        result = srcValue;
	        if (isArrayLike(srcValue) && (isArray(srcValue) || isTypedArray(srcValue))) {
	          result = isArray(value)
	            ? value
	            : (isArrayLike(value) ? arrayCopy(value) : []);
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          result = isArguments(value)
	            ? toPlainObject(value)
	            : (isPlainObject(value) ? value : {});
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      // Add the source value to the stack of traversed objects and associate
	      // it with its merged value.
	      stackA.push(srcValue);
	      stackB.push(result);
	
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        object[key] = mergeFunc(result, srcValue, customizer, stackA, stackB);
	      } else if (result === result ? (result !== value) : (value === value)) {
	        object[key] = result;
	      }
	    }
	
	    /**
	     * The base implementation of `_.property` without support for deep paths.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @returns {Function} Returns the new function.
	     */
	    function baseProperty(key) {
	      return function(object) {
	        return object == null ? undefined : object[key];
	      };
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new function.
	     */
	    function basePropertyDeep(path) {
	      var pathKey = (path + '');
	      path = toPath(path);
	      return function(object) {
	        return baseGet(object, path, pathKey);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * index arguments and capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0;
	      while (length--) {
	        var index = indexes[length];
	        if (index != previous && isIndex(index)) {
	          var previous = index;
	          splice.call(array, index, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for argument juggling
	     * and returning floating-point numbers.
	     *
	     * @private
	     * @param {number} min The minimum possible value.
	     * @param {number} max The maximum possible value.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(min, max) {
	      return min + nativeFloor(nativeRandom() * (max - min + 1));
	    }
	
	    /**
	     * The base implementation of `_.reduce` and `_.reduceRight` without support
	     * for callback shorthands and `this` binding, which iterates over `collection`
	     * using the provided `eachFunc`.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {*} accumulator The initial value.
	     * @param {boolean} initFromCollection Specify using the first or last element
	     *  of `collection` as the initial value.
	     * @param {Function} eachFunc The function to iterate over `collection`.
	     * @returns {*} Returns the accumulated value.
	     */
	    function baseReduce(collection, iteratee, accumulator, initFromCollection, eachFunc) {
	      eachFunc(collection, function(value, index, collection) {
	        accumulator = initFromCollection
	          ? (initFromCollection = false, value)
	          : iteratee(accumulator, value, index, collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop detection.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      start = start == null ? 0 : (+start || 0);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : (+end || 0);
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for callback shorthands
	     * and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortBy` which uses `comparer` to define
	     * the sort order of `array` and replaces criteria objects with their
	     * corresponding values.
	     *
	     * @private
	     * @param {Array} array The array to sort.
	     * @param {Function} comparer The function to define sort order.
	     * @returns {Array} Returns `array`.
	     */
	    function baseSortBy(array, comparer) {
	      var length = array.length;
	
	      array.sort(comparer);
	      while (length--) {
	        array[length] = array[length].value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.sortByOrder` without param guards.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {boolean[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseSortByOrder(collection, iteratees, orders) {
	      var callback = getCallback(),
	          index = -1;
	
	      iteratees = arrayMap(iteratees, function(iteratee) { return callback(iteratee); });
	
	      var result = baseMap(collection, function(value) {
	        var criteria = arrayMap(iteratees, function(iteratee) { return iteratee(value); });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.sum` without support for callback shorthands
	     * and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {number} Returns the sum.
	     */
	    function baseSum(collection, iteratee) {
	      var result = 0;
	      baseEach(collection, function(value, index, collection) {
	        result += +iteratee(value, index, collection) || 0;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.uniq` without support for callback shorthands
	     * and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The function invoked per iteration.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee) {
	      var index = -1,
	          indexOf = getIndexOf(),
	          length = array.length,
	          isCommon = indexOf === baseIndexOf,
	          isLarge = isCommon && length >= LARGE_ARRAY_SIZE,
	          seen = isLarge ? createCache() : null,
	          result = [];
	
	      if (seen) {
	        indexOf = cacheIndexOf;
	        isCommon = false;
	      } else {
	        isLarge = false;
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value, index, array) : value;
	
	        if (isCommon && value === value) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (indexOf(seen, computed, 0) < 0) {
	          if (iteratee || isLarge) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.values` and `_.valuesIn` which creates an
	     * array of `object` property values corresponding to the property names
	     * of `props`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} props The property names to get values for.
	     * @returns {Object} Returns the array of property values.
	     */
	    function baseValues(object, props) {
	      var index = -1,
	          length = props.length,
	          result = Array(length);
	
	      while (++index < length) {
	        result[index] = object[props[index]];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.dropRightWhile`, `_.dropWhile`, `_.takeRightWhile`,
	     * and `_.takeWhile` without support for callback shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) && predicate(array[index], index, array)) {}
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to peform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      var index = -1,
	          length = actions.length;
	
	      while (++index < length) {
	        var action = actions[index];
	        result = action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }
	      return result;
	    }
	
	    /**
	     * Performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function binaryIndex(array, value, retHighest) {
	      var low = 0,
	          high = array ? array.length : low;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if ((retHighest ? (computed <= value) : (computed < value)) && computed !== null) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return binaryIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * This function is like `binaryIndex` except that it invokes `iteratee` for
	     * `value` and each element of `array` to compute their sort ranking. The
	     * iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function binaryIndexBy(array, value, iteratee, retHighest) {
	      value = iteratee(value);
	
	      var low = 0,
	          high = array ? array.length : 0,
	          valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsUndef = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            isDef = computed !== undefined,
	            isReflexive = computed === computed;
	
	        if (valIsNaN) {
	          var setLow = isReflexive || retHighest;
	        } else if (valIsNull) {
	          setLow = isReflexive && isDef && (retHighest || computed != null);
	        } else if (valIsUndef) {
	          setLow = isReflexive && (retHighest || isDef);
	        } else if (computed == null) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * A specialized version of `baseCallback` which only supports `this` binding
	     * and specifying the number of arguments to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {number} [argCount] The number of arguments to provide to `func`.
	     * @returns {Function} Returns the callback.
	     */
	    function bindCallback(func, thisArg, argCount) {
	      if (typeof func != 'function') {
	        return identity;
	      }
	      if (thisArg === undefined) {
	        return func;
	      }
	      switch (argCount) {
	        case 1: return function(value) {
	          return func.call(thisArg, value);
	        };
	        case 3: return function(value, index, collection) {
	          return func.call(thisArg, value, index, collection);
	        };
	        case 4: return function(accumulator, value, index, collection) {
	          return func.call(thisArg, accumulator, value, index, collection);
	        };
	        case 5: return function(value, other, key, object, source) {
	          return func.call(thisArg, value, other, key, object, source);
	        };
	      }
	      return function() {
	        return func.apply(thisArg, arguments);
	      };
	    }
	
	    /**
	     * Creates a clone of the given array buffer.
	     *
	     * @private
	     * @param {ArrayBuffer} buffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function bufferClone(buffer) {
	      var result = new ArrayBuffer(buffer.byteLength),
	          view = new Uint8Array(result);
	
	      view.set(new Uint8Array(buffer));
	      return result;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array|Object} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders) {
	      var holdersLength = holders.length,
	          argsIndex = -1,
	          argsLength = nativeMax(args.length - holdersLength, 0),
	          leftIndex = -1,
	          leftLength = partials.length,
	          result = Array(leftLength + argsLength);
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        result[holders[argsIndex]] = args[argsIndex];
	      }
	      while (argsLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array|Object} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders) {
	      var holdersIndex = -1,
	          holdersLength = holders.length,
	          argsIndex = -1,
	          argsLength = nativeMax(args.length - holdersLength, 0),
	          rightIndex = -1,
	          rightLength = partials.length,
	          result = Array(argsLength + rightLength);
	
	      while (++argsIndex < argsLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        result[offset + holders[holdersIndex]] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * Creates a `_.countBy`, `_.groupBy`, `_.indexBy`, or `_.partition` function.
	     *
	     * @private
	     * @param {Function} setter The function to set keys and values of the accumulator object.
	     * @param {Function} [initializer] The function to initialize the accumulator object.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee, thisArg) {
	        var result = initializer ? initializer() : {};
	        iteratee = getCallback(iteratee, thisArg, 3);
	
	        if (isArray(collection)) {
	          var index = -1,
	              length = collection.length;
	
	          while (++index < length) {
	            var value = collection[index];
	            setter(result, value, iteratee(value, index, collection), collection);
	          }
	        } else {
	          baseEach(collection, function(value, key, collection) {
	            setter(result, value, iteratee(value, key, collection), collection);
	          });
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a `_.assign`, `_.defaults`, or `_.merge` function.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return restParam(function(object, sources) {
	        var index = -1,
	            length = object == null ? 0 : sources.length,
	            customizer = length > 2 ? sources[length - 2] : undefined,
	            guard = length > 2 ? sources[2] : undefined,
	            thisArg = length > 1 ? sources[length - 1] : undefined;
	
	        if (typeof customizer == 'function') {
	          customizer = bindCallback(customizer, thisArg, 5);
	          length -= 2;
	        } else {
	          customizer = typeof thisArg == 'function' ? thisArg : undefined;
	          length -= (customizer ? 1 : 0);
	        }
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        var length = collection ? getLength(collection) : 0;
	        if (!isLength(length)) {
	          return eachFunc(collection, iteratee);
	        }
	        var index = fromRight ? length : -1,
	            iterable = toObject(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for `_.forIn` or `_.forInRight`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var iterable = toObject(object),
	            props = keysFunc(object),
	            length = props.length,
	            index = fromRight ? length : -1;
	
	        while ((fromRight ? index-- : ++index < length)) {
	          var key = props[index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` and invokes it with the `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to bind.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new bound function.
	     */
	    function createBindWrapper(func, thisArg) {
	      var Ctor = createCtorWrapper(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(thisArg, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `Set` cache object to optimize linear searches of large arrays.
	     *
	     * @private
	     * @param {Array} [values] The values to cache.
	     * @returns {null|Object} Returns the new cache object if `Set` is supported, else `null`.
	     */
	    function createCache(values) {
	      return (nativeCreate && Set) ? new SetCache(values) : null;
	    }
	
	    /**
	     * Creates a function that produces compound words out of the words in a
	     * given string.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        var index = -1,
	            array = words(deburr(string)),
	            length = array.length,
	            result = '';
	
	        while (++index < length) {
	          result = callback(result, array[index], index);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtorWrapper(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors.
	        // See http://ecma-international.org/ecma-262/6.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a `_.curry` or `_.curryRight` function.
	     *
	     * @private
	     * @param {boolean} flag The curry bit flag.
	     * @returns {Function} Returns the new curry function.
	     */
	    function createCurry(flag) {
	      function curryFunc(func, arity, guard) {
	        if (guard && isIterateeCall(func, arity, guard)) {
	          arity = undefined;
	        }
	        var result = createWrapper(func, flag, undefined, undefined, undefined, undefined, undefined, arity);
	        result.placeholder = curryFunc.placeholder;
	        return result;
	      }
	      return curryFunc;
	    }
	
	    /**
	     * Creates a `_.defaults` or `_.defaultsDeep` function.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Function} Returns the new defaults function.
	     */
	    function createDefaults(assigner, customizer) {
	      return restParam(function(args) {
	        var object = args[0];
	        if (object == null) {
	          return object;
	        }
	        args.push(customizer);
	        return assigner.apply(undefined, args);
	      });
	    }
	
	    /**
	     * Creates a `_.max` or `_.min` function.
	     *
	     * @private
	     * @param {Function} comparator The function used to compare values.
	     * @param {*} exValue The initial extremum value.
	     * @returns {Function} Returns the new extremum function.
	     */
	    function createExtremum(comparator, exValue) {
	      return function(collection, iteratee, thisArg) {
	        if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
	          iteratee = undefined;
	        }
	        iteratee = getCallback(iteratee, thisArg, 3);
	        if (iteratee.length == 1) {
	          collection = isArray(collection) ? collection : toIterable(collection);
	          var result = arrayExtremum(collection, iteratee, comparator, exValue);
	          if (!(collection.length && result === exValue)) {
	            return result;
	          }
	        }
	        return baseExtremum(collection, iteratee, comparator, exValue);
	      };
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(eachFunc, fromRight) {
	      return function(collection, predicate, thisArg) {
	        predicate = getCallback(predicate, thisArg, 3);
	        if (isArray(collection)) {
	          var index = baseFindIndex(collection, predicate, fromRight);
	          return index > -1 ? collection[index] : undefined;
	        }
	        return baseFind(collection, predicate, eachFunc);
	      };
	    }
	
	    /**
	     * Creates a `_.findIndex` or `_.findLastIndex` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFindIndex(fromRight) {
	      return function(array, predicate, thisArg) {
	        if (!(array && array.length)) {
	          return -1;
	        }
	        predicate = getCallback(predicate, thisArg, 3);
	        return baseFindIndex(array, predicate, fromRight);
	      };
	    }
	
	    /**
	     * Creates a `_.findKey` or `_.findLastKey` function.
	     *
	     * @private
	     * @param {Function} objectFunc The function to iterate over an object.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFindKey(objectFunc) {
	      return function(object, predicate, thisArg) {
	        predicate = getCallback(predicate, thisArg, 3);
	        return baseFind(object, predicate, objectFunc, true);
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return function() {
	        var wrapper,
	            length = arguments.length,
	            index = fromRight ? length : -1,
	            leftIndex = 0,
	            funcs = Array(length);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          var func = funcs[leftIndex++] = arguments[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (!wrapper && LodashWrapper.prototype.thru && getFuncName(func) == 'wrapper') {
	            wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? -1 : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) && data[1] == (ARY_FLAG | CURRY_FLAG | PARTIAL_FLAG | REARG_FLAG) && !data[4].length && data[9] == 1) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func)) ? wrapper[funcName]() : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 && isArray(value) && value.length >= LARGE_ARRAY_SIZE) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      };
	    }
	
	    /**
	     * Creates a function for `_.forEach` or `_.forEachRight`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over an array.
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @returns {Function} Returns the new each function.
	     */
	    function createForEach(arrayFunc, eachFunc) {
	      return function(collection, iteratee, thisArg) {
	        return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
	          ? arrayFunc(collection, iteratee)
	          : eachFunc(collection, bindCallback(iteratee, thisArg, 3));
	      };
	    }
	
	    /**
	     * Creates a function for `_.forIn` or `_.forInRight`.
	     *
	     * @private
	     * @param {Function} objectFunc The function to iterate over an object.
	     * @returns {Function} Returns the new each function.
	     */
	    function createForIn(objectFunc) {
	      return function(object, iteratee, thisArg) {
	        if (typeof iteratee != 'function' || thisArg !== undefined) {
	          iteratee = bindCallback(iteratee, thisArg, 3);
	        }
	        return objectFunc(object, iteratee, keysIn);
	      };
	    }
	
	    /**
	     * Creates a function for `_.forOwn` or `_.forOwnRight`.
	     *
	     * @private
	     * @param {Function} objectFunc The function to iterate over an object.
	     * @returns {Function} Returns the new each function.
	     */
	    function createForOwn(objectFunc) {
	      return function(object, iteratee, thisArg) {
	        if (typeof iteratee != 'function' || thisArg !== undefined) {
	          iteratee = bindCallback(iteratee, thisArg, 3);
	        }
	        return objectFunc(object, iteratee);
	      };
	    }
	
	    /**
	     * Creates a function for `_.mapKeys` or `_.mapValues`.
	     *
	     * @private
	     * @param {boolean} [isMapKeys] Specify mapping keys instead of values.
	     * @returns {Function} Returns the new map function.
	     */
	    function createObjectMapper(isMapKeys) {
	      return function(object, iteratee, thisArg) {
	        var result = {};
	        iteratee = getCallback(iteratee, thisArg, 3);
	
	        baseForOwn(object, function(value, key, object) {
	          var mapped = iteratee(value, key, object);
	          key = isMapKeys ? mapped : key;
	          value = isMapKeys ? value : mapped;
	          result[key] = value;
	        });
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function for `_.padLeft` or `_.padRight`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify padding from the right.
	     * @returns {Function} Returns the new pad function.
	     */
	    function createPadDir(fromRight) {
	      return function(string, length, chars) {
	        string = baseToString(string);
	        return (fromRight ? string : '') + createPadding(string, length, chars) + (fromRight ? '' : string);
	      };
	    }
	
	    /**
	     * Creates a `_.partial` or `_.partialRight` function.
	     *
	     * @private
	     * @param {boolean} flag The partial bit flag.
	     * @returns {Function} Returns the new partial function.
	     */
	    function createPartial(flag) {
	      var partialFunc = restParam(function(func, partials) {
	        var holders = replaceHolders(partials, partialFunc.placeholder);
	        return createWrapper(func, flag, undefined, partials, holders);
	      });
	      return partialFunc;
	    }
	
	    /**
	     * Creates a function for `_.reduce` or `_.reduceRight`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over an array.
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @returns {Function} Returns the new each function.
	     */
	    function createReduce(arrayFunc, eachFunc) {
	      return function(collection, iteratee, accumulator, thisArg) {
	        var initFromArray = arguments.length < 3;
	        return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
	          ? arrayFunc(collection, iteratee, accumulator, initFromArray)
	          : baseReduce(collection, getCallback(iteratee, thisArg, 4), accumulator, initFromArray, eachFunc);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` and invokes it with optional `this`
	     * binding of, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to reference.
	     * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybridWrapper(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & ARY_FLAG,
	          isBind = bitmask & BIND_FLAG,
	          isBindKey = bitmask & BIND_KEY_FLAG,
	          isCurry = bitmask & CURRY_FLAG,
	          isCurryBound = bitmask & CURRY_BOUND_FLAG,
	          isCurryRight = bitmask & CURRY_RIGHT_FLAG,
	          Ctor = isBindKey ? undefined : createCtorWrapper(func);
	
	      function wrapper() {
	        // Avoid `arguments` object use disqualifying optimizations by
	        // converting it to an array before providing it to other functions.
	        var length = arguments.length,
	            index = length,
	            args = Array(length);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight);
	        }
	        if (isCurry || isCurryRight) {
	          var placeholder = wrapper.placeholder,
	              argsHolders = replaceHolders(args, placeholder);
	
	          length -= argsHolders.length;
	          if (length < arity) {
	            var newArgPos = argPos ? arrayCopy(argPos) : undefined,
	                newArity = nativeMax(arity - length, 0),
	                newsHolders = isCurry ? argsHolders : undefined,
	                newHoldersRight = isCurry ? undefined : argsHolders,
	                newPartials = isCurry ? args : undefined,
	                newPartialsRight = isCurry ? undefined : args;
	
	            bitmask |= (isCurry ? PARTIAL_FLAG : PARTIAL_RIGHT_FLAG);
	            bitmask &= ~(isCurry ? PARTIAL_RIGHT_FLAG : PARTIAL_FLAG);
	
	            if (!isCurryBound) {
	              bitmask &= ~(BIND_FLAG | BIND_KEY_FLAG);
	            }
	            var newData = [func, bitmask, thisArg, newPartials, newsHolders, newPartialsRight, newHoldersRight, newArgPos, ary, newArity],
	                result = createHybridWrapper.apply(undefined, newData);
	
	            if (isLaziable(func)) {
	              setData(result, newData);
	            }
	            result.placeholder = placeholder;
	            return result;
	          }
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        if (argPos) {
	          args = reorder(args, argPos);
	        }
	        if (isAry && ary < args.length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtorWrapper(func);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates the padding required for `string` based on the given `length`.
	     * The `chars` string is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {string} string The string to create padding for.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the pad for `string`.
	     */
	    function createPadding(string, length, chars) {
	      var strLength = string.length;
	      length = +length;
	
	      if (strLength >= length || !nativeIsFinite(length)) {
	        return '';
	      }
	      var padLength = length - strLength;
	      chars = chars == null ? ' ' : (chars + '');
	      return repeat(chars, nativeCeil(padLength / chars.length)).slice(0, padLength);
	    }
	
	    /**
	     * Creates a function that wraps `func` and invokes it with the optional `this`
	     * binding of `thisArg` and the `partials` prepended to those provided to
	     * the wrapper.
	     *
	     * @private
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to the new function.
	     * @returns {Function} Returns the new bound function.
	     */
	    function createPartialWrapper(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & BIND_FLAG,
	          Ctor = createCtorWrapper(func);
	
	      function wrapper() {
	        // Avoid `arguments` object use disqualifying optimizations by
	        // converting it to an array before providing it `func`.
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength);
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.ceil`, `_.floor`, or `_.round` function.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        precision = precision === undefined ? 0 : (+precision || 0);
	        if (precision) {
	          precision = pow(10, precision);
	          return func(number * precision) / precision;
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a `_.sortedIndex` or `_.sortedLastIndex` function.
	     *
	     * @private
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {Function} Returns the new index function.
	     */
	    function createSortedIndex(retHighest) {
	      return function(array, value, iteratee, thisArg) {
	        var callback = getCallback(iteratee);
	        return (iteratee == null && callback === baseCallback)
	          ? binaryIndex(array, value, retHighest)
	          : binaryIndexBy(array, value, callback(iteratee, thisArg, 1), retHighest);
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to reference.
	     * @param {number} bitmask The bitmask of flags.
	     *  The bitmask may be composed of the following flags:
	     *     1 - `_.bind`
	     *     2 - `_.bindKey`
	     *     4 - `_.curry` or `_.curryRight` of a bound function
	     *     8 - `_.curry`
	     *    16 - `_.curryRight`
	     *    32 - `_.partial`
	     *    64 - `_.partialRight`
	     *   128 - `_.rearg`
	     *   256 - `_.ary`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrapper(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(PARTIAL_FLAG | PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      length -= (holders ? holders.length : 0);
	      if (bitmask & PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func),
	          newData = [func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity];
	
	      if (data) {
	        mergeData(newData, data);
	        bitmask = newData[1];
	        arity = newData[9];
	      }
	      newData[9] = arity == null
	        ? (isBindKey ? 0 : func.length)
	        : (nativeMax(arity - length, 0) || 0);
	
	      if (bitmask == BIND_FLAG) {
	        var result = createBindWrapper(newData[0], newData[2]);
	      } else if ((bitmask == PARTIAL_FLAG || bitmask == (BIND_FLAG | PARTIAL_FLAG)) && !newData[4].length) {
	        result = createPartialWrapper.apply(undefined, newData);
	      } else {
	        result = createHybridWrapper.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setter(result, newData);
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} [customizer] The function to customize comparing arrays.
	     * @param {boolean} [isLoose] Specify performing partial comparisons.
	     * @param {Array} [stackA] Tracks traversed `value` objects.
	     * @param {Array} [stackB] Tracks traversed `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, equalFunc, customizer, isLoose, stackA, stackB) {
	      var index = -1,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isLoose && othLength > arrLength)) {
	        return false;
	      }
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index],
	            result = customizer ? customizer(isLoose ? othValue : arrValue, isLoose ? arrValue : othValue, index) : undefined;
	
	        if (result !== undefined) {
	          if (result) {
	            continue;
	          }
	          return false;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (isLoose) {
	          if (!arraySome(other, function(othValue) {
	                return arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB);
	              })) {
	            return false;
	          }
	        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB))) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag) {
	      switch (tag) {
	        case boolTag:
	        case dateTag:
	          // Coerce dates and booleans to numbers, dates to milliseconds and booleans
	          // to `1` or `0` treating invalid dates coerced to `NaN` as not equal.
	          return +object == +other;
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case numberTag:
	          // Treat `NaN` vs. `NaN` as equal.
	          return (object != +object)
	            ? other != +other
	            : object == +other;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings primitives and string
	          // objects as equal. See https://es5.github.io/#x15.10.6.4 for more details.
	          return object == (other + '');
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} [customizer] The function to customize comparing values.
	     * @param {boolean} [isLoose] Specify performing partial comparisons.
	     * @param {Array} [stackA] Tracks traversed `value` objects.
	     * @param {Array} [stackB] Tracks traversed `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
	      var objProps = keys(object),
	          objLength = objProps.length,
	          othProps = keys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isLoose) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isLoose ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      var skipCtor = isLoose;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key],
	            result = customizer ? customizer(isLoose ? othValue : objValue, isLoose? objValue : othValue, key) : undefined;
	
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(result === undefined ? equalFunc(objValue, othValue, customizer, isLoose, stackA, stackB) : result)) {
	          return false;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (!skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Gets the appropriate "callback" function. If the `_.callback` method is
	     * customized this function returns the custom method, otherwise it returns
	     * the `baseCallback` function. If arguments are provided the chosen function
	     * is invoked with them and its result is returned.
	     *
	     * @private
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getCallback(func, thisArg, argCount) {
	      var result = lodash.callback || callback;
	      result = result === callback ? baseCallback : result;
	      return argCount ? result(func, thisArg, argCount) : result;
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = array ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the appropriate "indexOf" function. If the `_.indexOf` method is
	     * customized this function returns the custom method, otherwise it returns
	     * the `baseIndexOf` function. If arguments are provided the chosen function
	     * is invoked with them and its result is returned.
	     *
	     * @private
	     * @returns {Function|number} Returns the chosen function or its result.
	     */
	    function getIndexOf(collection, target, fromIndex) {
	      var result = lodash.indexOf || indexOf;
	      result = result === indexOf ? baseIndexOf : result;
	      return collection ? result(collection, target, fromIndex) : result;
	    }
	
	    /**
	     * Gets the "length" property value of `object`.
	     *
	     * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
	     * that affects Safari on at least iOS 8.1-8.3 ARM64.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {*} Returns the "length" value.
	     */
	    var getLength = baseProperty('length');
	
	    /**
	     * Gets the propery names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = pairs(object),
	          length = result.length;
	
	      while (length--) {
	        result[length][2] = isStrictComparable(result[length][1]);
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = object == null ? undefined : object[key];
	      return isNative(value) ? value : undefined;
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = new array.constructor(length);
	
	      // Add array properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      var Ctor = object.constructor;
	      if (!(typeof Ctor == 'function' && Ctor instanceof Ctor)) {
	        Ctor = Object;
	      }
	      return new Ctor;
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return bufferClone(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          var buffer = object.buffer;
	          return new Ctor(isDeep ? bufferClone(buffer) : buffer, object.byteOffset, object.length);
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          var result = new Ctor(object.source, reFlags.exec(object));
	          result.lastIndex = object.lastIndex;
	      }
	      return result;
	    }
	
	    /**
	     * Invokes the method at `path` on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function invokePath(object, path, args) {
	      if (object != null && !isKey(path, object)) {
	        path = toPath(path);
	        object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	        path = last(path);
	      }
	      var func = object == null ? object : object[path];
	      return func == null ? undefined : func.apply(object, args);
	    }
	
	    /**
	     * Checks if `value` is array-like.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(getLength(value));
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
	      length = length == null ? MAX_SAFE_INTEGER : length;
	      return value > -1 && value % 1 == 0 && value < length;
	    }
	
	    /**
	     * Checks if the provided arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call, else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	          ? (isArrayLike(object) && isIndex(index, object.length))
	          : (type == 'string' && index in object)) {
	        var other = object[index];
	        return value === value ? (value === other) : (other !== other);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      var type = typeof value;
	      if ((type == 'string' && reIsPlainProp.test(value)) || type == 'number') {
	        return true;
	      }
	      if (isArray(value)) {
	        return false;
	      }
	      var result = !reIsDeepProp.test(value);
	      return result || (object != null && value in toObject(object));
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart, else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];
	
	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     */
	    function isLength(value) {
	      return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers required to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and `_.rearg`
	     * augment function arguments, making the order in which they are executed important,
	     * preventing the merging of metadata. However, we make an exception for a safe
	     * common case where curried functions have `_.ary` and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < ARY_FLAG;
	
	      var isCombo =
	        (srcBitmask == ARY_FLAG && bitmask == CURRY_FLAG) ||
	        (srcBitmask == ARY_FLAG && bitmask == REARG_FLAG && data[7].length <= source[8]) ||
	        (srcBitmask == (ARY_FLAG | REARG_FLAG) && bitmask == CURRY_FLAG);
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= (bitmask & BIND_FLAG) ? 0 : CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : arrayCopy(value);
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : arrayCopy(source[4]);
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : arrayCopy(value);
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : arrayCopy(source[6]);
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = arrayCopy(value);
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use.
	     *
	     * @private
	     * @param {*} objectValue The destination object property value.
	     * @param {*} sourceValue The source object property value.
	     * @returns {*} Returns the value to assign to the destination object.
	     */
	    function mergeDefaults(objectValue, sourceValue) {
	      return objectValue === undefined ? sourceValue : merge(objectValue, sourceValue, mergeDefaults);
	    }
	
	    /**
	     * A specialized version of `_.pick` which picks `object` properties specified
	     * by `props`.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} props The property names to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function pickByArray(object, props) {
	      object = toObject(object);
	
	      var index = -1,
	          length = props.length,
	          result = {};
	
	      while (++index < length) {
	        var key = props[index];
	        if (key in object) {
	          result[key] = object[key];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.pick` which picks `object` properties `predicate`
	     * returns truthy for.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Object} Returns the new object.
	     */
	    function pickByCallback(object, predicate) {
	      var result = {};
	      baseForIn(object, function(value, key, object) {
	        if (predicate(value, key, object)) {
	          result[key] = value;
	        }
	      });
	      return result;
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = arrayCopy(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity function
	     * to avoid garbage collection pauses in V8. See [V8 issue 2070](https://code.google.com/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = (function() {
	      var count = 0,
	          lastCalled = 0;
	
	      return function(key, value) {
	        var stamp = now(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return key;
	          }
	        } else {
	          count = 0;
	        }
	        return baseSetData(key, value);
	      };
	    }());
	
	    /**
	     * A fallback implementation of `Object.keys` which creates an array of the
	     * own enumerable property names of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function shimKeys(object) {
	      var props = keysIn(object),
	          propsLength = props.length,
	          length = propsLength && object.length;
	
	      var allowIndexes = !!length && isLength(length) &&
	        (isArray(object) || isArguments(object));
	
	      var index = -1,
	          result = [];
	
	      while (++index < propsLength) {
	        var key = props[index];
	        if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to an array-like object if it's not one.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {Array|Object} Returns the array-like object.
	     */
	    function toIterable(value) {
	      if (value == null) {
	        return [];
	      }
	      if (!isArrayLike(value)) {
	        return values(value);
	      }
	      return isObject(value) ? value : Object(value);
	    }
	
	    /**
	     * Converts `value` to an object if it's not one.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {Object} Returns the object.
	     */
	    function toObject(value) {
	      return isObject(value) ? value : Object(value);
	    }
	
	    /**
	     * Converts `value` to property path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {Array} Returns the property path array.
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return value;
	      }
	      var result = [];
	      baseToString(value).replace(rePropName, function(match, number, quote, string) {
	        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      return wrapper instanceof LazyWrapper
	        ? wrapper.clone()
	        : new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__, arrayCopy(wrapper.__actions__));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `collection` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the new array containing chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if (guard ? isIterateeCall(array, size, guard) : size == null) {
	        size = 1;
	      } else {
	        size = nativeMax(nativeFloor(size) || 1, 1);
	      }
	      var index = 0,
	          length = array ? array.length : 0,
	          resIndex = -1,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[++resIndex] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array ? array.length : 0,
	          resIndex = -1,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[++resIndex] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of unique `array` values not included in the other
	     * provided arrays using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The arrays of values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.difference([1, 2, 3], [4, 2]);
	     * // => [1, 3]
	     */
	    var difference = restParam(function(array, values) {
	      return (isObjectLike(array) && isArrayLike(array))
	        ? baseDifference(array, baseFlatten(values, false, true))
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (guard ? isIterateeCall(array, n, guard) : n == null) {
	        n = 1;
	      }
	      return baseSlice(array, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (guard ? isIterateeCall(array, n, guard) : n == null) {
	        n = 1;
	      }
	      n = length - (+n || 0);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * bound to `thisArg` and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that match the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRightWhile([1, 2, 3], function(n) {
	     *   return n > 1;
	     * });
	     * // => [1]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.dropRightWhile(users, { 'user': 'pebbles', 'active': false }), 'user');
	     * // => ['barney', 'fred']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.dropRightWhile(users, 'active', false), 'user');
	     * // => ['barney']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.dropRightWhile(users, 'active'), 'user');
	     * // => ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate, thisArg) {
	      return (array && array.length)
	        ? baseWhile(array, getCallback(predicate, thisArg, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * bound to `thisArg` and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropWhile([1, 2, 3], function(n) {
	     *   return n < 3;
	     * });
	     * // => [3]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.dropWhile(users, { 'user': 'barney', 'active': false }), 'user');
	     * // => ['fred', 'pebbles']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.dropWhile(users, 'active', false), 'user');
	     * // => ['pebbles']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.dropWhile(users, 'active'), 'user');
	     * // => ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate, thisArg) {
	      return (array && array.length)
	        ? baseWhile(array, getCallback(predicate, thisArg, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8], '*', 1, 2);
	     * // => [4, '*', 8]
	     */
	    function fill(array, value, start, end) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(chr) {
	     *   return chr.user == 'barney';
	     * });
	     * // => 0
	     *
	     * // using the `_.matches` callback shorthand
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.findIndex(users, 'active', false);
	     * // => 0
	     *
	     * // using the `_.property` callback shorthand
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    var findIndex = createFindIndex();
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(chr) {
	     *   return chr.user == 'pebbles';
	     * });
	     * // => 2
	     *
	     * // using the `_.matches` callback shorthand
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.findLastIndex(users, 'active', false);
	     * // => 2
	     *
	     * // using the `_.property` callback shorthand
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    var findLastIndex = createFindIndex(true);
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @alias head
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.first([1, 2, 3]);
	     * // => 1
	     *
	     * _.first([]);
	     * // => undefined
	     */
	    function first(array) {
	      return array ? array[0] : undefined;
	    }
	
	    /**
	     * Flattens a nested array. If `isDeep` is `true` the array is recursively
	     * flattened, otherwise it's only flattened a single level.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {boolean} [isDeep] Specify a deep flatten.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, 3, [4]]]);
	     * // => [1, 2, 3, [4]]
	     *
	     * // using `isDeep`
	     * _.flatten([1, [2, 3, [4]]], true);
	     * // => [1, 2, 3, 4]
	     */
	    function flatten(array, isDeep, guard) {
	      var length = array ? array.length : 0;
	      if (guard && isIterateeCall(array, isDeep, guard)) {
	        isDeep = false;
	      }
	      return length ? baseFlatten(array, isDeep) : [];
	    }
	
	    /**
	     * Recursively flattens a nested array.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to recursively flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, 3, [4]]]);
	     * // => [1, 2, 3, 4]
	     */
	    function flattenDeep(array) {
	      var length = array ? array.length : 0;
	      return length ? baseFlatten(array, true) : [];
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the offset
	     * from the end of `array`. If `array` is sorted providing `true` for `fromIndex`
	     * performs a faster binary search.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {*} value The value to search for.
	     * @param {boolean|number} [fromIndex=0] The index to search from or `true`
	     *  to perform a binary search on a sorted array.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // using `fromIndex`
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     *
	     * // performing a binary search
	     * _.indexOf([1, 1, 2, 2], 2, true);
	     * // => 2
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return -1;
	      }
	      if (typeof fromIndex == 'number') {
	        fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : fromIndex;
	      } else if (fromIndex) {
	        var index = binaryIndex(array, value);
	        if (index < length &&
	            (value === value ? (value === array[index]) : (array[index] !== array[index]))) {
	          return index;
	        }
	        return -1;
	      }
	      return baseIndexOf(array, value, fromIndex || 0);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      return dropRight(array, 1);
	    }
	
	    /**
	     * Creates an array of unique values that are included in all of the provided
	     * arrays using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of shared values.
	     * @example
	     * _.intersection([1, 2], [4, 2], [2, 1]);
	     * // => [2]
	     */
	    var intersection = restParam(function(arrays) {
	      var othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(length),
	          indexOf = getIndexOf(),
	          isCommon = indexOf === baseIndexOf,
	          result = [];
	
	      while (othIndex--) {
	        var value = arrays[othIndex] = isArrayLike(value = arrays[othIndex]) ? value : [];
	        caches[othIndex] = (isCommon && value.length >= 120) ? createCache(othIndex && value) : null;
	      }
	      var array = arrays[0],
	          index = -1,
	          length = array ? array.length : 0,
	          seen = caches[0];
	
	      outer:
	      while (++index < length) {
	        value = array[index];
	        if ((seen ? cacheIndexOf(seen, value) : indexOf(result, value, 0)) < 0) {
	          var othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if ((cache ? cacheIndexOf(cache, value) : indexOf(arrays[othIndex], value, 0)) < 0) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(value);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    });
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array ? array.length : 0;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {*} value The value to search for.
	     * @param {boolean|number} [fromIndex=array.length-1] The index to search from
	     *  or `true` to perform a binary search on a sorted array.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // using `fromIndex`
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     *
	     * // performing a binary search
	     * _.lastIndexOf([1, 1, 2, 2], 2, true);
	     * // => 3
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (typeof fromIndex == 'number') {
	        index = (fromIndex < 0 ? nativeMax(length + fromIndex, 0) : nativeMin(fromIndex || 0, length - 1)) + 1;
	      } else if (fromIndex) {
	        index = binaryIndex(array, value, true) - 1;
	        var other = array[index];
	        if (value === value ? (value === other) : (other !== other)) {
	          return index;
	        }
	        return -1;
	      }
	      if (value !== value) {
	        return indexOfNaN(array, index, true);
	      }
	      while (index--) {
	        if (array[index] === value) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Removes all provided values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3, 1, 2, 3];
	     *
	     * _.pull(array, 2, 3);
	     * console.log(array);
	     * // => [1, 1]
	     */
	    function pull() {
	      var args = arguments,
	          array = args[0];
	
	      if (!(array && array.length)) {
	        return array;
	      }
	      var index = 0,
	          indexOf = getIndexOf(),
	          length = args.length;
	
	      while (++index < length) {
	        var fromIndex = 0,
	            value = args[index];
	
	        while ((fromIndex = indexOf(array, value, fromIndex)) > -1) {
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to the given indexes and returns
	     * an array of the removed elements. Indexes may be specified as an array of
	     * indexes or as individual arguments.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove,
	     *  specified as individual indexes or arrays of indexes.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [5, 10, 15, 20];
	     * var evens = _.pullAt(array, 1, 3);
	     *
	     * console.log(array);
	     * // => [5, 15]
	     *
	     * console.log(evens);
	     * // => [10, 20]
	     */
	    var pullAt = restParam(function(array, indexes) {
	      indexes = baseFlatten(indexes);
	
	      var result = baseAt(array, indexes);
	      basePullAt(array, indexes.sort(baseCompareAscending));
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is bound to
	     * `thisArg` and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate, thisArg) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getCallback(predicate, thisArg, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @alias tail
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.rest([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function rest(array) {
	      return drop(array, 1);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of `Array#slice` to support node
	     * lists in IE < 9 and to ensure dense arrays are returned.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value` should
	     * be inserted into `array` in order to maintain its sort order. If an iteratee
	     * function is provided it's invoked for `value` and each element of `array`
	     * to compute their sort ranking. The iteratee is bound to `thisArg` and
	     * invoked with one argument; (value).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     *
	     * _.sortedIndex([4, 4, 5, 5], 5);
	     * // => 2
	     *
	     * var dict = { 'data': { 'thirty': 30, 'forty': 40, 'fifty': 50 } };
	     *
	     * // using an iteratee function
	     * _.sortedIndex(['thirty', 'fifty'], 'forty', function(word) {
	     *   return this.data[word];
	     * }, dict);
	     * // => 1
	     *
	     * // using the `_.property` callback shorthand
	     * _.sortedIndex([{ 'x': 30 }, { 'x': 50 }], { 'x': 40 }, 'x');
	     * // => 1
	     */
	    var sortedIndex = createSortedIndex();
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 4, 5, 5], 5);
	     * // => 4
	     */
	    var sortedLastIndex = createSortedIndex(true);
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (guard ? isIterateeCall(array, n, guard) : n == null) {
	        n = 1;
	      }
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (guard ? isIterateeCall(array, n, guard) : n == null) {
	        n = 1;
	      }
	      n = length - (+n || 0);
	      return baseSlice(array, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is bound to `thisArg`
	     * and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRightWhile([1, 2, 3], function(n) {
	     *   return n > 1;
	     * });
	     * // => [2, 3]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.takeRightWhile(users, { 'user': 'pebbles', 'active': false }), 'user');
	     * // => ['pebbles']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.takeRightWhile(users, 'active', false), 'user');
	     * // => ['fred', 'pebbles']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.takeRightWhile(users, 'active'), 'user');
	     * // => []
	     */
	    function takeRightWhile(array, predicate, thisArg) {
	      return (array && array.length)
	        ? baseWhile(array, getCallback(predicate, thisArg, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is bound to
	     * `thisArg` and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeWhile([1, 2, 3], function(n) {
	     *   return n < 3;
	     * });
	     * // => [1, 2]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false},
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.takeWhile(users, { 'user': 'barney', 'active': false }), 'user');
	     * // => ['barney']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.takeWhile(users, 'active', false), 'user');
	     * // => ['barney', 'fred']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.takeWhile(users, 'active'), 'user');
	     * // => []
	     */
	    function takeWhile(array, predicate, thisArg) {
	      return (array && array.length)
	        ? baseWhile(array, getCallback(predicate, thisArg, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all of the provided arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([1, 2], [4, 2], [2, 1]);
	     * // => [1, 2, 4]
	     */
	    var union = restParam(function(arrays) {
	      return baseUniq(baseFlatten(arrays, false, true));
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurence of each element
	     * is kept. Providing `true` for `isSorted` performs a faster search algorithm
	     * for sorted arrays. If an iteratee function is provided it's invoked for
	     * each element in the array to generate the criterion by which uniqueness
	     * is computed. The `iteratee` is bound to `thisArg` and invoked with three
	     * arguments: (value, index, array).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias unique
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {boolean} [isSorted] Specify the array is sorted.
	     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new duplicate-value-free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     *
	     * // using `isSorted`
	     * _.uniq([1, 1, 2], true);
	     * // => [1, 2]
	     *
	     * // using an iteratee function
	     * _.uniq([1, 2.5, 1.5, 2], function(n) {
	     *   return this.floor(n);
	     * }, Math);
	     * // => [1, 2.5]
	     *
	     * // using the `_.property` callback shorthand
	     * _.uniq([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniq(array, isSorted, iteratee, thisArg) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (isSorted != null && typeof isSorted != 'boolean') {
	        thisArg = iteratee;
	        iteratee = isIterateeCall(array, isSorted, thisArg) ? undefined : isSorted;
	        isSorted = false;
	      }
	      var callback = getCallback();
	      if (!(iteratee == null && callback === baseCallback)) {
	        iteratee = callback(iteratee, thisArg, 3);
	      }
	      return (isSorted && getIndexOf() === baseIndexOf)
	        ? sortedUniq(array, iteratee)
	        : baseUniq(array, iteratee);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['fred', 'barney'], [30, 40], [true, false]);
	     * // => [['fred', 30, true], ['barney', 40, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['fred', 'barney'], [30, 40], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var index = -1,
	          length = 0;
	
	      array = arrayFilter(array, function(group) {
	        if (isArrayLike(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = arrayMap(array, baseProperty(index));
	      }
	      return result;
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts an iteratee to specify
	     * how regrouped values should be combined. The `iteratee` is bound to `thisArg`
	     * and invoked with four arguments: (accumulator, value, index, group).
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee] The function to combine regrouped values.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee, thisArg) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      iteratee = bindCallback(iteratee, thisArg, 4);
	      return arrayMap(result, function(group) {
	        return arrayReduce(group, iteratee, undefined, true);
	      });
	    }
	
	    /**
	     * Creates an array excluding all provided values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to filter.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.without([1, 2, 1, 3], 1, 2);
	     * // => [3]
	     */
	    var without = restParam(function(array, values) {
	      return isArrayLike(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the provided arrays.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of values.
	     * @example
	     *
	     * _.xor([1, 2], [4, 2]);
	     * // => [1, 4]
	     */
	    function xor() {
	      var index = -1,
	          length = arguments.length;
	
	      while (++index < length) {
	        var array = arguments[index];
	        if (isArrayLike(array)) {
	          var result = result
	            ? arrayPush(baseDifference(result, array), baseDifference(array, result))
	            : array;
	        }
	      }
	      return result ? baseUniq(result) : [];
	    }
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the first
	     * elements of the given arrays, the second of which contains the second elements
	     * of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['fred', 'barney'], [30, 40], [true, false]);
	     * // => [['fred', 30, true], ['barney', 40, false]]
	     */
	    var zip = restParam(unzip);
	
	    /**
	     * The inverse of `_.pairs`; this method returns an object composed from arrays
	     * of property names and values. Provide either a single two dimensional array,
	     * e.g. `[[key1, value1], [key2, value2]]` or two arrays, one of property names
	     * and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @alias object
	     * @category Array
	     * @param {Array} props The property names.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject([['fred', 30], ['barney', 40]]);
	     * // => { 'fred': 30, 'barney': 40 }
	     *
	     * _.zipObject(['fred', 'barney'], [30, 40]);
	     * // => { 'fred': 30, 'barney': 40 }
	     */
	    function zipObject(props, values) {
	      var index = -1,
	          length = props ? props.length : 0,
	          result = {};
	
	      if (length && !values && !isArray(props[0])) {
	        values = [];
	      }
	      while (++index < length) {
	        var key = props[index];
	        if (values) {
	          result[key] = values[index];
	        } else if (key) {
	          result[key[0]] = key[1];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an iteratee to specify
	     * how grouped values should be combined. The `iteratee` is bound to `thisArg`
	     * and invoked with four arguments: (accumulator, value, index, group).
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee] The function to combine grouped values.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], _.add);
	     * // => [111, 222]
	     */
	    var zipWith = restParam(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 2 ? arrays[length - 2] : undefined,
	          thisArg = length > 1 ? arrays[length - 1] : undefined;
	
	      if (length > 2 && typeof iteratee == 'function') {
	        length -= 2;
	      } else {
	        iteratee = (length > 1 && typeof thisArg == 'function') ? (--length, thisArg) : undefined;
	        thisArg = undefined;
	      }
	      arrays.length = length;
	      return unzipWith(arrays, iteratee, thisArg);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object that wraps `value` with explicit method
	     * chaining enabled.
	     *
	     * @static
	     * @memberOf _
	     * @category Chain
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _.chain(users)
	     *   .sortBy('age')
	     *   .map(function(chr) {
	     *     return chr.user + ' is ' + chr.age;
	     *   })
	     *   .first()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor is
	     * bound to `thisArg` and invoked with one argument; (value). The purpose of
	     * this method is to "tap into" a method chain in order to perform operations
	     * on intermediate results within the chain.
	     *
	     * @static
	     * @memberOf _
	     * @category Chain
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @param {*} [thisArg] The `this` binding of `interceptor`.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor, thisArg) {
	      interceptor.call(thisArg, value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     *
	     * @static
	     * @memberOf _
	     * @category Chain
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @param {*} [thisArg] The `this` binding of `interceptor`.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor, thisArg) {
	      return interceptor.call(thisArg, value);
	    }
	
	    /**
	     * Enables explicit method chaining on the wrapper object.
	     *
	     * @name chain
	     * @memberOf _
	     * @category Chain
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // without explicit chaining
	     * _(users).first();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // with explicit chaining
	     * _(users).chain()
	     *   .first()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chained sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @category Chain
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Creates a new array joining a wrapped array with any additional arrays
	     * and/or values.
	     *
	     * @name concat
	     * @memberOf _
	     * @category Chain
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var wrapped = _(array).concat(2, [3], [[4]]);
	     *
	     * console.log(wrapped.value());
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    var wrapperConcat = restParam(function(values) {
	      values = baseFlatten(values);
	      return this.thru(function(array) {
	        return arrayConcat(isArray(array) ? array : [toObject(array)], values);
	      });
	    });
	
	    /**
	     * Creates a clone of the chained sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @category Chain
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).map(function(value) {
	     *   return Math.pow(value, 2);
	     * });
	     *
	     * var other = [3, 4];
	     * var otherWrapped = wrapped.plant(other);
	     *
	     * otherWrapped.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * Reverses the wrapped array so the first element becomes the last, the
	     * second element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @category Chain
	     * @returns {Object} Returns the new reversed `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	
	      var interceptor = function(value) {
	        return value.reverse();
	      };
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(interceptor);
	    }
	
	    /**
	     * Produces the result of coercing the unwrapped value to a string.
	     *
	     * @name toString
	     * @memberOf _
	     * @category Chain
	     * @returns {string} Returns the coerced string value.
	     * @example
	     *
	     * _([1, 2, 3]).toString();
	     * // => '1,2,3'
	     */
	    function wrapperToString() {
	      return (this.value() + '');
	    }
	
	    /**
	     * Executes the chained sequence to extract the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @alias run, toJSON, valueOf
	     * @category Chain
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements corresponding to the given keys, or indexes,
	     * of `collection`. Keys may be specified as individual arguments or as arrays
	     * of keys.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {...(number|number[]|string|string[])} [props] The property names
	     *  or indexes of elements to pick, specified individually or in arrays.
	     * @returns {Array} Returns the new array of picked elements.
	     * @example
	     *
	     * _.at(['a', 'b', 'c'], [0, 2]);
	     * // => ['a', 'c']
	     *
	     * _.at(['barney', 'fred', 'pebbles'], 0, 2);
	     * // => ['barney', 'pebbles']
	     */
	    var at = restParam(function(collection, props) {
	      return baseAt(collection, baseFlatten(props));
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` through `iteratee`. The corresponding value
	     * of each key is the number of times the key was returned by `iteratee`.
	     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([4.3, 6.1, 6.4], function(n) {
	     *   return Math.floor(n);
	     * });
	     * // => { '4': 1, '6': 2 }
	     *
	     * _.countBy([4.3, 6.1, 6.4], function(n) {
	     *   return this.floor(n);
	     * }, Math);
	     * // => { '4': 1, '6': 2 }
	     *
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      hasOwnProperty.call(result, key) ? ++result[key] : (result[key] = 1);
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * The predicate is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias all
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': false },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.every(users, 'active', false);
	     * // => true
	     *
	     * // using the `_.property` callback shorthand
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, thisArg) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (thisArg && isIterateeCall(collection, predicate, thisArg)) {
	        predicate = undefined;
	      }
	      if (typeof predicate != 'function' || thisArg !== undefined) {
	        predicate = getCallback(predicate, thisArg, 3);
	      }
	      return func(collection, predicate);
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is bound to `thisArg` and
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias select
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the new filtered array.
	     * @example
	     *
	     * _.filter([4, 5, 6], function(n) {
	     *   return n % 2 == 0;
	     * });
	     * // => [4, 6]
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.filter(users, { 'age': 36, 'active': true }), 'user');
	     * // => ['barney']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.filter(users, 'active', false), 'user');
	     * // => ['fred']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.filter(users, 'active'), 'user');
	     * // => ['barney']
	     */
	    function filter(collection, predicate, thisArg) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      predicate = getCallback(predicate, thisArg, 3);
	      return func(collection, predicate);
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is bound to `thisArg` and
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias detect
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.result(_.find(users, function(chr) {
	     *   return chr.age < 40;
	     * }), 'user');
	     * // => 'barney'
	     *
	     * // using the `_.matches` callback shorthand
	     * _.result(_.find(users, { 'age': 1, 'active': true }), 'user');
	     * // => 'pebbles'
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.result(_.find(users, 'active', false), 'user');
	     * // => 'fred'
	     *
	     * // using the `_.property` callback shorthand
	     * _.result(_.find(users, 'active'), 'user');
	     * // => 'barney'
	     */
	    var find = createFind(baseEach);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(baseEachRight, true);
	
	    /**
	     * Performs a deep comparison between each element in `collection` and the
	     * source object, returning the first element that has equivalent property
	     * values.
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties. For comparing a single
	     * own or inherited property value see `_.matchesProperty`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Object} source The object of property values to match.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.result(_.findWhere(users, { 'age': 36, 'active': true }), 'user');
	     * // => 'barney'
	     *
	     * _.result(_.findWhere(users, { 'age': 40, 'active': false }), 'user');
	     * // => 'fred'
	     */
	    function findWhere(collection, source) {
	      return find(collection, baseMatches(source));
	    }
	
	    /**
	     * Iterates over elements of `collection` invoking `iteratee` for each element.
	     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection). Iteratee functions may exit iteration early
	     * by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length" property
	     * are iterated like arrays. To avoid this behavior `_.forIn` or `_.forOwn`
	     * may be used for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @alias each
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array|Object|string} Returns `collection`.
	     * @example
	     *
	     * _([1, 2]).forEach(function(n) {
	     *   console.log(n);
	     * }).value();
	     * // => logs each value from left to right and returns the array
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(n, key) {
	     *   console.log(n, key);
	     * });
	     * // => logs each value-key pair and returns the object (iteration order is not guaranteed)
	     */
	    var forEach = createForEach(arrayEach, baseEach);
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array|Object|string} Returns `collection`.
	     * @example
	     *
	     * _([1, 2]).forEachRight(function(n) {
	     *   console.log(n);
	     * }).value();
	     * // => logs each value from right to left and returns the array
	     */
	    var forEachRight = createForEach(arrayEachRight, baseEachRight);
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` through `iteratee`. The corresponding value
	     * of each key is an array of the elements responsible for generating the key.
	     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([4.2, 6.1, 6.4], function(n) {
	     *   return Math.floor(n);
	     * });
	     * // => { '4': [4.2], '6': [6.1, 6.4] }
	     *
	     * _.groupBy([4.2, 6.1, 6.4], function(n) {
	     *   return this.floor(n);
	     * }, Math);
	     * // => { '4': [4.2], '6': [6.1, 6.4] }
	     *
	     * // using the `_.property` callback shorthand
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        result[key] = [value];
	      }
	    });
	
	    /**
	     * Checks if `target` is in `collection` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the offset
	     * from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @alias contains, include
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {*} target The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.reduce`.
	     * @returns {boolean} Returns `true` if a matching element is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'user': 'fred', 'age': 40 }, 'fred');
	     * // => true
	     *
	     * _.includes('pebbles', 'eb');
	     * // => true
	     */
	    function includes(collection, target, fromIndex, guard) {
	      var length = collection ? getLength(collection) : 0;
	      if (!isLength(length)) {
	        collection = values(collection);
	        length = collection.length;
	      }
	      if (typeof fromIndex != 'number' || (guard && isIterateeCall(target, fromIndex, guard))) {
	        fromIndex = 0;
	      } else {
	        fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : (fromIndex || 0);
	      }
	      return (typeof collection == 'string' || !isArray(collection) && isString(collection))
	        ? (fromIndex <= length && collection.indexOf(target, fromIndex) > -1)
	        : (!!length && getIndexOf(collection, target, fromIndex) > -1);
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` through `iteratee`. The corresponding value
	     * of each key is the last element responsible for generating the key. The
	     * iteratee function is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var keyData = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.indexBy(keyData, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.indexBy(keyData, function(object) {
	     *   return String.fromCharCode(object.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.indexBy(keyData, function(object) {
	     *   return this.fromCharCode(object.code);
	     * }, String);
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     */
	    var indexBy = createAggregator(function(result, value, key) {
	      result[key] = value;
	    });
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `methodName` is a function it's
	     * invoked for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invoke([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invoke([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invoke = restParam(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          isProp = isKey(path),
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        var func = isFunc ? path : ((isProp && value != null) ? value[path] : undefined);
	        result[++index] = func ? func.apply(value, args) : invokePath(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` through
	     * `iteratee`. The `iteratee` is bound to `thisArg` and invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `callback`, `chunk`, `clone`, `create`, `curry`, `curryRight`,
	     * `drop`, `dropRight`, `every`, `fill`, `flatten`, `invert`, `max`, `min`,
	     * `parseInt`, `slice`, `sortBy`, `take`, `takeRight`, `template`, `trim`,
	     * `trimLeft`, `trimRight`, `trunc`, `random`, `range`, `sample`, `some`,
	     * `sum`, `uniq`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @alias collect
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function timesThree(n) {
	     *   return n * 3;
	     * }
	     *
	     * _.map([1, 2], timesThree);
	     * // => [3, 6]
	     *
	     * _.map({ 'a': 1, 'b': 2 }, timesThree);
	     * // => [3, 6] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // using the `_.property` callback shorthand
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee, thisArg) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      iteratee = getCallback(iteratee, thisArg, 3);
	      return func(collection, iteratee);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, while the second of which
	     * contains elements `predicate` returns falsey for. The predicate is bound
	     * to `thisArg` and invoked with three arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * _.partition([1, 2, 3], function(n) {
	     *   return n % 2;
	     * });
	     * // => [[1, 3], [2]]
	     *
	     * _.partition([1.2, 2.3, 3.4], function(n) {
	     *   return this.floor(n) % 2;
	     * }, Math);
	     * // => [[1.2, 3.4], [2.3]]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * var mapper = function(array) {
	     *   return _.pluck(array, 'user');
	     * };
	     *
	     * // using the `_.matches` callback shorthand
	     * _.map(_.partition(users, { 'age': 1, 'active': false }), mapper);
	     * // => [['pebbles'], ['barney', 'fred']]
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.map(_.partition(users, 'active', false), mapper);
	     * // => [['barney', 'pebbles'], ['fred']]
	     *
	     * // using the `_.property` callback shorthand
	     * _.map(_.partition(users, 'active'), mapper);
	     * // => [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Gets the property value of `path` from all elements in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Array|string} path The path of the property to pluck.
	     * @returns {Array} Returns the property values.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * _.pluck(users, 'user');
	     * // => ['barney', 'fred']
	     *
	     * var userIndex = _.indexBy(users, 'user');
	     * _.pluck(userIndex, 'age');
	     * // => [36, 40] (iteration order is not guaranteed)
	     */
	    function pluck(collection, path) {
	      return map(collection, property(path));
	    }
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` through `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not provided the first element of `collection` is used as the initial
	     * value. The `iteratee` is bound to `thisArg` and invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `sortByAll`,
	     * and `sortByOrder`
	     *
	     * @static
	     * @memberOf _
	     * @alias foldl, inject
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.reduce([1, 2], function(total, n) {
	     *   return total + n;
	     * });
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2 }, function(result, n, key) {
	     *   result[key] = n * 3;
	     *   return result;
	     * }, {});
	     * // => { 'a': 3, 'b': 6 } (iteration order is not guaranteed)
	     */
	    var reduce = createReduce(arrayReduce, baseEach);
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @alias foldr
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    var reduceRight = createReduce(arrayReduceRight, baseEachRight);
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the new filtered array.
	     * @example
	     *
	     * _.reject([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 0;
	     * });
	     * // => [1, 3]
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.reject(users, { 'age': 40, 'active': true }), 'user');
	     * // => ['barney']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.reject(users, 'active', false), 'user');
	     * // => ['fred']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.reject(users, 'active'), 'user');
	     * // => ['barney']
	     */
	    function reject(collection, predicate, thisArg) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      predicate = getCallback(predicate, thisArg, 3);
	      return func(collection, function(value, index, collection) {
	        return !predicate(value, index, collection);
	      });
	    }
	
	    /**
	     * Gets a random element or `n` random elements from a collection.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to sample.
	     * @param {number} [n] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {*} Returns the random sample(s).
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     *
	     * _.sample([1, 2, 3, 4], 2);
	     * // => [3, 1]
	     */
	    function sample(collection, n, guard) {
	      if (guard ? isIterateeCall(collection, n, guard) : n == null) {
	        collection = toIterable(collection);
	        var length = collection.length;
	        return length > 0 ? collection[baseRandom(0, length - 1)] : undefined;
	      }
	      var index = -1,
	          result = toArray(collection),
	          length = result.length,
	          lastIndex = length - 1;
	
	      n = nativeMin(n < 0 ? 0 : (+n || 0), length);
	      while (++index < n) {
	        var rand = baseRandom(index, lastIndex),
	            value = result[rand];
	
	        result[rand] = result[index];
	        result[index] = value;
	      }
	      result.length = n;
	      return result;
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      return sample(collection, POSITIVE_INFINITY);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the size of `collection`.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      var length = collection ? getLength(collection) : 0;
	      return isLength(length) ? length : keys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * The function returns as soon as it finds a passing value and does not iterate
	     * over the entire collection. The predicate is bound to `thisArg` and invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias any
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.some(users, 'active', false);
	     * // => true
	     *
	     * // using the `_.property` callback shorthand
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, thisArg) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (thisArg && isIterateeCall(collection, predicate, thisArg)) {
	        predicate = undefined;
	      }
	      if (typeof predicate != 'function' || thisArg !== undefined) {
	        predicate = getCallback(predicate, thisArg, 3);
	      }
	      return func(collection, predicate);
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection through `iteratee`. This method performs
	     * a stable sort, that is, it preserves the original sort order of equal elements.
	     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * _.sortBy([1, 2, 3], function(n) {
	     *   return Math.sin(n);
	     * });
	     * // => [3, 1, 2]
	     *
	     * _.sortBy([1, 2, 3], function(n) {
	     *   return this.sin(n);
	     * }, Math);
	     * // => [3, 1, 2]
	     *
	     * var users = [
	     *   { 'user': 'fred' },
	     *   { 'user': 'pebbles' },
	     *   { 'user': 'barney' }
	     * ];
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.sortBy(users, 'user'), 'user');
	     * // => ['barney', 'fred', 'pebbles']
	     */
	    function sortBy(collection, iteratee, thisArg) {
	      if (collection == null) {
	        return [];
	      }
	      if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
	        iteratee = undefined;
	      }
	      var index = -1;
	      iteratee = getCallback(iteratee, thisArg, 3);
	
	      var result = baseMap(collection, function(value, key, collection) {
	        return { 'criteria': iteratee(value, key, collection), 'index': ++index, 'value': value };
	      });
	      return baseSortBy(result, compareAscending);
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it can sort by multiple iteratees
	     * or property names.
	     *
	     * If a property name is provided for an iteratee the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If an object is provided for an iteratee the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {...(Function|Function[]|Object|Object[]|string|string[])} iteratees
	     *  The iteratees to sort by, specified as individual values or arrays of values.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 42 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.map(_.sortByAll(users, ['user', 'age']), _.values);
	     * // => [['barney', 34], ['barney', 36], ['fred', 42], ['fred', 48]]
	     *
	     * _.map(_.sortByAll(users, 'user', function(chr) {
	     *   return Math.floor(chr.age / 10);
	     * }), _.values);
	     * // => [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
	     */
	    var sortByAll = restParam(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var guard = iteratees[2];
	      if (guard && isIterateeCall(iteratees[0], iteratees[1], guard)) {
	        iteratees.length = 1;
	      }
	      return baseSortByOrder(collection, baseFlatten(iteratees), []);
	    });
	
	    /**
	     * This method is like `_.sortByAll` except that it allows specifying the
	     * sort orders of the iteratees to sort by. If `orders` is unspecified, all
	     * values are sorted in ascending order. Otherwise, a value is sorted in
	     * ascending order if its corresponding order is "asc", and descending if "desc".
	     *
	     * If a property name is provided for an iteratee the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If an object is provided for an iteratee the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {boolean[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 42 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // sort by `user` in ascending order and by `age` in descending order
	     * _.map(_.sortByOrder(users, ['user', 'age'], ['asc', 'desc']), _.values);
	     * // => [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
	     */
	    function sortByOrder(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (guard && isIterateeCall(iteratees, orders, guard)) {
	        orders = undefined;
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseSortByOrder(collection, iteratees, orders);
	    }
	
	    /**
	     * Performs a deep comparison between each element in `collection` and the
	     * source object, returning an array of all elements that have equivalent
	     * property values.
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties. For comparing a single
	     * own or inherited property value see `_.matchesProperty`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Object} source The object of property values to match.
	     * @returns {Array} Returns the new filtered array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false, 'pets': ['hoppy'] },
	     *   { 'user': 'fred',   'age': 40, 'active': true, 'pets': ['baby puss', 'dino'] }
	     * ];
	     *
	     * _.pluck(_.where(users, { 'age': 36, 'active': false }), 'user');
	     * // => ['barney']
	     *
	     * _.pluck(_.where(users, { 'pets': ['dino'] }), 'user');
	     * // => ['fred']
	     */
	    function where(collection, source) {
	      return filter(collection, baseMatches(source));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the number of milliseconds that have elapsed since the Unix epoch
	     * (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @category Date
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => logs the number of milliseconds it took for the deferred function to be invoked
	     */
	    var now = nativeNow || function() {
	      return new Date().getTime();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => logs 'done saving!' after the two async saves have completed
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        if (typeof n == 'function') {
	          var temp = n;
	          n = func;
	          func = temp;
	        } else {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	      }
	      n = nativeIsFinite(n = +n) ? n : 0;
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that accepts up to `n` arguments ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      if (guard && isIterateeCall(func, n, guard)) {
	        n = undefined;
	      }
	      n = (func && n == null) ? func.length : nativeMax(+n || 0, 0);
	      return createWrapper(func, ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery('#add').on('click', _.before(5, addContactToList));
	     * // => allows adding up to 4 contacts to the list
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        if (typeof n == 'function') {
	          var temp = n;
	          n = func;
	          func = temp;
	        } else {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	      }
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and prepends any additional `_.bind` arguments to those provided to the
	     * bound function.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind` this method does not set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var greet = function(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * };
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // using placeholders
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = restParam(function(func, thisArg, partials) {
	      var bitmask = BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, bind.placeholder);
	        bitmask |= PARTIAL_FLAG;
	      }
	      return createWrapper(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method. Method names may be specified as individual arguments or as arrays
	     * of method names. If no method names are provided all enumerable function
	     * properties, own and inherited, of `object` are bound.
	     *
	     * **Note:** This method does not set the "length" property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} [methodNames] The object method names to bind,
	     *  specified as individual method names or arrays of method names.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'onClick': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view);
	     * jQuery('#docs').on('click', view.onClick);
	     * // => logs 'clicked docs' when the element is clicked
	     */
	    var bindAll = restParam(function(object, methodNames) {
	      methodNames = methodNames.length ? baseFlatten(methodNames) : functions(object);
	
	      var index = -1,
	          length = methodNames.length;
	
	      while (++index < length) {
	        var key = methodNames[index];
	        object[key] = createWrapper(object[key], BIND_FLAG, object);
	      }
	      return object;
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` and prepends
	     * any additional `_.bindKey` arguments to those provided to the bound function.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist.
	     * See [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Object} object The object the method belongs to.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // using placeholders
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = restParam(function(object, key, partials) {
	      var bitmask = BIND_FLAG | BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, bindKey.placeholder);
	        bitmask |= PARTIAL_FLAG;
	      }
	      return createWrapper(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts one or more arguments of `func` that when
	     * called either invokes `func` returning its result, if all `func` arguments
	     * have been provided, or returns a function that accepts one or more of the
	     * remaining `func` arguments, and so on. The arity of `func` may be specified
	     * if `func.length` is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method does not set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // using placeholders
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    var curry = createCurry(CURRY_FLAG);
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method does not set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // using placeholders
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    var curryRight = createCurry(CURRY_RIGHT_FLAG);
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed invocations. Provide an options object to indicate that `func`
	     * should be invoked on the leading and/or trailing edge of the `wait` timeout.
	     * Subsequent calls to the debounced function return the result of the last
	     * `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
	     * on the trailing edge of the timeout only if the the debounced function is
	     * invoked more than once during the `wait` timeout.
	     *
	     * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options] The options object.
	     * @param {boolean} [options.leading=false] Specify invoking on the leading
	     *  edge of the timeout.
	     * @param {number} [options.maxWait] The maximum time `func` is allowed to be
	     *  delayed before it's invoked.
	     * @param {boolean} [options.trailing=true] Specify invoking on the trailing
	     *  edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // avoid costly calculations while the window size is in flux
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // invoke `sendMail` when the click event is fired, debouncing subsequent calls
	     * jQuery('#postbox').on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // ensure `batchLog` is invoked once after 1 second of debounced calls
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', _.debounce(batchLog, 250, {
	     *   'maxWait': 1000
	     * }));
	     *
	     * // cancel a debounced call
	     * var todoChanges = _.debounce(batchLog, 1000);
	     * Object.observe(models.todo, todoChanges);
	     *
	     * Object.observe(models, function(changes) {
	     *   if (_.find(changes, { 'user': 'todo', 'type': 'delete'})) {
	     *     todoChanges.cancel();
	     *   }
	     * }, ['delete']);
	     *
	     * // ...at some point `models.todo` is changed
	     * models.todo.completed = true;
	     *
	     * // ...before 1 second has passed `models.todo` is deleted
	     * // which cancels the debounced `todoChanges` call
	     * delete models.todo;
	     */
	    function debounce(func, wait, options) {
	      var args,
	          maxTimeoutId,
	          result,
	          stamp,
	          thisArg,
	          timeoutId,
	          trailingCall,
	          lastCalled = 0,
	          maxWait = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = wait < 0 ? 0 : (+wait || 0);
	      if (options === true) {
	        var leading = true;
	        trailing = false;
	      } else if (isObject(options)) {
	        leading = !!options.leading;
	        maxWait = 'maxWait' in options && nativeMax(+options.maxWait || 0, wait);
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function cancel() {
	        if (timeoutId) {
	          clearTimeout(timeoutId);
	        }
	        if (maxTimeoutId) {
	          clearTimeout(maxTimeoutId);
	        }
	        lastCalled = 0;
	        maxTimeoutId = timeoutId = trailingCall = undefined;
	      }
	
	      function complete(isCalled, id) {
	        if (id) {
	          clearTimeout(id);
	        }
	        maxTimeoutId = timeoutId = trailingCall = undefined;
	        if (isCalled) {
	          lastCalled = now();
	          result = func.apply(thisArg, args);
	          if (!timeoutId && !maxTimeoutId) {
	            args = thisArg = undefined;
	          }
	        }
	      }
	
	      function delayed() {
	        var remaining = wait - (now() - stamp);
	        if (remaining <= 0 || remaining > wait) {
	          complete(trailingCall, maxTimeoutId);
	        } else {
	          timeoutId = setTimeout(delayed, remaining);
	        }
	      }
	
	      function maxDelayed() {
	        complete(trailing, timeoutId);
	      }
	
	      function debounced() {
	        args = arguments;
	        stamp = now();
	        thisArg = this;
	        trailingCall = trailing && (timeoutId || !leading);
	
	        if (maxWait === false) {
	          var leadingCall = leading && !timeoutId;
	        } else {
	          if (!maxTimeoutId && !leading) {
	            lastCalled = stamp;
	          }
	          var remaining = maxWait - (stamp - lastCalled),
	              isCalled = remaining <= 0 || remaining > maxWait;
	
	          if (isCalled) {
	            if (maxTimeoutId) {
	              maxTimeoutId = clearTimeout(maxTimeoutId);
	            }
	            lastCalled = stamp;
	            result = func.apply(thisArg, args);
	          }
	          else if (!maxTimeoutId) {
	            maxTimeoutId = setTimeout(maxDelayed, remaining);
	          }
	        }
	        if (isCalled && timeoutId) {
	          timeoutId = clearTimeout(timeoutId);
	        }
	        else if (!timeoutId && wait !== maxWait) {
	          timeoutId = setTimeout(delayed, wait);
	        }
	        if (leadingCall) {
	          isCalled = true;
	          result = func.apply(thisArg, args);
	        }
	        if (isCalled && !timeoutId && !maxTimeoutId) {
	          args = thisArg = undefined;
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke the function with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // logs 'deferred' after one or more milliseconds
	     */
	    var defer = restParam(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke the function with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => logs 'later' after one second
	     */
	    var delay = restParam(function(func, wait, args) {
	      return baseDelay(func, wait, args);
	    });
	
	    /**
	     * Creates a function that returns the result of invoking the provided
	     * functions with the `this` binding of the created function, where each
	     * successive invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {...Function} [funcs] Functions to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow(_.add, square);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the provided functions from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @alias backflow, compose
	     * @category Function
	     * @param {...Function} [funcs] Functions to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight(square, _.add);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is coerced to a string and used as the
	     * cache key. The `func` is invoked with the `this` binding of the memoized
	     * function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the [`Map`](http://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoizing function.
	     * @example
	     *
	     * var upperCase = _.memoize(function(string) {
	     *   return string.toUpperCase();
	     * });
	     *
	     * upperCase('fred');
	     * // => 'FRED'
	     *
	     * // modifying the result cache
	     * upperCase.cache.set('fred', 'BARNEY');
	     * upperCase('fred');
	     * // => 'BARNEY'
	     *
	     * // replacing `_.memoize.Cache`
	     * var object = { 'user': 'fred' };
	     * var other = { 'user': 'barney' };
	     * var identity = _.memoize(_.identity);
	     *
	     * identity(object);
	     * // => { 'user': 'fred' }
	     * identity(other);
	     * // => { 'user': 'fred' }
	     *
	     * _.memoize.Cache = WeakMap;
	     * var identity = _.memoize(_.identity);
	     *
	     * identity(object);
	     * // => { 'user': 'fred' }
	     * identity(other);
	     * // => { 'user': 'barney' }
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result);
	        return result;
	      };
	      memoized.cache = new memoize.Cache;
	      return memoized;
	    }
	
	    /**
	     * Creates a function that runs each argument through a corresponding
	     * transform function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms] The functions to transform
	     * arguments, specified as individual functions or arrays of functions.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var modded = _.modArgs(function(x, y) {
	     *   return [x, y];
	     * }, square, doubled);
	     *
	     * modded(1, 2);
	     * // => [1, 4]
	     *
	     * modded(5, 10);
	     * // => [25, 20]
	     */
	    var modArgs = restParam(function(func, transforms) {
	      transforms = baseFlatten(transforms);
	      if (typeof func != 'function' || !arrayEvery(transforms, baseIsFunction)) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = transforms.length;
	      return restParam(function(args) {
	        var index = nativeMin(args.length, length);
	        while (index--) {
	          args[index] = transforms[index](args[index]);
	        }
	        return func.apply(this, args);
	      });
	    });
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        return !predicate.apply(this, arguments);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first call. The `func` is invoked
	     * with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // `initialize` invokes `createApplication` once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with `partial` arguments prepended
	     * to those provided to the new function. This method is like `_.bind` except
	     * it does **not** alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method does not set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * var greet = function(greeting, name) {
	     *   return greeting + ' ' + name;
	     * };
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // using placeholders
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = createPartial(PARTIAL_FLAG);
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to those provided to the new function.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method does not set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * var greet = function(greeting, name) {
	     *   return greeting + ' ' + name;
	     * };
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // using placeholders
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = createPartial(PARTIAL_RIGHT_FLAG);
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified indexes where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes,
	     *  specified as individual indexes or arrays of indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, 2, 0, 1);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     *
	     * var map = _.rearg(_.map, [1, 0]);
	     * map(function(n) {
	     *   return n * 3;
	     * }, [1, 2, 3]);
	     * // => [3, 6, 9]
	     */
	    var rearg = restParam(function(func, indexes) {
	      return createWrapper(func, REARG_FLAG, undefined, undefined, undefined, baseFlatten(indexes));
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as an array.
	     *
	     * **Note:** This method is based on the [rest parameter](https://developer.mozilla.org/Web/JavaScript/Reference/Functions/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.restParam(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function restParam(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = nativeMax(start === undefined ? (func.length - 1) : (+start || 0), 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            rest = Array(length);
	
	        while (++index < length) {
	          rest[index] = args[start + index];
	        }
	        switch (start) {
	          case 0: return func.call(this, rest);
	          case 1: return func.call(this, args[0], rest);
	          case 2: return func.call(this, args[0], args[1], rest);
	        }
	        var otherArgs = Array(start + 1);
	        index = -1;
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = rest;
	        return func.apply(this, otherArgs);
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the created
	     * function and an array of arguments much like [`Function#apply`](https://es5.github.io/#x15.3.4.3).
	     *
	     * **Note:** This method is based on the [spread operator](https://developer.mozilla.org/Web/JavaScript/Reference/Operators/Spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * // with a Promise
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function(array) {
	        return func.apply(this, array);
	      };
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed invocations. Provide an options object to indicate
	     * that `func` should be invoked on the leading and/or trailing edge of the
	     * `wait` timeout. Subsequent calls to the throttled function return the
	     * result of the last `func` call.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
	     * on the trailing edge of the timeout only if the the throttled function is
	     * invoked more than once during the `wait` timeout.
	     *
	     * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options] The options object.
	     * @param {boolean} [options.leading=true] Specify invoking on the leading
	     *  edge of the timeout.
	     * @param {boolean} [options.trailing=true] Specify invoking on the trailing
	     *  edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // avoid excessively updating the position while scrolling
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // invoke `renewToken` when the click event is fired, but not more than once every 5 minutes
	     * jQuery('.interactive').on('click', _.throttle(renewToken, 300000, {
	     *   'trailing': false
	     * }));
	     *
	     * // cancel a trailing throttled call
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (options === false) {
	        leading = false;
	      } else if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, { 'leading': leading, 'maxWait': +wait, 'trailing': trailing });
	    }
	
	    /**
	     * Creates a function that provides `value` to the wrapper function as its
	     * first argument. Any additional arguments provided to the function are
	     * appended to those provided to the wrapper function. The wrapper is invoked
	     * with the `this` binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} wrapper The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      wrapper = wrapper == null ? identity : wrapper;
	      return createWrapper(wrapper, PARTIAL_FLAG, undefined, [value], []);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a clone of `value`. If `isDeep` is `true` nested objects are cloned,
	     * otherwise they are assigned by reference. If `customizer` is provided it's
	     * invoked to produce the cloned values. If `customizer` returns `undefined`
	     * cloning is handled by the method instead. The `customizer` is bound to
	     * `thisArg` and invoked with up to three argument; (value [, index|key, object]).
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
	     * The enumerable properties of `arguments` objects and objects created by
	     * constructors other than `Object` are cloned to plain `Object` objects. An
	     * empty object is returned for uncloneable values such as functions, DOM nodes,
	     * Maps, Sets, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @param {Function} [customizer] The function to customize cloning values.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {*} Returns the cloned value.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * var shallow = _.clone(users);
	     * shallow[0] === users[0];
	     * // => true
	     *
	     * var deep = _.clone(users, true);
	     * deep[0] === users[0];
	     * // => false
	     *
	     * // using a customizer callback
	     * var el = _.clone(document.body, function(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * });
	     *
	     * el === document.body
	     * // => false
	     * el.nodeName
	     * // => BODY
	     * el.childNodes.length;
	     * // => 0
	     */
	    function clone(value, isDeep, customizer, thisArg) {
	      if (isDeep && typeof isDeep != 'boolean' && isIterateeCall(value, isDeep, customizer)) {
	        isDeep = false;
	      }
	      else if (typeof isDeep == 'function') {
	        thisArg = customizer;
	        customizer = isDeep;
	        isDeep = false;
	      }
	      return typeof customizer == 'function'
	        ? baseClone(value, isDeep, bindCallback(customizer, thisArg, 3))
	        : baseClone(value, isDeep);
	    }
	
	    /**
	     * Creates a deep clone of `value`. If `customizer` is provided it's invoked
	     * to produce the cloned values. If `customizer` returns `undefined` cloning
	     * is handled by the method instead. The `customizer` is bound to `thisArg`
	     * and invoked with up to three argument; (value [, index|key, object]).
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
	     * The enumerable properties of `arguments` objects and objects created by
	     * constructors other than `Object` are cloned to plain `Object` objects. An
	     * empty object is returned for uncloneable values such as functions, DOM nodes,
	     * Maps, Sets, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to deep clone.
	     * @param {Function} [customizer] The function to customize cloning values.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {*} Returns the deep cloned value.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * var deep = _.cloneDeep(users);
	     * deep[0] === users[0];
	     * // => false
	     *
	     * // using a customizer callback
	     * var el = _.cloneDeep(document.body, function(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * });
	     *
	     * el === document.body
	     * // => false
	     * el.nodeName
	     * // => BODY
	     * el.childNodes.length;
	     * // => 20
	     */
	    function cloneDeep(value, customizer, thisArg) {
	      return typeof customizer == 'function'
	        ? baseClone(value, true, bindCallback(customizer, thisArg, 3))
	        : baseClone(value, true);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`, else `false`.
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    function gt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to `other`, else `false`.
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    function gte(value, other) {
	      return value >= other;
	    }
	
	    /**
	     * Checks if `value` is classified as an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    function isArguments(value) {
	      return isObjectLike(value) && isArrayLike(value) &&
	        hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
	    }
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(function() { return arguments; }());
	     * // => false
	     */
	    var isArray = nativeIsArray || function(value) {
	      return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
	    };
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false || (isObjectLike(value) && objToString.call(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    function isDate(value) {
	      return isObjectLike(value) && objToString.call(value) == dateTag;
	    }
	
	    /**
	     * Checks if `value` is a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return !!value && value.nodeType === 1 && isObjectLike(value) && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is empty. A value is considered empty unless it's an
	     * `arguments` object, array, string, or jQuery-like collection with a length
	     * greater than `0` or an object with own enumerable properties.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {Array|Object|string} value The value to inspect.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) && (isArray(value) || isString(value) || isArguments(value) ||
	          (isObjectLike(value) && isFunction(value.splice)))) {
	        return !value.length;
	      }
	      return !keys(value).length;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent. If `customizer` is provided it's invoked to compare values.
	     * If `customizer` returns `undefined` comparisons are handled by the method
	     * instead. The `customizer` is bound to `thisArg` and invoked with up to
	     * three arguments: (value, other [, index|key]).
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties. Functions and DOM nodes
	     * are **not** supported. Provide a customizer function to extend support
	     * for comparing other values.
	     *
	     * @static
	     * @memberOf _
	     * @alias eq
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize value comparisons.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     * var other = { 'user': 'fred' };
	     *
	     * object == other;
	     * // => false
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * // using a customizer callback
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqual(array, other, function(value, other) {
	     *   if (_.every([value, other], RegExp.prototype.test, /^h(?:i|ello)$/)) {
	     *     return true;
	     *   }
	     * });
	     * // => true
	     */
	    function isEqual(value, other, customizer, thisArg) {
	      customizer = typeof customizer == 'function' ? bindCallback(customizer, thisArg, 3) : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return  result === undefined ? baseIsEqual(value, other, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      return isObjectLike(value) && typeof value.message == 'string' && objToString.call(value) == errorTag;
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on [`Number.isFinite`](http://ecma-international.org/ecma-262/6.0/#sec-number.isfinite).
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(10);
	     * // => true
	     *
	     * _.isFinite('10');
	     * // => false
	     *
	     * _.isFinite(true);
	     * // => false
	     *
	     * _.isFinite(Object(10));
	     * // => false
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in older versions of Chrome and Safari which return 'function' for regexes
	      // and Safari 8 which returns 'object' for typed array constructors.
	      return isObject(value) && objToString.call(value) == funcTag;
	    }
	
	    /**
	     * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	     * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(1);
	     * // => false
	     */
	    function isObject(value) {
	      // Avoid a V8 JIT bug in Chrome 19-20.
	      // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	      var type = typeof value;
	      return !!value && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Performs a deep comparison between `object` and `source` to determine if
	     * `object` contains equivalent property values. If `customizer` is provided
	     * it's invoked to compare values. If `customizer` returns `undefined`
	     * comparisons are handled by the method instead. The `customizer` is bound
	     * to `thisArg` and invoked with three arguments: (value, other, index|key).
	     *
	     * **Note:** This method supports comparing properties of arrays, booleans,
	     * `Date` objects, numbers, `Object` objects, regexes, and strings. Functions
	     * and DOM nodes are **not** supported. Provide a customizer function to extend
	     * support for comparing other values.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize value comparisons.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'user': 'fred', 'age': 40 };
	     *
	     * _.isMatch(object, { 'age': 40 });
	     * // => true
	     *
	     * _.isMatch(object, { 'age': 36 });
	     * // => false
	     *
	     * // using a customizer callback
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatch(object, source, function(value, other) {
	     *   return _.every([value, other], RegExp.prototype.test, /^h(?:i|ello)$/) || undefined;
	     * });
	     * // => true
	     */
	    function isMatch(object, source, customizer, thisArg) {
	      customizer = typeof customizer == 'function' ? bindCallback(customizer, thisArg, 3) : undefined;
	      return baseIsMatch(object, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is not the same as [`isNaN`](https://es5.github.io/#x15.1.2.4)
	     * which returns `true` for `undefined` and other non-numeric values.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some host objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a native function.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (value == null) {
	        return false;
	      }
	      if (isFunction(value)) {
	        return reIsNative.test(fnToString.call(value));
	      }
	      return isObjectLike(value) && reIsHostCtor.test(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are classified
	     * as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isNumber(8.4);
	     * // => true
	     *
	     * _.isNumber(NaN);
	     * // => true
	     *
	     * _.isNumber('8.4');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' || (isObjectLike(value) && objToString.call(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * **Note:** This method assumes objects created by the `Object` constructor
	     * have no inherited enumerable properties.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      var Ctor;
	
	      // Exit early for non `Object` objects.
	      if (!(isObjectLike(value) && objToString.call(value) == objectTag && !isArguments(value)) ||
	          (!hasOwnProperty.call(value, 'constructor') && (Ctor = value.constructor, typeof Ctor == 'function' && !(Ctor instanceof Ctor)))) {
	        return false;
	      }
	      // IE < 9 iterates inherited properties before own properties. If the first
	      // iterated property is an object's own property then there are no inherited
	      // enumerable properties.
	      var result;
	      // In most environments an object's own properties are iterated before
	      // its inherited properties. If the last iterated property is an object's
	      // own property then there are no inherited enumerable properties.
	      baseForIn(value, function(subValue, key) {
	        result = key;
	      });
	      return result === undefined || hasOwnProperty.call(value, result);
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    function isRegExp(value) {
	      return isObject(value) && objToString.call(value) == regexpTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' || (isObjectLike(value) && objToString.call(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    function isTypedArray(value) {
	      return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objToString.call(value)];
	    }
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`, else `false`.
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    function lt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to `other`, else `false`.
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    function lte(value, other) {
	      return value <= other;
	    }
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * (function() {
	     *   return _.toArray(arguments).slice(1);
	     * }(1, 2, 3));
	     * // => [2, 3]
	     */
	    function toArray(value) {
	      var length = value ? getLength(value) : 0;
	      if (!isLength(length)) {
	        return values(value);
	      }
	      if (!length) {
	        return [];
	      }
	      return arrayCopy(value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable
	     * properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return baseCopy(value, keysIn(value));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Recursively merges own enumerable properties of the source object(s), that
	     * don't resolve to `undefined` into the destination object. Subsequent sources
	     * overwrite property assignments of previous sources. If `customizer` is
	     * provided it's invoked to produce the merged values of the destination and
	     * source properties. If `customizer` returns `undefined` merging is handled
	     * by the method instead. The `customizer` is bound to `thisArg` and invoked
	     * with five arguments: (objectValue, sourceValue, key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var users = {
	     *   'data': [{ 'user': 'barney' }, { 'user': 'fred' }]
	     * };
	     *
	     * var ages = {
	     *   'data': [{ 'age': 36 }, { 'age': 40 }]
	     * };
	     *
	     * _.merge(users, ages);
	     * // => { 'data': [{ 'user': 'barney', 'age': 36 }, { 'user': 'fred', 'age': 40 }] }
	     *
	     * // using a customizer callback
	     * var object = {
	     *   'fruits': ['apple'],
	     *   'vegetables': ['beet']
	     * };
	     *
	     * var other = {
	     *   'fruits': ['banana'],
	     *   'vegetables': ['carrot']
	     * };
	     *
	     * _.merge(object, other, function(a, b) {
	     *   if (_.isArray(a)) {
	     *     return a.concat(b);
	     *   }
	     * });
	     * // => { 'fruits': ['apple', 'banana'], 'vegetables': ['beet', 'carrot'] }
	     */
	    var merge = createAssigner(baseMerge);
	
	    /**
	     * Assigns own enumerable properties of source object(s) to the destination
	     * object. Subsequent sources overwrite property assignments of previous sources.
	     * If `customizer` is provided it's invoked to produce the assigned values.
	     * The `customizer` is bound to `thisArg` and invoked with five arguments:
	     * (objectValue, sourceValue, key, object, source).
	     *
	     * **Note:** This method mutates `object` and is based on
	     * [`Object.assign`](http://ecma-international.org/ecma-262/6.0/#sec-object.assign).
	     *
	     * @static
	     * @memberOf _
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * _.assign({ 'user': 'barney' }, { 'age': 40 }, { 'user': 'fred' });
	     * // => { 'user': 'fred', 'age': 40 }
	     *
	     * // using a customizer callback
	     * var defaults = _.partialRight(_.assign, function(value, other) {
	     *   return _.isUndefined(value) ? other : value;
	     * });
	     *
	     * defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
	     * // => { 'user': 'barney', 'age': 36 }
	     */
	    var assign = createAssigner(function(object, source, customizer) {
	      return customizer
	        ? assignWith(object, source, customizer)
	        : baseAssign(object, source);
	    });
	
	    /**
	     * Creates an object that inherits from the given `prototype` object. If a
	     * `properties` object is provided its own enumerable properties are assigned
	     * to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties, guard) {
	      var result = baseCreate(prototype);
	      if (guard && isIterateeCall(prototype, properties, guard)) {
	        properties = undefined;
	      }
	      return properties ? baseAssign(result, properties) : result;
	    }
	
	    /**
	     * Assigns own enumerable properties of source object(s) to the destination
	     * object for all destination properties that resolve to `undefined`. Once a
	     * property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * _.defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
	     * // => { 'user': 'barney', 'age': 36 }
	     */
	    var defaults = createDefaults(assign, assignDefaults);
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * _.defaultsDeep({ 'user': { 'name': 'barney' } }, { 'user': { 'name': 'fred', 'age': 36 } });
	     * // => { 'user': { 'name': 'barney', 'age': 36 } }
	     *
	     */
	    var defaultsDeep = createDefaults(merge, mergeDefaults);
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(chr) {
	     *   return chr.age < 40;
	     * });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // using the `_.matches` callback shorthand
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.findKey(users, 'active', false);
	     * // => 'fred'
	     *
	     * // using the `_.property` callback shorthand
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    var findKey = createFindKey(baseForOwn);
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(chr) {
	     *   return chr.age < 40;
	     * });
	     * // => returns `pebbles` assuming `_.findKey` returns `barney`
	     *
	     * // using the `_.matches` callback shorthand
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.findLastKey(users, 'active', false);
	     * // => 'fred'
	     *
	     * // using the `_.property` callback shorthand
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    var findLastKey = createFindKey(baseForOwnRight);
	
	    /**
	     * Iterates over own and inherited enumerable properties of an object invoking
	     * `iteratee` for each property. The `iteratee` is bound to `thisArg` and invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'a', 'b', and 'c' (iteration order is not guaranteed)
	     */
	    var forIn = createForIn(baseFor);
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'c', 'b', and 'a' assuming `_.forIn ` logs 'a', 'b', and 'c'
	     */
	    var forInRight = createForIn(baseForRight);
	
	    /**
	     * Iterates over own enumerable properties of an object invoking `iteratee`
	     * for each property. The `iteratee` is bound to `thisArg` and invoked with
	     * three arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'a' and 'b' (iteration order is not guaranteed)
	     */
	    var forOwn = createForOwn(baseForOwn);
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'b' and 'a' assuming `_.forOwn` logs 'a' and 'b'
	     */
	    var forOwnRight = createForOwn(baseForOwnRight);
	
	    /**
	     * Creates an array of function property names from all enumerable properties,
	     * own and inherited, of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @alias methods
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the new array of property names.
	     * @example
	     *
	     * _.functions(_);
	     * // => ['after', 'ary', 'assign', ...]
	     */
	    function functions(object) {
	      return baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the property value at `path` of `object`. If the resolved value is
	     * `undefined` the `defaultValue` is used in its place.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, toPath(path), (path + ''));
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` is a direct property, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': { 'c': 3 } } };
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b.c');
	     * // => true
	     *
	     * _.has(object, ['a', 'b', 'c']);
	     * // => true
	     */
	    function has(object, path) {
	      if (object == null) {
	        return false;
	      }
	      var result = hasOwnProperty.call(object, path);
	      if (!result && !isKey(path)) {
	        path = toPath(path);
	        object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	        if (object == null) {
	          return false;
	        }
	        path = last(path);
	        result = hasOwnProperty.call(object, path);
	      }
	      return result || (isLength(object.length) && isIndex(path, object.length) &&
	        (isArray(object) || isArguments(object)));
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite property
	     * assignments of previous values unless `multiValue` is `true`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {boolean} [multiValue] Allow multiple values per key.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     *
	     * // with `multiValue`
	     * _.invert(object, true);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function invert(object, multiValue, guard) {
	      if (guard && isIterateeCall(object, multiValue, guard)) {
	        multiValue = undefined;
	      }
	      var index = -1,
	          props = keys(object),
	          length = props.length,
	          result = {};
	
	      while (++index < length) {
	        var key = props[index],
	            value = object[key];
	
	        if (multiValue) {
	          if (hasOwnProperty.call(result, value)) {
	            result[value].push(key);
	          } else {
	            result[value] = [key];
	          }
	        }
	        else {
	          result[value] = key;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    var keys = !nativeKeys ? shimKeys : function(object) {
	      var Ctor = object == null ? undefined : object.constructor;
	      if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
	          (typeof object != 'function' && isArrayLike(object))) {
	        return shimKeys(object);
	      }
	      return isObject(object) ? nativeKeys(object) : [];
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      if (object == null) {
	        return [];
	      }
	      if (!isObject(object)) {
	        object = Object(object);
	      }
	      var length = object.length;
	      length = (length && isLength(length) &&
	        (isArray(object) || isArguments(object)) && length) || 0;
	
	      var Ctor = object.constructor,
	          index = -1,
	          isProto = typeof Ctor == 'function' && Ctor.prototype === object,
	          result = Array(length),
	          skipIndexes = length > 0;
	
	      while (++index < length) {
	        result[index] = (index + '');
	      }
	      for (var key in object) {
	        if (!(skipIndexes && isIndex(key, length)) &&
	            !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * property of `object` through `iteratee`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the new mapped object.
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    var mapKeys = createObjectMapper(true);
	
	    /**
	     * Creates an object with the same keys as `object` and values generated by
	     * running each own enumerable property of `object` through `iteratee`. The
	     * iteratee function is bound to `thisArg` and invoked with three arguments:
	     * (value, key, object).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the new mapped object.
	     * @example
	     *
	     * _.mapValues({ 'a': 1, 'b': 2 }, function(n) {
	     *   return n * 3;
	     * });
	     * // => { 'a': 3, 'b': 6 }
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * // using the `_.property` callback shorthand
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    var mapValues = createObjectMapper();
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable properties of `object` that are not omitted.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function|...(string|string[])} [predicate] The function invoked per
	     *  iteration or property names to omit, specified as individual property
	     *  names or arrays of property names.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'user': 'fred', 'age': 40 };
	     *
	     * _.omit(object, 'age');
	     * // => { 'user': 'fred' }
	     *
	     * _.omit(object, _.isNumber);
	     * // => { 'user': 'fred' }
	     */
	    var omit = restParam(function(object, props) {
	      if (object == null) {
	        return {};
	      }
	      if (typeof props[0] != 'function') {
	        var props = arrayMap(baseFlatten(props), String);
	        return pickByArray(object, baseDifference(keysIn(object), props));
	      }
	      var predicate = bindCallback(props[0], props[1], 3);
	      return pickByCallback(object, function(value, key, object) {
	        return !predicate(value, key, object);
	      });
	    });
	
	    /**
	     * Creates a two dimensional array of the key-value pairs for `object`,
	     * e.g. `[[key1, value1], [key2, value2]]`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the new array of key-value pairs.
	     * @example
	     *
	     * _.pairs({ 'barney': 36, 'fred': 40 });
	     * // => [['barney', 36], ['fred', 40]] (iteration order is not guaranteed)
	     */
	    function pairs(object) {
	      object = toObject(object);
	
	      var index = -1,
	          props = keys(object),
	          length = props.length,
	          result = Array(length);
	
	      while (++index < length) {
	        var key = props[index];
	        result[index] = [key, object[key]];
	      }
	      return result;
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties. Property
	     * names may be specified as individual arguments or as arrays of property
	     * names. If `predicate` is provided it's invoked for each property of `object`
	     * picking the properties `predicate` returns truthy for. The predicate is
	     * bound to `thisArg` and invoked with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function|...(string|string[])} [predicate] The function invoked per
	     *  iteration or property names to pick, specified as individual property
	     *  names or arrays of property names.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'user': 'fred', 'age': 40 };
	     *
	     * _.pick(object, 'user');
	     * // => { 'user': 'fred' }
	     *
	     * _.pick(object, _.isString);
	     * // => { 'user': 'fred' }
	     */
	    var pick = restParam(function(object, props) {
	      if (object == null) {
	        return {};
	      }
	      return typeof props[0] == 'function'
	        ? pickByCallback(object, bindCallback(props[0], props[1], 3))
	        : pickByArray(object, baseFlatten(props));
	    });
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a function
	     * it's invoked with the `this` binding of its parent object and its result
	     * is returned.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a.b.c', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a.b.c', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      var result = object == null ? undefined : object[path];
	      if (result === undefined) {
	        if (object != null && !isKey(path, object)) {
	          path = toPath(path);
	          object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	          result = object == null ? undefined : object[last(path)];
	        }
	        result = result === undefined ? defaultValue : result;
	      }
	      return isFunction(result) ? result.call(object) : result;
	    }
	
	    /**
	     * Sets the property value of `path` on `object`. If a portion of `path`
	     * does not exist it's created.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to augment.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, 'x[0].y.z', 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      if (object == null) {
	        return object;
	      }
	      var pathKey = (path + '');
	      path = (object[pathKey] != null || isKey(path, object)) ? [pathKey] : toPath(path);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = path[index];
	        if (isObject(nested)) {
	          if (index == lastIndex) {
	            nested[key] = value;
	          } else if (nested[key] == null) {
	            nested[key] = isIndex(path[index + 1]) ? [] : {};
	          }
	        }
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own enumerable
	     * properties through `iteratee`, with each invocation potentially mutating
	     * the `accumulator` object. The `iteratee` is bound to `thisArg` and invoked
	     * with four arguments: (accumulator, value, key, object). Iteratee functions
	     * may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Array|Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * });
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2 }, function(result, n, key) {
	     *   result[key] = n * 3;
	     * });
	     * // => { 'a': 3, 'b': 6 }
	     */
	    function transform(object, iteratee, accumulator, thisArg) {
	      var isArr = isArray(object) || isTypedArray(object);
	      iteratee = getCallback(iteratee, thisArg, 4);
	
	      if (accumulator == null) {
	        if (isArr || isObject(object)) {
	          var Ctor = object.constructor;
	          if (isArr) {
	            accumulator = isArray(object) ? new Ctor : [];
	          } else {
	            accumulator = baseCreate(isFunction(Ctor) ? Ctor.prototype : undefined);
	          }
	        } else {
	          accumulator = {};
	        }
	      }
	      (isArr ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Creates an array of the own enumerable property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property values
	     * of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Checks if `n` is between `start` and up to but not including, `end`. If
	     * `end` is not specified it's set to `start` with `start` then set to `0`.
	     *
	     * @static
	     * @memberOf _
	     * @category Number
	     * @param {number} n The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `n` is in the range, else `false`.
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     */
	    function inRange(value, start, end) {
	      start = +start || 0;
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = +end || 0;
	      }
	      return value >= nativeMin(start, end) && value < nativeMax(start, end);
	    }
	
	    /**
	     * Produces a random number between `min` and `max` (inclusive). If only one
	     * argument is provided a number between `0` and the given number is returned.
	     * If `floating` is `true`, or either `min` or `max` are floats, a floating-point
	     * number is returned instead of an integer.
	     *
	     * @static
	     * @memberOf _
	     * @category Number
	     * @param {number} [min=0] The minimum possible value.
	     * @param {number} [max=1] The maximum possible value.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(min, max, floating) {
	      if (floating && isIterateeCall(min, max, floating)) {
	        max = floating = undefined;
	      }
	      var noMin = min == null,
	          noMax = max == null;
	
	      if (floating == null) {
	        if (noMax && typeof min == 'boolean') {
	          floating = min;
	          min = 1;
	        }
	        else if (typeof max == 'boolean') {
	          floating = max;
	          noMax = true;
	        }
	      }
	      if (noMin && noMax) {
	        max = 1;
	        noMax = false;
	      }
	      min = +min || 0;
	      if (noMax) {
	        max = min;
	        min = 0;
	      } else {
	        max = +max || 0;
	      }
	      if (floating || min % 1 || max % 1) {
	        var rand = nativeRandom();
	        return nativeMin(min + (rand * (max - min + parseFloat('1e-' + ((rand + '').length - 1)))), max);
	      }
	      return baseRandom(min, max);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__foo_bar__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? (word.charAt(0).toUpperCase() + word.slice(1)) : word);
	    });
	
	    /**
	     * Capitalizes the first character of `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('fred');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      string = baseToString(string);
	      return string && (string.charAt(0).toUpperCase() + string.slice(1));
	    }
	
	    /**
	     * Deburrs `string` by converting [latin-1 supplementary letters](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * to basic latin letters and removing [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = baseToString(string);
	      return string && string.replace(reLatin1, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to search.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search from.
	     * @returns {boolean} Returns `true` if `string` ends with `target`, else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = baseToString(string);
	      target = (target + '');
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : nativeMin(position < 0 ? 0 : (+position || 0), length);
	
	      position -= target.length;
	      return position >= 0 && string.indexOf(target, position) == position;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', "'", and "\`", in `string` to
	     * their corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional characters
	     * use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value.
	     * See [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * Backticks are escaped because in Internet Explorer < 9, they can break out
	     * of attribute values or HTML comments. See [#59](https://html5sec.org/#59),
	     * [#102](https://html5sec.org/#102), [#108](https://html5sec.org/#108), and
	     * [#133](https://html5sec.org/#133) of the [HTML5 Security Cheatsheet](https://html5sec.org/)
	     * for more details.
	     *
	     * When working with HTML you should always [quote attribute values](http://wonko.com/post/html-escaping)
	     * to reduce XSS vectors.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      // Reset `lastIndex` because in IE < 9 `String#replace` does not.
	      string = baseToString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "\", "/", "^", "$", ".", "|", "?",
	     * "*", "+", "(", ")", "[", "]", "{" and "}" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https:\/\/lodash\.com\/\)'
	     */
	    function escapeRegExp(string) {
	      string = baseToString(string);
	      return (string && reHasRegExpChars.test(string))
	        ? string.replace(reRegExpChars, escapeRegExpChar)
	        : (string || '(?:)');
	    }
	
	    /**
	     * Converts `string` to [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__foo_bar__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = baseToString(string);
	      length = +length;
	
	      var strLength = string.length;
	      if (strLength >= length || !nativeIsFinite(length)) {
	        return string;
	      }
	      var mid = (length - strLength) / 2,
	          leftLength = nativeFloor(mid),
	          rightLength = nativeCeil(mid);
	
	      chars = createPadding('', rightLength, chars);
	      return chars.slice(0, leftLength) + string + chars;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padLeft('abc', 6);
	     * // => '   abc'
	     *
	     * _.padLeft('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padLeft('abc', 3);
	     * // => 'abc'
	     */
	    var padLeft = createPadDir();
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padRight('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padRight('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padRight('abc', 3);
	     * // => 'abc'
	     */
	    var padRight = createPadDir(true);
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a hexadecimal,
	     * in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the [ES5 implementation](https://es5.github.io/#E)
	     * of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      // Firefox < 21 and Opera < 15 follow ES3 for `parseInt`.
	      // Chrome fails to trim leading <BOM> whitespace characters.
	      // See https://code.google.com/p/v8/issues/detail?id=3109 for more details.
	      if (guard ? isIterateeCall(string, radix, guard) : radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      string = trim(string);
	      return nativeParseInt(string, radix || (reHasHexPrefix.test(string) ? 16 : 10));
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=0] The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n) {
	      var result = '';
	      string = baseToString(string);
	      n = +n;
	      if (n < 1 || !string || !nativeIsFinite(n)) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        string += string;
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * Converts `string` to [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--foo-bar');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string` to [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__foo_bar__');
	     * // => 'Foo Bar'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + (word.charAt(0).toUpperCase() + word.slice(1));
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to search.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`, else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = baseToString(string);
	      position = position == null
	        ? 0
	        : nativeMin(position < 0 ? 0 : (+position || 0), string.length);
	
	      return string.lastIndexOf(target, position) == position;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is provided it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options] The options object.
	     * @param {RegExp} [options.escape] The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate] The "evaluate" delimiter.
	     * @param {Object} [options.imports] An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate] The "interpolate" delimiter.
	     * @param {string} [options.sourceURL] The sourceURL of the template's compiled source.
	     * @param {string} [options.variable] The data object variable name.
	     * @param- {Object} [otherOptions] Enables the legacy `options` param signature.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // using the "interpolate" delimiter to create a compiled template
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // using the HTML "escape" delimiter to escape data property values
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // using the "evaluate" delimiter to execute JavaScript and generate HTML
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // using the internal `print` function in "evaluate" delimiters
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // using the ES delimiter as an alternative to the default "interpolate" delimiter
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // using custom template delimiters
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // using backslashes to treat delimiters as plain text
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // using the `imports` option to import `jQuery` as `jq`
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // using the `sourceURL` option to specify a custom sourceURL for the template
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector
	     *
	     * // using the `variable` option to ensure a with-statement isn't used in the compiled template
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // using the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and a stack trace
	     * fs.writeFileSync(path.join(cwd, 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, otherOptions) {
	      // Based on John Resig's `tmpl` implementation (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (otherOptions && isIterateeCall(string, options, otherOptions)) {
	        options = otherOptions = undefined;
	      }
	      string = baseToString(string);
	      options = assignWith(baseAssign({}, otherOptions || options), settings, assignOwnDefaults);
	
	      var imports = assignWith(baseAssign({}, options.imports), settings.imports, assignOwnDefaults),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      var sourceURL = '//# sourceURL=' +
	        ('sourceURL' in options
	          ? options.sourceURL
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products requires returning the `match`
	        // string in order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      var value = string;
	      string = baseToString(string);
	      if (!string) {
	        return string;
	      }
	      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
	        return string.slice(trimmedLeftIndex(string), trimmedRightIndex(string) + 1);
	      }
	      chars = (chars + '');
	      return string.slice(charsLeftIndex(string, chars), charsRightIndex(string, chars) + 1);
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimLeft('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimLeft('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimLeft(string, chars, guard) {
	      var value = string;
	      string = baseToString(string);
	      if (!string) {
	        return string;
	      }
	      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
	        return string.slice(trimmedLeftIndex(string));
	      }
	      return string.slice(charsLeftIndex(string, (chars + '')));
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimRight('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimRight('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimRight(string, chars, guard) {
	      var value = string;
	      string = baseToString(string);
	      if (!string) {
	        return string;
	      }
	      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
	        return string.slice(0, trimmedRightIndex(string) + 1);
	      }
	      return string.slice(0, charsRightIndex(string, (chars + '')) + 1);
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object|number} [options] The options object or maximum string length.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.trunc('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.trunc('hi-diddly-ho there, neighborino', 24);
	     * // => 'hi-diddly-ho there, n...'
	     *
	     * _.trunc('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.trunc('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.trunc('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function trunc(string, options, guard) {
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (options != null) {
	        if (isObject(options)) {
	          var separator = 'separator' in options ? options.separator : separator;
	          length = 'length' in options ? (+options.length || 0) : length;
	          omission = 'omission' in options ? baseToString(options.omission) : omission;
	        } else {
	          length = +options || 0;
	        }
	      }
	      string = baseToString(string);
	      if (length >= string.length) {
	        return string;
	      }
	      var end = length - omission.length;
	      if (end < 1) {
	        return omission;
	      }
	      var result = string.slice(0, end);
	      if (separator == null) {
	        return result + omission;
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              newEnd,
	              substring = string.slice(0, end);
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, (reFlags.exec(separator) || '') + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            newEnd = match.index;
	          }
	          result = result.slice(0, newEnd == null ? end : newEnd);
	        }
	      } else if (string.indexOf(separator, end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, `&#39;`, and `&#96;` in `string` to their
	     * corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional HTML
	     * entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = baseToString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      if (guard && isIterateeCall(string, pattern, guard)) {
	        pattern = undefined;
	      }
	      string = baseToString(string);
	      return string.match(pattern || reWords) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Function} func The function to attempt.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // avoid throwing errors for invalid selectors
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = restParam(function(func, args) {
	      try {
	        return func.apply(undefined, args);
	      } catch(e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and arguments of the created function. If `func` is a property name the
	     * created callback returns the property value for a given element. If `func`
	     * is an object the created callback returns `true` for elements that contain
	     * the equivalent object properties, otherwise it returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias iteratee
	     * @category Utility
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // wrap to create custom callback shorthands
	     * _.callback = _.wrap(_.callback, function(callback, func, thisArg) {
	     *   var match = /^(.+?)__([gl]t)(.+)$/.exec(func);
	     *   if (!match) {
	     *     return callback(func, thisArg);
	     *   }
	     *   return function(object) {
	     *     return match[2] == 'gt'
	     *       ? object[match[1]] > match[3]
	     *       : object[match[1]] < match[3];
	     *   };
	     * });
	     *
	     * _.filter(users, 'age__gt36');
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     */
	    function callback(func, thisArg, guard) {
	      if (guard && isIterateeCall(func, thisArg, guard)) {
	        thisArg = undefined;
	      }
	      return isObjectLike(func)
	        ? matches(func)
	        : baseCallback(func, thisArg);
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     * var getter = _.constant(object);
	     *
	     * getter() === object;
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * This method returns the first argument provided to it.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * _.identity(object) === object;
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that performs a deep comparison between a given object
	     * and `source`, returning `true` if the given object has equivalent property
	     * values, else `false`.
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties. For comparing a single
	     * own or inherited property value see `_.matchesProperty`.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, _.matches({ 'age': 40, 'active': false }));
	     * // => [{ 'user': 'fred', 'age': 40, 'active': false }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, true));
	    }
	
	    /**
	     * Creates a function that compares the property value of `path` on a given
	     * object to `value`.
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * _.find(users, _.matchesProperty('user', 'fred'));
	     * // => { 'user': 'fred' }
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, true));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` on a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': { 'c': _.constant(2) } } },
	     *   { 'a': { 'b': { 'c': _.constant(1) } } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b.c'));
	     * // => [2, 1]
	     *
	     * _.invoke(_.sortBy(objects, _.method(['a', 'b', 'c'])), 'a.b.c');
	     * // => [1, 2]
	     */
	    var method = restParam(function(path, args) {
	      return function(object) {
	        return invokePath(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path on `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = restParam(function(object, args) {
	      return function(path) {
	        return invokePath(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable function properties of a source object to the
	     * destination object. If `object` is a function then methods are added to
	     * its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options] The options object.
	     * @param {boolean} [options.chain=true] Specify whether the functions added
	     *  are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      if (options == null) {
	        var isObj = isObject(source),
	            props = isObj ? keys(source) : undefined,
	            methodNames = (props && props.length) ? baseFunctions(source, props) : undefined;
	
	        if (!(methodNames ? methodNames.length : isObj)) {
	          methodNames = false;
	          options = source;
	          source = object;
	          object = this;
	        }
	      }
	      if (!methodNames) {
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = true,
	          index = -1,
	          isFunc = isFunction(object),
	          length = methodNames.length;
	
	      if (options === false) {
	        chain = false;
	      } else if (isObject(options) && 'chain' in options) {
	        chain = options.chain;
	      }
	      while (++index < length) {
	        var methodName = methodNames[index],
	            func = source[methodName];
	
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = (function(func) {
	            return function() {
	              var chainAll = this.__chain__;
	              if (chain || chainAll) {
	                var result = object(this.__wrapped__),
	                    actions = result.__actions__ = arrayCopy(this.__actions__);
	
	                actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	                result.__chain__ = chainAll;
	                return result;
	              }
	              return func.apply(object, arrayPush([this.value()], arguments));
	            };
	          }(func));
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      root._ = oldDash;
	      return this;
	    }
	
	    /**
	     * A no-operation function that returns `undefined` regardless of the
	     * arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * _.noop(object) === undefined;
	     * // => true
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that returns the property value at `path` on a
	     * given object.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': { 'c': 2 } } },
	     *   { 'a': { 'b': { 'c': 1 } } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b.c'));
	     * // => [2, 1]
	     *
	     * _.pluck(_.sortBy(objects, _.property(['a', 'b', 'c'])), 'a.b.c');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(path) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the property value at a given path on `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return baseGet(object, toPath(path), (path + ''));
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. If `end` is not specified it's
	     * set to `start` with `start` then set to `0`. If `end` is less than `start`
	     * a zero-length range is created unless a negative `step` is specified.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the new array of numbers.
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    function range(start, end, step) {
	      if (step && isIterateeCall(start, end, step)) {
	        end = step = undefined;
	      }
	      start = +start || 0;
	      step = step == null ? 1 : (+step || 0);
	
	      if (end == null) {
	        end = start;
	        start = 0;
	      } else {
	        end = +end || 0;
	      }
	      // Use `Array(length)` so engines like Chakra and V8 avoid slower modes.
	      // See https://youtu.be/XAqIpGU8ZZk#t=17m25s for more details.
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (++index < length) {
	        result[index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * Invokes the iteratee function `n` times, returning an array of the results
	     * of each invocation. The `iteratee` is bound to `thisArg` and invoked with
	     * one argument; (index).
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * var diceRolls = _.times(3, _.partial(_.random, 1, 6, false));
	     * // => [3, 6, 4]
	     *
	     * _.times(3, function(n) {
	     *   mage.castSpell(n);
	     * });
	     * // => invokes `mage.castSpell(n)` three times with `n` of `0`, `1`, and `2`
	     *
	     * _.times(3, function(n) {
	     *   this.cast(n);
	     * }, mage);
	     * // => also invokes `mage.castSpell(n)` three times
	     */
	    function times(n, iteratee, thisArg) {
	      n = nativeFloor(n);
	
	      // Exit early to avoid a JSC JIT bug in Safari 8
	      // where `Array(0)` is treated as `Array(1)`.
	      if (n < 1 || !nativeIsFinite(n)) {
	        return [];
	      }
	      var index = -1,
	          result = Array(nativeMin(n, MAX_ARRAY_LENGTH));
	
	      iteratee = bindCallback(iteratee, thisArg, 1);
	      while (++index < n) {
	        if (index < MAX_ARRAY_LENGTH) {
	          result[index] = iteratee(index);
	        } else {
	          iteratee(index);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is provided the ID is appended to it.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {string} [prefix] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return baseToString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} augend The first number to add.
	     * @param {number} addend The second number to add.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    function add(augend, addend) {
	      return (+augend || 0) + (+addend || 0);
	    }
	
	    /**
	     * Calculates `n` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} n The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Calculates `n` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} n The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Gets the maximum value of `collection`. If `collection` is empty or falsey
	     * `-Infinity` is returned. If an iteratee function is provided it's invoked
	     * for each value in `collection` to generate the criterion by which the value
	     * is ranked. The `iteratee` is bound to `thisArg` and invoked with three
	     * arguments: (value, index, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => -Infinity
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * _.max(users, function(chr) {
	     *   return chr.age;
	     * });
	     * // => { 'user': 'fred', 'age': 40 }
	     *
	     * // using the `_.property` callback shorthand
	     * _.max(users, 'age');
	     * // => { 'user': 'fred', 'age': 40 }
	     */
	    var max = createExtremum(gt, NEGATIVE_INFINITY);
	
	    /**
	     * Gets the minimum value of `collection`. If `collection` is empty or falsey
	     * `Infinity` is returned. If an iteratee function is provided it's invoked
	     * for each value in `collection` to generate the criterion by which the value
	     * is ranked. The `iteratee` is bound to `thisArg` and invoked with three
	     * arguments: (value, index, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => Infinity
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * _.min(users, function(chr) {
	     *   return chr.age;
	     * });
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // using the `_.property` callback shorthand
	     * _.min(users, 'age');
	     * // => { 'user': 'barney', 'age': 36 }
	     */
	    var min = createExtremum(lt, POSITIVE_INFINITY);
	
	    /**
	     * Calculates `n` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} n The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Gets the sum of the values in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 6]);
	     * // => 10
	     *
	     * _.sum({ 'a': 4, 'b': 6 });
	     * // => 10
	     *
	     * var objects = [
	     *   { 'n': 4 },
	     *   { 'n': 6 }
	     * ];
	     *
	     * _.sum(objects, function(object) {
	     *   return object.n;
	     * });
	     * // => 10
	     *
	     * // using the `_.property` callback shorthand
	     * _.sum(objects, 'n');
	     * // => 10
	     */
	    function sum(collection, iteratee, thisArg) {
	      if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
	        iteratee = undefined;
	      }
	      iteratee = getCallback(iteratee, thisArg, 3);
	      return iteratee.length == 1
	        ? arraySum(isArray(collection) ? collection : toIterable(collection), iteratee)
	        : baseSum(collection, iteratee);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    // Add functions to the `Map` cache.
	    MapCache.prototype['delete'] = mapDelete;
	    MapCache.prototype.get = mapGet;
	    MapCache.prototype.has = mapHas;
	    MapCache.prototype.set = mapSet;
	
	    // Add functions to the `Set` cache.
	    SetCache.prototype.push = cachePush;
	
	    // Assign cache to `_.memoize`.
	    memoize.Cache = MapCache;
	
	    // Add functions that return wrapped values when chaining.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.callback = callback;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.functions = functions;
	    lodash.groupBy = groupBy;
	    lodash.indexBy = indexBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.invert = invert;
	    lodash.invoke = invoke;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.modArgs = modArgs;
	    lodash.negate = negate;
	    lodash.omit = omit;
	    lodash.once = once;
	    lodash.pairs = pairs;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pluck = pluck;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.restParam = restParam;
	    lodash.set = set;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortByAll = sortByAll;
	    lodash.sortByOrder = sortByOrder;
	    lodash.spread = spread;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.times = times;
	    lodash.toArray = toArray;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.union = union;
	    lodash.uniq = uniq;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.where = where;
	    lodash.without = without;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.backflow = flowRight;
	    lodash.collect = map;
	    lodash.compose = flowRight;
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.extend = assign;
	    lodash.iteratee = callback;
	    lodash.methods = functions;
	    lodash.object = zipObject;
	    lodash.select = filter;
	    lodash.tail = rest;
	    lodash.unique = uniq;
	
	    // Add functions to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add functions that return unwrapped values when chaining.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.deburr = deburr;
	    lodash.endsWith = endsWith;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.findWhere = findWhere;
	    lodash.first = first;
	    lodash.floor = floor;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isBoolean = isBoolean;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isMatch = isMatch;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isString = isString;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.min = min;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padLeft = padLeft;
	    lodash.padRight = padRight;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.sum = sum;
	    lodash.template = template;
	    lodash.trim = trim;
	    lodash.trimLeft = trimLeft;
	    lodash.trimRight = trimRight;
	    lodash.trunc = trunc;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.words = words;
	
	    // Add aliases.
	    lodash.all = every;
	    lodash.any = some;
	    lodash.contains = includes;
	    lodash.eq = isEqual;
	    lodash.detect = find;
	    lodash.foldl = reduce;
	    lodash.foldr = reduceRight;
	    lodash.head = first;
	    lodash.include = includes;
	    lodash.inject = reduce;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!lodash.prototype[methodName]) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), false);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add functions capable of returning wrapped and unwrapped values when chaining.
	    lodash.sample = sample;
	
	    lodash.prototype.sample = function(n) {
	      if (!this.__chain__ && n == null) {
	        return sample(this.value());
	      }
	      return this.thru(function(value) {
	        return sample(value, n);
	      });
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type string
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        var filtered = this.__filtered__;
	        if (filtered && !index) {
	          return new LazyWrapper(this);
	        }
	        n = n == null ? 1 : nativeMax(nativeFloor(n) || 0, 0);
	
	        var result = this.clone();
	        if (filtered) {
	          result.__takeCount__ = nativeMin(result.__takeCount__, n);
	        } else {
	          result.__views__.push({ 'size': n, 'type': methodName + (result.__dir__ < 0 ? 'Right' : '') });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type != LAZY_MAP_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee, thisArg) {
	        var result = this.clone();
	        result.__iteratees__.push({ 'iteratee': getCallback(iteratee, thisArg, 1), 'type': type });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.first` and `_.last`.
	    arrayEach(['first', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.rest`.
	    arrayEach(['initial', 'rest'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.pluck` and `_.where`.
	    arrayEach(['pluck', 'where'], function(methodName, index) {
	      var operationName = index ? 'filter' : 'map',
	          createCallback = index ? baseMatches : property;
	
	      LazyWrapper.prototype[methodName] = function(value) {
	        return this[operationName](createCallback(value));
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.reject = function(predicate, thisArg) {
	      predicate = getCallback(predicate, thisArg, 1);
	      return this.filter(function(value) {
	        return !predicate(value);
	      });
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = start == null ? 0 : (+start || 0);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = (+end || 0);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate, thisArg) {
	      return this.reverse().takeWhile(predicate, thisArg).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(POSITIVE_INFINITY);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|map|reject)|While$/.test(methodName),
	          retUnwrapped = /^(?:first|last)$/.test(methodName),
	          lodashFunc = lodash[retUnwrapped ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName];
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var args = retUnwrapped ? [1] : arguments,
	            chainAll = this.__chain__,
	            value = this.__wrapped__,
	            isHybrid = !!this.__actions__.length,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var interceptor = function(value) {
	          return (retUnwrapped && chainAll)
	            ? lodashFunc(value, 1)[0]
	            : lodashFunc.apply(undefined, arrayPush([value], args));
	        };
	
	        var action = { 'func': thru, 'args': [interceptor], 'thisArg': undefined },
	            onlyLazy = isLazy && !isHybrid;
	
	        if (retUnwrapped && !chainAll) {
	          if (onlyLazy) {
	            value = value.clone();
	            value.__actions__.push(action);
	            return func.call(value);
	          }
	          return lodashFunc.call(undefined, this.value())[0];
	        }
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push(action);
	          return new LodashWrapper(result, chainAll);
	        }
	        return this.thru(interceptor);
	      };
	    });
	
	    // Add `Array` and `String` methods to `lodash.prototype`.
	    arrayEach(['join', 'pop', 'push', 'replace', 'shift', 'sort', 'splice', 'split', 'unshift'], function(methodName) {
	      var func = (/^(?:replace|split)$/.test(methodName) ? stringProto : arrayProto)[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:join|pop|replace|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          return func.apply(this.value(), args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(value, args);
	        });
	      };
	    });
	
	    // Map minified function names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = (lodashFunc.name + ''),
	            names = realNames[key] || (realNames[key] = []);
	
	        names.push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybridWrapper(undefined, BIND_KEY_FLAG).name] = [{ 'name': 'wrapper', 'func': undefined }];
	
	    // Add functions to the lazy wrapper.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chaining functions to the `lodash` wrapper.
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.concat = wrapperConcat;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toString = wrapperToString;
	    lodash.prototype.run = lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add function aliases to the `lodash` wrapper.
	    lodash.prototype.collect = lodash.prototype.map;
	    lodash.prototype.head = lodash.prototype.first;
	    lodash.prototype.select = lodash.prototype.filter;
	    lodash.prototype.tail = lodash.prototype.rest;
	
	    return lodash;
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers like r.js check for condition patterns like the following:
	  if (true) {
	    // Expose lodash to the global object when an AMD loader is present to avoid
	    // errors in cases where lodash is loaded by a script tag and not intended
	    // as an AMD module. See http://requirejs.org/docs/errors.html#mismatch for
	    // more details.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds an `exports` object.
	  else if (freeExports && freeModule) {
	    // Export for Node.js or RingoJS.
	    if (moduleExports) {
	      (freeModule.exports = _)._ = _;
	    }
	    // Export for Rhino with CommonJS support.
	    else {
	      freeExports._ = _;
	    }
	  }
	  else {
	    // Export for a browser or Rhino.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)(module), (function() { return this; }())))

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(7);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _webstoragePolyfill = __webpack_require__(10);
	
	var _webstoragePolyfill2 = _interopRequireDefault(_webstoragePolyfill);
	
	var _analytics = __webpack_require__(13);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	var _product = __webpack_require__(22);
	
	var _product2 = _interopRequireDefault(_product);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = ['$rootScope', '$timeout', '$q', 'CartAPIService', 'CampaignService', 'ErrorHandler', function () {
	  function CartService($rootScope, $timeout, $q, cartAPIService, campaignService, ErrorHandler) {
	    var webstorage = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : new _webstoragePolyfill2.default();
	    var analytics = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : new _analytics2.default();
	
	    _classCallCheck(this, CartService);
	
	    this._$rootScope = $rootScope;
	    this._$timeout = $timeout;
	    this._$q = $q;
	    this._cartAPIService = cartAPIService;
	    this._campaignService = campaignService;
	    this._errorHandler = ErrorHandler;
	    this._webstorage = webstorage;
	    this.analytics = analytics;
	
	    this._readyDeferred = this._$q.defer();
	    this.ready = this._readyDeferred.promise;
	
	    this._initDefaults();
	  }
	
	  _createClass(CartService, [{
	    key: "_initDefaults",
	    value: function _initDefaults() {
	      this.cart = {};
	      this.coupon = {};
	      this.totals = {};
	
	      this.country = 'US';
	      this.processing = false;
	      this.getTotalPromiseComplete = true;
	
	      this.previousCouponCode = null;
	    }
	  }, {
	    key: "_localstoreCart",
	    value: function _localstoreCart() {
	      if (this.cart.slug === null) return false;
	      var cartObj = { coupon: this.coupon, contents: this.cart.contents };
	      this._webstorage.setLocalItem("" + this.cart.slug, JSON.stringify(cartObj));
	    }
	  }, {
	    key: "_getCartTotalsHelper",
	    value: function _getCartTotalsHelper(cartFunc) {
	      var _this = this;
	
	      var promise = cartFunc();
	
	      this.processing = true;
	      promise.then(function (res) {
	        _this._setTotals(res);
	        _this.getTotalPromiseComplete = true;
	      }).catch(function (err) {
	        // -1 status means we cancelled it manually so we dont want to reset totals at this time.
	        if (err.status && err.status !== -1) {
	          _this._errorHandler.throwError('Totals Error', _lodash2.default.get(err, 'data.message') ? err.data.message : 'Error updating cart totals.', { rawError: err });
	
	          // if there was no discount amount before this error, reset the coupon object.
	          if (!_this.totals.discount) {
	            _this.coupon = {};
	          } else if (_this.totals.couponCode) {
	            _this.coupon.code = _this.totals.couponCode;
	          }
	
	          if (_lodash2.default.get(err, 'data.message').match(/Coupon \[.*\] cannot be used on this order\./)) {
	            _this._localstoreCart();
	            _this._getCartTotals();
	          }
	        }
	      }).finally(function () {
	        return _this.processing = false;
	      });
	
	      return promise;
	    }
	  }, {
	    key: "_getCartTotals",
	    value: function _getCartTotals() {
	      var _this2 = this;
	
	      var deferred = this._$q.defer(),
	          promise = void 0;
	
	      if (this.size() > 0) {
	        var contents = _lodash2.default.map(this.cart.contents, function (item) {
	          // Strip out data the API doesn't need.
	          item = _lodash2.default.clone(item);
	          delete item.price;
	          delete item.thumbnail;
	          return item;
	        });
	        promise = this._getCartTotalsHelper(function () {
	          return _this2._cartAPIService.getTotal(_this2.campaign.id, _this2.coupon.code, _this2.state, _this2.country, contents);
	        });
	      } else {
	        promise = deferred.promise;
	        deferred.resolve();
	      }
	
	      return promise;
	    }
	  }, {
	    key: "_getAmazonCartTotals",
	    value: function _getAmazonCartTotals(amazonReferenceId, orderReferenceID) {
	      var _this3 = this;
	
	      return this._getCartTotalsHelper(function () {
	        return _this3._cartAPIService.getAmazonTotal(amazonReferenceId, orderReferenceID, _this3.coupon.code);
	      });
	    }
	  }, {
	    key: "_setTotals",
	    value: function _setTotals(cartData) {
	      this.totals.items = cartData.totals;
	      this.totals.discount = cartData.discount_amount;
	      this.totals.checkout = cartData.sub_total;
	      this.totals.shipping = cartData.shipping_cost;
	      this.totals.shippingDiscount = cartData.shipping_discount;
	      this.totals.tax = cartData.sales_tax;
	      this.totals.grand = cartData.grand_total;
	      this.totals.coupon = cartData.coupon;
	      this.totals.couponCode = cartData.coupon ? cartData.coupon.code : null;
	
	      this.coupon = cartData.coupon || {};
	    }
	  }, {
	    key: "_applyCouponHelper",
	    value: function _applyCouponHelper(totalsFunc) {
	      var _this4 = this;
	
	      var deferred = this._$q.defer(),
	          promise = deferred.promise,
	          rejectData = {
	        data: {
	          message: 'Please enter a coupon code.'
	        }
	      };
	
	      if (this.coupon.code) {
	        this.processing = true;
	
	        this._campaignService.validateCoupon(this.username, this.campaignSlug, this.coupon.code).then(function (res) {
	          if (res.valid) {
	            _this4.couponType = res.type;
	            _this4.couponAmount = res.amount;
	
	            if (_this4.size() > 0) totalsFunc();
	          } else {
	            _this4.coupon = {};
	            _this4._localstoreCart();
	            totalsFunc();
	          }
	          deferred.resolve(res);
	        }).catch(function () {
	          _this4.coupon = {};
	          _this4._localstoreCart();
	          totalsFunc();
	          deferred.resolve();
	        }).finally(function () {
	          return _this4.processing = false;
	        });
	      } else {
	        if (this.totals.couponCode) rejectData.data.couponCode = this.totals.couponCode;
	        this.processing = true;
	        deferred.reject(rejectData);
	      }
	
	      return promise;
	    }
	  }, {
	    key: "init",
	    value: function init(username, campaignSlug) {
	      var _this5 = this;
	
	      if (!this.cart.initialized) {
	        this.username = username;
	        this.campaignSlug = campaignSlug;
	        this.cart.slug = username + "/" + campaignSlug;
	        var cartObj = JSON.parse(this._webstorage.getLocalItem("" + this.cart.slug)) || {};
	
	        if (Array.isArray(cartObj)) this.cart.contents = cartObj;else if (!Array.isArray(cartObj) && Array.isArray(cartObj.contents)) {
	          this.coupon = _typeof(cartObj.coupon) == 'object' ? cartObj.coupon : {};
	          this.cart.contents = cartObj.contents;
	        } else this.cart.contents = [];
	
	        this._campaignService.getBySlug(username, campaignSlug).then(function (data) {
	          _this5.campaign = data.campaign;
	
	          // remove any inactive products
	          var products = _product2.default.filterInactiveProducts(_this5.campaign.products);
	          data.campaign.products = products;
	          _this5.campaign.products = products;
	
	          // remove any inactive products from exisiting cart and save the changes
	          _this5.cart.contents = _lodash2.default.filter(_this5.cart.contents, function (item) {
	            return _lodash2.default.find(_this5.campaign.products, function (product) {
	              return product.id === item.cpid;
	            });
	          });
	          _this5._localstoreCart();
	
	          if (_this5.cart.contents.length > 0 && _this5.campaign.id !== _this5.cart.contents[0].cid) {
	            _this5.cart.contents = [];
	          }
	
	          if (_this5.size() > 0) {
	            if (Object.keys(_this5.coupon).length > 0) {
	              _this5._applyCouponHelper(function () {
	                return _this5._getCartTotals();
	              }).then(function () {
	                return _this5._readyDeferred.resolve(data);
	              });
	            } else {
	              _this5._getCartTotals().then(function () {
	                return _this5._readyDeferred.resolve(data);
	              });
	            }
	          } else {
	            _this5._readyDeferred.resolve(data);
	          }
	
	          _this5.cart.initialized = true;
	        }).catch(function (err) {
	          _this5._errorHandler.throwError('Unable to Find Campaign', 'There was a problem loading this campaign.', {
	            cart: cartObj,
	            rawError: err
	          });
	          _this5._readyDeferred.reject();
	        });
	      } else {
	        this._readyDeferred.resolve({
	          campaign: this.campaign
	        });
	      }
	
	      return this.ready;
	    }
	  }, {
	    key: "contents",
	    value: function contents() {
	      return this.cart.contents;
	    }
	  }, {
	    key: "contentsAsCampaignProducts",
	    value: function contentsAsCampaignProducts() {
	      var products = [];
	
	      if (this.cart.contents) {
	        for (var i = 0; i < this.cart.contents.length; i++) {
	          var product = _lodash2.default.clone(_lodash2.default.find(this.campaign.products, { id: this.cart.contents[i].cpid }));
	          product.qty = this.cart.contents[i].qty;
	          product.size = this.cart.contents[i].size;
	          if (product) products.push(product);
	        }
	      }
	
	      return products;
	    }
	  }, {
	    key: "add",
	    value: function add(product, size, qty) {
	      if (this.cart.slug === null) return false;
	      qty = parseInt(qty);
	      var cartSearch = _lodash2.default.find(this.cart.contents, function (item) {
	        return item.cpid === product.id && item.size === size;
	      });
	
	      if (cartSearch !== undefined) {
	        cartSearch.qty += qty;
	      } else {
	        this.cart.contents.push({
	          cid: this.campaign.id,
	          cpid: product.id,
	          baseProduct: product.product.id,
	          thumbnail: product.default_side_to_display === 'BACK' ? product.assets.back_thumbnail : product.assets.front_thumbnail,
	          size: size,
	          qty: qty,
	          price: (parseFloat(product.selling_price) + parseFloat(product.product.upcharges[size])).toFixed(2),
	          name: product.color.name + " " + product.product.name,
	          group: product.product.group,
	          specialPrinting: this.campaign.requires_special_printing
	        });
	      }
	
	      this._localstoreCart();
	
	      if (this.getTotalPromiseComplete) {
	        this.getTotalPromiseComplete = false;
	        this._getCartTotals();
	      } else {
	        this._cartAPIService.cancelGetTotal();
	        this._getCartTotals();
	      }
	    }
	  }, {
	    key: "remove",
	    value: function remove(index) {
	      if (this.cart.slug === null) return false;
	
	      if (index === 'all') {
	        this.cart.contents = [];
	      } else {
	        var product = _lodash2.default.find(this.campaign.products, {
	          id: this.cart.contents[index].cpid
	        });
	        if (product) {
	          this.analytics.removeFromCart(product, this.cart.contents[index].qty, this.cart.contents[index].size);
	        }
	        this.cart.contents.splice(index, 1);
	      }
	
	      this._localstoreCart();
	
	      if (this.getTotalPromiseComplete) {
	        this.getTotalPromiseComplete = false;
	        this._getCartTotals();
	      } else {
	        this._cartAPIService.cancelGetTotal();
	        this._getCartTotals();
	      }
	    }
	  }, {
	    key: "clearCart",
	    value: function clearCart(cartSlug) {
	      this._webstorage.removeLocalItem(cartSlug);
	    }
	  }, {
	    key: "size",
	    value: function size() {
	      if (this.cart.slug === null) return false;
	
	      var size = 0;
	
	      for (var i = 0; i < this.cart.contents.length; i++) {
	        size += this.cart.contents[i].qty;
	      }
	
	      return size;
	    }
	  }, {
	    key: "isProcessing",
	    value: function isProcessing() {
	      return this.processing;
	    }
	  }, {
	    key: "applyCoupon",
	    value: function applyCoupon(couponCode, amazonReferenceId, orderReferenceID) {
	      var _this6 = this;
	
	      var promise = void 0;
	
	      if (!this.previousCouponCode) this.previousCouponCode = this.coupon.code;
	      this.coupon.code = couponCode;
	
	      if (amazonReferenceId) {
	        promise = this._applyCouponHelper(function () {
	          return _this6._getAmazonCartTotals(amazonReferenceId, orderReferenceID);
	        });
	      } else {
	        promise = this._applyCouponHelper(function () {
	          return _this6._getCartTotals();
	        });
	      }
	      promise.then(function (res) {
	        _this6._localstoreCart();
	
	        if (res.valid && _this6.coupon.code !== _this6.previousCouponCode) {
	          _this6.previousCouponCode = _this6.coupon.code;
	          _this6.analytics.applyCoupon(_this6.coupon.code);
	        }
	      });
	
	      return promise;
	    }
	  }, {
	    key: "validateCouponBeforeCheckout",
	    value: function validateCouponBeforeCheckout() {
	      var _this7 = this;
	
	      var deferred = this._$q.defer(),
	          promise = deferred.promise;
	
	      if (Object.keys(this.coupon).length > 0) {
	        this._applyCouponHelper(function () {
	          return _this7._getCartTotals();
	        }).then(function (res) {
	          if (res.valid) {
	            deferred.resolve({ valid: true });
	          } else {
	            deferred.reject({ valid: false });
	          }
	        }).catch(function (err) {
	          _this7._errorHandler.throwError('Coupon Error', 'An error occured while attempting to validate coupon. Please try again.', { rawError: err });
	          deferred.reject();
	        });
	      } else {
	        deferred.resolve({ valid: true });
	      }
	
	      return promise;
	    }
	  }, {
	    key: "setCountry",
	    value: function setCountry(country, state) {
	      var promise = void 0,
	          deferred = this._$q.defer(),
	          prevCountry = this.country,
	          prevState = this.state;
	
	      this.country = country;
	      this.state = state;
	
	      if (this.cart.contents.length > 0 && (this.country !== prevCountry || this.state !== prevState)) {
	        promise = this._getCartTotals();
	      } else {
	        promise = deferred.promise;
	        deferred.resolve({});
	      }
	
	      return promise;
	    }
	  }, {
	    key: "setPixels",
	    value: function setPixels(pixels) {
	      this.pixels = pixels;
	    }
	  }, {
	    key: "getTotals",
	    value: function getTotals() {
	      return this.totals;
	    }
	  }, {
	    key: "getCouponInfo",
	    value: function getCouponInfo() {
	      return {
	        type: this.couponType,
	        amount: this.couponAmount
	      };
	    }
	  }, {
	    key: "getAmazonTotals",
	    value: function getAmazonTotals(amazonReferenceID, orderReferenceID) {
	      this._getAmazonCartTotals(amazonReferenceID, orderReferenceID);
	      return this.totals;
	    }
	  }, {
	    key: "triggerInitiateCheckout",
	    value: function triggerInitiateCheckout() {
	      this.analytics.initiateCheckout(this.campaign, this.size());
	    }
	  }, {
	    key: "paypalCheckoutCart",
	    value: function paypalCheckoutCart(callbackUrl, cancelUrl) {
	      var _this8 = this;
	
	      var purchases = [];
	      this.processing = true;
	      this.size();
	
	      _lodash2.default.forEach(this.cart.contents, function (item) {
	        purchases.push({
	          cpid: item.cpid,
	          qty: item.qty,
	          size: item.size
	        });
	      });
	
	      var payload = {
	        shipping_country: this.country,
	        coupon_code: this.coupon.code,
	        purchases: purchases,
	        success_callback_url: callbackUrl,
	        cancel_callback_url: cancelUrl
	      };
	
	      var promise = this._cartAPIService.paypalCheckout(payload);
	
	      promise.finally(function () {
	        return _this8.processing = false;
	      });
	
	      return promise;
	    }
	  }, {
	    key: "paypalCheckoutUpsellCart",
	    value: function paypalCheckoutUpsellCart(callbackUrl, cancelUrl, selectedProduct, upsellCampaignID, orderID) {
	      var payload = {
	        shipping_country: this.country,
	        purchases: [selectedProduct],
	        success_callback_url: callbackUrl,
	        cancel_callback_url: cancelUrl,
	        upsell_campaign_id: upsellCampaignID,
	        original_order_id: orderID
	      };
	
	      var promise = this._cartAPIService.paypalUpsellCheckout(payload);
	
	      return promise;
	    }
	  }, {
	    key: "amazonCheckoutCart",
	    value: function amazonCheckoutCart(amazonReferenceId, access_token) {
	      var _this9 = this;
	
	      this.size();
	
	      var purchases = [];
	      _lodash2.default.forEach(this.cart.contents, function (item) {
	        purchases.push({
	          product_id: item.cpid,
	          quantity: item.qty,
	          size: item.size,
	          cid: _this9.campaign.id // Ugh.
	        });
	      });
	
	      return this._cartAPIService.amazonCheckout({
	        campaign_id: this.campaign.id,
	        purchases: purchases,
	        ref_id: amazonReferenceId,
	        access_token: access_token
	      });
	    }
	  }, {
	    key: "amazonCheckoutUpsellCart",
	    value: function amazonCheckoutUpsellCart(amazonReferenceId, access_token, selectedProduct, campaignID, upsellCampaignID, orderID) {
	      return this._cartAPIService.amazonCheckout({
	        campaign_id: campaignID,
	        purchases: [selectedProduct],
	        ref_id: amazonReferenceId,
	        access_token: access_token,
	        upsell_campaign_id: upsellCampaignID,
	        order_type: 'UPSELL',
	        order_id: orderID
	      });
	    }
	  }, {
	    key: "createCCTokenCart",
	    value: function createCCTokenCart(card, customer) {
	      var _this10 = this;
	
	      this.processing = true;
	
	      var promise = this._cartAPIService.createCCToken(card, customer);
	
	      promise.then(function (res) {
	        return _this10.analytics.placeOrder({ option: res.merchant, cart: _this10.contentsAsCampaignProducts() });
	      }).catch(function (err) {
	        return _this10._errorHandler.throwError('Payment Processing', err && err.message ? err.message : 'Error creating credit card token.', { rawError: err });
	      });
	
	      return promise;
	    }
	  }, {
	    key: "_orderPayload",
	    value: function _orderPayload(token, customer) {
	      customer.name = customer.firstName + " " + customer.lastName;
	
	      return {
	        cid: this.campaign.id,
	        customer: customer,
	        card: {
	          token: token
	        },
	        coupon_code: this.coupon.code,
	        products: _lodash2.default.map(this.cart.contents, function (item) {
	          return { product_id: item.cpid, quantity: item.qty, size: item.size };
	        })
	      };
	    }
	  }, {
	    key: "processCCPayment",
	    value: function processCCPayment(token, customer, card) {
	      var _this11 = this;
	
	      var payload = this._orderPayload(token, customer);
	      payload.card.cc_bin = card.cc_num.replace(/\s/g, '').substr(0, 6);
	
	      var promise = this._cartAPIService.placeOrder(payload);
	
	      promise.catch(function (err) {
	        return _this11._errorHandler.throwError('Payment Processing', 'Error processing credit card payment.', {
	          rawError: err
	        });
	      }).finally(function () {
	        return _this11.processing = false;
	      });
	
	      return promise;
	    }
	  }, {
	    key: "processSavedPayment",
	    value: function processSavedPayment(token, customer) {
	      var _this12 = this;
	
	      var promise = this._cartAPIService.placeOrder(this._orderPayload(token, customer));
	
	      promise.catch(function (err) {
	        return _this12._errorHandler.throwError('Payment Processing', 'Error processing saved credit card payment.');
	      }).finally(function () {
	        return _this12.processing = false;
	      });
	
	      return promise;
	    }
	  }, {
	    key: "processAmazonPaymentCart",
	    value: function processAmazonPaymentCart(id, orderReferenceID) {
	      var _this13 = this;
	
	      this.processing = true;
	
	      var promise = this._cartAPIService.processAmazonPayment(id, orderReferenceID, this.coupon.code);
	
	      promise.catch(function (err) {
	        return _this13._errorHandler.throwError('Amazon Payment Processing', 'Unable to process payment at this time.', {
	          rawError: err
	        });
	      }).finally(function () {
	        return _this13.processing = false;
	      });
	
	      return promise;
	    }
	  }, {
	    key: "slug",
	    value: function slug() {
	      return this.cart.slug;
	    }
	  }]);
	
	  return CartService;
	}()];

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _localstoragePolyfill = __webpack_require__(11);
	
	var _sessionstoragePolyfill = __webpack_require__(12);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var WebStoragePolyfill = function () {
	  function WebStoragePolyfill() {
	    var localPoly = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _localstoragePolyfill.localStoragePolyfill;
	    var sessionPoly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _sessionstoragePolyfill.sessionStoragePolyfill;
	
	    _classCallCheck(this, WebStoragePolyfill);
	
	    this._localStoragePolyfill = localPoly;
	    this._sessionStoragePolyfill = sessionPoly;
	  }
	
	  _createClass(WebStoragePolyfill, [{
	    key: 'isLocalStorageAvailable',
	    value: function isLocalStorageAvailable() {
	      try {
	        // browsers will throw an error if we try to access a storage object when the user has blocked us from using them
	        if (typeof window.localStorage == 'undefined') return false;
	      } catch (err) {
	        return false;
	      }
	
	      try {
	        // hack for safari incognito
	        window.localStorage.setItem("storage", "");
	        window.localStorage.getItem("storage");
	        window.localStorage.removeItem("storage");
	        return true;
	      } catch (err) {
	        return false;
	      }
	    }
	  }, {
	    key: 'isSessionStorageAvailable',
	    value: function isSessionStorageAvailable() {
	      try {
	        // browsers will throw an error if we try to access a storage object when the user has blocked us from using them
	        if (typeof window.sessionStorage == 'undefined') return false;
	      } catch (err) {
	        return false;
	      }
	
	      try {
	        // hack for safari incognito
	        window.sessionStorage.setItem("storage", "");
	        window.sessionStorage.getItem("storage");
	        window.sessionStorage.removeItem("storage");
	        return true;
	      } catch (err) {
	        return false;
	      }
	    }
	  }, {
	    key: 'setSessionItem',
	    value: function setSessionItem(key, value) {
	      if (!this.isSessionStorageAvailable()) return this._sessionStoragePolyfill.setItem(key, value);else return window.sessionStorage.setItem(key, value);
	    }
	  }, {
	    key: 'setLocalItem',
	    value: function setLocalItem(key, value) {
	      if (!this.isLocalStorageAvailable()) return this._localStoragePolyfill.setItem(key, value);else return window.localStorage.setItem(key, value);
	    }
	  }, {
	    key: 'getSessionItem',
	    value: function getSessionItem(key) {
	      if (!this.isSessionStorageAvailable()) return this._sessionStoragePolyfill.getItem(key);else return window.sessionStorage.getItem(key);
	    }
	  }, {
	    key: 'getLocalItem',
	    value: function getLocalItem(key) {
	      if (!this.isLocalStorageAvailable()) return this._localStoragePolyfill.getItem(key);else return window.localStorage.getItem(key);
	    }
	  }, {
	    key: 'removeSessionItem',
	    value: function removeSessionItem(key) {
	      if (!this.isSessionStorageAvailable()) return this._sessionStoragePolyfill.removeItem(key);else return window.sessionStorage.removeItem(key);
	    }
	  }, {
	    key: 'removeLocalItem',
	    value: function removeLocalItem(key) {
	      if (!this.isLocalStorageAvailable()) return this._localStoragePolyfill.removeItem(key);else return window.localStorage.removeItem(key);
	    }
	  }]);
	
	  return WebStoragePolyfill;
	}();
	
	exports.default = WebStoragePolyfill;

/***/ }),
/* 11 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var LocalStoragePolyfill = function () {
	  function LocalStoragePolyfill() {
	    _classCallCheck(this, LocalStoragePolyfill);
	
	    this.length = 0;
	
	    var data = this._readCookie('localStorage');
	    this.data = data ? data : {};
	  }
	
	  _createClass(LocalStoragePolyfill, [{
	    key: 'clear',
	    value: function clear() {
	      this.data = {};
	      this.length = 0;
	      this._clearData();
	    }
	  }, {
	    key: 'getItem',
	    value: function getItem(key) {
	      return this.data[key] === undefined ? null : this.data[key];
	    }
	  }, {
	    key: 'key',
	    value: function key(i) {
	      var ctr = 0;
	      for (var k in this.data) {
	        if (ctr == i) return k;else ctr++;
	      }
	      return null;
	    }
	  }, {
	    key: 'removeItem',
	    value: function removeItem(key) {
	      if (this.data[key] === undefined) this.length--;
	      delete this.data[key];
	      this._setData();
	    }
	  }, {
	    key: 'setItem',
	    value: function setItem(key, value) {
	      if (this.data[key] === undefined) this.length++;
	      this.data[key] = value + ''; // forces the value to a string
	      this._setData();
	    }
	  }, {
	    key: '_readCookie',
	    value: function _readCookie(name) {
	      return this._getCookie(name);
	    }
	  }, {
	    key: '_setData',
	    value: function _setData() {
	      this._setCookie('localStorage', this.data, 365);
	    }
	  }, {
	    key: '_clearData',
	    value: function _clearData() {
	      this._setCookie('localStorage', '', 365);
	    }
	  }, {
	    key: '_getCookie',
	    value: function _getCookie(cname) {
	      var name = cname + "=";
	      var ca = document.cookie.split(';');
	      for (var i = 0; i < ca.length; i++) {
	        var c = ca[i];
	        while (c.charAt(0) == ' ') {
	          c = c.substring(1);
	        }
	        if (c.indexOf(name) == 0) {
	          return JSON.parse(c.substring(name.length, c.length));
	        }
	      }
	      return "";
	    }
	  }, {
	    key: '_setCookie',
	    value: function _setCookie(cname, cvalue, exdays) {
	      var d = new Date();
	      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
	      document.cookie = cname + '=' + JSON.stringify(cvalue) + ';expires=' + d.toUTCString() + ';path=/';
	    }
	  }]);
	
	  return LocalStoragePolyfill;
	}();
	
	var localStoragePolyfill = exports.localStoragePolyfill = new LocalStoragePolyfill();

/***/ }),
/* 12 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SessionStoragePolyfill = function () {
	  function SessionStoragePolyfill() {
	    _classCallCheck(this, SessionStoragePolyfill);
	
	    this.length = 0;
	
	    var data = window.name;
	
	    if (data) {
	      try {
	        this.data = JSON.parse(data);
	      } catch (e) {
	        this.data = data;
	      }
	    } else {
	      this.data = {};
	    }
	  }
	
	  _createClass(SessionStoragePolyfill, [{
	    key: 'clear',
	    value: function clear() {
	      this.data = {};
	      this.length = 0;
	      this._clearData();
	    }
	  }, {
	    key: 'getItem',
	    value: function getItem(key) {
	      return this.data[key] === undefined ? null : this.data[key];
	    }
	  }, {
	    key: 'key',
	    value: function key(i) {
	      // not perfect, but works
	      var ctr = 0;
	      for (var k in this.data) {
	        if (ctr == i) return k;else ctr++;
	      }
	      return null;
	    }
	  }, {
	    key: 'removeItem',
	    value: function removeItem(key) {
	      if (this.data[key] === undefined) this.length--;
	      delete this.data[key];
	      this._setData();
	    }
	  }, {
	    key: 'setItem',
	    value: function setItem(key, value) {
	      if (this.data[key] === undefined) this.length++;
	      this.data[key] = value + ''; // forces the value to a string
	      this._setData();
	    }
	  }, {
	    key: '_setData',
	    value: function _setData() {
	      window.name = JSON.stringify(this.data);
	    }
	  }, {
	    key: '_clearData',
	    value: function _clearData() {
	      window.name = '';
	    }
	  }]);
	
	  return SessionStoragePolyfill;
	}();
	
	var sessionStoragePolyfill = exports.sessionStoragePolyfill = new SessionStoragePolyfill();

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(7);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _config = __webpack_require__(2);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _facebook = __webpack_require__(14);
	
	var _facebook2 = _interopRequireDefault(_facebook);
	
	var _googleAnalytics = __webpack_require__(15);
	
	var _googleAnalytics2 = _interopRequireDefault(_googleAnalytics);
	
	var _googleRemarketing = __webpack_require__(16);
	
	var _googleRemarketing2 = _interopRequireDefault(_googleRemarketing);
	
	var _adroll = __webpack_require__(17);
	
	var _adroll2 = _interopRequireDefault(_adroll);
	
	var _custom = __webpack_require__(18);
	
	var _custom2 = _interopRequireDefault(_custom);
	
	var _perfectAudience = __webpack_require__(19);
	
	var _perfectAudience2 = _interopRequireDefault(_perfectAudience);
	
	var _pinterest = __webpack_require__(20);
	
	var _pinterest2 = _interopRequireDefault(_pinterest);
	
	var _twitter = __webpack_require__(21);
	
	var _twitter2 = _interopRequireDefault(_twitter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var instance = null;
	
	var Analytics = function () {
	  function Analytics() {
	    _classCallCheck(this, Analytics);
	
	    if (!instance) instance = this;
	
	    this.vsInit = false;
	    this.googleRemarketingInterval = null;
	    this.pendingEvents = [];
	
	    return instance;
	  }
	
	  _createClass(Analytics, [{
	    key: 'pageView',
	    value: function pageView(to) {
	      if (_config2.default.Analytics.enabled) {
	        this._loadVSTags();
	        if (to.name.indexOf('sales') === -1 && to.name.indexOf('checkout') === -1 && to.name !== 'thank-you' && to.name !== 'client-store') this._default();
	        this._vwo(to);
	      }
	    }
	  }, {
	    key: 'sales',
	    value: function sales(campaign, product) {
	      var coupon = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	      if (_config2.default.Analytics.enabled) this._vsSales(campaign, product, coupon);
	      if (_config2.default.ClientAnalytics.enabled) this._clientSales(campaign);
	    }
	  }, {
	    key: 'thankYou',
	    value: function thankYou(order, upsellOrder) {
	      if (_config2.default.Analytics.enabled && !upsellOrder) this._vsThankYou(order);
	      if (_config2.default.ClientAnalytics.enabled) this._clientThankYou(order, upsellOrder);
	    }
	  }, {
	    key: 'store',
	    value: function store(_store, storeUrl) {
	      if (_config2.default.Analytics.enabled) this._vsStore();
	      if (_config2.default.ClientAnalytics.enabled) this._clientStore(_store, storeUrl);
	    }
	  }, {
	    key: 'addToCart',
	    value: function addToCart(campaign, product, quantity, size) {
	      if (_config2.default.Analytics.enabled) this._vsAddToCart(campaign, product, quantity, size);
	      if (_config2.default.ClientAnalytics.enabled) this._clientAddToCart(campaign);
	    }
	  }, {
	    key: 'initiateCheckout',
	    value: function initiateCheckout(campaign, numItems) {
	      if (_config2.default.Analytics.enabled) this._vsInitiateCheckout(campaign, numItems);
	      if (_config2.default.ClientAnalytics.enabled) this._clientInitiateCheckout(campaign, numItems);
	    }
	  }, {
	    key: 'checkout',
	    value: function checkout(_ref) {
	      var cart = _ref.cart,
	          upsell = _ref.upsell,
	          option = _ref.option;
	
	      if (_config2.default.Analytics.enabled) this._vsCheckout(cart, upsell, option);
	    }
	  }, {
	    key: 'placeOrder',
	    value: function placeOrder(_ref2) {
	      var cart = _ref2.cart,
	          upsell = _ref2.upsell,
	          option = _ref2.option;
	
	      if (_config2.default.Analytics.enabled) this._vsPlaceOrder(cart, upsell, option);
	    }
	  }, {
	    key: 'removeFromCart',
	    value: function removeFromCart(product, quantity, size) {
	      if (_config2.default.Analytics.enabled) {
	        _googleAnalytics2.default.removeFromCart(product, quantity, size);
	
	        window.dataLayer.push({ 'event': 'remove-from-cart-tracking' });
	      }
	    }
	  }, {
	    key: 'changeSize',
	    value: function changeSize(size) {
	      if (_config2.default.Analytics.enabled) {
	        _googleAnalytics2.default.changeSize(size);
	
	        window.dataLayer.push({ 'event': 'change-size-tracking' });
	      }
	    }
	  }, {
	    key: 'changeQuantity',
	    value: function changeQuantity(quantity) {
	      if (_config2.default.Analytics.enabled) {
	        _googleAnalytics2.default.changeQuantity(quantity);
	
	        window.dataLayer.push({ 'event': 'change-quantity-tracking' });
	      }
	    }
	  }, {
	    key: 'changeColor',
	    value: function changeColor(color) {
	      if (_config2.default.Analytics.enabled) {
	        _googleAnalytics2.default.changeColor(color);
	
	        window.dataLayer.push({ 'event': 'change-color-tracking' });
	      }
	    }
	  }, {
	    key: 'applyCoupon',
	    value: function applyCoupon(coupon) {
	      if (_config2.default.Analytics.enabled) {
	        _googleAnalytics2.default.applyCoupon(coupon);
	
	        window.dataLayer.push({ 'event': 'apply-coupon-tracking' });
	      }
	    }
	  }, {
	    key: 'register',
	    value: function register() {
	      if (_config2.default.Analytics.enabled) {
	        _googleAnalytics2.default.register();
	        _googleRemarketing2.default.register();
	
	        this._asyncEvent('register-tracking');
	      }
	    }
	  }, {
	    key: '_loadVSTags',
	    value: function _loadVSTags() {
	      if (!this.vsInit) {
	        window.dataLayer.push({ 'event': 'load-vs-tags' });
	        this.vsInit = true;
	      }
	    }
	  }, {
	    key: '_default',
	    value: function _default() {
	      _facebook2.default.default();
	      _googleAnalytics2.default.default();
	      _googleRemarketing2.default.default();
	
	      this._asyncEvent('vs-default-tracking');
	    }
	  }, {
	    key: '_vsSales',
	    value: function _vsSales(campaign, product, coupon) {
	      if (!campaign.pixels.global.disable_vs_retargeting) {
	        _facebook2.default.vsSales(campaign);
	        _googleRemarketing2.default.vsSales(campaign);
	      }
	      _googleAnalytics2.default.vsSales(campaign, product, coupon);
	    }
	  }, {
	    key: '_clientSales',
	    value: function _clientSales(campaign) {
	      _adroll2.default.clientSales(campaign);
	      _facebook2.default.clientSales(campaign);
	      _googleRemarketing2.default.clientSales(campaign);
	      _perfectAudience2.default.clientSales(campaign);
	
	      _googleAnalytics2.default.clientSales(campaign);
	    }
	  }, {
	    key: '_vsThankYou',
	    value: function _vsThankYou(order) {
	      if (!order.campaign.pixels.global.disable_vs_retargeting) {
	        _facebook2.default.vsThankYou(order);
	        _googleRemarketing2.default.vsThankYou(order);
	      }
	      _googleAnalytics2.default.vsThankYou(order);
	    }
	  }, {
	    key: '_clientThankYou',
	    value: function _clientThankYou(order, upsellOrder) {
	      if (!upsellOrder) {
	        _adroll2.default.clientThankYou(order);
	        _custom2.default.clientThankYou(order);
	        _facebook2.default.clientThankYou(order);
	        _googleRemarketing2.default.clientThankYou(order);
	        _perfectAudience2.default.clientThankYou(order);
	        _pinterest2.default.clientThankYou(order);
	        _twitter2.default.clientThankYou(order);
	      }
	
	      _googleAnalytics2.default.clientThankYou(order, upsellOrder);
	    }
	  }, {
	    key: '_vsStore',
	    value: function _vsStore() {
	      this._default();
	    }
	  }, {
	    key: '_clientStore',
	    value: function _clientStore(store, storeUrl) {
	      _facebook2.default.clientStore(store, storeUrl);
	
	      _googleAnalytics2.default.clientStore(store);
	    }
	  }, {
	    key: '_vsAddToCart',
	    value: function _vsAddToCart(campaign, product, quantity, size) {
	      if (!campaign.pixels.global.disable_vs_retargeting) _facebook2.default.vsAddToCart(campaign);
	      _googleAnalytics2.default.addToCart(product, quantity, size);
	
	      window.dataLayer.push({ 'event': 'vs-add-to-cart-tracking' });
	    }
	  }, {
	    key: '_clientAddToCart',
	    value: function _clientAddToCart(campaign) {
	      _facebook2.default.clientAddToCart(campaign);
	    }
	  }, {
	    key: '_vsInitiateCheckout',
	    value: function _vsInitiateCheckout(campaign, numItems) {
	      if (!campaign.pixels.global.disable_vs_retargeting) {
	        _facebook2.default.vsInitiateCheckout(campaign, numItems);
	
	        window.dataLayer.push({ 'event': 'vs-initiate-checkout-tracking' });
	      }
	    }
	  }, {
	    key: '_vsCheckout',
	    value: function _vsCheckout(cart, upsell, option) {
	      _googleAnalytics2.default.checkout(cart, upsell, option);
	
	      window.dataLayer.push({ 'event': 'vs-checkout-tracking' });
	    }
	  }, {
	    key: '_clientInitiateCheckout',
	    value: function _clientInitiateCheckout(campaign, numItems) {
	      _facebook2.default.clientInitiateCheckout(campaign, numItems);
	    }
	  }, {
	    key: '_vsPlaceOrder',
	    value: function _vsPlaceOrder(cart, upsell, option) {
	      _googleAnalytics2.default.placeOrder(cart, upsell, option);
	
	      window.dataLayer.push({ 'event': 'vs-place-order-tracking' });
	    }
	  }, {
	    key: '_vwo',
	    value: function _vwo(to) {
	      if (_config2.default.VWO.enabled) {
	        var url = void 0;
	        switch (to.name) {
	          // uncomment to enable store
	          // case 'sales-store':
	          //   url = `https://viralstyle.com/salespage2${location.pathname}`;
	          //   break;
	          // uncomment to enable checkout
	          // case 'checkout':
	          //   url = `https://viralstyle.com/checkout2`;
	          //   break;
	          case 'thank-you':
	            url = 'https://viralstyle.com/thankyou2';
	            break;
	        }
	        if (url) {
	          window.dataLayer.push({ 'vwoUrl': url });
	          window.dataLayer.push({ 'vwoId': _config2.default.VWO.id });
	          window.dataLayer.push({ 'event': 'vwo' });
	        }
	      }
	    }
	  }, {
	    key: '_asyncEvent',
	    value: function _asyncEvent(event) {
	      var _this = this;
	
	      if (window.google_trackConversion) {
	        window.dataLayer.push({ event: event });
	      } else {
	        // async tags -__-
	        this.pendingEvents.push(event);
	        if (!this.googleRemarketingInterval) {
	          this.googleRemarketingInterval = setInterval(function () {
	            if (window.google_trackConversion) {
	              clearInterval(_this.googleRemarketingInterval);
	              _this.googleRemarketingInterval = null;
	              _lodash2.default.each(_this.pendingEvents, function (pendingEvent) {
	                return window.dataLayer.push({ event: pendingEvent });
	              });
	              _this.pendingEvents = [];
	            }
	          }, 100);
	        }
	      }
	    }
	  }]);
	
	  return Analytics;
	}();
	
	exports.default = Analytics;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(7);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _config = __webpack_require__(2);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FacebookAnalytics = function () {
	  function FacebookAnalytics() {
	    _classCallCheck(this, FacebookAnalytics);
	
	    this.vsFacebookInit = false;
	  }
	
	  _createClass(FacebookAnalytics, [{
	    key: 'default',
	    value: function _default() {
	      window.dataLayer.push({ 'vsFacebookAcquisitionId': _config2.default.Analytics.facebookAcquisitionID });
	    }
	  }, {
	    key: 'vsSales',
	    value: function vsSales(campaign) {
	      var pageViewPaylod = this._pageViewPayload(campaign),
	          viewContentPayload = _lodash2.default.clone(pageViewPaylod);
	
	      viewContentPayload.campaign_url = campaign.creator.user_info.public_name + '/' + campaign.slug;
	
	      window.dataLayer.push({ 'vsFacebookPageViewPayload': pageViewPaylod });
	      window.dataLayer.push({ 'vsFacebookViewContentPayload': viewContentPayload });
	      window.dataLayer.push({ 'vsFacebookPixelId': _config2.default.Analytics.facebookPixelID });
	
	      window.dataLayer.push({ 'event': 'vs-facebook-sales-tracking' });
	    }
	  }, {
	    key: '_globalPixelIsNotCampaignPixel',
	    value: function _globalPixelIsNotCampaignPixel(campaign) {
	      return campaign.pixels.campaign.facebook.id !== campaign.pixels.global.facebook.id;
	    }
	  }, {
	    key: 'clientSales',
	    value: function clientSales(campaign) {
	      this._clientSalesHelper(campaign.pixels.campaign, campaign);
	
	      if (this._globalPixelIsNotCampaignPixel(campaign)) {
	        this._clientSalesHelper(campaign.pixels.global, campaign);
	      }
	    }
	  }, {
	    key: '_clientSalesHelper',
	    value: function _clientSalesHelper(pixels, campaign) {
	      if (pixels.facebook.id) {
	        var pageViewPayload = this._clientPageViewPayload(campaign),
	            viewContentPayload = _lodash2.default.clone(pageViewPayload);
	
	        viewContentPayload = this._mapCustomVars(viewContentPayload, pixels.facebook.custom_vars.VIEW_CONTENT);
	
	        viewContentPayload.content_ids = [campaign.slug];
	        viewContentPayload.content_type = 'product';
	
	        window.dataLayer.push({ 'clientFacebookViewContentPayload': undefined });
	        window.dataLayer.push({ 'clientFacebookPageViewPayload': pageViewPayload });
	        window.dataLayer.push({ 'clientFacebookViewContentPayload': viewContentPayload });
	        window.dataLayer.push({ 'clientFacebookPixelId': pixels.facebook.id });
	
	        window.dataLayer.push({ 'event': 'client-facebook-sales-tracking' });
	      }
	    }
	  }, {
	    key: 'vsThankYou',
	    value: function vsThankYou(order) {
	      var pageViewPayload = this._pageViewPayload(order.campaign),
	          purchasePayload = _lodash2.default.clone(pageViewPayload);
	
	      purchasePayload = this._purchasePayload(order, purchasePayload, this._numItems(order));
	
	      window.dataLayer.push({ 'vsFacebookPageViewPayload': pageViewPayload });
	      window.dataLayer.push({ 'vsFacebookPurchasePayload': purchasePayload });
	      window.dataLayer.push({ 'vsFacebookPixelId': _config2.default.Analytics.facebookPixelID });
	
	      window.dataLayer.push({ 'event': 'vs-facebook-thank-you-tracking' });
	    }
	  }, {
	    key: 'clientThankYou',
	    value: function clientThankYou(order) {
	      this._clientThankYouHelper(order.campaign.pixels.campaign, order);
	
	      if (this._globalPixelIsNotCampaignPixel(order.campaign)) {
	        this._clientThankYouHelper(order.campaign.pixels.global, order);
	      }
	    }
	  }, {
	    key: '_clientThankYouHelper',
	    value: function _clientThankYouHelper(pixels, order) {
	      if (pixels.facebook.id) {
	        var pageViewPayload = this._clientPageViewPayload(order.campaign),
	            purchasePayload = _lodash2.default.clone(pageViewPayload);
	
	        purchasePayload = this._purchasePayload(order, purchasePayload, this._numItems(order));
	        purchasePayload = this._mapCustomVars(purchasePayload, pixels.facebook.custom_vars.PURCHASE);
	
	        purchasePayload.content_ids = [order.campaign.slug];
	        purchasePayload.content_type = 'product';
	
	        window.dataLayer.push({ 'clientFacebookPurchasePayload': undefined });
	        window.dataLayer.push({ 'clientFacebookPageViewPayload': pageViewPayload });
	        window.dataLayer.push({ 'clientFacebookPurchasePayload': purchasePayload });
	        window.dataLayer.push({ 'clientFacebookPixelId': pixels.facebook.id });
	
	        window.dataLayer.push({ 'event': 'client-facebook-thank-you-tracking' });
	      }
	    }
	  }, {
	    key: 'clientStore',
	    value: function clientStore(store, storeUrl) {
	      if (store.tracking_pixels.facebook) {
	        var clientFacebookStorePayload = {
	          content_name: store.name,
	          store_url: storeUrl || '',
	          content_type: 'product_group'
	        };
	
	        window.dataLayer.push({ 'clientFacebookStorePayload': clientFacebookStorePayload });
	        window.dataLayer.push({ 'clientFacebookStorePixelId': store.tracking_pixels.facebook });
	
	        window.dataLayer.push({ 'event': 'client-facebook-store-tracking' });
	      }
	    }
	  }, {
	    key: 'vsAddToCart',
	    value: function vsAddToCart(campaign) {
	      var addToCartPayload = this._pageViewPayload(campaign);
	
	      window.dataLayer.push({ 'vsFacebookPixelId': _config2.default.Analytics.facebookPixelID });
	      window.dataLayer.push({ 'vsFacebookAddToCartPayload': addToCartPayload });
	    }
	  }, {
	    key: 'clientAddToCart',
	    value: function clientAddToCart(campaign) {
	      this._clientAddToCartHelper(campaign.pixels.campaign, campaign);
	
	      if (this._globalPixelIsNotCampaignPixel(campaign)) {
	        this._clientAddToCartHelper(campaign.pixels.global, campaign);
	      }
	    }
	  }, {
	    key: '_clientAddToCartHelper',
	    value: function _clientAddToCartHelper(pixels, campaign) {
	      if (pixels.facebook.id) {
	        var clientAddToCartPayload = this._clientPageViewPayload(campaign);
	        clientAddToCartPayload = this._mapCustomVars(clientAddToCartPayload, pixels.facebook.custom_vars.ADD_TO_CART);
	
	        clientAddToCartPayload.content_ids = [campaign.slug];
	        clientAddToCartPayload.content_type = 'product';
	
	        window.dataLayer.push({ 'clientFacebookAddToCartPayload': undefined });
	        window.dataLayer.push({ 'clientFacebookPixelId': pixels.facebook.id });
	        window.dataLayer.push({ 'clientFacebookAddToCartPayload': clientAddToCartPayload });
	
	        window.dataLayer.push({ 'event': 'client-add-to-cart-tracking' });
	      }
	    }
	  }, {
	    key: 'vsInitiateCheckout',
	    value: function vsInitiateCheckout(campaign, numItems) {
	      var initiateCheckoutPayload = this._pageViewPayload(campaign);
	      initiateCheckoutPayload.num_items = numItems;
	
	      window.dataLayer.push({ 'vsFacebookPixelId': _config2.default.Analytics.facebookPixelID });
	      window.dataLayer.push({ 'vsFacebookInitiateCheckoutPayload': initiateCheckoutPayload });
	    }
	  }, {
	    key: 'clientInitiateCheckout',
	    value: function clientInitiateCheckout(campaign, numItems) {
	      this._clientInitiateCheckoutHelper(campaign.pixels.campaign, campaign, numItems);
	
	      if (this._globalPixelIsNotCampaignPixel(campaign)) {
	        this._clientInitiateCheckoutHelper(campaign.pixels.global, campaign, numItems);
	      }
	    }
	  }, {
	    key: '_clientInitiateCheckoutHelper',
	    value: function _clientInitiateCheckoutHelper(pixels, campaign, numItems) {
	      if (pixels.facebook.id) {
	        var clientInitiateCheckoutPayload = this._clientPageViewPayload(campaign);
	        clientInitiateCheckoutPayload.num_items = numItems;
	        clientInitiateCheckoutPayload = this._mapCustomVars(clientInitiateCheckoutPayload, pixels.facebook.custom_vars.INITIATE_CHECKOUT);
	
	        window.dataLayer.push({ 'clientFacebookInitiateCheckoutPayload': undefined });
	        window.dataLayer.push({ 'clientFacebookPixelId': pixels.facebook.id });
	        window.dataLayer.push({ 'clientFacebookInitiateCheckoutPayload': clientInitiateCheckoutPayload });
	
	        window.dataLayer.push({ 'event': 'client-initiate-checkout-tracking' });
	      }
	    }
	  }, {
	    key: '_purchasePayload',
	    value: function _purchasePayload(order, purchasePayload, numItems) {
	      purchasePayload.value = '' + (order.price.sub_total - order.price.coupon_discount).toFixed(2);
	      purchasePayload.currency = 'USD';
	      purchasePayload.num_items = '' + numItems;
	      return purchasePayload;
	    }
	  }, {
	    key: '_numItems',
	    value: function _numItems(order) {
	      var numItems = 0;
	      for (var i = 0; i < order.order_products.length; i++) {
	        numItems += order.order_products[i].quantity;
	      }
	      return numItems;
	    }
	  }, {
	    key: '_mapCustomVars',
	    value: function _mapCustomVars(payload, customObj) {
	      _lodash2.default.each(customObj, function (customVar) {
	        return payload[customVar.key] = customVar.value;
	      });
	      return payload;
	    }
	  }, {
	    key: '_pageViewPayload',
	    value: function _pageViewPayload(campaign) {
	      return {
	        content_ids: [campaign.id || ''],
	        content_type: 'product',
	        product_category: this._getCategoryFromCampaign(campaign)
	      };
	    }
	  }, {
	    key: '_clientPageViewPayload',
	    value: function _clientPageViewPayload(campaign) {
	      return {
	        content_name: campaign.name,
	        campaign_url: campaign.creator.user_info.public_name + '/' + campaign.slug || '',
	        product_category: this._getCategoryFromCampaign(campaign)
	      };
	    }
	  }, {
	    key: '_getCategoryFromCampaign',
	    value: function _getCategoryFromCampaign(campaign) {
	      var category = void 0;
	      var hasParent = false,
	          hasSub = false;
	
	      if (campaign && campaign.category && typeof campaign.category.parent_category !== 'undefined' && campaign.category.parent_category !== null) {
	        category = campaign.category.parent_category;
	        hasParent = true;
	      }
	
	      if (hasParent && typeof campaign.category.name !== 'undefined' && campaign.category.name !== null) {
	        category += ' > ' + campaign.category.name;
	        hasSub = true;
	      }
	
	      if (!hasParent && !hasSub) category = null;
	
	      return category;
	    }
	  }]);
	
	  return FacebookAnalytics;
	}();
	
	exports.default = new FacebookAnalytics();

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _config = __webpack_require__(2);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var GoogleAnalytics = function () {
	  function GoogleAnalytics() {
	    _classCallCheck(this, GoogleAnalytics);
	  }
	
	  _createClass(GoogleAnalytics, [{
	    key: 'default',
	    value: function _default() {
	      window.dataLayer.push({ 'vsGoogleAnalyticsId': _config2.default.Analytics.googleID });
	      window.dataLayer.push({ 'vsGoogleAnalyticsDomain': _config2.default.Analytics.domain });
	    }
	  }, {
	    key: 'vsSales',
	    value: function vsSales(campaign, product, coupon) {
	      var productPayload = {
	        id: '' + product.product.id,
	        name: '' + product.product.sku,
	        variant: '' + product.product_color.name,
	        price: '' + product.selling_price
	      };
	
	      if (coupon) productPayload.coupon = '' + coupon;
	
	      window.dataLayer.push({ 'vsGoogleAnalyticsId': _config2.default.Analytics.googleID });
	      window.dataLayer.push({ 'vsGoogleAnalyticsDomain': _config2.default.Analytics.domain });
	      window.dataLayer.push({ 'vsGoogleAnalyticsCampaignId': '' + campaign.id });
	      window.dataLayer.push({ 'vsGoogleAnalyticsCreatorId': '' + campaign.creator.id });
	      window.dataLayer.push({ 'vsGoogleAnalyticsProductPayload': productPayload });
	
	      window.dataLayer.push({ 'event': 'vs-google-analytics-sales-tracking' });
	    }
	  }, {
	    key: 'clientSales',
	    value: function clientSales(campaign) {
	      if (campaign.creator.user_info.google_analytics_code) {
	        window.dataLayer.push({ 'clientGoogleAnalyticsId': campaign.creator.user_info.google_analytics_code });
	
	        window.dataLayer.push({ 'event': 'client-google-analytics-tracking' });
	      }
	    }
	  }, {
	    key: 'vsThankYou',
	    value: function vsThankYou(order) {
	      var coupon = order.campaign_upsell != null ? 'upsell' : order.coupon.code,
	          products = order.order_products,
	          productsPayload = [],
	          purchasePayload = this._purchasePayload(order);
	
	      if (coupon) purchasePayload['coupon'] = coupon;
	
	      for (var i = 0; i < products.length; i++) {
	        var cp = products[i].campaign_product;
	        var product = {
	          id: '' + cp.product.id,
	          name: '' + cp.product.sku,
	          variant: '' + cp.product_color.name,
	          price: '' + (cp.selling_price + cp.product.upcharges[products[i].size]),
	          quantity: '' + products[i].quantity,
	          'dimension7': '' + products[i].size
	        };
	        if (coupon) product['coupon'] = coupon;
	        productsPayload.push(product);
	      }
	
	      window.dataLayer.push({ 'vsGoogleAnalyticsId': _config2.default.Analytics.googleID });
	      window.dataLayer.push({ 'vsGoogleAnalyticsDomain': _config2.default.Analytics.domain });
	      window.dataLayer.push({ 'vsGoogleAnalyticsPaymentType': order.transaction.payment_type });
	      window.dataLayer.push({ 'vsGoogleAnalyticsCurrency': order.transaction.currency });
	      window.dataLayer.push({ 'vsGoogleAnalyticsProductsPayload': productsPayload });
	      window.dataLayer.push({ 'vsGoogleAnalyticsPurchasePayload': purchasePayload });
	
	      window.dataLayer.push({ 'event': 'vs-google-analytics-thank-you-tracking' });
	    }
	  }, {
	    key: 'clientThankYou',
	    value: function clientThankYou(order, upsellOrder) {
	      if (order && order.campaign.creator.user_info.google_analytics_code) {
	        var clientGoogleAnalyticsPayload = this._purchasePayload(order);
	
	        window.dataLayer.push({ 'clientGoogleAnalyticsPayload': clientGoogleAnalyticsPayload });
	        window.dataLayer.push({ 'clientGoogleAnalyticsId': order.campaign.creator.user_info.google_analytics_code });
	
	        window.dataLayer.push({ 'event': 'client-google-analytics-tracking' });
	        window.dataLayer.push({ 'event': 'client-google-analytics-thank-you-tracking' });
	      }
	
	      if (upsellOrder && upsellOrder.campaign.creator.user_info.google_analytics_code) {
	        var clientGoogleAnalyticsUpsellPayload = this._purchasePayload(upsellOrder);
	
	        window.dataLayer.push({ 'clientGoogleAnalyticsUpsellPayload': clientGoogleAnalyticsUpsellPayload });
	        window.dataLayer.push({ 'clientGoogleAnalyticsId': upsellOrder.campaign.creator.user_info.google_analytics_code });
	
	        window.dataLayer.push({ 'event': 'client-google-analytics-thank-you-upsell-tracking' });
	      }
	    }
	  }, {
	    key: 'clientStore',
	    value: function clientStore(store) {
	      if (store.google_analytics) {
	        window.dataLayer.push({ 'clientGoogleAnalyticsId': store.google_analytics });
	
	        window.dataLayer.push({ 'event': 'client-google-analytics-tracking' });
	      }
	    }
	  }, {
	    key: 'addToCart',
	    value: function addToCart(product, quantity, size) {
	      product.size = size;
	      var productPayload = this._productPayload(product);
	      productPayload.quantity = quantity;
	      productPayload['dimension7'] = size;
	
	      window.dataLayer.push({ 'vsGoogleAnalyticsAddToCartPayload': productPayload });
	    }
	  }, {
	    key: 'removeFromCart',
	    value: function removeFromCart(product, quantity, size) {
	      product.size = size;
	      var productPayload = this._productPayload(product);
	      productPayload.quantity = quantity;
	      productPayload['dimension7'] = size;
	
	      window.dataLayer.push({ 'vsGoogleAnalyticsRemoveFromCartPayload': productPayload });
	    }
	  }, {
	    key: 'changeSize',
	    value: function changeSize(size) {
	      window.dataLayer.push({ 'vsGoogleAnalyticsSize': size });
	    }
	  }, {
	    key: 'changeQuantity',
	    value: function changeQuantity(quantity) {
	      window.dataLayer.push({ 'vsGoogleAnalyticsQuantity': quantity });
	    }
	  }, {
	    key: 'changeColor',
	    value: function changeColor(color) {
	      window.dataLayer.push({ 'vsGoogleAnalyticsColor': color });
	    }
	  }, {
	    key: 'applyCoupon',
	    value: function applyCoupon(coupon) {
	      window.dataLayer.push({ 'vsGoogleAnalyticsCoupon': coupon });
	    }
	  }, {
	    key: 'checkout',
	    value: function checkout(cart, isUpsell, option) {
	      this._checkout(cart, isUpsell, option);
	    }
	  }, {
	    key: 'placeOrder',
	    value: function placeOrder(cart, isUpsell, option) {
	      this._checkout(cart, isUpsell, option, 2);
	    }
	  }, {
	    key: 'register',
	    value: function register() {
	      window.dataLayer.push({ 'vsGoogleAnalyticsId': _config2.default.Analytics.googleID });
	      window.dataLayer.push({ 'vsGoogleAnalyticsDomain': _config2.default.Analytics.domain });
	    }
	  }, {
	    key: '_productPayload',
	    value: function _productPayload(product) {
	      return {
	        'id': '' + product.product.id,
	        'name': '' + product.product.sku,
	        'variant': '' + product.product_color.name,
	        'price': '' + (product.selling_price + product.product.upcharges[product.size])
	      };
	    }
	  }, {
	    key: '_checkout',
	    value: function _checkout(cart) {
	      var isUpsell = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      var option = arguments[2];
	      var step = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
	
	      if (!isUpsell) {
	        var productsPayload = [];
	
	        for (var i = 0; i < cart.length; i++) {
	          var productPayload = this._productPayload(cart[i]);
	          productPayload.quantity = cart[i].qty;
	          productPayload['dimension7'] = cart[i].size;
	          productsPayload.push(productPayload);
	        }
	
	        window.dataLayer.push({ 'vsGoogleAnalyticsCheckoutProductsPayload': productsPayload });
	      } else {
	        window.dataLayer.push({ 'vsGoogleAnalyticsId': _config2.default.Analytics.googleID });
	        window.dataLayer.push({ 'vsGoogleAnalyticsDomain': _config2.default.Analytics.domain });
	      }
	
	      var checkoutPayload = { step: step };
	      if (option) checkoutPayload.option = option;
	
	      if (step === 1) {
	        window.dataLayer.push({ 'vsGoogleAnalyticsCheckoutStep1Payload': checkoutPayload });
	      } else {
	        window.dataLayer.push({ 'vsGoogleAnalyticsCheckoutStep2Payload': checkoutPayload });
	      }
	    }
	  }, {
	    key: '_purchasePayload',
	    value: function _purchasePayload(order) {
	      var shipping = order.price.shipping_cost - order.price.shipping_discount;
	
	      if (shipping < 0) shipping = 0;
	
	      return {
	        id: '' + order.order_num,
	        affiliation: '' + order.campaign_id,
	        revenue: '' + (order.price.sub_total - order.price.coupon_discount).toFixed(2),
	        shipping: '' + shipping.toFixed(2),
	        tax: '' + order.price.sales_tax.toFixed(2)
	      };
	    }
	  }]);
	
	  return GoogleAnalytics;
	}();
	
	exports.default = new GoogleAnalytics();

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(7);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _config = __webpack_require__(2);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var GoogleRemarketing = function () {
	  function GoogleRemarketing() {
	    _classCallCheck(this, GoogleRemarketing);
	
	    this.googleRemarketingInterval = null;
	    this.pendingEvents = [];
	  }
	
	  _createClass(GoogleRemarketing, [{
	    key: 'default',
	    value: function _default() {
	      var googleRemarketingCustomParams = {
	        ecomm_prodid: '1',
	        ecomm_pagetype: 'other'
	      },
	          googleRemarketingPayload = this._remarketingPayload(_config2.default.Analytics.googleRetargetID, googleRemarketingCustomParams);
	
	      window.dataLayer.push({ 'vsGoogleRemarketingPayload': googleRemarketingPayload });
	    }
	  }, {
	    key: 'vsSales',
	    value: function vsSales(campaign) {
	      if (!campaign.pixels.global.disable_vs_retargeting) {
	        var googleRemarketingCustomParams = this._salesPayload(campaign),
	            googleRemarketingPayload = this._remarketingPayload(_config2.default.Analytics.googleRetargetID, googleRemarketingCustomParams);
	
	        window.dataLayer.push({ 'vsGoogleRemarketingPayload': googleRemarketingPayload });
	
	        this._asyncEvent('vs-google-remarketing-sales-tracking');
	      }
	    }
	  }, {
	    key: '_globalPixelIsNotCampaignPixel',
	    value: function _globalPixelIsNotCampaignPixel(campaign) {
	      return campaign.pixels.campaign.google.id !== campaign.pixels.global.google.id;
	    }
	  }, {
	    key: 'clientSales',
	    value: function clientSales(campaign) {
	      this._clientSalesHelper(campaign.pixels.campaign, campaign);
	
	      if (this._globalPixelIsNotCampaignPixel(campaign)) {
	        this._clientSalesHelper(campaign.pixels.global, campaign);
	      }
	    }
	  }, {
	    key: '_clientSalesHelper',
	    value: function _clientSalesHelper(pixels, campaign) {
	      if (pixels.google.id) {
	        var googleRemarketingCustomParams = this._salesPayload(campaign),
	            googleRemarketingPayload = this._remarketingPayload(pixels.google.id, googleRemarketingCustomParams, true, pixels.google.label);
	
	        window.dataLayer.push({ 'clientGoogleRemarketingPayload': undefined });
	        window.dataLayer.push({ 'clientGoogleRemarketingPayload': googleRemarketingPayload });
	
	        this._asyncEvent('client-google-remarketing-tracking');
	      }
	    }
	  }, {
	    key: 'vsThankYou',
	    value: function vsThankYou(order) {
	      var googleRemarketingCustomParams = this._thankYouPayload(order),
	          googleRemarketingPayload = this._remarketingPayload(_config2.default.Analytics.googleRetargetID, googleRemarketingCustomParams),
	          thankYouRemarkertingPayload = {
	        google_conversion_id: _config2.default.Analytics.googleRetargetID,
	        google_conversion_language: 'en',
	        google_conversion_format: '3',
	        google_conversion_color: 'ffffff',
	        google_conversion_label: 'gva2CLne_mEQvNehzQM',
	        google_remarketing_only: false
	      },
	          thankYouRemarkertingPayload2 = {
	        google_conversion_id: _config2.default.Analytics.googleAdwordsID,
	        google_conversion_language: 'en',
	        google_conversion_format: '3',
	        google_conversion_color: 'ffffff',
	        google_conversion_label: 'TEdcCP2zjGcQrrH5vQM',
	        google_conversion_value: '' + (order.price.sub_total - order.price.coupon_discount).toFixed(2),
	        google_conversion_currency: 'USD',
	        google_remarketing_only: false
	      };
	
	      window.dataLayer.push({ 'vsGoogleRemarketingPayloadThankYou': thankYouRemarkertingPayload });
	      window.dataLayer.push({ 'vsGoogleRemarketingPayloadThankYou2': thankYouRemarkertingPayload2 });
	      window.dataLayer.push({ 'vsGoogleRemarketingPayload': googleRemarketingPayload });
	
	      this._asyncEvent('vs-google-remarketing-thank-you-tracking');
	    }
	  }, {
	    key: 'clientThankYou',
	    value: function clientThankYou(order) {
	      this._clientThankYouHelper(order.campaign.pixels.campaign, order);
	
	      if (this._globalPixelIsNotCampaignPixel(order.campaign)) {
	        this._clientThankYouHelper(order.campaign.pixels.global, order);
	      }
	    }
	  }, {
	    key: '_clientThankYouHelper',
	    value: function _clientThankYouHelper(pixels, order) {
	      if (pixels.google.id) {
	        var googleRemarketingCustomParams = this._salesPayload(order.campaign),
	            googleRemarketingPayload = this._remarketingPayload(pixels.google.id, googleRemarketingCustomParams, true, pixels.google.label),
	            googleRemarketingThankYouCustomParams = this._thankYouPayload(order),
	            googleRemarketingThankYouPayload = this._remarketingPayload(pixels.google.id, googleRemarketingThankYouCustomParams, false, pixels.google.label);
	
	        window.dataLayer.push({ 'clientGoogleRemarketingPayload': undefined });
	        window.dataLayer.push({ 'clientGoogleRemarketingThankYouPayload': undefined });
	        window.dataLayer.push({ 'clientGoogleRemarketingPayload': googleRemarketingPayload });
	        window.dataLayer.push({ 'clientGoogleRemarketingThankYouPayload': googleRemarketingThankYouPayload });
	
	        this._asyncEvent('client-google-remarketing-tracking');
	        this._asyncEvent('client-google-remarketing-thank-you-tracking');
	      }
	    }
	  }, {
	    key: 'register',
	    value: function register() {
	      window.dataLayer.push({
	        'vsGoogleRemarketingRegisterPayload': {
	          google_conversion_id: _config2.default.Analytics.googleRetargetID,
	          google_conversion_label: "8wYGCPD75WYQvNehzQM",
	          google_conversion_format: "3",
	          google_remarketing_only: false
	        }
	      });
	      window.dataLayer.push({
	        'vsGoogleRemarketingRegister2Payload': {
	          google_conversion_id: _config2.default.Analytics.googleAdwordsID,
	          google_conversion_label: "ivwfCODPoGcQrrH5vQM",
	          google_conversion_format: "3",
	          google_remarketing_only: false
	        }
	      });
	    }
	  }, {
	    key: '_remarketingPayload',
	    value: function _remarketingPayload(id, customParams) {
	      var remarketingOnly = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	      var conversionLabel = arguments[3];
	
	      var payload = {
	        google_conversion_id: id,
	        google_custom_params: customParams,
	        google_remarketing_only: remarketingOnly
	      };
	      if (conversionLabel) payload.google_conversion_label = conversionLabel;
	      return payload;
	    }
	  }, {
	    key: '_salesPayload',
	    value: function _salesPayload(campaign) {
	      return {
	        ecomm_prodid: campaign.id || '',
	        ecomm_pagetype: 'product'
	      };
	    }
	  }, {
	    key: '_thankYouPayload',
	    value: function _thankYouPayload(order) {
	      return {
	        ecomm_prodid: order.campaign_id || '',
	        ecomm_pagetype: 'purchase',
	        ecomm_totalvalue: '' + (order.price.sub_total - order.price.coupon_discount).toFixed(2)
	      };
	    }
	  }, {
	    key: '_asyncEvent',
	    value: function _asyncEvent(event) {
	      var _this = this;
	
	      if (window.google_trackConversion) {
	        window.dataLayer.push({ event: event });
	      } else {
	        // async tags -__-
	        this.pendingEvents.push(event);
	        if (!this.googleRemarketingInterval) {
	          this.googleRemarketingInterval = setInterval(function () {
	            if (window.google_trackConversion) {
	              clearInterval(_this.googleRemarketingInterval);
	              _this.googleRemarketingInterval = null;
	              _lodash2.default.each(_this.pendingEvents, function (pendingEvent) {
	                return window.dataLayer.push({ event: pendingEvent });
	              });
	              _this.pendingEvents = [];
	            }
	          }, 100);
	        }
	      }
	    }
	  }]);
	
	  return GoogleRemarketing;
	}();
	
	exports.default = new GoogleRemarketing();

/***/ }),
/* 17 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AdrollAnalytics = function () {
	  function AdrollAnalytics() {
	    _classCallCheck(this, AdrollAnalytics);
	  }
	
	  _createClass(AdrollAnalytics, [{
	    key: 'clientSales',
	    value: function clientSales(campaign) {
	      this._triggerHelper(campaign.pixels.campaign, campaign.pixels.global);
	    }
	  }, {
	    key: 'clientThankYou',
	    value: function clientThankYou(order) {
	      this._triggerHelper(order.campaign.pixels.campaign, order.campaign.pixels.global);
	    }
	  }, {
	    key: '_triggerHelper',
	    value: function _triggerHelper(campaignPixels, globalPixels) {
	      this._trigger(campaignPixels);
	
	      if (campaignPixels.adroll.pixel_id !== globalPixels.adroll.pixel_id && campaignPixels.adroll.adv_id !== globalPixels.adroll.adv_id) {
	        this._trigger(globalPixels);
	      }
	    }
	  }, {
	    key: '_trigger',
	    value: function _trigger(pixels) {
	      if (pixels.adroll.pixel_id && pixels.adroll.adv_id) {
	        window.dataLayer.push({ clientAdrollAdvId: pixels.adroll.adv_id }, { clientAdrollPixelId: pixels.adroll.pixel_id }, { event: 'client-adroll-tracking' });
	      }
	    }
	  }]);
	
	  return AdrollAnalytics;
	}();
	
	exports.default = new AdrollAnalytics();

/***/ }),
/* 18 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CustomAnalytics = function () {
	  function CustomAnalytics() {
	    _classCallCheck(this, CustomAnalytics);
	  }
	
	  _createClass(CustomAnalytics, [{
	    key: 'clientThankYou',
	    value: function clientThankYou(order) {
	      this._trigger(order.campaign.pixels.campaign);
	
	      if (order.campaign.pixels.campaign.custom !== order.campaign.pixels.global.custom) {
	        this._trigger(order.campaign.pixels.global);
	      }
	    }
	  }, {
	    key: '_trigger',
	    value: function _trigger(pixels) {
	      if (pixels.custom) {
	        window.dataLayer.push({ clientCustomId: pixels.custom }, { event: 'client-custom-tracking' });
	      }
	    }
	  }]);
	
	  return CustomAnalytics;
	}();
	
	exports.default = new CustomAnalytics();

/***/ }),
/* 19 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PerfectAudienceAnalytics = function () {
	  function PerfectAudienceAnalytics() {
	    _classCallCheck(this, PerfectAudienceAnalytics);
	  }
	
	  _createClass(PerfectAudienceAnalytics, [{
	    key: 'clientSales',
	    value: function clientSales(campaign) {
	      this._trigger(campaign.pixels.campaign);
	
	      if (this._globalPixelIsNotCampaignPixel(campaign)) {
	        this._trigger(campaign.pixels.global);
	      }
	    }
	  }, {
	    key: 'clientThankYou',
	    value: function clientThankYou(order) {
	      this._trigger(order.campaign.pixels.campaign);
	
	      if (this._globalPixelIsNotCampaignPixel(order.campaign)) {
	        this._trigger(order.campaign.pixels.global);
	      }
	    }
	  }, {
	    key: '_globalPixelIsNotCampaignPixel',
	    value: function _globalPixelIsNotCampaignPixel(campaign) {
	      return campaign.pixels.campaign.perfect !== campaign.pixels.global.perfect;
	    }
	  }, {
	    key: '_trigger',
	    value: function _trigger(pixels) {
	      if (pixels.perfect) {
	        window.dataLayer.push({ 'clientPerfectAudiencePixelId': pixels.perfect });
	        window.dataLayer.push({ 'event': 'client-perfect-audience-tracking' });
	      }
	    }
	  }]);
	
	  return PerfectAudienceAnalytics;
	}();
	
	exports.default = new PerfectAudienceAnalytics();

/***/ }),
/* 20 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PinterestAnalytics = function () {
	  function PinterestAnalytics() {
	    _classCallCheck(this, PinterestAnalytics);
	  }
	
	  _createClass(PinterestAnalytics, [{
	    key: 'clientThankYou',
	    value: function clientThankYou(order) {
	      this._trigger(order.campaign.pixels.campaign);
	
	      if (order.campaign.pixels.campaign.pinterest !== order.campaign.pixels.global.pinterest) {
	        this._trigger(order.campaign.pixels.global);
	      }
	    }
	  }, {
	    key: '_trigger',
	    value: function _trigger(pixels) {
	      if (pixels.pinterest) {
	        window.dataLayer.push({ 'clientPinterestPixelId': pixels.pinterest });
	        window.dataLayer.push({ 'event': 'client-pinterest-tracking' });
	      }
	    }
	  }]);
	
	  return PinterestAnalytics;
	}();
	
	exports.default = new PinterestAnalytics();

/***/ }),
/* 21 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var TwitterAnalytics = function () {
	  function TwitterAnalytics() {
	    _classCallCheck(this, TwitterAnalytics);
	  }
	
	  _createClass(TwitterAnalytics, [{
	    key: 'clientThankYou',
	    value: function clientThankYou(order) {
	      this._trigger(order.campaign.pixels.campaign);
	
	      if (order.campaign.pixels.campaign.twitter !== order.campaign.pixels.global.twitter) {
	        this._trigger(order.campaign.pixels.global);
	      }
	    }
	  }, {
	    key: '_trigger',
	    value: function _trigger(pixels) {
	      if (pixels.twitter) {
	        window.dataLayer.push({ 'clientTwitterPixelId': pixels.twitter });
	        window.dataLayer.push({ 'event': 'client-twitter-tracking' });
	      }
	    }
	  }]);
	
	  return TwitterAnalytics;
	}();
	
	exports.default = new TwitterAnalytics();

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(7);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ProductActions = function () {
	  function ProductActions() {
	    _classCallCheck(this, ProductActions);
	  }
	
	  _createClass(ProductActions, [{
	    key: 'defaultProduct',
	    value: function defaultProduct(products) {
	      return _lodash2.default.find(products, function (product) {
	        return product.is_default_product;
	      }) || _lodash2.default.find(products, function (product) {
	        return product.product_type === 'MAIN';
	      }) || _lodash2.default.head(products);
	    }
	  }, {
	    key: 'defaultUpsellProduct',
	    value: function defaultUpsellProduct(products, defaultCampaignId) {
	      return _lodash2.default.find(products, function (product) {
	        return product.id === defaultCampaignId;
	      }) || _lodash2.default.find(products, function (product) {
	        return product.is_default_product;
	      }) || _lodash2.default.find(products, function (product) {
	        return product.product_type === 'MAIN';
	      }) || _lodash2.default.head(products);
	    }
	  }, {
	    key: 'filterInactiveProducts',
	    value: function filterInactiveProducts(products) {
	      return _lodash2.default.filter(products, function (product) {
	        if (typeof product.is_active !== 'undefined') {
	          return product.product_color.active && product.is_active;
	        } else {
	          return product.product_color.active;
	        }
	      });
	    }
	  }, {
	    key: 'sizeDisplay',
	    value: function sizeDisplay(product, size) {
	      if (this.isProductClock(product)) {
	        if (size === 'M') return '8"';else if (size === 'L') return '11"';else return size;
	      }
	
	      return size;
	    }
	  }, {
	    key: 'isProductClock',
	    value: function isProductClock(product) {
	      return product.group ? product.group.toLowerCase() === 'clock' : false;
	    }
	  }]);
	
	  return ProductActions;
	}();
	
	exports.default = new ProductActions();

/***/ }),
/* 23 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = ['CartAPIService', 'CampaignService', 'ErrorHandler', function () {
	  function UpsellCartService(cartAPI, campaignService, errorHandler) {
	    _classCallCheck(this, UpsellCartService);
	
	    this._cartAPI = cartAPI;
	    this._campaignService = campaignService;
	    this._errorHandler = errorHandler;
	
	    this._shippingState = '';
	    this._shippingCountry = 'US';
	
	    this._originalCampaignId = null;
	    this._campaign = {};
	    this._contents = [];
	    this.totals = {};
	  }
	
	  _createClass(UpsellCartService, [{
	    key: 'initAmazon',
	    value: function initAmazon(refID, orderID, upsellProduct) {
	      if (this.paypal) return false;
	      this.amazon = {
	        referenceID: refID,
	        orderID: orderID
	      };
	      this._contents = upsellProduct;
	      return this.getAmazonTotals();
	    }
	  }, {
	    key: 'initPaypal',
	    value: function initPaypal(publicName, campaignSlug, upsellProduct, originalCampaignId) {
	      var _this = this;
	
	      if (_typeof(this.amazon) === 'object') return false;
	      this._contents = upsellProduct;
	      this._originalCampaignId = originalCampaignId;
	      this.paypal = true;
	
	      var campaignPromise = this._campaignService.getBySlug(publicName, campaignSlug);
	      campaignPromise.then(function (res) {
	        return _this._campaign = res.campaign;
	      });
	      return campaignPromise;
	    }
	  }, {
	    key: 'setCountry',
	    value: function setCountry(country) {
	      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	      this._shippingCountry = country;
	      this._shippingState = state;
	      return this._getTotals();
	    }
	  }, {
	    key: 'contents',
	    value: function contents() {
	      return this._contents;
	    }
	  }, {
	    key: 'getTotals',
	    value: function getTotals() {
	      this._getTotals();
	      return this.totals;
	    }
	  }, {
	    key: '_getTotals',
	    value: function _getTotals() {
	      if (_typeof(this.amazon) === 'object') return this.getAmazonTotals();else if (this.paypal) return this._getPaypalTotals();else return this.totals;
	    }
	  }, {
	    key: 'getAmazonTotals',
	    value: function getAmazonTotals() {
	      var _this2 = this;
	
	      var p = this._cartAPI.getAmazonTotal(this.amazon.referenceID, this.amazon.orderID);
	
	      p.then(function (cartData) {
	        _this2.totals.discount = cartData['discount_amount'];
	        _this2.totals.checkout = cartData['sub_total'];
	        _this2.totals.shipping = cartData['shipping_cost'];
	        _this2.totals.tax = cartData['sales_tax'];
	        _this2.totals.grand = cartData['grand_total'];
	      });
	
	      return p;
	    }
	  }, {
	    key: '_getPaypalTotals',
	    value: function _getPaypalTotals() {
	      var _this3 = this;
	
	      var p = this._cartAPI.getTotal(this._campaign.id, null, this._shippingState, this._shippingCountry, this._contents, this._originalCampaignId);
	
	      p.then(function (cartData) {
	        _this3.totals.discount = cartData['discount_amount'];
	        _this3.totals.checkout = cartData['sub_total'];
	        _this3.totals.shipping = cartData['shipping_cost'];
	        _this3.totals.tax = cartData['sales_tax'];
	        _this3.totals.grand = cartData['grand_total'];
	      });
	
	      return p;
	    }
	  }, {
	    key: 'processAmazonPaymentCart',
	    value: function processAmazonPaymentCart(id, orderReferenceID) {
	      var _this4 = this;
	
	      return this._cartAPI.processAmazonPayment(id, orderReferenceID).catch(function () {
	        return _this4._errorHandler.throwError('Amazon Payment Processing', 'Unable to process payment at this time.');
	      });
	    }
	  }, {
	    key: '_processPaypalPayment',
	    value: function _processPaypalPayment() {}
	  }]);
	
	  return UpsellCartService;
	}()];

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(7);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = ['Raven', 'ResourceService', function ErrorHandler(Raven, ResourceService) {
	  var errors = [];
	
	  function throwError(title, message, context) {
	    errors.push({
	      title: title,
	      message: message
	    });
	
	    ResourceService.releaseVersion().then(function (version) {
	      return Raven.setRelease(version);
	    }).finally(function () {
	      return logError(title, message, context);
	    });
	  }
	
	  function logError(title, message, context) {
	    context = context || {};
	
	    Raven.captureMessage(title + ': ' + message, {
	      level: 'warning',
	      extra: context
	    });
	  }
	
	  function stopPromises(message) {
	    return ResourceService.errorPromise(message);
	  }
	
	  function getErrors() {
	    return _lodash2.default.clone(errors);
	  }
	
	  function clear() {
	    errors.length = 0;
	  }
	
	  return {
	    throwError: throwError,
	    logError: logError,
	    stopPromises: stopPromises,
	    getErrors: getErrors,
	    clear: clear
	  };
	}];

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(7);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _webstoragePolyfill = __webpack_require__(10);
	
	var _webstoragePolyfill2 = _interopRequireDefault(_webstoragePolyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var KEY = 'user-history';
	var LIMIT = 8;
	
	exports.default = ['$window', function () {
	  function CampaignHistory($window) {
	    var webstorage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new _webstoragePolyfill2.default();
	
	    _classCallCheck(this, CampaignHistory);
	
	    this._$window = $window;
	    this._storage = webstorage;
	    this._history = [];
	    this._loadHistory();
	  }
	
	  _createClass(CampaignHistory, [{
	    key: 'getHistory',
	    value: function getHistory(limit) {
	      var history = _lodash2.default.sortBy(this._history, function (item) {
	        return -item.viewed;
	      });
	      if (typeof limit === 'number') {
	        history = history.slice(0, limit);
	      }
	
	      return history;
	    }
	  }, {
	    key: 'addItem',
	    value: function addItem(campaign, item) {
	      var newItem = {
	        viewed: new Date().getTime(),
	        id: campaign.id,
	        name: campaign.name,
	        category: {
	          name: campaign.category.name,
	          id: campaign.category.id
	        },
	        image: item.default_side_to_display === 'BACK' ? item.assets.back_display_url : item.assets.front_display_url,
	        uri: campaign.creator.user_info.public_name + '/' + campaign.slug,
	        price: item.selling_price
	      };
	
	      _lodash2.default.remove(this._history, {
	        id: newItem.id
	      }); // Remove by ID
	      _lodash2.default.remove(this._history, {
	        name: newItem.name
	      }); // Remove by campaign name
	      this._history.push(newItem);
	      this._saveHistory();
	    }
	  }, {
	    key: 'clear',
	    value: function clear() {
	      this._storage.removeLocalItem(KEY);
	    }
	  }, {
	    key: '_loadHistory',
	    value: function _loadHistory() {
	      this._history = JSON.parse(this._storage.getLocalItem(KEY)) || [];
	    }
	  }, {
	    key: '_saveHistory',
	    value: function _saveHistory() {
	      var history = _lodash2.default.sortBy(this._history, function (item) {
	        return -item.viewed;
	      }).slice(0, LIMIT);
	      this._storage.setLocalItem(KEY, JSON.stringify(history));
	    }
	  }]);
	
	  return CampaignHistory;
	}()];

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _config = __webpack_require__(2);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = ['$q', '$cookies', 'AuthService', 'md5', function () {
	  function UserDataService($q, $cookies, AuthService, md5) {
	    _classCallCheck(this, UserDataService);
	
	    this._$q = $q;
	    this._$cookies = $cookies;
	    this._authService = AuthService;
	    this._md5 = md5;
	    this.user = null;
	  }
	
	  _createClass(UserDataService, [{
	    key: 'setUserData',
	    value: function setUserData(res) {
	      var setJwtCookie = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      if (res && res.user) {
	        this.user = res.user;
	        this._storeLogin(res, setJwtCookie);
	      } else {
	        this.user = res;
	        this._clearLogin();
	      }
	    }
	  }, {
	    key: 'clearUserData',
	    value: function clearUserData() {
	      this.user = null;
	      this._clearLogin();
	    }
	  }, {
	    key: 'getUserData',
	    value: function getUserData() {
	      var promise = void 0;
	      var defer = this._$q.defer();
	
	      if (this.user) {
	        promise = defer.promise;
	        defer.resolve({
	          user: this.user
	        });
	      } else {
	        if (this.userLoggedIn()) {
	          promise = this._authService.getCurrentUser();
	        } else {
	          promise = defer.promise;
	          defer.reject();
	        }
	      }
	      return promise;
	    }
	  }, {
	    key: 'isInAdminRole',
	    value: function isInAdminRole() {
	      if (this.user && this.user.is_internal) {
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: 'userLoggedIn',
	    value: function userLoggedIn() {
	      return this._$cookies.get('login');
	    }
	  }, {
	    key: '_storeLogin',
	    value: function _storeLogin(res, setJwtCookie) {
	      if (res.user && typeof res.user.email === 'string') {
	        this._$cookies.put('login', true);
	      }
	
	      if (setJwtCookie) {
	        this._$cookies.put('client-jwt', res.jwt, { domain: '.' + _config2.default.DOMAIN });
	      }
	
	      return res;
	    }
	  }, {
	    key: '_clearLogin',
	    value: function _clearLogin() {
	      this._$cookies.remove('login');
	      this._$cookies.remove('client-jwt', { domain: '.' + _config2.default.DOMAIN });
	    }
	  }]);
	
	  return UserDataService;
	}()];

/***/ }),
/* 27 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = ['$q', 'CurrencyAPIService', 'ErrorHandler', function () {
	  function CurrencyService($q, CurrencyAPISerice, errorHandler) {
	    _classCallCheck(this, CurrencyService);
	
	    this._$q = $q;
	    this._currencyAPIService = CurrencyAPISerice;
	    this._errorHandler = errorHandler;
	
	    // default currency info to USD
	    this.info = this._defaultInfo();
	
	    this.currencyInit = false;
	  }
	
	  _createClass(CurrencyService, [{
	    key: 'init',
	    value: function init(country) {
	      var _this = this;
	
	      var deferred = this._$q.defer();
	
	      if (!this.currencyInit) {
	        this._currencyAPIService.getCurrencyInfo(country).then(function (res) {
	          _this.info = res;
	          deferred.resolve(res);
	        }).catch(function (err) {
	          if (err.status == 500) {
	            _this._errorHandler.logError('Currency Error', 'An error was encountered while attempting to fetch currency information.', {
	              rawError: err
	            });
	          }
	          _this.info = _this._defaultInfo();
	          deferred.reject();
	        });
	
	        this.currencyInit = true;
	      } else {
	        deferred.resolve(this.info);
	      }
	
	      return deferred.promise;
	    }
	  }, {
	    key: 'setCountry',
	    value: function setCountry(country) {
	      if (country !== this.info.country_code) {
	        this.currencyInit = false;
	        this.init(country);
	      }
	    }
	  }, {
	    key: '_defaultInfo',
	    value: function _defaultInfo() {
	      return {
	        conversion_rate: 1,
	        iso_code: "USD",
	        currency_symbol: "$",
	        country_code: "US"
	      };
	    }
	  }]);
	
	  return CurrencyService;
	}()];

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _webstoragePolyfill = __webpack_require__(10);
	
	var _webstoragePolyfill2 = _interopRequireDefault(_webstoragePolyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = ['CustomerService', 'CartService', function () {
	  function AbandonedCartService(customerService, cartService) {
	    _classCallCheck(this, AbandonedCartService);
	
	    this._customerService = customerService;
	    this._storage = new _webstoragePolyfill2.default();
	
	    this.cart = cartService;
	  }
	
	  _createClass(AbandonedCartService, [{
	    key: 'trackAbandonedCart',
	    value: function trackAbandonedCart(email) {
	      var _this = this;
	
	      this._storeEmail(email);
	      this.cart.ready.then(function () {
	        var pid = _this._getFirstProductId();
	        return _this._customerService.trackAbandonedCart(email, _this.cart.campaign.id, pid, _this._getHash());
	      }).then(function (res) {
	        return _this._storeHash(res['cart_hash']);
	      });
	    }
	  }, {
	    key: 'trackNewCart',
	    value: function trackNewCart() {
	      var email = this._getEmail();
	      if (email) this.trackAbandonedCart(email);
	    }
	  }, {
	    key: 'convertTrackedCart',
	    value: function convertTrackedCart(email, orderNum) {
	      var _this2 = this;
	
	      this.cart.ready.then(function () {
	        return _this2._customerService.convertTrackedCart(email, _this2.cart.campaign.id, orderNum);
	      });
	    }
	  }, {
	    key: 'optOutCart',
	    value: function optOutCart(hash) {
	      return this._customerService.optOutCart(hash);
	    }
	  }, {
	    key: '_getFirstProductId',
	    value: function _getFirstProductId() {
	      return this.cart.contents()[0].cpid;
	    }
	  }, {
	    key: '_storeHash',
	    value: function _storeHash(hash) {
	      this._storage.setLocalItem('cartHash:' + this.cart.campaign.id, hash);
	    }
	  }, {
	    key: '_getHash',
	    value: function _getHash() {
	      return this._storage.getLocalItem('cartHash:' + this.cart.campaign.id);
	    }
	  }, {
	    key: '_storeEmail',
	    value: function _storeEmail(email) {
	      this._storage.setLocalItem('userEmail', email);
	    }
	  }, {
	    key: '_getEmail',
	    value: function _getEmail() {
	      return this._storage.getLocalItem('userEmail');
	    }
	  }]);
	
	  return AbandonedCartService;
	}()];

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _resourceService = __webpack_require__(30);
	
	var _resourceService2 = _interopRequireDefault(_resourceService);
	
	var _campaignService = __webpack_require__(31);
	
	var _campaignService2 = _interopRequireDefault(_campaignService);
	
	var _clientService = __webpack_require__(32);
	
	var _clientService2 = _interopRequireDefault(_clientService);
	
	var _customerService = __webpack_require__(33);
	
	var _customerService2 = _interopRequireDefault(_customerService);
	
	var _orderService = __webpack_require__(34);
	
	var _orderService2 = _interopRequireDefault(_orderService);
	
	var _supportService = __webpack_require__(35);
	
	var _supportService2 = _interopRequireDefault(_supportService);
	
	var _authService = __webpack_require__(36);
	
	var _authService2 = _interopRequireDefault(_authService);
	
	var _cartService = __webpack_require__(37);
	
	var _cartService2 = _interopRequireDefault(_cartService);
	
	var _marketplaceService = __webpack_require__(38);
	
	var _marketplaceService2 = _interopRequireDefault(_marketplaceService);
	
	var _userService = __webpack_require__(39);
	
	var _userService2 = _interopRequireDefault(_userService);
	
	var _productsService = __webpack_require__(40);
	
	var _productsService2 = _interopRequireDefault(_productsService);
	
	var _offersService = __webpack_require__(41);
	
	var _offersService2 = _interopRequireDefault(_offersService);
	
	var _currencyService = __webpack_require__(42);
	
	var _currencyService2 = _interopRequireDefault(_currencyService);
	
	var _cobrandedService = __webpack_require__(43);
	
	var _cobrandedService2 = _interopRequireDefault(_cobrandedService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('cui.apiServices', []).service('ResourceService', _resourceService2.default).service('CampaignService', _campaignService2.default).service('ClientService', _clientService2.default).service('CustomerService', _customerService2.default).service('OrderService', _orderService2.default).service('SupportService', _supportService2.default).service('AuthService', _authService2.default).service('CartAPIService', _cartService2.default).service('MarketplaceService', _marketplaceService2.default).service('UserService', _userService2.default).service('ProductsService', _productsService2.default).service('OffersService', _offersService2.default).service('CurrencyAPIService', _currencyService2.default).service('CobrandedAPISerice', _cobrandedService2.default);

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(7);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _config = __webpack_require__(2);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _webstoragePolyfill = __webpack_require__(10);
	
	var _webstoragePolyfill2 = _interopRequireDefault(_webstoragePolyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = ['$http', '$q', '$window', 'Raven', function () {
	  function ResourceService($http, $q, $window, Raven) {
	    _classCallCheck(this, ResourceService);
	
	    // Angular dependencies
	    this._$http = $http;
	    this._$q = $q;
	    this._$window = $window;
	    this._storage = new _webstoragePolyfill2.default();
	    this._Raven = Raven;
	
	    // Default values
	    this._API_BASE = _config2.default['API_BASE'] + '/api/v2';
	    this._httpConfigBase = {};
	    this._releaseVersion = null;
	
	    // OAuth
	    this.oauthHandshake();
	  }
	
	  _createClass(ResourceService, [{
	    key: 'get',
	    value: function get(endpoint, httpConfig) {
	      return this._makeRequest('get', endpoint, null, httpConfig);
	    }
	  }, {
	    key: 'post',
	    value: function post(endpoint, data, httpConfig) {
	      return this._makeRequest('post', endpoint, data, httpConfig);
	    }
	  }, {
	    key: 'postFile',
	    value: function postFile(endpoint, data, httpConfig) {
	      return this._makeRequest('post', endpoint, data, httpConfig, false, true);
	    }
	  }, {
	    key: 'put',
	    value: function put(endpoint, data, httpConfig) {
	      return this._makeRequest('put', endpoint, data, httpConfig);
	    }
	  }, {
	    key: 'patch',
	    value: function patch(endpoint, data, httpConfig) {
	      return this._makeRequest('patch', endpoint, data, httpConfig);
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(endpoint, httpConfig) {
	      return this._makeRequest('delete', endpoint, null, httpConfig);
	    }
	  }, {
	    key: 'legacyGet',
	    value: function legacyGet(endpoint, httpConfig) {
	      return this._makeRequest('get', endpoint, null, httpConfig, true);
	    }
	  }, {
	    key: 'legacyPost',
	    value: function legacyPost(endpoint, data, httpConfig) {
	      return this._makeRequest('post', endpoint, data, httpConfig, true);
	    }
	  }, {
	    key: 'jsonp',
	    value: function jsonp(url) {
	      return this._$http.jsonp(url);
	    }
	  }, {
	    key: 'releaseVersion',
	    value: function releaseVersion() {
	      var _this = this;
	
	      var deferred = this._$q.defer();
	      if (this._releaseVersion === null) {
	        this._makeRequest('get', '/version').then(function (res) {
	          _this._releaseVersion = res.version;
	          deferred.resolve(_this._releaseVersion);
	        }).catch(function () {
	          return deferred.reject();
	        });
	      } else deferred.resolve(this._releaseVersion);
	
	      return deferred.promise;
	    }
	  }, {
	    key: 'errorPromise',
	    value: function errorPromise(message) {
	      message || (message = null);
	
	      // Log a Warning
	      var title = typeof message == 'string' ? message : 'ResourceService Error Promise';
	      var context = (typeof message === 'undefined' ? 'undefined' : _typeof(message)) == 'object' ? message : null;
	      this._Raven.captureMessage(title, {
	        level: 'warning',
	        extra: context
	      });
	
	      // Reject the Promise
	      var deferred = this._$q.defer();
	      deferred.reject(message);
	      return deferred.promise;
	    }
	  }, {
	    key: 'emptyResolvedPromise',
	    value: function emptyResolvedPromise(data) {
	      var deferred = this._$q.defer();
	      deferred.resolve(data);
	      return deferred.promise;
	    }
	  }, {
	    key: 'emptyRejectedPromise',
	    value: function emptyRejectedPromise(message) {
	      var deferred = this._$q.defer();
	      deferred.reject({
	        data: {
	          message: message
	        }
	      });
	      return deferred.promise;
	    }
	  }, {
	    key: 'oauthHandshake',
	    value: function oauthHandshake() {
	      var _this2 = this;
	
	      if (!this.oauthDeferred) {
	        this.oauthDeferred = this._$q.defer();
	      }
	
	      // Do nothing if not required.
	      if (_config2.default['OAuth_Required'] === false) {
	        this.oauthDeferred.resolve();
	        return this.oauthDeferred.promise;
	      }
	
	      var oauth = this._retrieveOauthToken();
	      if (oauth !== null && oauth.expiration > new Date()) {
	        this._setOauthHeader(oauth);
	        this.oauthDeferred.resolve();
	      } else if (this.checkingOauth !== true) {
	        this.checkingOauth = true;
	        var httpConfig = {
	          headers: {
	            'Content-Type': 'application/x-www-form-urlencoded'
	          }
	        };
	
	        this._$http.post(this._API_BASE + '/token', $.param(_config2.default['OAuth']), httpConfig).then(function (token) {
	          _this2.storeOauthToken(token.data);
	          _this2._setOauthHeader(_this2._retrieveOauthToken());
	          _this2.checkingOauth = false;
	          _this2.oauthDeferred.resolve();
	        });
	      }
	
	      return this.oauthDeferred.promise;
	    }
	  }, {
	    key: 'storeOauthToken',
	    value: function storeOauthToken(token) {
	      // Calculate the date/time of expiration.
	      var expiration = new Date().getTime() + token['expires_in'] * 999; // 3600 * 1000 is 1 hour in ms. 3600 * 999 will preemt the expiration by 3.6 seconds.
	      // Add the new expiration to response object.
	      _lodash2.default.extend(token, {
	        expiration: expiration
	      });
	      // Store the entire object.
	      this._storage.setSessionItem('oauth', JSON.stringify(token));
	    }
	  }, {
	    key: 'trashOauthToken',
	    value: function trashOauthToken() {
	      this._storage.removeSessionItem('oauth');
	    }
	  }, {
	    key: '_retrieveOauthToken',
	    value: function _retrieveOauthToken() {
	      var oauth = this._storage.getSessionItem('oauth') ? JSON.parse(this._storage.getSessionItem('oauth')) : null;
	
	      if (oauth !== null) {
	        oauth.expiration = new Date(oauth.expiration);
	      }
	
	      return oauth;
	    }
	  }, {
	    key: '_setOauthHeader',
	    value: function _setOauthHeader(oauth) {
	      _lodash2.default.extend(this._httpConfigBase, {
	        headers: {
	          'authorization': oauth['token_type'] + ' ' + oauth['access_token']
	        }
	      });
	    }
	  }, {
	    key: '_makeRequest',
	    value: function _makeRequest(method, endpoint, data, httpConfig, overrideBase, isFileUpload) {
	      var _this3 = this;
	
	      httpConfig || (httpConfig = {});
	
	      var uri = overrideBase === true ? endpoint : this._API_BASE + endpoint;
	      var deferred = this._$q.defer();
	
	      // When OAuth resolves, append the token to the request headers.
	      this.oauthHandshake().then(function () {
	        _this3.oauthDeferred = null; //has to be set to null after the handshake otherwise all subsequent requests will automatically resolve.
	        _lodash2.default.extend(httpConfig, _this3._httpConfigBase);
	        if (isFileUpload) httpConfig.headers['Content-Type'] = undefined;
	
	        // No data arg:
	        if (method === 'get' || method === 'delete') {
	          return _this3._$http[method](uri, httpConfig);
	        }
	        // Data arg:
	        else if (method === 'post' || method === 'put' || method === 'patch') {
	            return _this3._$http[method](uri, data, httpConfig);
	          }
	      }).then(function (success) {
	        var apiResponse = success['data']['data'] || success['data'] || success;
	        deferred.resolve(apiResponse);
	      }, function (failure) {
	        deferred.reject(failure);
	      }).catch(function () {
	        return _this3.oauthDeferred = null;
	      }); //if there is some error somewhere lets make sure to make this null anyway just to be safe.
	
	      return deferred.promise;
	    }
	  }]);
	
	  return ResourceService;
	}()];

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(7);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = ['ResourceService', function () {
	  function CampaignService(resourceService) {
	    _classCallCheck(this, CampaignService);
	
	    this._resourceService = resourceService;
	    this._API_BASE = '/campaigns';
	  }
	
	  _createClass(CampaignService, [{
	    key: 'initializeSession',
	    value: function initializeSession(publicID, slug, query) {
	      if (!publicID || !slug) {
	        return this._resourceService.errorPromise('campaign:initializeSession: missing parameters');
	      }
	
	      var q = _lodash2.default.clone(query);
	      _lodash2.default.extend(q, { referrer: document.referrer });
	
	      return this._resourceService.get(this._API_BASE + '/' + publicID + '/' + slug + '/initialize', {
	        params: q,
	        paramSerializer: '$httpParamSerializerJQLike'
	      });
	    }
	  }, {
	    key: 'getById',
	    value: function getById(id) {
	      if (!id) {
	        return this._resourceService.errorPromise('campaign:getById: missing parameters');
	      }
	      return this._resourceService.get(this._API_BASE + '/' + id);
	      //.then( cache in this._campaignDetails ); ?
	    }
	  }, {
	    key: 'getBySlug',
	    value: function getBySlug(publicID, slug) {
	      if (!publicID || !slug) {
	        return this._resourceService.errorPromise('campaign:getBySlug: missing parameters');
	      }
	
	      return this._resourceService.get('/users/' + publicID + '/campaigns/' + slug + '/customer');
	    }
	  }, {
	    key: 'getFeatured',
	    value: function getFeatured(limit) {
	      var query = void 0;
	      if (typeof limit === 'number') {
	        query = '?limit=' + limit;
	      }
	
	      return this._resourceService.get(this._API_BASE + '/featured' + query);
	    }
	  }, {
	    key: 'validateCoupon',
	    value: function validateCoupon(publicID, slug, coupon) {
	      if (!publicID || !slug || !coupon) {
	        return this._resourceService.errorPromise('campaign:validateCoupon: missing parameters');
	      }
	
	      return this._resourceService.get('/users/' + publicID + '/campaigns/' + slug + '/validate-coupon?discount_code=' + encodeURIComponent(coupon));
	    }
	  }, {
	    key: 'getTracking',
	    value: function getTracking(publicID, slug) {
	      if (!publicID || !slug) {
	        return this._resourceService.errorPromise('campaign:getTracking: missing parameters');
	      }
	
	      return this._resourceService.get('/users/' + publicID + '/campaigns/' + slug + '/tracking');
	    }
	  }, {
	    key: 'getUpsells',
	    value: function getUpsells(id, previous, country) {
	      if (!id) {
	        return this._resourceService.errorPromise('campaign:getUpsells: missing parameter');
	      }
	
	      var query = '?';
	      if (Array.isArray(previous) && previous.length > 0) {
	        var csv = previous.join(',');
	        query += 'previously_viewed_upsells=' + csv;
	      }
	
	      if (typeof country == 'string') {
	        if (query.length > 1) query += '&';
	        query += 'country=' + country;
	      }
	
	      return this._resourceService.get(this._API_BASE + '/' + id + '/upsells' + query);
	    }
	  }, {
	    key: 'getTrending',
	    value: function getTrending(limit, type) {
	      var query = void 0;
	      limit || (limit = 4);
	      type || (type = null);
	
	      return this._resourceService.get(this._API_BASE + '/trending', {
	        params: {
	          limit: limit,
	          pcat: type
	        },
	        paramSerializer: '$httpParamSerializerJQLike'
	      });
	    }
	  }, {
	    key: 'toggleCampaignLockFromMarketplace',
	    value: function toggleCampaignLockFromMarketplace(id, lock, unhide) {
	      if (!id || typeof lock === 'undefined' || typeof unhide === 'undefined') {
	        return this._resourceService.errorPromise('campaign:toggleCampaignLockFromMarketplace: missing parameters');
	      }
	      return this._resourceService.post(this._API_BASE + '/' + id + '/marketplace/lock', {
	        lock: lock ? 1 : 0,
	        unhide: unhide ? 1 : 0
	      });
	    }
	  }]);
	
	  return CampaignService;
	}()];

/***/ }),
/* 32 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = ['ResourceService', function () {
	  function ClientAPIService(resourceService) {
	    _classCallCheck(this, ClientAPIService);
	
	    this._resourceService = resourceService;
	    this._API_BASE = '/clients';
	  }
	
	  _createClass(ClientAPIService, [{
	    key: 'getStore',
	    value: function getStore(client, store) {
	      var cb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new Date().toString();
	
	      if (!client || !store) {
	        return this._resourceService.errorPromise('clientAPI:getStore: missing parameters');
	      }
	
	      return this._resourceService.get(this._API_BASE + '/' + client + '/stores/' + store + '?cb=' + cb);
	    }
	  }, {
	    key: 'getCampaignsForStore',
	    value: function getCampaignsForStore(client, store, query) {
	      if (!client || !store) {
	        return this._resourceService.errorPromise('clientAPI:getCampaignsForStore: missing parameters');
	      }
	      query || (query = {});
	
	      return this._resourceService.get(this._API_BASE + '/' + client + '/stores/' + store + '/campaigns', {
	        params: query,
	        paramSerializer: '$httpParamSerializerJQLike'
	      });
	    }
	  }]);
	
	  return ClientAPIService;
	}()];

/***/ }),
/* 33 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = ['ResourceService', function () {
	  function CustomerService(resourceService) {
	    _classCallCheck(this, CustomerService);
	
	    this._resourceService = resourceService;
	    this._API_BASE = '/customers';
	  }
	
	  _createClass(CustomerService, [{
	    key: 'updateAddress',
	    value: function updateAddress(id, address) {
	      if (!id || !address) {
	        return this._resourceService.errorPromise('customer:updateAddress: missing parameters');
	      } else if ((typeof address === 'undefined' ? 'undefined' : _typeof(address)) !== 'object') {
	        return this._resourceService.errorPromise('invalid parameters');
	      }
	      return this._resourceService.put(this._API_BASE + '/' + id, address);
	    }
	  }, {
	    key: 'updatePhone',
	    value: function updatePhone(id, phone_number, zip) {
	      if (!id || !phone_number || !zip) {
	        return this._resourceService.errorPromise('customer:updatePhone: missing parameters');
	      }
	      return this._resourceService.patch(this._API_BASE + '/' + id + '/phone', {
	        phone_number: phone_number,
	        original_zip: zip
	      });
	    }
	  }, {
	    key: 'getOrderHistory',
	    value: function getOrderHistory(id) {
	      if (!id) {
	        return this._resourceService.errorPromise('customer:getOrderHistory: missing parameters');
	      }
	      var columns = 'columns[]=order_number&columns[]=created_at&columns[]=item_count&columns[]=sale_net_price&columns[]=order_status&columns[]=payment_status&columns[]=shipment_status';
	
	      return this._resourceService.get('/users/' + id + '/orders?' + columns);
	    }
	  }, {
	    key: 'getSavedPaymentMethod',
	    value: function getSavedPaymentMethod(id) {
	      if (!id) {
	        return this._resourceService.errorPromise('customer:getSavedPaymentMethod: missing parameters');
	      }
	
	      return this._resourceService.get('/users/' + id + '/payment');
	    }
	  }, {
	    key: 'updateSavedPaymentMethod',
	    value: function updateSavedPaymentMethod(id, token, last4, cc_bin) {
	      if (!id || !token || !last4 || !cc_bin) {
	        return this._resourceService.errorPromise('customer:updateSavedPaymentMethod: missing parameters');
	      }
	
	      return this._resourceService.post('/users/' + id + '/payment', { token: token, last4: last4, cc_bin: cc_bin });
	    }
	  }, {
	    key: 'removeSavedPaymentMethod',
	    value: function removeSavedPaymentMethod(id, payment) {
	      if (!id || !payment) {
	        return this._resourceService.errorPromise('customer:removeSavedPaymentMethod: missing parameters');
	      }
	
	      return this._resourceService.delete('/users/' + id + '/payment/' + payment);
	    }
	  }, {
	    key: 'trackAbandonedCart',
	    value: function trackAbandonedCart(email, campaignID, productID) {
	      var hash = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	      if (!email || !campaignID || !productID) {
	        return this._resourceService.errorPromise('missing parameters');
	      }
	
	      var payload = { 'email': email, 'pid': productID };
	      if (hash !== null) payload['hash'] = hash;
	
	      return this._resourceService.post(this._API_BASE + '/track/' + campaignID, payload);
	    }
	  }, {
	    key: 'convertTrackedCart',
	    value: function convertTrackedCart(email, campaignID, orderNum) {
	      if (!email || !campaignID || !orderNum) {
	        return this._resourceService.errorPromise('customer:convertTrackedCart: missing parameters');
	      }
	
	      return this._resourceService.post(this._API_BASE + '/track/' + campaignID + '/converted', { 'email': email, 'order_id': orderNum });
	    }
	  }, {
	    key: 'optOutCart',
	    value: function optOutCart(hash) {
	      if (!hash) {
	        return this._resourceService.errorPromise('missing parameters');
	      }
	
	      return this._resourceService.post(this._API_BASE + '/track/' + hash + '/optout');
	    }
	  }]);
	
	  return CustomerService;
	}()];

/***/ }),
/* 34 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = ['ResourceService', function () {
	  function OrderService(resourceService) {
	    _classCallCheck(this, OrderService);
	
	    this._resourceService = resourceService;
	    this._API_BASE = '/orders';
	  }
	
	  _createClass(OrderService, [{
	    key: 'getByOrderNumberAndZipCode',
	    value: function getByOrderNumberAndZipCode(orderNumber, zipCode) {
	      if (!orderNumber || !zipCode) return null;
	      var query = 'zip_code=' + zipCode;
	      if (typeof orderNumber == 'string' && orderNumber.indexOf('#') == 0) {
	        orderNumber = orderNumber.substring(1);
	      }
	      return this._resourceService.get(this._API_BASE + '/' + orderNumber + '?' + query);
	    }
	  }, {
	    key: 'getBaseOrder',
	    value: function getBaseOrder(orderNumber, zipCode) {
	      if (!orderNumber || !zipCode) return this._resourceService.errorPromise('order:getBaseOrder: missing parameters');
	      var query = 'zip_code=' + zipCode;
	      return this._resourceService.get(this._API_BASE + '/' + orderNumber + '/base?' + query);
	    }
	  }, {
	    key: 'sendReminder',
	    value: function sendReminder(email) {
	      if (!email) return null;
	      var data = {
	        'email_address': email
	      };
	      return this._resourceService.post(this._API_BASE + '/remind', data);
	    }
	  }, {
	    key: 'getTrackingHistoryByOrderNumber',
	    value: function getTrackingHistoryByOrderNumber(orderNumber) {
	      if (!orderNumber) return null;
	      return this._resourceService.get(this._API_BASE + '/' + orderNumber + '/fulfillment/history');
	    }
	  }, {
	    key: 'getShipmentDetailsById',
	    value: function getShipmentDetailsById(id) {
	      if (!id) return null;
	      return this._resourceService.get(this._API_BASE + '/' + id + '/fulfillment/shipment');
	    }
	  }, {
	    key: 'getShipmentDetailsByOrderNumber',
	    value: function getShipmentDetailsByOrderNumber(orderNumber) {
	      if (!orderNumber) return null;
	      return this._resourceService.get(this._API_BASE + '/' + orderNumber + '/fulfillment/shipment');
	    }
	  }, {
	    key: 'getFulfillmentDatesByOrderNumber',
	    value: function getFulfillmentDatesByOrderNumber(orderNumber) {
	      if (!orderNumber) return null;
	      return this._resourceService.get(this._API_BASE + '/' + orderNumber + '/fulfillment/estimate');
	    }
	  }]);
	
	  return OrderService;
	}()];

/***/ }),
/* 35 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = ['ResourceService', function () {
	  function SupportService(resourceService) {
	    _classCallCheck(this, SupportService);
	
	    this._resourceService = resourceService;
	    this._API_BASE = '/support';
	  }
	
	  _createClass(SupportService, [{
	    key: 'sendMessage',
	    value: function sendMessage(name, email, category, message, _email, type) {
	      // cant do !_email becuase it should be equal to '' unless its submitted by a scraper.
	      if (!name || !email || !category || !message || _email == null) {
	        return this._resourceService.errorPromise('support:sendMessage: missing parameters');
	      }
	
	      return this._resourceService.post(this._API_BASE + '/contact-us', {
	        'name': name,
	        'email': email,
	        'category': category,
	        'message': message,
	        '_email': _email,
	        'form_type': type
	      });
	    }
	  }]);
	
	  return SupportService;
	}()];

/***/ }),
/* 36 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = ['ResourceService', function () {
	  function AuthService(resourceService) {
	    _classCallCheck(this, AuthService);
	
	    this._resourceService = resourceService;
	    this._API_BASE = '/auth';
	
	    this.getCurrentUserPromise = null;
	  }
	
	  _createClass(AuthService, [{
	    key: 'register',
	    value: function register(name, publicName, email, password, terms, refId, partnerId, recaptchaToken) {
	      var _this = this;
	
	      if (!name || !publicName || !email || !password || !terms) {
	        return this._resourceService.errorPromise('auth:register: missing parameters');
	      }
	
	      var payload = {
	        'full_name': name,
	        'public_name': publicName,
	        'email_address': email,
	        'password': password,
	        'accept_tos': terms,
	        'ref_id': refId,
	        'token': recaptchaToken
	      };
	
	      if (partnerId) payload.partner = partnerId;
	
	      return this._resourceService.post(this._API_BASE + '/register', payload).then(function (res) {
	        _this._resourceService.storeOauthToken(res.token);
	        return res;
	      });
	    }
	  }, {
	    key: 'login',
	    value: function login(email, password, rememberMe, recaptchaToken) {
	      var _this2 = this;
	
	      if (!email || !password || rememberMe == null) {
	        return this._resourceService.errorPromise('auth:login: missing parameters');
	      }
	      return this._resourceService.post(this._API_BASE + '/login', {
	        'email_address': email,
	        'password': password,
	        'remember': rememberMe,
	        'token': recaptchaToken
	      }).then(function (res) {
	        _this2._resourceService.storeOauthToken(res.token);
	        return res;
	      });
	    }
	  }, {
	    key: 'logout',
	    value: function logout() {
	      return this._resourceService.get(this._API_BASE + '/logout');
	      this._resourceService.trashOauthToken();
	    }
	  }, {
	    key: 'verifyPublicName',
	    value: function verifyPublicName(publicName) {
	      if (!publicName) {
	        return this._resourceService.errorPromise('auth:verifyPublicName: missing parameters');
	      }
	      return this._resourceService.get(this._API_BASE + '/validate-public-name?public_name=' + publicName);
	    }
	  }, {
	    key: 'verifyEmailAddress',
	    value: function verifyEmailAddress(email) {
	      if (!email) {
	        return this._resourceService.errorPromise('auth:verifyEmailAddress: missing parameters');
	      }
	      return this._resourceService.get(this._API_BASE + '/validate-email?email_address=' + encodeURIComponent(email));
	    }
	  }, {
	    key: 'resetPasswordRequest',
	    value: function resetPasswordRequest(email) {
	      if (!email) {
	        return this._resourceService.errorPromise('auth:resetPasswordRequest: missing parameters');
	      }
	      return this._resourceService.post(this._API_BASE + '/reset-password-request', {
	        'email_address': email
	      });
	    }
	  }, {
	    key: 'resetPassword',
	    value: function resetPassword(password, token) {
	      if (!password || !token) {
	        return this._resourceService.errorPromise('auth:resetPassword: missing parameters');
	      }
	      return this._resourceService.post(this._API_BASE + '/reset-password', {
	        'password': password,
	        'token': token
	      });
	    }
	  }, {
	    key: 'quickRegister',
	    value: function quickRegister(orderNum, password, recaptchaToken) {
	      var _this3 = this;
	
	      if (!orderNum || !password) {
	        return this._resourceService.errorPromise('auth:quickRegister: missing parameters');
	      }
	      return this._resourceService.post(this._API_BASE + '/register/customer', {
	        'password': password,
	        'orders': [orderNum],
	        token: recaptchaToken
	      }).then(function (res) {
	        _this3._resourceService.storeOauthToken(res.token);
	        return res;
	      });
	    }
	  }, {
	    key: 'getCurrentUser',
	    value: function getCurrentUser() {
	      var _this4 = this;
	
	      if (!this.getCurrentUserPromise) {
	        this.getCurrentUserPromise = this._resourceService.get(this._API_BASE + '/current-user');
	      }
	
	      this.getCurrentUserPromise.then(function (res) {
	        return _this4._resourceService.storeOauthToken(res.token);
	      }).finally(function () {
	        return _this4.getCurrentUserPromise = null;
	      });
	
	      return this.getCurrentUserPromise;
	    }
	  }, {
	    key: 'socialLogin',
	    value: function socialLogin(type, token, id, role) {
	      if (!type || !token || !id || !role) {
	        this._resourceService.errorPromise('auth:socialLogin: missing params');
	      }
	
	      return this._resourceService.post(this._API_BASE + '/social/' + type, {
	        'provider_access_token': token,
	        'provider_user_id': id,
	        'user_role': role
	      });
	    }
	  }]);
	
	  return AuthService;
	}()];

/***/ }),
/* 37 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = ['ResourceService', '$q', '$window', '$rootScope', function () {
	  function CartAPIService(resourceService, $q, $window, $rootScope) {
	    _classCallCheck(this, CartAPIService);
	
	    this._resourceService = resourceService;
	    this._$q = $q;
	    this._API_BASE = '/cart';
	    this._$window = $window;
	    this._$rootScope = $rootScope;
	
	    this._totalsCanceler = $q.defer();
	  }
	
	  _createClass(CartAPIService, [{
	    key: 'getTotal',
	    value: function getTotal(campaignId, couponCode, state, country, cart) {
	      var originalCID = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
	
	      if (!campaignId || !cart) {
	        return this._resourceService.errorPromise('cartAPI:getTotal: missing parameters');
	      }
	
	      var upsellCID = originalCID != null ? cart[0]['cid'] : null;
	      return this._resourceService.get(this._API_BASE + '/totals', {
	        params: {
	          cc: couponCode,
	          ships: state,
	          shipc: country,
	          upsell_cid: upsellCID,
	          original_cid: originalCID,
	          cart: cart
	        },
	        paramSerializer: '$httpParamSerializerJQLike',
	        timeout: this._totalsCanceler.promise
	      });
	    }
	  }, {
	    key: 'cancelGetTotal',
	    value: function cancelGetTotal() {
	      this._totalsCanceler.resolve({ data: 'promise cancelled' });
	      this._totalsCanceler = this._$q.defer();
	    }
	  }, {
	    key: 'checkout',
	    value: function checkout(payload) {
	      if (!payload) {
	        return this._resourceService.errorPromise('cartAPI:checkout: missing parameters');
	      }
	
	      return this._resourceService.legacyPost('/purchase/checkout2', payload);
	    }
	  }, {
	    key: 'placeOrder',
	    value: function placeOrder(payload) {
	      if (!payload) {
	        return this._resourceService.errorPromise('cartAPI:placeOrder: missing parameters');
	      }
	
	      return this._resourceService.legacyPost('/purchase/place-order2', payload);
	    }
	  }, {
	    key: 'getAmazonTotal',
	    value: function getAmazonTotal(amazonReferenceId, orderReferenceID, couponCode) {
	
	      if (!amazonReferenceId || !orderReferenceID) {
	        return this._resourceService.errorPromise('missing parameter');
	      }
	
	      return this._resourceService.get(this._API_BASE + '/amazon-cart/' + amazonReferenceId + '/' + orderReferenceID, {
	        params: {
	          cc: couponCode
	        },
	        paramSerializer: '$httpParamSerializerJQLike'
	      });
	    }
	  }, {
	    key: 'amazonCheckout',
	    value: function amazonCheckout(payload) {
	      return this._resourceService.post(this._API_BASE + '/amazon-checkout', payload);
	    }
	  }, {
	    key: 'processAmazonPayment',
	    value: function processAmazonPayment(referenceID, orderID, coupon) {
	      if (!referenceID || !orderID) {
	        return this._resourceService.errorPromise('cartAPI:processAmazonPayment: missing parameters');
	      }
	
	      return this._resourceService.post(this._API_BASE + '/amazon-order', {
	        app_reference_id: referenceID,
	        amazon_order_ref_id: orderID,
	        coupon_code: coupon
	      });
	    }
	  }, {
	    key: 'paypalCheckout',
	    value: function paypalCheckout(payload) {
	      if (!payload) {
	        return this._resourceService.errorPromise('cartAPI:paypalCheckout: missing parameters');
	      }
	
	      return this._resourceService.post(this._API_BASE + '/paypal-checkout', payload);
	    }
	  }, {
	    key: 'paypalUpsellCheckout',
	    value: function paypalUpsellCheckout(payload) {
	      if (!payload) {
	        return this._resourceService.errorPromise('cartAPI:paypalUpsellCheckout: missing parameters');
	      }
	
	      return this._resourceService.post(this._API_BASE + '/paypal-upsell-checkout', payload);
	    }
	  }, {
	    key: 'paypalPaymentResource',
	    value: function paypalPaymentResource(paymentID) {
	      if (!paymentID) {
	        return this._resourceService.errorPromise('missing payment ID');
	      }
	
	      return this._resourceService.get(this._API_BASE + '/paypal-payment-resource/' + paymentID);
	    }
	  }, {
	    key: 'placePaypalOrder',
	    value: function placePaypalOrder(payload) {
	      if (!payload) {
	        return this._resourceService.errorPromise('cartAPI:placePaypalOrder: missing parameters');
	      }
	
	      return this._resourceService.post(this._API_BASE + '/paypal-order', payload);
	    }
	  }, {
	    key: 'createCCToken',
	    value: function createCCToken(card, customer) {
	      var _this = this;
	
	      var deferred = this._$q.defer(),
	          merchant = void 0;
	
	      this._resourceService.get('/merchant').then(function (res) {
	        merchant = res.merchant;
	
	        switch (merchant) {
	          case 'STRIPE':
	            return _this._createStripeToken(card, res.token);
	            break;
	          case 'BRAINTREE':
	            return _this._createBraintreeToken(card, res.token);
	            break;
	          case 'WORLDPAY':
	            return _this._createWorldpayToken(card, res.token, customer);
	            break;
	        }
	      }).then(function (token) {
	        return deferred.resolve({ token: token, merchant: merchant });
	      }).catch(function (error) {
	        return deferred.reject(error);
	      });
	
	      return deferred.promise;
	    }
	  }, {
	    key: '_assignJsonpParams',
	    value: function _assignJsonpParams(url, payload) {
	      for (var key in payload) {
	        url += key + '=' + payload[key] + '&';
	      }
	
	      url = url.slice(0, -1);
	
	      return url;
	    }
	  }, {
	    key: '_createWorldpayToken',
	    value: function _createWorldpayToken(card, token, customer) {
	      var _this2 = this;
	
	      var deferred = this._$q.defer(),
	          customerName = customer.firstName + ' ' + customer.lastName,
	          expMM = '' + card.cc_expiry_mm,
	          expYY = '' + card.cc_expiry_yy,
	          worldPayApiUrl = 'https://prod.moderntransact.com/ws',
	          sharedPayload = {
	        payscriptToken: token,
	        ResponseType: 'json',
	        mycallback: 'JSON_CALLBACK'
	      },
	          createCustomerUrl = worldPayApiUrl + '/recurring.asmx/ManageCustomer?',
	          createTokenUrl = worldPayApiUrl + '/cardsafe.asmx/StoreCard?',
	          createCustomerPayload = Object.assign({
	        TransType: 'ADD',
	        Vendor: 1,
	        Company: 'VS',
	        CustomerName: customerName,
	        FirstName: customer.firstName,
	        LastName: customer.lastName
	      }, sharedPayload),
	          createTokenPayload = Object.assign({
	        TokenMode: 'DEFAULT',
	        NameOnCard: customerName,
	        CardNum: card.cc_num,
	        ExpDate: '' + (expMM.length > 1 ? expMM : '0' + expMM) + expYY.slice(2, 4),
	        Street: customer.address,
	        PostalCode: customer.zip
	      }, sharedPayload);
	
	      createCustomerUrl = this._assignJsonpParams(createCustomerUrl, createCustomerPayload);
	
	      // create customer
	      this._resourceService.jsonp(createCustomerUrl).then(function (res) {
	        if (res.data.error === 'OK') {
	          createTokenPayload.CustomerKey = res.data.CustomerKey;
	
	          createTokenUrl = _this2._assignJsonpParams(createTokenUrl, createTokenPayload);
	
	          // create token
	          _this2._resourceService.jsonp(createTokenUrl).then(function (res) {
	            if (res.data.error === 'OK') {
	              deferred.resolve('wpt_' + res.data.CardSafeToken);
	            } else {
	              deferred.reject(res.data.error);
	            }
	          });
	        } else {
	          deferred.reject(res.data.error);
	        }
	      });
	
	      return deferred.promise;
	    }
	  }, {
	    key: '_createStripeToken',
	    value: function _createStripeToken(card, key) {
	      var deferred = this._$q.defer();
	      this._$window.Stripe.setPublishableKey(key);
	
	      this._$window.Stripe.card.createToken({
	        number: card.cc_num,
	        cvc: card.cc_cvc,
	        exp_month: card.cc_expiry_mm,
	        exp_year: card.cc_expiry_yy
	      }, function (status, res) {
	        if (res.error) {
	          deferred.reject(res.error);
	        } else {
	          deferred.resolve(res.id);
	        }
	      });
	
	      return deferred.promise;
	    }
	  }, {
	    key: '_createBraintreeToken',
	    value: function _createBraintreeToken(card, token) {
	      var deferred = this._$q.defer();
	      var btClient = new this._$window.braintree.api.Client({ clientToken: token });
	
	      btClient.tokenizeCard({
	        number: card.cc_num,
	        cvv: card.cc_cvc,
	        expirationMonth: card.cc_expiry_mm,
	        expirationYear: card.cc_expiry_yy
	      }, function (err, nonce) {
	        if (err) deferred.reject(err);else deferred.resolve(nonce);
	      });
	
	      return deferred.promise;
	    }
	  }]);
	
	  return CartAPIService;
	}()];

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _config = __webpack_require__(2);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = ['ResourceService', function () {
	  function MarketplaceService(resourceService) {
	    _classCallCheck(this, MarketplaceService);
	
	    this._resourceService = resourceService;
	    this._API_BASE = '/market';
	  }
	
	  _createClass(MarketplaceService, [{
	    key: 'searchMarketplace',
	    value: function searchMarketplace(page, type, minPrice, maxPrice, name, term) {
	      if (_.isUndefined(page)) {
	        this._resourceService.errorPromise('marketplace:search: missing parameters');
	      }
	
	      var query = 'from=' + (page - 1) * _config2.default.Marketplace.LIMIT + '&per_page=' + _config2.default.Marketplace.LIMIT;
	      if (name && name !== 'ALL') query += '&category=' + encodeURIComponent(name);
	      if (term) query += '&term=' + encodeURIComponent(term);
	      if (type && type !== '0') query += '&type=' + type;
	      if (minPrice > _config2.default.Marketplace.MIN_PRICE) query += '&min_price=' + minPrice;
	      if (maxPrice < _config2.default.Marketplace.MAX_PRICE) query += '&max_price=' + maxPrice;
	      query += '&v=' + moment().format();
	
	      return this._resourceService.get(this._API_BASE + '/search?' + query);
	    }
	  }, {
	    key: 'productTypes',
	    value: function productTypes() {
	      return this._resourceService.get(this._API_BASE + '/list-types');
	    }
	  }, {
	    key: 'categories',
	    value: function categories() {
	      return this._resourceService.get(this._API_BASE + '/categories');
	    }
	  }, {
	    key: 'categoriesTree',
	    value: function categoriesTree() {
	      return this._resourceService.get(this._API_BASE + '/categories-tree');
	    }
	  }, {
	    key: 'suggest',
	    value: function suggest(term) {
	      if (!term) {
	        this._resourceService.errorPromise('marketplace:suggest: missing parameter');
	      }
	      return this._resourceService.get(this._API_BASE + '/suggest?term=' + encodeURIComponent(term));
	    }
	  }, {
	    key: 'initializeGlobalDiscount',
	    value: function initializeGlobalDiscount(csdc, csdcEmail) {
	      var data = {
	        csdc: csdc,
	        csdc_email: csdcEmail
	      };
	
	      return this._resourceService.post('/global-discount', data);
	    }
	  }]);
	
	  return MarketplaceService;
	}()];

/***/ }),
/* 39 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = ['ResourceService', function () {
	  function UserService(resourceService) {
	    _classCallCheck(this, UserService);
	
	    this._resourceService = resourceService;
	    this._API_BASE = '/users';
	  }
	
	  _createClass(UserService, [{
	    key: 'getSavedPayment',
	    value: function getSavedPayment(slug) {
	      if (!slug) {
	        return this._resourceService.errorPromise('missing params');
	      }
	      return this._resourceService.get(this._API_BASE + '/' + slug + '/payment');
	    }
	  }, {
	    key: 'linkOrder',
	    value: function linkOrder(id, orderNum, emailAddress) {
	      if (!id || !orderNum || !emailAddress) {
	        return this._resourceService.errorPromise('missing params');
	      }
	      return this._resourceService.patch(this._API_BASE + '/' + id + '/orders', {
	        'user_email': emailAddress,
	        'orders': [orderNum]
	      });
	    }
	  }, {
	    key: 'updateAddress',
	    value: function updateAddress(slug, name, address, city, state, zip, country) {
	      var mobile = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;
	      var apt = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : null;
	
	      if (!slug) {
	        return this._resourceService.errorPromise('missing params');
	      }
	      return this._resourceService.put(this._API_BASE + '/' + slug + '/address', {
	        name: name,
	        address: address,
	        city: city,
	        state: state,
	        zip: zip,
	        country: country,
	        mobile: mobile,
	        apt: apt
	      });
	    }
	  }]);
	
	  return UserService;
	}()];

/***/ }),
/* 40 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = ['$q', 'ResourceService', function () {
	  function ProductsService($q, resourceService) {
	    _classCallCheck(this, ProductsService);
	
	    this._$q = $q;
	    this._resourceService = resourceService;
	    this._API_BASE = '/products';
	  }
	
	  _createClass(ProductsService, [{
	    key: 'getDescription',
	    value: function getDescription(id) {
	      if (!id) {
	        return this._resourceService.errorPromise('products:getDescription: missing parameters');
	      }
	
	      return this._resourceService.get(this._API_BASE + '/' + id + '/description');
	    }
	  }, {
	    key: 'getSizing',
	    value: function getSizing(id) {
	      if (!id) {
	        return this._resourceService.errorPromise('products:getSizing: missing parameters');
	      }
	
	      return this._resourceService.get(this._API_BASE + '/' + id + '/sizing');
	    }
	  }, {
	    key: 'getSizingAndDescription',
	    value: function getSizingAndDescription(id) {
	      if (!id) {
	        return this._resourceService.errorPromise('products:getSizingAndDescription: missing parameters');
	      }
	
	      var sizingRes = void 0,
	          descRes = void 0,
	          sizingDef = void 0,
	          descDef = void 0;
	
	      sizingDef = this.getSizing(id).then(function (res) {
	        return sizingRes = res;
	      });
	      descDef = this.getDescription(id).then(function (res) {
	        return descRes = res;
	      });
	
	      return this._$q.all([sizingDef, descDef]).then(function () {
	        return { sizing: sizingRes, description: descRes.description };
	      });
	    }
	  }]);
	
	  return ProductsService;
	}()];

/***/ }),
/* 41 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = ['ResourceService', function () {
	  function OffersService(resourceService) {
	    _classCallCheck(this, OffersService);
	
	    this._resourceService = resourceService;
	    this._API_BASE = '/offers';
	  }
	
	  _createClass(OffersService, [{
	    key: 'subscribe',
	    value: function subscribe(email, _email) {
	      if (!email || typeof _email === 'undefined') {
	        return this._resourceService.errorPromise('offers:subscribe: missing parameters');
	      }
	      return this._resourceService.post(this._API_BASE + '/subscribe', {
	        'email': email,
	        '_email': _email
	      });
	    }
	  }]);
	
	  return OffersService;
	}()];

/***/ }),
/* 42 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = ['ResourceService', function () {
	  function CurrencyAPISerice(resourceService) {
	    _classCallCheck(this, CurrencyAPISerice);
	
	    this._resourceService = resourceService;
	    this._API_BASE = '/currency';
	  }
	
	  _createClass(CurrencyAPISerice, [{
	    key: 'getCurrencyInfo',
	    value: function getCurrencyInfo(country) {
	      var query = '';
	
	      if (country) query += '?country=' + country;
	
	      return this._resourceService.get('' + this._API_BASE + query);
	    }
	  }]);
	
	  return CurrencyAPISerice;
	}()];

/***/ }),
/* 43 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = ['ResourceService', function () {
	  function CobrandedAPISerice(resourceService) {
	    _classCallCheck(this, CobrandedAPISerice);
	
	    this._resourceService = resourceService;
	    this._API_BASE = '/cobranded';
	  }
	
	  _createClass(CobrandedAPISerice, [{
	    key: 'getRegistrationData',
	    value: function getRegistrationData(partnerId) {
	      if (!partnerId) {
	        return this._resourceService.errorPromise('missing params');
	      }
	
	      return this._resourceService.get(this._API_BASE + '/' + partnerId + '/registration');
	    }
	  }, {
	    key: 'uploadFile',
	    value: function uploadFile(partnerId, formData) {
	      if (!partnerId || !formData) {
	        return this._resourceService.errorPromise('missing params');
	      }
	
	      return this._resourceService.postFile(this._API_BASE + '/' + partnerId + '/orders/bulk-process', formData);
	    }
	  }, {
	    key: 'getImportHistory',
	    value: function getImportHistory(partnerId) {
	      if (!partnerId) {
	        return this._resourceService.errorPromise('missing params');
	      }
	
	      return this._resourceService.get(this._API_BASE + '/' + partnerId + '/orders/bulk-process/history?' + moment().format());
	    }
	  }, {
	    key: 'getImportStatus',
	    value: function getImportStatus(partnerId, processId) {
	      if (!partnerId || !processId) {
	        return this._resourceService.errorPromise('missing params');
	      }
	
	      return this._resourceService.get(this._API_BASE + '/' + partnerId + '/orders/bulk-process/history/' + processId + '?' + moment().format());
	    }
	  }]);
	
	  return CobrandedAPISerice;
	}()];

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _protocolRelative = __webpack_require__(45);
	
	var _protocolRelative2 = _interopRequireDefault(_protocolRelative);
	
	var _trusted = __webpack_require__(46);
	
	var _trusted2 = _interopRequireDefault(_trusted);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('cui.filters', []).filter('protocolRelative', _protocolRelative2.default).filter('trusted', _trusted2.default);

/***/ }),
/* 45 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ProtocolRelativeFilter;
	function ProtocolRelativeFilter() {
	  return function (input) {
	    if (typeof input !== 'string') return input;
	
	    if (input.indexOf('https://') === 0 || input.indexOf('http://') === 0) {
	      do {
	        input = input.substring(1);
	      } while (input.indexOf('//') > 0);
	    }
	
	    return input;
	  };
	};

/***/ }),
/* 46 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ['$sce', function TrustedFilter($sce) {
	  return function (url) {
	    return $sce.trustAsResourceUrl(url);
	  };
	}];

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _header = __webpack_require__(48);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(54);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _modal = __webpack_require__(55);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _errorModal = __webpack_require__(60);
	
	var _errorModal2 = _interopRequireDefault(_errorModal);
	
	var _changeAddress = __webpack_require__(61);
	
	var _changeAddress2 = _interopRequireDefault(_changeAddress);
	
	var _changeAddress3 = __webpack_require__(62);
	
	var _changeAddress4 = _interopRequireDefault(_changeAddress3);
	
	var _contactForm = __webpack_require__(63);
	
	var _contactForm2 = _interopRequireDefault(_contactForm);
	
	var _lazyImg = __webpack_require__(64);
	
	var _lazyImg2 = _interopRequireDefault(_lazyImg);
	
	var _smartImg = __webpack_require__(65);
	
	var _smartImg2 = _interopRequireDefault(_smartImg);
	
	var _liveChat = __webpack_require__(66);
	
	var _liveChat2 = _interopRequireDefault(_liveChat);
	
	var _loadingOverlay = __webpack_require__(67);
	
	var _loadingOverlay2 = _interopRequireDefault(_loadingOverlay);
	
	var _loadingButton = __webpack_require__(69);
	
	var _loadingButton2 = _interopRequireDefault(_loadingButton);
	
	var _innerBanner = __webpack_require__(70);
	
	var _innerBanner2 = _interopRequireDefault(_innerBanner);
	
	var _forgotPassword = __webpack_require__(71);
	
	var _forgotPassword2 = _interopRequireDefault(_forgotPassword);
	
	var _forgotPassword3 = __webpack_require__(73);
	
	var _forgotPassword4 = _interopRequireDefault(_forgotPassword3);
	
	var _amazonPayment = __webpack_require__(74);
	
	var _amazonPayment2 = _interopRequireDefault(_amazonPayment);
	
	var _email = __webpack_require__(75);
	
	var _email2 = _interopRequireDefault(_email);
	
	var _facebook = __webpack_require__(76);
	
	var _facebook2 = _interopRequireDefault(_facebook);
	
	var _twitter = __webpack_require__(77);
	
	var _twitter2 = _interopRequireDefault(_twitter);
	
	var _pinterest = __webpack_require__(78);
	
	var _pinterest2 = _interopRequireDefault(_pinterest);
	
	var _google = __webpack_require__(79);
	
	var _google2 = _interopRequireDefault(_google);
	
	var _shoppingCart = __webpack_require__(80);
	
	var _shoppingCart2 = _interopRequireDefault(_shoppingCart);
	
	var _shoppingCartItems = __webpack_require__(82);
	
	var _shoppingCartItems2 = _interopRequireDefault(_shoppingCartItems);
	
	var _paypalPayment = __webpack_require__(84);
	
	var _paypalPayment2 = _interopRequireDefault(_paypalPayment);
	
	var _stripePayment = __webpack_require__(86);
	
	var _stripePayment2 = _interopRequireDefault(_stripePayment);
	
	var _testimonials = __webpack_require__(88);
	
	var _testimonials2 = _interopRequireDefault(_testimonials);
	
	var _focusElement = __webpack_require__(89);
	
	var _focusElement2 = _interopRequireDefault(_focusElement);
	
	var _infiniteScroll = __webpack_require__(90);
	
	var _infiniteScroll2 = _interopRequireDefault(_infiniteScroll);
	
	var _homeImageCarousel = __webpack_require__(91);
	
	var _homeImageCarousel2 = _interopRequireDefault(_homeImageCarousel);
	
	var _login = __webpack_require__(93);
	
	var _login2 = _interopRequireDefault(_login);
	
	var _login3 = __webpack_require__(95);
	
	var _login4 = _interopRequireDefault(_login3);
	
	var _registerModal = __webpack_require__(96);
	
	var _registerModal2 = _interopRequireDefault(_registerModal);
	
	var _registerForm = __webpack_require__(98);
	
	var _registerForm2 = _interopRequireDefault(_registerForm);
	
	var _register = __webpack_require__(99);
	
	var _register2 = _interopRequireDefault(_register);
	
	var _facebookLoginService = __webpack_require__(100);
	
	var _facebookLoginService2 = _interopRequireDefault(_facebookLoginService);
	
	var _eventBroadcaster = __webpack_require__(101);
	
	var _eventBroadcaster2 = _interopRequireDefault(_eventBroadcaster);
	
	var _floatLabelText = __webpack_require__(102);
	
	var _floatLabelText2 = _interopRequireDefault(_floatLabelText);
	
	var _floatLabelSelect = __webpack_require__(103);
	
	var _floatLabelSelect2 = _interopRequireDefault(_floatLabelSelect);
	
	var _fileUploader = __webpack_require__(104);
	
	var _fileUploader2 = _interopRequireDefault(_fileUploader);
	
	var _googleAddressAutocomplete = __webpack_require__(105);
	
	var _googleAddressAutocomplete2 = _interopRequireDefault(_googleAddressAutocomplete);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('cui.layoutComponents', []).controller('HeaderCtrl', _header2.default).controller('FooterCtrl', _footer2.default).directive('cuiModal', _modal2.default).directive('errorModal', _errorModal2.default).controller('changeAddressCtrl', _changeAddress2.default).directive('changeAddress', _changeAddress4.default).directive('lazyImg', _lazyImg2.default).directive('smartImg', _smartImg2.default).directive('liveChat', _liveChat2.default).directive('cuiLoadingOverlay', _loadingOverlay2.default).directive('cuiLoadingButton', _loadingButton2.default).directive('innerBanner', _innerBanner2.default).directive('amazonPayment', _amazonPayment2.default).directive('paypalPayment', _paypalPayment2.default).directive('shoppingCart', _shoppingCart2.default).directive('shoppingCartItems', _shoppingCartItems2.default).directive('stripePayment', _stripePayment2.default).directive('viralstyleTestimonials', _testimonials2.default).directive('focusElement', _focusElement2.default).directive('infiniteScroll', _infiniteScroll2.default).directive('homeImageCarousel', _homeImageCarousel2.default).directive('contactForm', _contactForm2.default)
	// Auth Controls
	.directive('cuiLogin', _login2.default).controller('LoginCtrl', _login4.default).directive('forgotPassword', _forgotPassword2.default).controller('forgotPasswordCtrl', _forgotPassword4.default).directive('registerForm', _registerForm2.default).directive('cuiRegister', _registerModal2.default).controller('RegisterCtrl', _register2.default).service('FacebookLoginService', _facebookLoginService2.default).controller('EventBroadcasterCtrl', _eventBroadcaster2.default)
	// End Auth Controls
	// Begin Social Share
	.directive('emailShare', _email2.default).directive('facebookShare', _facebook2.default).directive('twitterShare', _twitter2.default).directive('pinterestShare', _pinterest2.default).directive('googleShare', _google2.default)
	// End Social Share
	.directive('floatLabelText', _floatLabelText2.default).directive('floatLabelSelect', _floatLabelSelect2.default).directive('fileUploader', _fileUploader2.default).directive('googleAddressAutocomplete', _googleAddressAutocomplete2.default);

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _config = __webpack_require__(2);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _cdnImagePreprocessor = __webpack_require__(49);
	
	var _cdnImagePreprocessor2 = _interopRequireDefault(_cdnImagePreprocessor);
	
	var _isValidPath = __webpack_require__(50);
	
	var _isValidPath2 = _interopRequireDefault(_isValidPath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = ['$window', '$rootScope', '$state', '$cookies', '$timeout', '$location', 'CartService', 'AuthService', 'MarketplaceService', 'UserDataService', 'FacebookLoginService', function () {
	  function HeaderController($window, $rootScope, $state, $cookies, $timeout, $location, CartService, AuthService, MarketplaceService, UserDataService, facebook) {
	    var _this = this;
	
	    _classCallCheck(this, HeaderController);
	
	    this._$window = $window;
	    this._$rootScope = $rootScope;
	    this._$state = $state;
	    this._$cookies = $cookies;
	    this._$timeout = $timeout;
	    this._$location = $location;
	    this._authService = AuthService;
	    this._marketplaceService = MarketplaceService;
	    this.userDataService = UserDataService;
	    this._facebook = facebook;
	    this.cart = CartService;
	    this.cartDropdownOpen = false;
	    this.showSearch = false;
	    this.blurTimeout = null;
	    this.validated = this._$location.search().email_validated;
	
	    if (this._$location.path() === '/client-logout') {
	      this.logout().then(function () {
	        _this._$state.go('home', {}, { location: 'replace' });
	        _this._loginCheck();
	      });
	    } else {
	      this._loginCheck();
	    }
	
	    this._initPartnershipEvents();
	    this._initScrollEvent();
	  }
	
	  _createClass(HeaderController, [{
	    key: "_loginCheck",
	    value: function _loginCheck() {
	      var _this2 = this;
	
	      var loginCheck = this._checkIfUserLoggedIn();
	      // let fbLoginCheck = this._facebook.getLoggedInUser();
	      var returnPath = this._$location.search().return,
	          route = typeof returnPath == 'string' && (0, _isValidPath2.default)(returnPath.split('?')[0]) ? returnPath.replace(/\\/g, '').replace('//', '') : '/client';
	
	      loginCheck.then(function (res) {
	        if (res.user.roles === 'COBRAND-ADMIN' && $state.current.name.indexOf('cobrand-admin') === -1) {
	          $window.location.href = '/cobrand-admin';
	        }
	      }).catch(function () {
	        // fbLoginCheck
	        //   .then((res) => this._facebookLogin(res))
	        //   .catch(() => {
	        //     if (this._$location.path() === '/login') this.showLogin(route);
	        //   });
	
	        switch (_this2._$location.path()) {
	          case '/login':
	            _this2.showLogin(route, _this2._$location.search()['email']);
	            break;
	          case '/register':
	            _this2.showRegister();
	            break;
	          case '/forgot-password':
	            _this2._$rootScope.$broadcast('login:forgotPassword');
	            break;
	        }
	      });
	    }
	  }, {
	    key: "onSalesFlow",
	    value: function onSalesFlow() {
	      return this._$state.includes('sales');
	    }
	  }, {
	    key: "onProductDetails",
	    value: function onProductDetails() {
	      return this._$state.current.name === 'sales-store';
	    }
	  }, {
	    key: "performSearch",
	    value: function performSearch() {
	      if (this.search) {
	        this._$window.location.href = "/marketplace/?search=" + this.search;
	      } else {
	        this._$window.location.href = "/marketplace";
	      }
	      this.redirecting = true;
	    }
	  }, {
	    key: "handleKeydown",
	    value: function handleKeydown(event) {
	      if (event.keyCode === 27) {
	        this.showSearch = false;
	        this.search = '';
	        this.showSearchSuggestions = false;
	        this.searchSuggestions = null;
	      }
	    }
	  }, {
	    key: "navigateToDashboard",
	    value: function navigateToDashboard() {
	      var _this3 = this;
	
	      if (this.userDataService.userLoggedIn()) {
	        this.redirecting = true;
	        this._checkIfUserLoggedIn().then(function (res) {
	          var route = void 0;
	
	          if (res.user.roles === 'CUSTOMER') route = '/my-account';else if (res.dashboard_link) route = res.dashboard_link;else route = '/client';
	
	          _this3._$window.location.href = route;
	        }).catch(function (err) {
	          _this3.showLogin('/client');
	          _this3.redirecting = false;
	        });
	      } else this.showLogin('/client');
	    }
	  }, {
	    key: "launchDesigner",
	    value: function launchDesigner() {
	      var _this4 = this;
	
	      if (this.gravatar()) {
	        this.redirecting = true;
	        this._checkIfUserLoggedIn().then(function (res) {
	          return _this4._$window.location.href = '/design.beta';
	        }).catch(function (err) {
	          _this4.showLogin('/design.beta');
	          _this4.redirecting = false;
	        });
	      } else this.showLogin('/design.beta');
	    }
	  }, {
	    key: "logout",
	    value: function logout() {
	      var _this5 = this;
	
	      this.redirecting = true;
	      this._facebook.logout();
	      this.showMenu = false;
	      this._$rootScope.$broadcast('menu-toggle', {
	        canScroll: true
	      });
	
	      return this._authService.logout().finally(function () {
	        _this5.userDataService.clearUserData();
	        _this5.redirecting = false;
	
	        if (_this5._$state.includes('my-account')) {
	          _this5._$window.location.href = '/';
	        }
	        _this5._$rootScope.$broadcast('logout:success');
	      });
	    }
	  }, {
	    key: "showLogin",
	    value: function showLogin(route, email) {
	      this._$rootScope.$broadcast('register:close');
	      this._$rootScope.$broadcast('login:open', { route: route, email: email });
	    }
	  }, {
	    key: "showRegister",
	    value: function showRegister() {
	      this._$rootScope.$broadcast('login:close');
	      this._$rootScope.$broadcast('register:open', {});
	    }
	  }, {
	    key: "searchChanged",
	    value: function searchChanged() {
	      var _this6 = this;
	
	      if (!this.search || typeof this.search == 'string' && this.search.length == 0) {
	        // Clear search suggestions without calling the API.
	        this.searchSuggestions = null;
	        return;
	      }
	
	      this._marketplaceService.suggest(this.search).then(function (res) {
	        _this6.searchSuggestions = res.results.length ? res.results : null;
	      }).catch(function () {
	        return _this6.searchSuggestions = null;
	      });
	    }
	  }, {
	    key: "searchBlur",
	    value: function searchBlur() {
	      var _this7 = this;
	
	      this._$timeout.cancel(this.blurTimeout);
	      this.blurTimeout = this._$timeout(function () {
	        if (!_this7.suggestionFocused) {
	          _this7.showSearchSuggestions = false;
	          _this7.showSearch = false;
	        }
	      }, 200);
	    }
	  }, {
	    key: "searchFocus",
	    value: function searchFocus() {
	      this.showSearchSuggestions = true;
	      this.showSearch = true;
	    }
	  }, {
	    key: "focusSuggestion",
	    value: function focusSuggestion(e) {
	      this.suggestionFocused = true;
	    }
	  }, {
	    key: "blurSuggestion",
	    value: function blurSuggestion(e) {
	      if (!$(':focus').closest('vs-search-suggest').length) {
	        this.suggestionFocused = false;
	        this.showSearchSuggestions = false;
	        this.showSearch = false;
	      }
	    }
	  }, {
	    key: "toggleMenu",
	    value: function toggleMenu() {
	      this.showMenu = !this.showMenu;
	      this._$rootScope.$broadcast('menu-toggle', {
	        canScroll: !this.showMenu
	      });
	    }
	  }, {
	    key: "toggleSlideMenu",
	    value: function toggleSlideMenu(toggle) {
	      var showSlideMenu = typeof toggle !== 'undefined' ? toggle : !this.showSlideMenu;
	
	      this.showSlideMenu = showSlideMenu;
	      this._$rootScope.$broadcast('slide-menu-toggle', {
	        canScroll: !this.showSlideMenu
	      });
	    }
	  }, {
	    key: "isScrolled",
	    value: function isScrolled() {
	      return this._$window.scrollY > 0;
	    }
	  }, {
	    key: "_checkIfUserLoggedIn",
	    value: function _checkIfUserLoggedIn() {
	      var _this8 = this;
	
	      var promise = this._authService.getCurrentUser();
	
	      promise.then(function (res) {
	        return _this8.userDataService.setUserData(res);
	      }).catch(function (err) {
	        return _this8.userDataService.clearUserData();
	      });
	
	      return promise;
	    }
	  }, {
	    key: "_facebookLogin",
	    value: function _facebookLogin(res) {
	      var _this9 = this;
	
	      var promise = this._authService.socialLogin('facebook', res.authResponse.accessToken, res.authResponse.userID, 'CLIENT');
	
	      promise.then(function (res) {
	        return _this9.userDataService.setUserData(res);
	      }).catch(function (err) {
	        return _this9.userDataService.clearUserData();
	      });
	
	      return promise;
	    }
	  }, {
	    key: "_initPartnershipEvents",
	    value: function _initPartnershipEvents() {
	      var _this10 = this;
	
	      this._$rootScope.$on('partnership:showLogo', function (e, args) {
	        _this10.partnershipLogoPath = (0, _cdnImagePreprocessor2.default)(_config2.default).asset("/" + args.pid + ".png");
	      });
	    }
	  }, {
	    key: "_initScrollEvent",
	    value: function _initScrollEvent() {
	      var _this11 = this;
	
	      var timeout = null; // Use the timeout to slow down the digests.
	      angular.element(this._$window).bind("scroll", function () {
	        if (timeout === null) timeout = _this11._$timeout(function () {
	          timeout = null;
	          _this11._$rootScope.$apply();
	        }, 100);
	      });
	    }
	  }]);
	
	  return HeaderController;
	}()];

/***/ }),
/* 49 */
/***/ (function(module, exports) {

	'use strict';
	
	var config, cacheBuster;
	
	function asset(path) {
	  var map = ['a', 'b', 'c'];
	  var base = config['ImagesUrl'];
	  var key = path.length % 3;
	
	  switch (config['Environment']) {
	    case 'Staging':
	      base = '//dev-' + map[key] + '.' + base;
	      break;
	    case 'Production':
	      base = '//' + map[key] + '.' + base;
	      break;
	  }
	  return base + path + cacheBuster;
	}
	
	module.exports = function cdnFactory(configObj) {
	  config = configObj;
	  cacheBuster = '?cb=' + new Date().getTime();
	  return { asset: asset };
	};

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * is-valid-path <https://github.com/jonschlinkert/is-valid-path>
	 *
	 * Copyright (c) 2015 Jon Schlinkert, contributors.
	 * Licensed under the MIT license.
	 */
	
	'use strict';
	
	var isInvalidPath = __webpack_require__(51);
	
	module.exports = function (str) {
	  return isInvalidPath(str) === false;
	};


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * is-invalid-path <https://github.com/jonschlinkert/is-invalid-path>
	 *
	 * Copyright (c) 2015, Jon Schlinkert.
	 * Licensed under the MIT License.
	 */
	
	'use strict';
	
	var isGlob = __webpack_require__(52);
	var re = /[‘“!#$%&+^<=>`]/;
	
	module.exports = function (str) {
	  return (typeof str !== 'string') || isGlob(str) || re.test(str);
	};


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * is-glob <https://github.com/jonschlinkert/is-glob>
	 *
	 * Copyright (c) 2014-2015, Jon Schlinkert.
	 * Licensed under the MIT License.
	 */
	
	var isExtglob = __webpack_require__(53);
	
	module.exports = function isGlob(str) {
	  return typeof str === 'string'
	    && (/[*!?{}(|)[\]]/.test(str)
	     || isExtglob(str));
	};

/***/ }),
/* 53 */
/***/ (function(module, exports) {

	/*!
	 * is-extglob <https://github.com/jonschlinkert/is-extglob>
	 *
	 * Copyright (c) 2014-2015, Jon Schlinkert.
	 * Licensed under the MIT License.
	 */
	
	module.exports = function isExtglob(str) {
	  return typeof str === 'string'
	    && /[@?!+*]\(/.test(str);
	};


/***/ }),
/* 54 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = ['$window', function FooterController($window) {
	  _classCallCheck(this, FooterController);
	
	  this.year = $window.moment(new Date()).format('YYYY');
	}];

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cdnPreprocessor = __webpack_require__(56);
	
	exports.default = ['$timeout', function CUIModalDirective($timeout) {
	  return {
	    restrict: 'E',
	    transclude: true,
	    scope: {
	      toggle: '=',
	      confirmState: '=?',
	      confirmDisabled: '=?',
	      cancelHandler: '&',
	      confirmHandler: '&',
	      modalTitle: '@',
	      confirmText: '@',
	      cancelText: '@',
	      type: '@',
	      confirmFormId: '@' //id of form that wires to the submit button (needed since the submit is outside of the form element)
	    },
	    template: __webpack_require__(57)(_cdnPreprocessor.jadeLocals),
	    link: function link(scope, el, attrs) {
	      var cancelTypes = ['form', 'account', 'contact', 'confirm'],
	          focusableElements = void 0,
	          firstElement = void 0,
	          lastElement = void 0,
	          close = function close() {
	        if (attrs.cancelHandler) scope.cancelHandler();else {
	          scope.toggle = false;
	          scope.$emit('cui-modal-close');
	        }
	      },
	          handleEscapePressed = function handleEscapePressed(e) {
	        if (e.keyCode == 27) {
	          close();
	          scope.$applyAsync();
	        }
	      };
	
	      scope.close = close;
	      scope.confirm = attrs.confirmHandler ? scope.confirmHandler : scope.close;
	      scope.confirmText = scope.confirmText || 'OK';
	      scope.cancelText = scope.cancelText || 'CLOSE';
	      scope.showCancel = scope.type ? cancelTypes.indexOf(scope.type) > -1 ? true : false : false;
	
	      scope.backdropStyle = function () {
	        return scope.toggle ? {
	          'display': 'block'
	        } : {
	          'display': 'none'
	        };
	      };
	
	      scope.$watch('toggle', function (visible) {
	        if (visible) {
	          focusableElements = $(el).find('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
	          firstElement = focusableElements.first();
	          lastElement = focusableElements.last();
	
	          firstElement.focus();
	
	          console.log('bind it');
	          $(document.body).on('keydown', handleEscapePressed);
	
	          firstElement.on('keydown', function (e) {
	            if (e.keyCode == 9 && e.shiftKey) {
	              e.preventDefault();
	
	              lastElement.focus();
	            }
	          });
	
	          lastElement.on('keydown', function (e) {
	            if (e.keyCode == 9 && !e.shiftKey) {
	              e.preventDefault();
	
	              firstElement.focus();
	            }
	          });
	
	          if (cancelTypes.indexOf(scope.type) === -1) {
	            $timeout(function () {
	              el.find('.form-btn')[0].focus();
	            });
	          }
	        } else {
	          $(document.body).off('keydown', handleEscapePressed);
	        }
	      });
	
	      scope.$on('$destroy', function () {
	        if (firstElement.length) firstElement.off();
	        if (lastElement.length) lastElement.off();
	        $(document.body).off('keydown', handleEscapePressed);
	      });
	    }
	  };
	}];

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _config = __webpack_require__(2);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function cdnAsset(path, base) {
	  var map = ['a', 'b', 'c'];
	  var key = path.length % 3;
	  var cb =  true ? '?cb=' + (1793767125608) : ''; // CACHE_BUSTER defined in webpack
	
	  switch (_config2.default['Environment']) {
	    case 'Staging':
	      base = 'https://dev-' + map[key] + '.' + base;
	      break;
	    case 'Production':
	      base = 'https://' + map[key] + '.' + base;
	      break;
	  }
	  return '' + base + path + cb;
	}
	
	module.exports = {
	  cdnTemplate: function cdnTemplate(path) {
	    return cdnAsset(path, _config2.default['TemplatesUrl']);
	  },
	  jadeLocals: {
	    cdn: { asset: function asset(path) {
	        return cdnAsset(path, _config2.default['ImagesUrl']);
	      } }
	  }
	};

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var jade = __webpack_require__(58);
	
	module.exports = function template(locals) {
	  var buf = [];
	  var jade_mixins = {};
	  var jade_interp;
	
	  buf.push("<div ng-class=\"{&quot;in&quot;: toggle}\" tabindex=\"-1\" role=\"dialog\" class=\"modal fade\"><div ng-class=\"{ &quot;account-modal&quot;: type === &quot;account&quot;}\" role=\"document\" class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><button ng-if=\"showCancel\" aria-label=\"Close\" type=\"button\" ng-click=\"close()\" class=\"close\"><span aria-hidden=\"true\">×</span></button><h4 class=\"modal-title\">{{modalTitle}}</h4></div><div ng-transclude class=\"modal-body\"></div><div ng-if=\"type !== &quot;account&quot; &amp;&amp; type !== &quot;contact&quot;\" class=\"modal-footer\"><button ng-if=\"showCancel\" type=\"button\" ng-click=\"close()\" class=\"btn btn-default btn-cancel\">{{cancelText}}</button><cui-loading-button tabindex=\"0\" type=\"{{ type === &quot;form&quot; ? &quot;submit&quot; : &quot;button&quot; }}\" text=\"{{confirmText}}\" state=\"confirmState\" ng-click=\"confirm()\" block=\"false\" button-disabled=\"confirmDisabled\" submit-form-id=\"{{confirmFormId}}\"></cui-loading-button></div></div></div></div><div ng-style=\"backdropStyle()\" class=\"modal-backdrop in\"></div>");;return buf.join("");
	};

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Merge two attribute objects giving precedence
	 * to values in object `b`. Classes are special-cased
	 * allowing for arrays and merging/joining appropriately
	 * resulting in a string.
	 *
	 * @param {Object} a
	 * @param {Object} b
	 * @return {Object} a
	 * @api private
	 */
	
	exports.merge = function merge(a, b) {
	  if (arguments.length === 1) {
	    var attrs = a[0];
	    for (var i = 1; i < a.length; i++) {
	      attrs = merge(attrs, a[i]);
	    }
	    return attrs;
	  }
	  var ac = a['class'];
	  var bc = b['class'];
	
	  if (ac || bc) {
	    ac = ac || [];
	    bc = bc || [];
	    if (!Array.isArray(ac)) ac = [ac];
	    if (!Array.isArray(bc)) bc = [bc];
	    a['class'] = ac.concat(bc).filter(nulls);
	  }
	
	  for (var key in b) {
	    if (key != 'class') {
	      a[key] = b[key];
	    }
	  }
	
	  return a;
	};
	
	/**
	 * Filter null `val`s.
	 *
	 * @param {*} val
	 * @return {Boolean}
	 * @api private
	 */
	
	function nulls(val) {
	  return val != null && val !== '';
	}
	
	/**
	 * join array as classes.
	 *
	 * @param {*} val
	 * @return {String}
	 */
	exports.joinClasses = joinClasses;
	function joinClasses(val) {
	  return (Array.isArray(val) ? val.map(joinClasses) :
	    (val && typeof val === 'object') ? Object.keys(val).filter(function (key) { return val[key]; }) :
	    [val]).filter(nulls).join(' ');
	}
	
	/**
	 * Render the given classes.
	 *
	 * @param {Array} classes
	 * @param {Array.<Boolean>} escaped
	 * @return {String}
	 */
	exports.cls = function cls(classes, escaped) {
	  var buf = [];
	  for (var i = 0; i < classes.length; i++) {
	    if (escaped && escaped[i]) {
	      buf.push(exports.escape(joinClasses([classes[i]])));
	    } else {
	      buf.push(joinClasses(classes[i]));
	    }
	  }
	  var text = joinClasses(buf);
	  if (text.length) {
	    return ' class="' + text + '"';
	  } else {
	    return '';
	  }
	};
	
	
	exports.style = function (val) {
	  if (val && typeof val === 'object') {
	    return Object.keys(val).map(function (style) {
	      return style + ':' + val[style];
	    }).join(';');
	  } else {
	    return val;
	  }
	};
	/**
	 * Render the given attribute.
	 *
	 * @param {String} key
	 * @param {String} val
	 * @param {Boolean} escaped
	 * @param {Boolean} terse
	 * @return {String}
	 */
	exports.attr = function attr(key, val, escaped, terse) {
	  if (key === 'style') {
	    val = exports.style(val);
	  }
	  if ('boolean' == typeof val || null == val) {
	    if (val) {
	      return ' ' + (terse ? key : key + '="' + key + '"');
	    } else {
	      return '';
	    }
	  } else if (0 == key.indexOf('data') && 'string' != typeof val) {
	    if (JSON.stringify(val).indexOf('&') !== -1) {
	      console.warn('Since Jade 2.0.0, ampersands (`&`) in data attributes ' +
	                   'will be escaped to `&amp;`');
	    };
	    if (val && typeof val.toISOString === 'function') {
	      console.warn('Jade will eliminate the double quotes around dates in ' +
	                   'ISO form after 2.0.0');
	    }
	    return ' ' + key + "='" + JSON.stringify(val).replace(/'/g, '&apos;') + "'";
	  } else if (escaped) {
	    if (val && typeof val.toISOString === 'function') {
	      console.warn('Jade will stringify dates in ISO form after 2.0.0');
	    }
	    return ' ' + key + '="' + exports.escape(val) + '"';
	  } else {
	    if (val && typeof val.toISOString === 'function') {
	      console.warn('Jade will stringify dates in ISO form after 2.0.0');
	    }
	    return ' ' + key + '="' + val + '"';
	  }
	};
	
	/**
	 * Render the given attributes object.
	 *
	 * @param {Object} obj
	 * @param {Object} escaped
	 * @return {String}
	 */
	exports.attrs = function attrs(obj, terse){
	  var buf = [];
	
	  var keys = Object.keys(obj);
	
	  if (keys.length) {
	    for (var i = 0; i < keys.length; ++i) {
	      var key = keys[i]
	        , val = obj[key];
	
	      if ('class' == key) {
	        if (val = joinClasses(val)) {
	          buf.push(' ' + key + '="' + val + '"');
	        }
	      } else {
	        buf.push(exports.attr(key, val, false, terse));
	      }
	    }
	  }
	
	  return buf.join('');
	};
	
	/**
	 * Escape the given string of `html`.
	 *
	 * @param {String} html
	 * @return {String}
	 * @api private
	 */
	
	var jade_encode_html_rules = {
	  '&': '&amp;',
	  '<': '&lt;',
	  '>': '&gt;',
	  '"': '&quot;'
	};
	var jade_match_html = /[&<>"]/g;
	
	function jade_encode_char(c) {
	  return jade_encode_html_rules[c] || c;
	}
	
	exports.escape = jade_escape;
	function jade_escape(html){
	  var result = String(html).replace(jade_match_html, jade_encode_char);
	  if (result === '' + html) return html;
	  else return result;
	};
	
	/**
	 * Re-throw the given `err` in context to the
	 * the jade in `filename` at the given `lineno`.
	 *
	 * @param {Error} err
	 * @param {String} filename
	 * @param {String} lineno
	 * @api private
	 */
	
	exports.rethrow = function rethrow(err, filename, lineno, str){
	  if (!(err instanceof Error)) throw err;
	  if ((typeof window != 'undefined' || !filename) && !str) {
	    err.message += ' on line ' + lineno;
	    throw err;
	  }
	  try {
	    str = str || __webpack_require__(59).readFileSync(filename, 'utf8')
	  } catch (ex) {
	    rethrow(err, null, lineno)
	  }
	  var context = 3
	    , lines = str.split('\n')
	    , start = Math.max(lineno - context, 0)
	    , end = Math.min(lines.length, lineno + context);
	
	  // Error context
	  var context = lines.slice(start, end).map(function(line, i){
	    var curr = i + start + 1;
	    return (curr == lineno ? '  > ' : '    ')
	      + curr
	      + '| '
	      + line;
	  }).join('\n');
	
	  // Alter exception message
	  err.path = filename;
	  err.message = (filename || 'Jade') + ':' + lineno
	    + '\n' + context + '\n\n' + err.message;
	  throw err;
	};
	
	exports.DebugItem = function DebugItem(lineno, filename) {
	  this.lineno = lineno;
	  this.filename = filename;
	}


/***/ }),
/* 59 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cdnPreprocessor = __webpack_require__(56);
	
	exports.default = ['ErrorHandler', function ErrorModalDirective(ErrorHandler) {
	  return {
	    restrict: 'E',
	    templateUrl: (0, _cdnPreprocessor.cdnTemplate)('/error-modal.html'),
	    link: function link(scope) {
	      scope.toggle = false;
	      scope.errors = function () {
	        return ErrorHandler.getErrors();
	      };
	
	      // Appear on a new error
	      scope.$watch(function () {
	        return ErrorHandler.getErrors().length;
	      }, function (newVal, oldVal) {
	        if (newVal > oldVal) scope.toggle = true;
	      });
	
	      // Clear errors when closed
	      scope.$watch(function () {
	        return scope.toggle;
	      }, function (newVal, oldVal) {
	        if (newVal === false && oldVal === true) ErrorHandler.clear();
	      });
	    }
	  };
	}];

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(7);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = ['$q', '$scope', 'StateTerritoryData', 'CustomerService', function () {
	  function ChangeAddressController($q, $scope, StateTerritoryData, CustomerService) {
	    _classCallCheck(this, ChangeAddressController);
	
	    this._$q = $q;
	    this._$scope = $scope;
	    this._customerService = CustomerService;
	
	    this.countries = StateTerritoryData.getCountries();
	    this.states = StateTerritoryData.getExtendedStates();
	    this.provinces = StateTerritoryData.getProvinces();
	  }
	
	  _createClass(ChangeAddressController, [{
	    key: 'show',
	    value: function show(e, orderNum) {
	      var order = this.orderObject.base.order_num === orderNum ? this.orderObject.base : _lodash2.default.find(this.orderObject.upsells, function (upsell) {
	        return upsell.order_num === orderNum;
	      });
	
	      if (order && order.can_update_address) {
	        this.toggle = true;
	        this._getStateFromAddress(order.order_customer);
	      }
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      this.toggle = false;
	    }
	  }, {
	    key: 'save',
	    value: function save() {
	      var _this = this;
	
	      if (this.changeAddress.$valid) {
	        this.submitState = 'loading';
	
	        this.updateAddress().then(function (res) {
	          _this.customer.name = res.name;
	          _this.customer.address.street_1 = res.address.street_1;
	          _this.customer.address.street_2 = res.address.street_2;
	          _this.customer.address.city = res.address.city;
	          _this.customer.address.state = res.address.state;
	          _this.customer.address.zip = res.address.zip;
	
	          _this.originalZip = res.address.zip;
	          _this.submitState = 'success';
	          _this.close();
	        }).catch(function () {
	          return _this.submitState = 'error';
	        });
	      }
	    }
	  }, {
	    key: 'updateAddress',
	    value: function updateAddress() {
	      return this._customerService.updateAddress(this.customer.id, {
	        name: this.customer.name,
	        'street_address_1': this.street_1,
	        'street_address_2': this.street_2,
	        'city': this.city,
	        'state': this.state,
	        'zip': this.zip,
	        'original_zip': this.originalZip,
	        'country': this.country
	      });
	    }
	  }, {
	    key: 'countryChanged',
	    value: function countryChanged() {
	      this.state = '';
	      this.zip = '';
	    }
	  }, {
	    key: '_getStateFromAddress',
	    value: function _getStateFromAddress(customer) {
	      _lodash2.default.assign(this, customer.address);
	
	      this.customer = customer;
	      this.originalZip = customer.address.zip;
	    }
	  }]);
	
	  return ChangeAddressController;
	}()];

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ChangeAddress;
	
	var _cdnPreprocessor = __webpack_require__(56);
	
	function ChangeAddress() {
	  return {
	    restrict: 'E',
	    scope: {
	      index: '=',
	      orderObject: '='
	    },
	    templateUrl: (0, _cdnPreprocessor.cdnTemplate)('/change-address.html'),
	    controller: 'changeAddressCtrl',
	    controllerAs: 'address',
	    bindToController: true,
	    link: function link(scope, el, attrs, ctrl) {
	      scope.$on('show:changeAddress', function (e, index) {
	        return ctrl.show(e, index);
	      });
	    }
	  };
	};

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cdnPreprocessor = __webpack_require__(56);
	
	exports.default = ['SupportService', function contactFormDirective(supportService) {
	  return {
	    restrict: 'E',
	    templateUrl: (0, _cdnPreprocessor.cdnTemplate)('/contact-form.html'),
	    scope: {
	      category: '=?',
	      type: '@?'
	    },
	    link: function link(scope, attrs) {
	      scope.categories = ['General Inquiry', 'Order Status', 'Billing Issue', 'Seller Support', 'Sales'];
	      scope.data = {
	        name: '',
	        email: '',
	        category: scope.category,
	        message: '',
	        _email: ''
	      };
	      scope.type = attrs.type || 'CONTACT';
	      scope.submitState = null;
	
	      scope.$watch('category', function (val) {
	        if (val) {
	          scope.data.category = val;
	        }
	      });
	
	      scope.sendMessage = function () {
	        if (scope.contactForm.$valid) {
	          scope.submitState = 'loading';
	
	          var fullCategory = _.find(scope.categories, function (category) {
	            return category === scope.data.category;
	          }) ? getFullCategory() : getFullPartnershipCategory();
	
	          supportService.sendMessage(scope.data.name, scope.data.email, fullCategory, scope.data.message, scope.data._email, scope.type).then(function (res) {
	            scope.submitState = 'success';
	            scope.data.name = '';
	            scope.data.email = '';
	            scope.data.category = '';
	            scope.data.message = '';
	            scope.data._email = '';
	            scope.contactForm.$setPristine();
	          }).catch(function (err) {
	            scope.submitState = 'error';
	          });
	        }
	      };
	
	      function getFullCategory() {
	        return 'Contact Form - ' + scope.data.category;
	      };
	
	      function getFullPartnershipCategory() {
	        return 'Partnership Contact - ' + scope.data.category;
	      };
	    }
	  };
	}];

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _config = __webpack_require__(2);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = ['$window', '$document', function lazyImg($window, $document) {
	  return {
	    restrict: 'A',
	    link: function link(scope, elm, attrs) {
	      var $el = $(elm[0]),
	          image = new Image();
	
	      var scrollFunc = function scrollFunc() {
	        if (angular.element($window).scrollTop() + angular.element($window).height() >= $el.offset().top) {
	          angular.element(image).on('load', imageLoad);
	          image.src = attrs.lazyImg;
	          $document.off('scroll', scrollFunc);
	        }
	      };
	
	      var imageLoad = function imageLoad() {
	        $el.attr('src', attrs.lazyImg);
	        angular.element(image).off('load', imageLoad);
	      };
	
	      $document.on('scroll', scrollFunc);
	
	      elm.on('$destroy', function () {
	        $document.off('scroll', scrollFunc);
	        angular.element(image).off('load', imageLoad);
	      });
	
	      $el.attr('src', '/assets/customer-ui/images/ring.gif');
	      // Run on link to load visible images.
	      scrollFunc();
	    }
	  };
	}];

/***/ }),
/* 65 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = [function smartImg() {
	  return {
	    restrict: 'A',
	    link: function link(scope, el, attrs) {
	      var $el = $(el[0]);
	      var $spin = $('<div class="smart-img-spinner"></div>');
	      $el.before($spin);
	
	      $el.attr('src', attrs.placeholderImg).addClass('smart-img-loading');
	
	      scope.$watch(function () {
	        return attrs.smartImg;
	      }, function (newImg) {
	        $el.attr('src', attrs.placeholderImg).addClass('smart-img-loading');
	        $spin.show();
	
	        var i = new Image();
	        i.onload = function () {
	          $el.attr('src', newImg).removeClass('smart-img-loading');
	          $spin.hide();
	          scope.$emit('smart-img:loaded');
	        };
	        i.src = newImg;
	      });
	    }
	  };
	}];

/***/ }),
/* 66 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var zopimInitComplete = false,
	    titleInterval = null,
	    zopimInit = function zopimInit() {
	  var ua = navigator.userAgent.toLowerCase(),
	      platform = navigator.platform.toLowerCase(),
	      platformName = ua.match(/ip(?:ad|od|hone)/) ? 'ios' : (ua.match(/(?:webos|android)/) || platform.match(/mac|win|linux/) || ['other'])[0],
	      isMobile = /ios|android|webos/.test(platformName);
	
	  if (!isMobile) {
	    // Start of Zopim Live Chat Script
	    window.$zopim || function (d, s) {
	      var z = window.$zopim = function (c) {
	        z._.push(c);
	      },
	          $ = z.s = d.createElement(s),
	          e = d.getElementsByTagName(s)[0];
	      z.set = function (o) {
	        z.set._.push(o);
	      };
	      z._ = [];
	      z.set._ = [];
	      $.async = !0;
	      $.setAttribute("charset", "utf-8");
	      $.src = "//v2.zopim.com/?2G49jHUlZLgQk1REVPOugqzWNNxQsU6a";
	      z.t = +new Date();
	      $.type = "text/javascript";
	      e.parentNode.insertBefore($, e);
	    }(document, "script");
	    // End of Zopim Live Chat Script
	    window.$zopim(function () {
	      $zopim.livechat.departments.filter('Customer Service');
	      $zopim.livechat.departments.setVisitorDepartment('Customer Service');
	    });
	
	    titleInterval = setInterval(function () {
	      if ($('iframe[data-test-id="ChatWidgetButton-iframe"').length) {
	        $('iframe[data-test-id="ChatWidgetButton-iframe"').attr('title', 'live chat widget');
	        clearInterval(titleInterval);
	      }
	    }, 100);
	  }
	
	  $(document).on('click', '[live-chat]', function (e) {
	    e.preventDefault();
	    if (!window.$zopim) return;
	    $zopim.livechat.window.show();
	    $('.zopim').removeClass('off-whitelist');
	  });
	
	  zopimInitComplete = true;
	};
	
	var WHITELIST = ['contact', 'faq', 'about', 'partnerships', 'press', 'how-it-works', 'features', 'track-order', 'order-summary', 'academy'];
	
	exports.default = ['$state', '$location', function zopimLiveChat($state, $location) {
	  function checkWhitelist() {
	    return !!_.find(WHITELIST, function (w) {
	      var found = false;
	      if ($state.includes(w)) found = true;
	      if ($state.is(w)) found = true;
	      if ($location.url().indexOf(w) > -1) found = true;
	      return found;
	    });
	  }
	
	  return {
	    restrict: 'E',
	    link: function link() {
	      if (!zopimInitComplete) zopimInit();
	
	      if (!checkWhitelist()) {
	        $('.zopim').addClass('off-whitelist');
	      }
	    }
	  };
	}];

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = CUILoadingOverlayDirective;
	
	var _cdnPreprocessor = __webpack_require__(56);
	
	function CUILoadingOverlayDirective() {
	  return {
	    restrict: 'E',
	    replace: true,
	    scope: {
	      toggle: '=',
	      message: '@'
	    },
	    template: __webpack_require__(68)(_cdnPreprocessor.jadeLocals),
	    link: function link(scope, el, attrs) {
	      scope.hide = function () {
	        return scope.toggle = false;
	      };
	      scope.message = attrs.message || 'Processing...';
	    }
	  };
	};

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var jade = __webpack_require__(58);
	
	module.exports = function template(locals) {
	  var buf = [];
	  var jade_mixins = {};
	  var jade_interp;
	
	  buf.push("<div ng-show=\"toggle\" class=\"loading\"><div class=\"loading-overlay\"></div><figure><svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 94.349997 86.700001\" version=\"1.1\" width=\"94.349998\" height=\"86.699997\"><path d=\"m 24.712404,40.37347 15.56928,14.688 c 0.4896,0.4896 0.78336,1.37088 1.07712,2.05632 1.9584,5.8752 4.01472,11.7504 5.58144,16.45056 4.896,-17.03808 10.08576,-35.05536 15.27552,-53.3664 5.3856,1.9584 10.57536,3.81888 16.05888,5.67936 1.9584,-4.896 3.81888,-9.596159 5.77728,-14.590077 l -14.1984,-7.7356762 23.79456,7.1481572 c -3.62304,8.323196 -7.14816,16.548476 -10.86912,24.871676 -6.3546,-1.7136 -6.3546,-1.7136 -11.45664,-3.13344 -5.975074,17.73964 -12.116483,36.48422 -17.136,51.8976 -0.4896,1.468797 -1.17504,1.860477 -2.64384,1.860477 -3.23136,-0.0979 -6.46272,0 -9.59616,-0.0979 -0.58752,0 -1.478606,-0.17392 -1.76256,-0.979197 C 34.016777,67.63374 28.398118,51.12113 24.712404,40.37347 Z\" class=\"top-left-logo\"></path><path d=\"m 39.664187,48.5879 c -5.216047,-4.76286 -10.8566,-9.88477 -15.386,-14.112 -0.98,-0.882 -1.764,-1.078 -2.94,-0.686 -3.234,0.98 -6.37,1.862 -9.898,2.744 C 7.9121875,28.3999 4.3841875,20.3639 0.66018746,12.131903 8.6437511,8.4521464 17.38625,4.6609067 24.474187,1.645907 c 1.47,-0.588 3.136,-0.88200012 4.704,-0.98000012 3.234,-0.196 6.468,0 9.8,0 0.784,4.99799972 2.548,9.40799712 8.428,9.79999712 4.116,0.294 7.35,-2.5479976 9.31,-7.6439971 1.078,5.1939995 -2.548,10.8779951 -7.644,12.7399941 -6.664,2.449999 -13.328,0.196 -16.17,-5.6839966 -2.94,-0.2939985 -5.684,0 -8.33,1.3719986 -3.92,1.959999 -8.134,3.625998 -12.25,5.487998 1.078,2.841999 2.156,5.585999 3.332,8.231999 0.196,0.392 1.274,0.784 1.764,0.686 4.214,-1.078 8.526,-2.254 12.74,-3.528 1.47,-0.392 2.058,-0.294 2.45,1.274 3.332,12.446 3.332,12.446 7.056,25.186 z\" class=\"bottom-right-logo\"></path></svg></figure></div>");;return buf.join("");
	};

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cdnPreprocessor = __webpack_require__(56);
	
	exports.default = ['$interval', '$timeout', function loadingButton($interval, $timeout) {
	  return {
	    restrict: 'E',
	    //replace: true,
	    scope: {
	      text: '@',
	      type: '@',
	      block: '@',
	      buttonClass: '@',
	      submitFormId: '@',
	      state: '=',
	      buttonDisabled: '='
	    },
	    templateUrl: (0, _cdnPreprocessor.cdnTemplate)('/loading-button.html'),
	    link: function link(scope, el, attrs) {
	      var progressInterval = void 0,
	          resetTimeout = void 0;
	
	      scope.progress = 1;
	      scope.strokeDasharray = 204.24;
	      scope.strokeDashoffset = 204.24;
	      scope.block = scope.block || true;
	      scope.buttonClass = scope.buttonClass || 'btn-primary';
	
	      scope.$watch('state', function (state) {
	        switch (state) {
	          case 'loading':
	            simulateLoad();
	            break;
	          case 'success':
	            resetState();
	            break;
	          case 'error':
	            resetState();
	            break;
	        }
	      });
	
	      function simulateLoad() {
	        scope.progress = 0;
	        progressInterval = $interval(function () {
	          scope.progress += Math.random() * .5;
	          scope.strokeDashoffset = calculateStrokeOffset(1 - scope.progress, 0, 1);
	
	          if (scope.progress >= 1) {
	            $interval.cancel(progressInterval);
	          }
	        }, 300);
	      }
	
	      function calculateStrokeOffset(num, min, max) {
	        return scope.strokeDasharray * Math.min(Math.max(num, min), max);
	      }
	
	      function resetState() {
	        resetTimeout = $timeout(function () {
	          scope.state = null;
	          scope.strokeDashoffset = calculateStrokeOffset(1 - 0, 0, 1);
	        }, 3000);
	      }
	
	      el.on('$destroy', function () {
	        $interval.cancel(progressInterval);
	        $timeout.cancel(resetTimeout);
	      });
	    }
	  };
	}];

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = innerBanner;
	
	var _cdnPreprocessor = __webpack_require__(56);
	
	function innerBanner() {
	  return {
	    restrict: 'E',
	    transclude: true,
	    replace: true,
	    scope: {
	      type: '@'
	    },
	    templateUrl: (0, _cdnPreprocessor.cdnTemplate)('/inner-banner.html'),
	    link: function link(scope) {
	      scope.getClass = function () {
	        var retVal = void 0;
	
	        switch (scope.type) {
	          case "about":
	            retVal = "our-story";
	            break;
	          case "features":
	            retVal = "features-banner";
	            break;
	          case "training":
	            retVal = "training-banner";
	            break;
	          case "career":
	            retVal = "career";
	            break;
	          case "press":
	            retVal = "default press";
	            break;
	          case "store":
	            retVal = "store-page";
	            break;
	          default:
	            retVal = "default";
	            break;
	        }
	
	        return retVal;
	      };
	    }
	  };
	};

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ForgotPassword;
	
	var _cdnPreprocessor = __webpack_require__(56);
	
	function ForgotPassword() {
	  return {
	    restrict: 'E',
	    template: __webpack_require__(72)(_cdnPreprocessor.jadeLocals),
	    controller: 'forgotPasswordCtrl',
	    controllerAs: 'password',
	    scope: {
	      passwordRetrieved: '=?',
	      toggle: '=?'
	    },
	    bindToController: true
	  };
	};

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var jade = __webpack_require__(58);
	
	module.exports = function template(locals) {
	  var buf = [];
	  var jade_mixins = {};
	  var jade_interp;
	
	  buf.push("<cui-modal type=\"form\" toggle=\"password.toggle\" modal-title=\"Forgot Password\" confirm-text=\"Retrieve Password\" cancel-text=\"Cancel\" confirm-handler=\"password.retrieve()\" confirm-state=\"password.submitState\" confirm-form-id=\"forgot_password_form\" cancel-handler=\"password.close()\"><form name=\"password.forgotPassword\" id=\"forgot_password_form\" novalidate><div ng-class=\"{&quot;has-error&quot;: password.forgotPassword.email.$invalid &amp;&amp; password.forgotPassword.$submitted}\" class=\"form-group\"><label for=\"email_input\" class=\"control-label\">Email</label><input type=\"email\" ng-model=\"password.email\" name=\"email\" id=\"email_input\" required ng-pattern=\"/^\\S+@\\S+\\.\\S+$/\" class=\"form-control\"><div ng-show=\"password.forgotPassword.email.$error.required &amp;&amp; password.forgotPassword.$submitted\" class=\"help-block\">Please input your email address.</div><div ng-show=\"password.forgotPassword.email.$error.pattern &amp;&amp; password.forgotPassword.$submitted\" class=\"help-block\">Please input a valid email address.</div></div></form></cui-modal><cui-modal type=\"alert\" toggle=\"password.passwordRetrieved\" modal-title=\"Success!\"><h5>Please check your email for password reset instructions. If you do not receive an email, the account was not found.</h5></cui-modal>");;return buf.join("");
	};

/***/ }),
/* 73 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = ['AuthService', '$rootScope', function () {
	  function ForgotPasswordController(authService, $rootScope) {
	    _classCallCheck(this, ForgotPasswordController);
	
	    this._authService = authService;
	    this._$rootScope = $rootScope;
	    this.passwordRetrieved = false;
	    this.submitState = 'test';
	  }
	
	  _createClass(ForgotPasswordController, [{
	    key: 'retrieve',
	    value: function retrieve() {
	      var _this = this;
	
	      this.submitState = 'loading';
	      this.passwordRetrieved = false;
	      this._authService.resetPasswordRequest(this.email).then(function (res) {
	        return _this.retrieveSuccess(res);
	      }).catch(function (err) {
	        return _this.retrieveFailed(err);
	      });
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      this.toggle = false;
	      this._$rootScope.$broadcast('login:open', {});
	    }
	  }, {
	    key: 'retrieveSuccess',
	    value: function retrieveSuccess(res) {
	      this.submitState = 'success';
	      this.toggle = false;
	      this.email = '';
	      this.forgotPassword.$setPristine();
	      this.passwordRetrieved = true;
	    }
	  }, {
	    key: 'retrieveFailed',
	    value: function retrieveFailed(err) {
	      this.submitState = 'error';
	      this.passwordRetrieved = false;
	    }
	  }]);
	
	  return ForgotPasswordController;
	}()];

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _config = __webpack_require__(2);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _analytics = __webpack_require__(13);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = ['$http', '$window', '$location', '$state', '$interval', 'CartService', 'ErrorHandler', function amazonPaymentButton($http, $window, $location, $state, $interval, cart, ErrorHandler) {
	  var analytics = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : new _analytics2.default();
	
	  var authRequest;
	  var access_token;
	
	  // Used for upsells
	  var campaignId, upsellId, orderId;
	  var selectedProduct;
	
	  function AmazonSignInCallback(orderReference, orderType) {
	    var amazonReferenceId = orderReference.getAmazonOrderReferenceId();
	
	    if (orderType === 'upsell') {
	      cart.amazonCheckoutUpsellCart(amazonReferenceId, access_token, selectedProduct, campaignId, campaignId, orderId).then(function (res) {
	        return $state.go('amazon-checkout', {
	          id: res['ref_id'],
	          session: amazonReferenceId,
	          upsell: true,
	          upsellProduct: selectedProduct,
	          csl: cart.slug()
	        });
	      });
	    } else {
	      if (cart.size() === 0) return false;
	      cart.amazonCheckoutCart(amazonReferenceId, access_token).then(function (res) {
	        return $state.go('amazon-checkout', { id: res['ref_id'], session: amazonReferenceId, csl: cart.slug() });
	      });
	    }
	  }
	
	  function createPaymentButton(orderType) {
	    new OffAmazonPayments.Button("amazon_pay_button", _config2.default['Amazon']['sellerID'], {
	      type: "PwA",
	      color: "Gold",
	      size: "large",
	      useAmazonAddressBook: true,
	      authorization: function authorization() {
	        authRequest = amazon.Login.authorize({
	          scope: 'profile payments:widget payments:shipping_address',
	          interactive: 'always'
	        }, function (d) {
	          return access_token = d.access_token;
	        });
	      },
	      onSignIn: function onSignIn(orderRef) {
	        return AmazonSignInCallback(orderRef, orderType);
	      },
	      onError: function onError(error) {
	        return ErrorHandler.throwError('Amazon Sign In Error', error.getErrorCode() + ' - ' + error.getErrorMessage());
	      }
	    });
	  }
	
	  return {
	    restrict: 'E',
	    replace: true,
	    scope: {
	      orderType: '@?',
	      campaignId: '@?',
	      upsellId: '@?',
	      selectedProduct: '=?',
	      orderId: '@?'
	    },
	    template: '<div id="amazon_pay_button" class="call-to-action amazon" ng-click="checkoutEvent()"></div>',
	    link: function link(scope, element) {
	      campaignId = scope.campaignId;
	      upsellId = scope.upsellId;
	      orderId = scope.orderId;
	      selectedProduct = scope.selectedProduct;
	
	      var amazonInterval = $interval(function () {
	        if (!$window.amazon || !$window.amazon.Login) return;else $interval.cancel(amazonInterval);
	
	        $window.amazon.Login.setClientId(_config2.default['Amazon']['clientID']);
	        $window.amazon.Login.setSandboxMode(_config2.default['Amazon']['sandbox']);
	        createPaymentButton(scope.orderType);
	      }, 250);
	
	      // scope.checkoutEvent = () => analytics.initiateCheckout({ option: 'Amazon', upsell: (typeof upsellId != 'undefined' && upsellId !== null), cart: cart.contentsAsCampaignProducts() });
	    }
	  };
	}];

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cdnPreprocessor = __webpack_require__(56);
	
	exports.default = ['$location', '$window', function EmailShare($location, $window) {
	  return {
	    restrict: 'C',
	    replace: true,
	    templateUrl: (0, _cdnPreprocessor.cdnTemplate)('/social-share-button.html'),
	    scope: true,
	    link: function link(scope) {
	      scope.share = function EmailShareCall() {
	        $window.location.href = 'mailto:?subject=Check%20out%20this%20shirt%20on%20Viralstyle.com&body=' + encodeURIComponent($location.absUrl());
	      };
	    }
	  };
	}];

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cdnPreprocessor = __webpack_require__(56);
	
	exports.default = ['$location', '$window', function FacebookShare($location, $window) {
	  return {
	    restrict: 'C',
	    replace: true,
	    templateUrl: (0, _cdnPreprocessor.cdnTemplate)('/social-share-button.html'),
	    scope: true,
	    link: function link(scope) {
	      scope.share = function FacebookShareCall() {
	        $window.open('https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent($location.absUrl()), 'facebook', 'width=600,height=530');
	      };
	    }
	  };
	}];

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cdnPreprocessor = __webpack_require__(56);
	
	exports.default = ['$location', '$window', function TwitterShare($location, $window) {
	  return {
	    restrict: 'C',
	    replace: true,
	    templateUrl: (0, _cdnPreprocessor.cdnTemplate)('/social-share-button.html'),
	    scope: true,
	    link: function link(scope) {
	      scope.share = function TwitterShareCall() {
	        $window.open('http://twitter.com/home?status=Check out this shirt on Viralstyle.com - ' + encodeURIComponent($location.absUrl()), 'twitter', 'width=600,height=530');
	      };
	    }
	  };
	}];

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cdnPreprocessor = __webpack_require__(56);
	
	exports.default = ['$location', '$window', function PinterestShare($location, $window) {
	  return {
	    restrict: 'C',
	    replace: true,
	    scope: {
	      image: '=?',
	      description: '=?'
	    },
	    templateUrl: (0, _cdnPreprocessor.cdnTemplate)('/social-share-button.html'),
	    link: function link(scope) {
	      scope.share = function PinterestShareCall() {
	        var uri = 'https://www.pinterest.com/pin/create/button/?url=' + encodeURIComponent($location.absUrl());
	
	        if (scope.image) uri += '&media=' + encodeURIComponent(scope.image);
	        if (scope.description) uri += '&description=' + encodeURIComponent(scope.description);
	
	        $window.open(uri);
	      };
	    }
	  };
	}];

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cdnPreprocessor = __webpack_require__(56);
	
	exports.default = ['$location', '$window', function GoogleShare($location, $window) {
	  return {
	    restrict: 'C',
	    replace: true,
	    templateUrl: (0, _cdnPreprocessor.cdnTemplate)('/social-share-button.html'),
	    scope: true,
	    link: function link(scope) {
	      scope.share = function GoogleShareCall() {
	        $window.open('https://plus.google.com/share?url=' + encodeURIComponent($location.absUrl()), 'google+', 'width=600,height=530');
	      };
	    }
	  };
	}];

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cdnPreprocessor = __webpack_require__(56);
	
	exports.default = ['CartService', function ShoppingCartDir(cart) {
	  return {
	    restrict: 'E',
	    scope: {
	      toggle: '=?',
	      scrollTo: '@?'
	    },
	    template: __webpack_require__(81)(_cdnPreprocessor.jadeLocals),
	    link: function link(scope, element) {
	      if (typeof scope.toggle != 'boolean') {
	        scope.toggle = 'na';
	      }
	
	      scope.cartTotals = cart.getTotals();
	
	      if (scope.scrollTo) {
	        var watcherSet = false;
	        scope.$watch(function () {
	          return cart.size();
	        }, function (s, ss) {
	          // Don't run when this watcher is set.
	          if (!watcherSet) {
	            watcherSet = true;
	            return;
	          }
	
	          if (s <= ss) return;
	
	          $('html,body').animate({
	            scrollTop: $(scope.scrollTo).offset().top
	          }, 300);
	        });
	      }
	    }
	  };
	}];

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var jade = __webpack_require__(58);
	
	module.exports = function template(locals) {
	  var buf = [];
	  var jade_mixins = {};
	  var jade_interp;
	  ;var locals_for_with = locals || {};(function (cdn) {
	    buf.push("<div class=\"upsell box-cart\"><div class=\"head\"><h2>YOUR SHOPPING CART</h2><a ng-show=\"toggle !== &quot;na&quot;\" ng-click=\"toggle = false\" class=\"closed\"></a></div><div class=\"body\"><shopping-cart-items toggle=\"toggle\"></shopping-cart-items><div class=\"payment-container\"><stripe-payment></stripe-payment><ul class=\"logo-row\"><li ng-if=\"cartTotals.grand &gt; 0\" class=\"payment-button\"><paypal-payment id=\"paypal\"></paypal-payment></li><li class=\"payment-button hide\"><amazon-payment></amazon-payment></li></ul></div><hr><div class=\"img-hold text-center\"><img" + jade.attr("src", '' + cdn.asset("/creditcards.png") + '', true, true) + " width=\"140\" alt=\"Visa, MasterCard, American Express, and Discover Accepted\"></div><br><div class=\"text-center\"><img" + jade.attr("src", '' + cdn.asset("/security-seals.png") + '', true, true) + " alt=\"Security seals\" class=\"img-responsive security-seals\"></div></div></div>");
	  }).call(this, "cdn" in locals_for_with ? locals_for_with.cdn : typeof cdn !== "undefined" ? cdn : undefined);;return buf.join("");
	};

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cdnPreprocessor = __webpack_require__(56);
	
	var _lodash = __webpack_require__(7);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _product = __webpack_require__(22);
	
	var _product2 = _interopRequireDefault(_product);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = ['$timeout', '$state', 'CartService', 'UpsellCartService', 'CurrencyService', function ShoppingCartItemsDir($timeout, $state, cart, upsellCart, CurrencyService) {
	  return {
	    restrict: 'E',
	    scope: {
	      amazonReference: '@?',
	      amazonOrderId: '@?',
	      amazonUpsell: '@?',
	      paypalUpsell: '@?',
	      disableCoupons: '@?',
	      toggle: '=?'
	    },
	    template: __webpack_require__(83)(_cdnPreprocessor.jadeLocals),
	    link: function link(scope, el) {
	      var couponTimeout = void 0;
	
	      function setInvalid() {
	        scope.couponInvalid = true;
	        couponTimeout = $timeout(function () {
	          scope.couponInvalid = false;
	        }, 5000);
	      }
	
	      if (typeof scope.toggle != 'boolean') {
	        scope.toggle = 'na';
	      }
	
	      scope.isUpsell = scope.amazonUpsell === "true" || scope.paypalUpsell === "true";
	
	      scope.showCoupon = !scope.isUpsell && !scope.disableCoupons;
	
	      scope.couponInvalid = false;
	      scope.cart = scope.isUpsell ? upsellCart : cart;
	      scope.cartTotals = scope.cart.getTotals();
	
	      scope.currency = CurrencyService;
	      scope.currency.init();
	
	      scope.applyCoupon = function () {
	        var apply = !!scope.amazonReference ? cart.applyCoupon(scope.couponCode, scope.amazonReference, scope.amazonOrderId) : cart.applyCoupon(scope.couponCode);
	
	        apply.then(function (res) {
	          if (res.valid === false) {
	            scope.couponMessage = "Invalid coupon.";
	            setInvalid();
	          }
	        });
	
	        apply.catch(function (err) {
	          scope.couponMessage = err.data.message;
	
	          if (err.data && err.data.couponCode) scope.couponCode = err.data.couponCode;
	
	          setInvalid();
	        });
	      };
	
	      scope.remove = function (i) {
	        cart.remove(i);
	        if (scope.toggle != 'na' && cart.size() === 0) {
	          scope.toggle = false;
	        } else if (scope.toggle != 'na') scope.toggle = true;
	      };
	
	      scope.sizeDisplay = function (product) {
	        return _product2.default.sizeDisplay(product, product.size);
	      };
	
	      scope.showHolidayMessage = function () {
	        var show = true;
	
	        _lodash2.default.each(cart.cart.contents, function (item) {
	          if ((item.group === 'Sublimation Tees' || item.specialPrinting) && moment().isBefore(moment('2017-12-26'))) {
	            show = true;
	            return false;
	          }
	        });
	
	        return show;
	      };
	
	      el.on('$destroy', function () {
	        $timeout.cancel(couponTimeout);
	      });
	    }
	  };
	}];

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var jade = __webpack_require__(58);
	
	module.exports = function template(locals) {
	  var buf = [];
	  var jade_mixins = {};
	  var jade_interp;
	
	  buf.push("<div class=\"shopping-cart-items block-basket\"><div ng-repeat=\"item in cart.contents() track by $index\" class=\"item-basket\"><div class=\"visual\"><img ng-src=\"{{item.thumbnail}}\" alt=\"{{item.name}}\"><span class=\"label\">{{item.qty}}</span></div><div class=\"body\"><span class=\"inc\">{{item.price * currency.info.conversion_rate | currency : currency.info.currency_symbol}}</span><div class=\"text\"><h3>{{item.name}} {{sizeDisplay(item)}}</h3></div></div><a ng-click=\"remove($index)\" ng-class=\"{ disabled: processing() }\" class=\"closed remove-item\"></a></div><div ng-show=\"!haveACoupon &amp;&amp; showCoupon\" class=\"coupon-basket form-hidden\"><a ng-click=\"haveACoupon = true\">Have a coupon code?</a></div><form id=\"coupon_form\" name=\"couponForm\" ng-class=\"{ &quot;has-error&quot; : couponInvalid }\" ng-show=\"haveACoupon &amp;&amp; showCoupon\" class=\"coupon-basket form-group\"><div class=\"input-group\"><input type=\"text\" ng-model=\"couponCode\" placeholder=\"Have a coupon code?\" class=\"form-control squared\"><span class=\"input-group-btn\"><button type=\"submit\" form=\"coupon_form\" ng-click=\"applyCoupon()\" class=\"btn btn-primary apply-coupon\">Apply</button></span></div><div ng-show=\"couponInvalid\" class=\"help-block form-text\">{{couponMessage}}</div></form><div class=\"footer-basket\"><div class=\"panel-basket\"><div class=\"col\"><p>Subtotal</p><p ng-show=\"cartTotals.discount\">Discount</p><p ng-show=\"cartTotals.tax &gt; 0\">Sales Tax</p><p class=\"extended-details\">Shipping</p><p ng-show=\"cartTotals.shippingDiscount\" class=\"extended-details\">Shipping Discount</p></div><div class=\"col\"><p>{{cartTotals.checkout * currency.info.conversion_rate | currency : currency.info.currency_symbol}}</p><p ng-show=\"cartTotals.discount\" class=\"discount\">-{{cartTotals.discount * currency.info.conversion_rate | currency : currency.info.currency_symbol}}</p><p ng-show=\"cartTotals.tax &gt; 0\">{{cartTotals.tax * currency.info.conversion_rate | currency : currency.info.currency_symbol}}</p><p class=\"extended-details\">{{cartTotals.shipping * currency.info.conversion_rate | currency : currency.info.currency_symbol}}</p><p ng-show=\"cartTotals.shippingDiscount\" class=\"extended-details discount\">-{{cartTotals.shippingDiscount * currency.info.conversion_rate | currency : currency.info.currency_symbol}}</p></div></div><div class=\"bar-basket extended-details\"><div class=\"col\"><span class=\"total\">Total</span></div><div class=\"col\"><span class=\"inc\">{{cartTotals.grand * currency.info.conversion_rate | currency : currency.info.currency_symbol}}<span class=\"value\"> {{currency.info.iso_code}}</span></span></div></div></div></div>");;return buf.join("");
	};

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _config = __webpack_require__(2);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _cdnPreprocessor = __webpack_require__(56);
	
	var _webstoragePolyfill = __webpack_require__(10);
	
	var _webstoragePolyfill2 = _interopRequireDefault(_webstoragePolyfill);
	
	var _analytics = __webpack_require__(13);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isUpsell = function isUpsell(scope) {
	  return typeof scope.product != 'undefined' && typeof scope.upsellId != 'undefined' && typeof scope.orderId != 'undefined';
	};
	
	exports.default = ['$window', '$timeout', 'CartService', 'ErrorHandler', function paypalPayment($window, $timeout, cart, errorHandler) {
	  var analytics = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : new _analytics2.default();
	
	  var checkoutFnInProgress = false;
	  var storage = new _webstoragePolyfill2.default();
	
	  var safePaypalInit = function safePaypalInit() {
	    // Putting Paypal's init in an empty timeout ensures it will fire after the current digest cycle.
	    // Should resolve errors related to Paypal interruping an in progress digest cycle.
	    $timeout(function () {
	      return $window.paypal.checkout.initXO();
	    });
	  };
	
	  return {
	    restrict: 'E',
	    scope: {
	      product: '&?',
	      upsellId: '@?',
	      originalId: '@?',
	      orderId: '@?',
	      size: '=?'
	    },
	    template: __webpack_require__(85)(_cdnPreprocessor.jadeLocals),
	    transclude: true,
	    link: function link(scope, el) {
	      scope.paypalCheckout = function paypalCheckout() {
	
	        // if its an upsell, make sure we have a valid size.
	        if (!isUpsell(scope) || isUpsell(scope) && scope.size) {
	
	          if (checkoutFnInProgress) return;
	          checkoutFnInProgress = true;
	          var paypalPromise = void 0;
	
	          if (!isUpsell(scope)) cart.triggerInitiateCheckout();
	          analytics.checkout({ option: 'PayPal', upsell: isUpsell(scope), cart: cart.contentsAsCampaignProducts() });
	          safePaypalInit();
	
	          var slug = cart.slug().split('/'),
	              publicName = slug[0],
	              campaignSlug = slug[1];
	
	          var cancelUrl = $window.location.href.split('#')[0];
	          storage.setLocalItem('paypal-cancel', cancelUrl);
	          if (isUpsell(scope)) {
	            var callbackUrl = 'https://' + $window.location.host + '/purchase/paypal-checkout?pn=' + publicName + '&sl=' + campaignSlug + '&upsell=true';
	            var upsellPayload = {
	              product: scope.product(),
	              upsellID: scope.upsellId,
	              originalID: scope.originalId,
	              orderID: scope.orderId
	            };
	            storage.removeLocalItem('paypal-upsell');
	            storage.setLocalItem('paypal-upsell', JSON.stringify(upsellPayload));
	            paypalPromise = cart.paypalCheckoutUpsellCart(callbackUrl, cancelUrl, scope.product(), scope.upsellId, scope.orderId);
	          } else {
	            var _callbackUrl = 'https://' + $window.location.host + '/purchase/paypal-checkout?pn=' + publicName + '&sl=' + campaignSlug;
	            paypalPromise = cart.paypalCheckoutCart(_callbackUrl, cancelUrl);
	          }
	
	          paypalPromise.then(function (res) {
	            return $window.paypal.checkout.startFlow(res.url);
	          }).catch(function (res) {
	            errorHandler.throwError(res.status + ' Error', res && res.data && res.data.message ? res.data.message : 'Occurred during paypal flow.');
	            $window.paypal.checkout.closeFlow();
	          }).finally(function () {
	            return checkoutFnInProgress = false;
	          });
	        };
	      };
	    }
	  };
	}];

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var jade = __webpack_require__(58);
	
	module.exports = function template(locals) {
	  var buf = [];
	  var jade_mixins = {};
	  var jade_interp;
	
	  buf.push("<span ng-click=\"paypalCheckout()\" style=\"width:100%;height:100%;display:block;\" class=\"paypal-click-trigger\"><span ng-transclude></span></span>");;return buf.join("");
	};

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cdnPreprocessor = __webpack_require__(56);
	
	var _analytics = __webpack_require__(13);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = ['$state', 'CartService', function stripePayment($state, cart) {
	  var analytics = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new _analytics2.default();
	
	  return {
	    restrict: 'E',
	    template: __webpack_require__(87)(_cdnPreprocessor.jadeLocals),
	    link: function link(scope) {
	      scope.stripeCheckout = function () {
	        cart.triggerInitiateCheckout();
	        analytics.checkout({ option: 'CreditCard', cart: cart.contentsAsCampaignProducts() });
	
	        var slugs = cart.slug().split('/');
	        $state.go('checkout', { pn: slugs[0], sl: slugs[1] });
	      };
	    }
	  };
	}];

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var jade = __webpack_require__(58);
	
	module.exports = function template(locals) {
	  var buf = [];
	  var jade_mixins = {};
	  var jade_interp;
	
	  buf.push("<div><button id=\"CCCheckout\" type=\"button\" ng-click=\"stripeCheckout()\" class=\"btn btn-secondary\"><i class=\"fa fa-credit-card\"></i> Pay with Credit Card</button></div>");;return buf.join("");
	};

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cdnPreprocessor = __webpack_require__(56);
	
	var _lodash = __webpack_require__(7);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = [function viralstyleTestimonials() {
	  return {
	    restrict: 'E',
	    replace: false,
	    templateUrl: (0, _cdnPreprocessor.cdnTemplate)('/testimonials.dir.html'),
	    link: function link(scope, element) {
	      var $owl = $(element).find('.owl-carousel'),
	          $next = void 0;
	
	      var nextTestimonial = function nextTestimonial(e) {
	        if (e.keyCode == 13) {
	          $owl.trigger('next.owl.carousel');
	
	          setTimeout(function () {
	            $owl.find('.owl-item.active:first > .testimonial').focus();
	          }, 250);
	        }
	      };
	
	      $owl.owlCarousel({
	        autoplay: true,
	        loop: true,
	        responsive: {
	          0: { items: 1, nav: false },
	          768: { items: 2, nav: true }
	        },
	        onInitialized: function onInitialized() {
	          $next = $owl.find('.owl-next');
	
	          $next.attr('tabindex', '0').attr('aria-label', 'press enter to go to the next slide');
	
	          $next.on('keyup', nextTestimonial);
	        }
	      });
	
	      scope.testimonialFocused = function (e) {
	
	        $owl.find('.testimonial').attr('tabindex', -1);
	      };
	
	      scope.testimonialsFocused = function (e) {
	        $owl.trigger('stop.owl.autoplay');
	        $owl.find('.owl-item.active:first > .testimonial').attr('tabindex', 0);
	      };
	
	      _lodash2.default.defer(function () {
	        var $boxes = $owl.find('.box');
	        var heights = $boxes.map(function () {
	          return $(this).height();
	        });
	        var maxHeight = _lodash2.default.max(heights);
	        $boxes.height(maxHeight);
	      });
	
	      scope.$on('$destroy', function () {
	        $next.off('keyup', nextTestimonial);
	      });
	    }
	  };
	}];

/***/ }),
/* 89 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ['$timeout', function focusDirective($timeout) {
	  return {
	    link: function link(scope, element, attrs) {
	      scope.$watch(attrs.focusElement, function (value) {
	        if (value === true) {
	          $timeout(function () {
	            element[0].focus();
	            scope[attrs.focusElement] = false;
	          });
	        }
	      });
	    }
	  };
	}];

/***/ }),
/* 90 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ['$window', '$document', function infiniteScroll($window, $document) {
	  return {
	    restrict: 'A',
	    link: function link(scope, elm, attrs) {
	      var el = elm[0];
	
	      var scrollFunc = function scrollFunc() {
	        if (angular.element($window).scrollTop() + angular.element($window).height() >= el.scrollHeight + el.offsetTop) {
	          scope.$apply(attrs.infiniteScroll);
	        }
	      };
	
	      $document.on('scroll', scrollFunc);
	
	      elm.on('$destroy', function () {
	        $document.off('scroll', scrollFunc);
	      });
	    }
	  };
	}];

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _config = __webpack_require__(2);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _cdnPreprocessor = __webpack_require__(56);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = [function homeImageCarousel() {
	  return {
	    restrict: 'E',
	    template: __webpack_require__(92)(_cdnPreprocessor.jadeLocals),
	    link: function link(scope, el) {
	      var $owl = $(el).find('.owl-carousel'),
	          dragging = false,
	          singleTap = false,
	          $next = void 0;
	
	      var nextSlide = function nextSlide(e) {
	        if (e.keyCode == 13) {
	          $owl.trigger('next.owl.carousel');
	
	          setTimeout(function () {
	            $owl.find('.owl-item.active > .carousel-item').focus();
	          }, 250);
	        }
	      };
	
	      $owl.owlCarousel({
	        autoplay: true,
	        autoplayTimeout: 10000,
	        loop: true,
	        autoplayHoverPause: true,
	        responsive: {
	          0: { items: 1, nav: false },
	          769: { items: 1, nav: true }
	        },
	        onDrag: function onDrag(e) {
	          dragging = true;
	        },
	        onInitialized: function onInitialized() {
	          $next = $owl.find('.owl-next');
	
	          $next.attr('tabindex', '0').attr('aria-label', 'press enter to go to the next slide');
	
	          $next.on('keyup', nextSlide);
	        }
	      });
	
	      $('.carousel-item').on('touchend', function (e) {
	        var _this = this;
	
	        if (!singleTap) {
	          singleTap = setTimeout(function () {
	            singleTap = null;
	            if (!dragging) {
	              window.location.href = _this.dataset.href;
	            } else {
	              dragging = false;
	            }
	          }, 300);
	        } else {
	          clearTimeout(singleTap);
	          singleTap = null;
	          dragging = false;
	        }
	        e.preventDefault();
	      });
	
	      scope.carouselFocused = function (e) {
	        $owl.trigger('stop.owl.autoplay');
	        $owl.find('.owl-item.active > .carousel-item').attr('tabindex', 0);
	      };
	
	      scope.navigate = function (e) {
	        if (e.keyCode == 13) {
	          window.location.href = e.target.dataset.href;
	        }
	      };
	
	      scope.slideFocused = function (e) {
	        $owl.find('.carousel-item').attr('tabindex', -1);
	      };
	
	      scope.$on('$destroy', function () {
	        $('.carousel-item').off();
	        $next.off('keyup', nextSlide);
	      });
	    }
	  };
	}];

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var jade = __webpack_require__(58);
	
	module.exports = function template(locals) {
	  var buf = [];
	  var jade_mixins = {};
	  var jade_interp;
	  ;var locals_for_with = locals || {};(function (cdn) {
	    buf.push("<div tabindex=\"0\" aria-label=\"marketplace image carousel\" ng-focus=\"carouselFocused($event)\" class=\"owl-carousel\"><div data-href=\"/marketplace/\" ng-keyup=\"navigate($event)\" ng-focus=\"slideFocused($event)\" aria-label=\"great gifts for everyone. press enter to shop now.\" class=\"carousel-item\"><img" + jade.attr("src", '' + cdn.asset("/Dad.jpg") + '', true, true) + " alt=\"man wearing t-shirt\" class=\"carousel-item__image carousel-item__image--dad\"><div class=\"carousel-item__content carousel-item__content--dad\"><div class=\"carousel-item__heading carousel-item__heading--dad\">GREAT GIFTS</div><div class=\"carousel-item__heading carousel-item__heading--dad\">FOR EVERYONE!</div><a href=\"/marketplace/\" tabindex=\"-1\" class=\"carousel-item__button\">SHOP NOW</a></div></div><div data-href=\"/trending\" ng-keyup=\"navigate($event)\" ng-focus=\"slideFocused($event)\" aria-label=\"new designs added daily. press enter to shop now.\" class=\"carousel-item\"><img" + jade.attr("src", '' + cdn.asset("/Hoodie.jpg") + '', true, true) + " alt=\"girl wearing hoody with skateboard\" class=\"carousel-item__image carousel-item__image--hoodie\"><div class=\"carousel-item__content carousel-item__content--hoodie\"><div class=\"carousel-item__heading\">NEW</div><div class=\"carousel-item__heading\">DESIGNS</div><div class=\"carousel-item__inline\"><div class=\"carousel-item__heading\">ADDED&nbsp;</div><div class=\"carousel-item__heading\">DAILY</div></div><a href=\"/trending\" tabindex=\"-1\" class=\"carousel-item__button\">SHOP NOW</a></div></div><div data-href=\"/marketplace/\" ng-keyup=\"navigate($event)\" ng-focus=\"slideFocused($event)\" aria-label=\"express yourself. thousands of designs to choose from. press enter to shop now.\" class=\"carousel-item\"><img" + jade.attr("src", '' + cdn.asset("/Lady.jpg") + '', true, true) + " alt=\"lady wearing a cat t-shirt\" class=\"carousel-item__image carousel-item__image--lady\"><div class=\"carousel-item__content carousel-item__content--lady\"><div class=\"carousel-item__heading carousel-item__heading--lady\">EXPRESS</div><div class=\"carousel-item__heading carousel-item__heading--lady\">YOURSELF!</div><div class=\"carousel-item__subheading carousel-item__subheading--lady\">THOUSANDS OF DESIGNS TO CHOOSE FROM</div><a href=\"/marketplace/\" tabindex=\"-1\" class=\"carousel-item__button\">SHOP NOW</a></div></div><div data-href=\"/marketplace/?product_type=8\" ng-keyup=\"navigate($event)\" ng-focus=\"slideFocused($event)\" aria-label=\"find your favorite coffee mug. press enter to shop now.\" class=\"carousel-item\"><img" + jade.attr("src", '' + cdn.asset("/MUG.jpg") + '', true, true) + " alt=\"woman holding coffee mug\" class=\"carousel-item__image carousel-item__image--mug\"><div class=\"carousel-item__content carousel-item__content--mug\"><div class=\"carousel-item__inline\"><div class=\"carousel-item__heading carousel-item__heading--mug\">FIND&nbsp;</div><div class=\"carousel-item__heading carousel-item__heading--mug\">YOUR</div></div><div class=\"carousel-item__heading carousel-item__heading--mug\">FAVORITE</div><div class=\"carousel-item__inline\"><div class=\"carousel-item__heading carousel-item__heading--mug\">COFFEE&nbsp;</div><div class=\"carousel-item__heading carousel-item__heading--mug\">MUG</div></div><a href=\"/marketplace/?product_type=8\" tabindex=\"-1\" class=\"carousel-item__button\">SHOP NOW</a></div></div><div data-href=\"/marketplace/?product_type=15\" ng-keyup=\"navigate($event)\" ng-focus=\"slideFocused($event)\" aria-label=\"its the little things. find the perfect accent for your home. press enter to shop now.\" class=\"carousel-item\"><img" + jade.attr("src", '' + cdn.asset("/Wall.jpg") + '', true, true) + " alt=\"wall with clocks on it\" class=\"carousel-item__image carousel-item__image--wall\"><div class=\"carousel-item__content carousel-item__content--wall\"><div class=\"carousel-item__inline\"><div class=\"carousel-item__heading carousel-item__heading--wall\">IT'S THE&nbsp;</div><div class=\"carousel-item__heading carousel-item__heading--wall\">LIT<span class=\"kern\">TLE</span></div></div><div class=\"carousel-item__heading carousel-item__heading--wall\">THINGS!</div><div class=\"carousel-item__subheading carousel-item__subheading--wall\">FIND THE PERFECT ACCENT FOR YOUR HOME.</div><a href=\"/marketplace/?product_type=15\" tabindex=\"-1\" class=\"carousel-item__button\">SHOP NOW</a></div></div></div>");
	  }).call(this, "cdn" in locals_for_with ? locals_for_with.cdn : typeof cdn !== "undefined" ? cdn : undefined);;return buf.join("");
	};

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cdnPreprocessor = __webpack_require__(56);
	
	var _config = __webpack_require__(2);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = [function LoginDirective() {
	  return {
	    restrict: 'E',
	    controller: 'LoginCtrl',
	    controllerAs: 'login',
	    bindToController: true,
	    template: __webpack_require__(94)(_cdnPreprocessor.jadeLocals),
	    scope: {
	      facebookUser: '=?',
	      userRole: '@?',
	      hideRegister: '@?',
	      successCallback: '&?',
	      redirecting: '=?'
	    }
	  };
	}];

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var jade = __webpack_require__(58);
	
	module.exports = function template(locals) {
	  var buf = [];
	  var jade_mixins = {};
	  var jade_interp;
	
	  buf.push("<cui-modal toggle=\"login.toggle\" type=\"account\" modal-title=\"Log in to Viralstyle\"><div class=\"container-fluid\"><div class=\"row hide\"><div class=\"col-xs-12\"><button type=\"button\" ng-click=\"login.facebookLogin()\" class=\"btn btn-facebook btn-block\">Log In with Facebook</button></div></div><div class=\"row hide\"><div class=\"col-xs-12 text-center\"><hr class=\"login-hr\"><div class=\"login-or\">or</div></div></div><div class=\"row\"><div class=\"col-xs-12\"><form name=\"login.loginForm\" novalidate ng-submit=\"login.submitLogin(login.loginForm.$valid)\" class=\"vs-form login\"><div ng-show=\"login.userRole !== &quot;CUSTOMER&quot;\" ng-class=\"{ &quot;has-error&quot; : login.loginForm.email.$invalid &amp;&amp; login.loginForm.$submitted }\" class=\"form-group\"><input float-label-text icon=\"glyphicon-envelope\" placeholder=\"Email\" ng-model=\"login.email\" name=\"email\" type=\"email\" required ng-model-options=\"{allowInvalid:true}\" aria-required=\"true\" aria-label=\"Email Address\" role=\"textbox\" data-focus=\"email\"><div ng-show=\"login.loginForm.email.$error.required &amp;&amp; login.loginForm.$submitted\" class=\"form-text help-block\">Please enter your email address.</div><div ng-show=\"login.loginForm.email.$error.email &amp;&amp; login.loginForm.$submitted\" class=\"form-text help-block\">Please enter a valid email address.</div></div><div ng-class=\"{ &quot;has-error&quot; : login.loginForm.password.$invalid &amp;&amp; login.loginForm.$submitted }\" class=\"form-group\"><input float-label-text icon=\"glyphicon-lock\" placeholder=\"Password\" ng-model=\"login.password\" name=\"password\" type=\"password\" required ng-model-options=\"{allowInvalid:true}\" aria-required=\"true\" aria-label=\"Password\" role=\"textbox\" data-focus=\"password\"><div ng-show=\"login.loginForm.password.$error.required &amp;&amp; login.loginForm.$submitted\" class=\"form-text help-block\">Please enter your password.</div></div><div ng-if=\"!login.hideRegister\" class=\"row\"><div class=\"col-sm-6 col-sm-push-6\"><div class=\"form-group\">     <cui-loading-button tabindex=\"0\" type=\"submit\" text=\"Log in\" state=\"login.submitState\" button-class=\"btn-primary login-btn\"></cui-loading-button></div></div><div class=\"col-sm-6 col-sm-pull-6\"><div class=\"form-group\"><a href=\"\" ng-click=\"login.showRegister()\" class=\"btn btn-default login-btn btn-block form-btn\">Sign Up</a></div></div></div><div ng-if=\"login.hideRegister\" class=\"row\"><div class=\"col-xs-12\"><div class=\"form-group\">     <cui-loading-button tabindex=\"0\" type=\"submit\" text=\"Log In\" state=\"login.submitState\" button-class=\"btn-primary login-btn\"></cui-loading-button></div></div></div><div class=\"form-group\"><div class=\"row\"><div class=\"col-sm-6 remember-me-col\"><div class=\"vs-checkbox\"><input type=\"checkbox\" name=\"rememberMe\" ng-model=\"login.rememberMe\" id=\"remember_checkbox\" aria-label=\"remember login\" aria-required=\"true\"><label for=\"remember_checkbox\" class=\"vs-checkbox-outline\"><span style=\"display:none;\">remember me</span><div class=\"vs-checkbox-fill\"></div></label><span class=\"form-text\">Remember Me</span></div></div><div class=\"col-sm-6 forgot-pwd-col\"><a href=\"\" ng-click=\"login.showForgotPasswordModal = true\" class=\"form-text\">Forgot Password?</a></div></div></div></form></div></div></div></cui-modal><forgot-password toggle=\"login.showForgotPasswordModal\"></forgot-password><cui-modal toggle=\"login.facebook.showPermissionsAlert\" type=\"confirm\" modal-title=\"Facebook Permission\" confirm-text=\"Grant Permission\" confirm-handler=\"login.facebookLogin(&quot;rerequest&quot;)\" cancel-handler=\"login.facebook.cancelAskForPermission()\"><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-12\"><p>Viralstyle needs permission to access your email address in order for our application to create your user account.</p></div></div></div></cui-modal><div id=\"google_recaptcha_login\" ng-show=\"login.toggle\" style=\"position:absolute;z-index:9999;\"></div><div id=\"google_recaptcha_register\" style=\"position:absolute;z-index:9999;\"></div>");;return buf.join("");
	};

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _config = __webpack_require__(2);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = ['$rootScope', '$scope', '$window', '$cookies', '$location', 'AuthService', 'ErrorHandler', 'UserDataService', 'FacebookLoginService', function () {
	  function LoginController($rootScope, $scope, $window, $cookies, $location, authService, errorHandler, UserDataService, facebookService) {
	    var _this = this;
	
	    _classCallCheck(this, LoginController);
	
	    this._$rootScope = $rootScope;
	    this._$window = $window;
	    this._$cookies = $cookies;
	    this._authService = authService;
	    this._userDataService = UserDataService;
	    this._errorHandler = errorHandler;
	    this._userDataService = UserDataService;
	    this.facebook = facebookService;
	
	    this.rememberMe = false;
	    this.showForgotPasswordModal = false;
	
	    $scope.$on('login:open', function (event, _ref) {
	      var route = _ref.route,
	          email = _ref.email,
	          cancelRedirect = _ref.cancelRedirect;
	
	      _this.route = typeof route !== 'undefined' ? route : _this.route || '/client';
	      _this.cancelRedirect = cancelRedirect || _this.cancelRedirect || null;
	      _this.email = email || _this.email || null;
	
	      _this.showLogin();
	    });
	
	    $scope.$on('login:close', function (event, args) {
	      _this.closeLogin();
	    });
	
	    $scope.$on('login:forgotPassword', function (e) {
	      _this.showForgotPasswordModal = true;
	    });
	
	    $scope.$on('cui-modal-close', function () {
	      _this.closeLogin();
	      if (_this.cancelRedirect) $window.location.href = _this.cancelRedirect;
	    });
	
	    this.grecaptchaInterval = setInterval(function () {
	      if (_this._$window.grecaptcha && _this._$window.grecaptcha.render) {
	        _this.recaptchaId = _this._$window.grecaptcha.render('google_recaptcha_login', {
	          sitekey: _config2.default.GOOGLE_RECAPTCHA_SITEKEY,
	          size: 'invisible',
	          callback: function callback(token) {
	            return _this.logIn(token);
	          }
	        });
	
	        clearInterval(_this.grecaptchaInterval);
	
	        $('.g-recaptcha-response').attr('aria-label', 'google recaptcha');
	      }
	    }, 100);
	  }
	
	  _createClass(LoginController, [{
	    key: 'submitLogin',
	    value: function submitLogin(isValid) {
	      if (isValid) this._$window.grecaptcha.execute(this.recaptchaId);
	    }
	  }, {
	    key: 'logIn',
	    value: function logIn(recaptchaToken) {
	      var _this2 = this;
	
	      this._$window.grecaptcha.reset(this.recaptchaId);
	
	      this.submitState = 'loading';
	
	      this._authService.login(this.email, this.password, this.rememberMe, recaptchaToken).then(function (res) {
	        return _this2.loginSuccess(res);
	      }).catch(function (err) {
	        return _this2.loginError(err);
	      });
	    }
	  }, {
	    key: 'facebookLogin',
	    value: function facebookLogin(authType) {
	      var _this3 = this;
	
	      this.facebook.login(authType).then(function (res) {
	        return _this3._authService.socialLogin('facebook', _this3.facebook.user.authResponse.accessToken, _this3.facebook.user.authResponse.userID, _this3.userRole);
	      }).then(function (res) {
	        return _this3.loginSuccess(res);
	      }).catch(function (err) {
	        if (err && err.error) {
	          _this3._errorHandler.throwError('Facebook Error', 'An error occured while attempting to create user from Facebook. Please try again later.');
	        } else if (err && err.data) {
	          _this3._errorHandler.throwError('Facebook Error', err.data.message);
	        }
	      });
	    }
	  }, {
	    key: 'loginSuccess',
	    value: function loginSuccess(res) {
	      this.submitState = 'success';
	      this._userDataService.setUserData(res, true);
	
	      if (this.route) {
	        this.redirecting = true;
	        if (this.route === '/client' && res.user.roles === 'CUSTOMER') {
	          this.route = '/my-account';
	        } else if (this.route === '/client' && res.user.roles === 'COBRAND-ADMIN') {
	          this.route = '/cobrand-admin';
	        } else if (this.route === '/client' && res.dashboard_link) {
	          this.route = res.dashboard_link;
	        }
	        this._$window.location.href = this.route;
	      } else {
	        this.closeLogin();
	        this._$rootScope.$broadcast('login:success');
	      }
	    }
	  }, {
	    key: 'loginError',
	    value: function loginError(err) {
	      this.submitState = 'error';
	      var message = err && err.data && err.data.message ? err.data.message : 'Login failed, please try again.';
	      this._errorHandler.throwError('Login Error', message, err ? err : {});
	    }
	  }, {
	    key: 'showRegister',
	    value: function showRegister() {
	      this.toggle = false;
	      this._$rootScope.$broadcast('register:open', { cancelRedirect: this.cancelRedirect });
	    }
	  }, {
	    key: 'showLogin',
	    value: function showLogin() {
	      var _this4 = this;
	
	      this.toggle = true;
	
	      _.delay(function () {
	        if (_this4.userRole === "CUSTOMER") $('[data-focus="password"]').focus();else $('[data-focus="email"]').focus();
	      }, 100);
	    }
	  }, {
	    key: 'closeLogin',
	    value: function closeLogin() {
	      this.toggle = false;
	      this.email = '';
	      this.password = '';
	      this.loginForm.$setPristine();
	    }
	  }]);
	
	  return LoginController;
	}()];

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cdnPreprocessor = __webpack_require__(56);
	
	exports.default = ['$window', '$rootScope', '$location', function RegisterModalDirective($window, $rootScope, $location) {
	  return {
	    restrict: 'E',
	    template: __webpack_require__(97)(_cdnPreprocessor.jadeLocals),
	    scope: {
	      redirecting: '='
	    },
	    link: function link(scope) {
	      scope.toggleLogin = function () {
	        scope.toggle = false;
	        $rootScope.$broadcast('login:open', {});
	      };
	
	      scope.$on('register:open', function (event, _ref) {
	        var _ref$cancelRedirect = _ref.cancelRedirect,
	            cancelRedirect = _ref$cancelRedirect === undefined ? null : _ref$cancelRedirect;
	
	        scope.toggle = true;
	        scope.cancelRedirect = cancelRedirect;
	
	        if ($location.path() === '/register' && $location.search().signup_email) scope.$broadcast('register:signUpEmail', { email: $location.search().signup_email });
	
	        _.delay(function () {
	          return angular.element(document.querySelector('input[name="name"]')).focus();
	        }, 100);
	      });
	
	      scope.$on('register:close', function (event, args) {
	        scope.toggle = false;
	      });
	
	      scope.$on('cui-modal-close', function () {
	        if (scope.cancelRedirect) $window.location.href = scope.cancelRedirect;
	      });
	    }
	  };
	}];

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var jade = __webpack_require__(58);
	
	module.exports = function template(locals) {
	  var buf = [];
	  var jade_mixins = {};
	  var jade_interp;
	
	  buf.push("<cui-modal toggle=\"toggle\" modal-title=\"CREATE ACCOUNT\" type=\"account\"><register-form redirecting=\"redirecting\"><div class=\"form-group text-center\"><span class=\"form-text\">Have an account?<a href=\"\" ng-click=\"toggleLogin()\"> Sign in</a></span></div></register-form></cui-modal>");;return buf.join("");
	};

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cdnPreprocessor = __webpack_require__(56);
	
	exports.default = [function RegisterFormDirective() {
	  return {
	    restrict: 'E',
	    controller: 'RegisterCtrl',
	    controllerAs: 'register',
	    bindToController: true,
	    templateUrl: (0, _cdnPreprocessor.cdnTemplate)('/register-form.html'),
	    transclude: true,
	    scope: {
	      redirecting: '=?',
	      partnerId: '=?'
	    }
	  };
	}];

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _isValidPath = __webpack_require__(50);
	
	var _isValidPath2 = _interopRequireDefault(_isValidPath);
	
	var _analytics = __webpack_require__(13);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	var _config = __webpack_require__(2);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = ['$scope', '$location', '$timeout', '$window', 'AuthService', 'UserDataService', 'ErrorHandler', function () {
	  function RegisterController($scope, $location, $timeout, $window, authService, userDataService, errorHandler) {
	    var _this = this;
	
	    var analytics = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : new _analytics2.default();
	
	    _classCallCheck(this, RegisterController);
	
	    this._authService = authService;
	    this._$scope = $scope;
	    this._$location = $location;
	    this._$window = $window;
	    this._$timeout = $timeout;
	    this._userDataService = userDataService;
	    this._errorHandler = errorHandler;
	    this.analytics = analytics;
	
	    this.refId = this._$location.search()['r'];
	    if (this.refId && typeof $window.localStorage !== 'undefined') $window.localStorage.setItem('referralCode', JSON.stringify({ refId: this.refId, time: new Date() }));
	
	    $scope.$on('register:signUpEmail', function (event, _ref) {
	      var email = _ref.email;
	
	      _this.email = email;
	    });
	
	    this.grecaptchaInterval = setInterval(function () {
	      if (_this._$window.grecaptcha && _this._$window.grecaptcha.render) {
	        _this.recaptchaId = _this._$window.grecaptcha.render('google_recaptcha_register', {
	          sitekey: _config2.default.GOOGLE_RECAPTCHA_SITEKEY,
	          size: 'invisible',
	          callback: function callback(token) {
	            return _this.register(token);
	          }
	        });
	
	        clearInterval(_this.grecaptchaInterval);
	
	        $('.g-recaptcha-response').attr('aria-label', 'google recaptcha');
	      }
	    }, 100);
	  }
	
	  _createClass(RegisterController, [{
	    key: 'submitRegistration',
	    value: function submitRegistration(isValid) {
	      if (isValid) this._$window.grecaptcha.execute(this.recaptchaId);
	    }
	  }, {
	    key: 'register',
	    value: function register(recaptchaToken) {
	      var _this2 = this;
	
	      this._$window.grecaptcha.reset(this.recaptchaId);
	
	      this.submitState = 'loading';
	
	      if (!this.refId && typeof this._$window.localStorage !== 'undefined') {
	        try {
	          var refObj = JSON.parse(this._$window.localStorage.getItem('referralCode'));
	          if (Math.abs(new Date() - new Date(refObj.time)) / 36e5 <= 24) {
	            this.refId = refObj.refId;
	          }
	        } catch (e) {}
	      }
	
	      this._authService.register(this.name, this.publicName, this.email, this.password, this.terms, this.refId, this.partnerId, recaptchaToken).then(function (res) {
	        return _this2.registerSuccess(res);
	      }).catch(function (err) {
	        return _this2.registerError(err);
	      });
	
	      if (typeof this._$window.localStorage !== 'undefined') this._$window.localStorage.removeItem('referralCode');
	    }
	  }, {
	    key: 'registerSuccess',
	    value: function registerSuccess(res) {
	      this.analytics.register();
	      this.submitState = 'success';
	      this.redirecting = true;
	      this._userDataService.setUserData(res, true);
	
	      var returnPath = this._$location.search().return,
	          route = typeof returnPath == 'string' && (0, _isValidPath2.default)(returnPath.split('?')[0]) && returnPath.indexOf('/auth/shopify') === 0 ? returnPath.replace(/\\/g, '').replace('//', '') : '/client';
	
	      if (route === '/client' && res.dashboard_link) {
	        this._$window.location.href = res.dashboard_link;
	      } else {
	        this._$window.location.href = route;
	      }
	    }
	  }, {
	    key: 'registerError',
	    value: function registerError(err) {
	      this.submitState = 'error';
	      this._errorHandler.throwError('Registration Error', err && err.data && err.data.message ? err.data.message : 'Error Registering, please try again.');
	    }
	  }, {
	    key: 'nameChanged',
	    value: function nameChanged() {
	      this.publicName = this.name;
	      this.formatPublicName();
	    }
	  }, {
	    key: 'validatePublicName',
	    value: function validatePublicName() {
	      var _this3 = this;
	
	      if (this.timeout) {
	        this._$timeout.cancel(this.timeout);
	      }
	
	      var name = this.publicName;
	      //prefer timeout over debounce so format changes happen on key press.
	      this.timeout = this._$timeout(function () {
	        return _this3._authService.verifyPublicName(name);
	      }, 500);
	
	      return this.timeout;
	    }
	  }, {
	    key: 'formatPublicName',
	    value: function formatPublicName() {
	      this.publicName = this.publicName.toLowerCase();
	      this.publicName = this.cleanPublicName();
	    }
	  }, {
	    key: 'cleanPublicName',
	    value: function cleanPublicName() {
	      return this.publicName.replace(/\s/g, '-').replace(/([~!@#%^&*()"'+=`{}\[\]\|\\:;'<>,.\/? ])+/g, '');
	    }
	  }, {
	    key: 'emailChanged',
	    value: function emailChanged() {
	      var _this4 = this;
	
	      if (this.emailTimeout) {
	        this._$timeout.cancel(this.emailTimeout);
	      }
	
	      this.emailTimeout = this._$timeout(function () {
	        return _this4._emailChangedHelper();
	      }, 500);
	
	      return this.emailTimeout;
	    }
	  }, {
	    key: '_emailChangedHelper',
	    value: function _emailChangedHelper() {
	      var _this5 = this;
	
	      var promise = this._authService.verifyEmailAddress(this.email);
	
	      promise.catch(function (err) {
	        _this5.emailError = err && err.data && err.data.message ? err.data.message : 'Invalid Email';
	      });
	
	      return promise;
	    }
	  }]);
	
	  return RegisterController;
	}()];

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(7);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = ['$window', '$q', '$interval', 'AuthService', 'ErrorHandler', 'UserDataService', function () {
	  function FacebookLoginService($window, $q, $interval, authService, errorHandler, userData) {
	    _classCallCheck(this, FacebookLoginService);
	
	    this._$window = $window;
	    this._$q = $q;
	    this._$interval = $interval;
	    this._authService = authService;
	    this._userData = userData;
	    this._errorHandler = errorHandler;
	
	    this.role = null;
	    this.showPermissionsAlert = false;
	    this.user = {
	      status: null
	    };
	  }
	
	  // allow login directive to handle errors
	
	
	  _createClass(FacebookLoginService, [{
	    key: 'login',
	    value: function login(authType) {
	      var _this = this;
	
	      return this._login(authType).then(function () {
	        return _this._fetchPermissions();
	      }).then(function (res) {
	        return _this._checkPermissions(res);
	      });
	    }
	  }, {
	    key: 'logout',
	    value: function logout() {
	      var _this2 = this;
	
	      if (this.user.status === 'connected') {
	        this._$window.FB.logout(function (res) {
	          _this2.user = res;
	        });
	      }
	    }
	  }, {
	    key: 'getLoggedInUser',
	    value: function getLoggedInUser() {
	      var _this3 = this;
	
	      var defer = this._$q.defer();
	
	      this._$interval.cancel(this.facebookInterval);
	      this.facebookInterval = this._$interval(function () {
	        if (_this3._$window.FB) {
	          _this3._$interval.cancel(_this3.facebookInterval);
	          _this3._$window.FB.getLoginStatus(function (res) {
	            _this3.user = res;
	            if (res.status === 'connected') {
	              defer.resolve(res);
	            } else {
	              defer.reject();
	            }
	
	            // TODO remove this
	            // this._$window.FB.api('/me/permissions', 'delete');
	            // this._$window.FB.logout((res) => {
	            //   this.facebookUser = res;
	            // });
	            //end remove this
	          });
	        }
	      }, 10);
	
	      return defer.promise;
	    }
	  }, {
	    key: 'cancelAskForPermission',
	    value: function cancelAskForPermission() {
	      this.showPermissionsAlert = false;
	    }
	  }, {
	    key: '_login',
	    value: function _login(authType) {
	      var _this4 = this;
	
	      var defer = this._$q.defer();
	
	      this._$window.FB.login(function (res) {
	        _this4.user = res;
	        if (res.authResponse) {
	          defer.resolve(res);
	        } else {
	          defer.reject(res);
	        }
	      }, {
	        scope: 'email',
	        auth_type: authType || 'https'
	      });
	
	      return defer.promise;
	    }
	  }, {
	    key: '_fetchPermissions',
	    value: function _fetchPermissions() {
	      var defer = this._$q.defer();
	
	      this._$window.FB.api('/me/permissions', function (res) {
	        if (!res.error) {
	          defer.resolve(res.data);
	        } else {
	          defer.reject(res);
	        }
	      });
	
	      return defer.promise;
	    }
	  }, {
	    key: '_checkPermissions',
	    value: function _checkPermissions(res) {
	      var defer = this._$q.defer();
	
	      var emailPerm = _lodash2.default.find(res, function (permission) {
	        return permission.permission === 'email';
	      });
	      if (emailPerm.status !== 'granted') {
	        this.showPermissionsAlert = true;
	        defer.reject();
	      } else {
	        this.showPermissionsAlert = false;
	        defer.resolve();
	      }
	
	      return defer.promise;
	    }
	  }]);
	
	  return FacebookLoginService;
	}()];

/***/ }),
/* 101 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = ['$rootScope', '$scope', '$window', '$cookies', 'AuthService', 'UserDataService', function () {
	  function EventBroadcasterController($rootScope, $scope, $window, $cookies, AuthService, UserDataService) {
	    var _this = this;
	
	    _classCallCheck(this, EventBroadcasterController);
	
	    this._$rootScope = $rootScope;
	    this._$window = $window;
	    this._$cookies = $cookies;
	    this._authService = AuthService;
	    this._userDataService = UserDataService;
	    this.canScroll = true;
	
	    $scope.$on('menu-toggle', function (event, args) {
	      _this.canScroll = args.canScroll;
	    });
	
	    $scope.$on('slide-menu-toggle', function (event, args) {
	      _this.canScroll = args.canScroll;
	      _this.isSlideMenuOpen = !_this.canScroll;
	    });
	  }
	
	  _createClass(EventBroadcasterController, [{
	    key: 'openLogin',
	    value: function openLogin(route, email) {
	      this._$rootScope.$broadcast('login:open', { route: route, email: email });
	    }
	  }, {
	    key: 'openRegister',
	    value: function openRegister() {
	      this._$rootScope.$broadcast('register:open', {});
	    }
	  }, {
	    key: 'gravatar',
	    value: function gravatar() {
	      if (this._$cookies.get('gravatar')) {
	        return 'https://www.gravatar.com/avatar/' + this._$cookies.get('gravatar');
	      }
	      return false;
	    }
	  }]);
	
	  return EventBroadcasterController;
	}()];

/***/ }),
/* 102 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ['$compile', function floatLabelText($compile) {
	  return {
	    restrict: 'A',
	    require: 'ngModel',
	    scope: true,
	    link: function link(scope, el, attrs, ngModel) {
	      scope.$watch(function () {
	        return ngModel.$modelValue;
	      }, function (newValue) {
	        if (newValue) {
	          scope.hasTextValue = true;
	        } else {
	          scope.hasTextValue = false;
	        }
	      });
	
	      var templateAttributes = [],
	          hasIcon = false;
	      for (var attr in attrs) {
	        if (attrs.hasOwnProperty(attr) && attr.substr(0, 1) !== '$' && attr !== 'floatLabelText' && attr !== 'placeholder') {
	          templateAttributes.push(attrs.$attr[attr] + '="' + attrs[attr] + '"');
	          if (attr === 'icon') hasIcon = true;
	        }
	      }
	
	      var template = '\n          <div class="vs-input' + (hasIcon ? ' input-icon' : '') + '">\n            ' + (hasIcon ? '<i class="glyphicon ' + attrs.icon + '"></i>' : '') + '\n            <input id="textbox_' + scope.$id + '" class="form-control" ng-class="{filled: hasTextValue}" ' + templateAttributes.join(' ') + '/>\n            <label for="textbox_' + scope.$id + '" class="placeholder">' + attrs.placeholder + '</label>\n            <div class="vs-input-bg"></div>\n          </div>\n        ';
	      var linkFn = $compile(template);
	      var content = linkFn(scope);
	      el.replaceWith(content);
	    }
	  };
	}];

/***/ }),
/* 103 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ['$compile', function floatLabelText($compile) {
	  return {
	    restrict: 'A',
	    scope: true,
	    require: 'ngModel',
	    link: function link(scope, el, attrs, ngModel) {
	      scope.$watch(function () {
	        return ngModel.$modelValue;
	      }, function (newValue) {
	        if (newValue) {
	          scope.hasSelectValue = true;
	        } else {
	          scope.hasSelectValue = false;
	        }
	      });
	
	      var templateAttributes = [],
	          smallSize = false;
	      for (var attr in attrs) {
	        if (attrs.hasOwnProperty(attr) && attr.substr(0, 1) !== '$' && attr !== 'floatLabelSelect' && attr !== 'placeholder') {
	          templateAttributes.push(attrs.$attr[attr] + '="' + attrs[attr] + '"');
	          if (attr === 'smallSize') smallSize = true;
	        }
	      }
	
	      var template = '\n          <div class="vs-input' + (smallSize ? ' small' : '') + '" ng-class="{filled: hasSelectValue}">\n            <label for="select_' + scope.$id + '" class="placeholder">' + attrs.placeholder + '</label>\n            <span class="icons icons-arrow-bottom"></span>\n            <div class="vs-input-bg"></div>\n            <select id="select_' + scope.$id + '" class="form-control" ' + templateAttributes.join(' ') + '></select>\n          </div>\n        ';
	      var linkFn = $compile(template);
	      var content = linkFn(scope);
	      el.replaceWith(content);
	    }
	  };
	}];

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cdnPreprocessor = __webpack_require__(56);
	
	exports.default = [function FileUploader() {
	  return {
	    restrict: 'E',
	    templateUrl: (0, _cdnPreprocessor.cdnTemplate)('/file-uploader.html'),
	    link: function link(scope, el) {
	      var fileInput = angular.element(document.getElementById('file'));
	
	      el.on('drag dragstart dragend dragover dragenter dragleave drop', dragStart).on('dragover dragenter', dragOver).on('dragleave dragend drop', dragEnd).on('drop', dragDrop);
	
	      fileInput.on('change', fileChange);
	
	      function dragStart(e) {
	        e.preventDefault();
	        e.stopPropagation();
	      }
	
	      function dragOver(e) {
	        el.addClass('is-dragover');
	      }
	
	      function dragEnd(e) {
	        el.removeClass('is-dragover');
	      }
	
	      function dragDrop(e) {
	        if (e.originalEvent.dataTransfer.files.length && e.originalEvent.dataTransfer.files[0].type === 'text/csv') {
	          scope.$emit('file-upload:file-selected', e.originalEvent.dataTransfer.files[0]);
	        }
	      }
	
	      function fileChange(e) {
	        scope.$emit('file-upload:file-selected', e.currentTarget.files[0]);
	      }
	
	      scope.$on('$destroy', function () {
	        el.off('drag dragstart dragend dragover dragenter dragleave drop', dragStart).off('dragover dragenter', dragOver).off('dragleave dragend drop', dragEnd).off('drop', dragDrop);
	        fileInput.off('change', fileChange);
	      });
	    }
	  };
	}];

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(7);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _config = __webpack_require__(2);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var appendGoogleAddressTag = function appendGoogleAddressTag() {
	  if (!$('#google_address_tag').length) {
	    var tag = angular.element('<script id="google_address_tag" src="https://maps.googleapis.com/maps/api/js?key=' + _config2.default.GOOGLE_PLACES_API_KEY + '&libraries=places&callback=initAutocomplete" async defer></script>');
	    angular.element(document.querySelector('head')).append(tag);
	  }
	};
	
	var findComponentType = function findComponentType(components, componentType, nameType) {
	  var retVal = _lodash2.default.find(components, function (component) {
	    return _lodash2.default.find(component.types, function (type) {
	      return type === componentType;
	    });
	  });
	
	  return retVal ? retVal[nameType + '_name'] : '';
	};
	
	exports.default = ['$window', function googleAddressAutocomplete($window) {
	  return {
	    restrict: 'A',
	    link: function link(scope, el) {
	      var placeSearch = void 0,
	          autocomplete = void 0;
	
	      $window.initAutocomplete = function () {
	        autocomplete = new google.maps.places.Autocomplete(el[0], { types: ['geocode'] });
	        autocomplete.addListener('place_changed', fillInAddress);
	      };
	
	      $window.fillInAddress = function () {
	        var place = autocomplete.getPlace(),
	            components = place.address_components,
	            country = document.getElementsByName('country')[0];
	
	        country.value = 'string:' + findComponentType(components, 'country', 'short');
	        $(country).change();
	
	        // defer so the address form can update after the country is changed
	        _lodash2.default.delay(function () {
	          var address = document.getElementsByName('address')[0],
	              city = document.getElementsByName('city')[0],
	              state = document.getElementsByName('state')[0],
	              zip = document.getElementsByName('zip')[0],
	              address2 = document.getElementsByName('apt')[0],
	              streetNumber = findComponentType(components, 'street_number', 'long'),
	              streetName = findComponentType(components, 'route', 'short');
	
	          city.value = findComponentType(components, 'locality', 'short') || findComponentType(components, 'postal_town', 'short');
	          zip.value = findComponentType(components, 'postal_code', 'short');
	
	          if (streetNumber) {
	            address.value = streetNumber + ' ' + streetName;
	          } else {
	            var matches = el[0].value.match(/(^[0-9\/-]+\s*(?:[a-zA-Z](?![a-zA-Z]))?)/),
	                routeMatches = streetName.match(/(^[0-9\/-]+\s*(?:[a-zA-Z](?![a-zA-Z]))?)/);
	
	            if (matches.length && !routeMatches) {
	              address.value = matches[0].trim() + ' ' + streetName;
	            } else {
	              address.value = '' + streetName;
	            }
	          }
	
	          if (country.value === 'string:US' || country.value === 'string:CA') {
	            state.value = 'string:' + findComponentType(components, 'administrative_area_level_1', 'short');
	          } else {
	            state.value = findComponentType(components, 'administrative_area_level_1', 'long');
	          }
	
	          if (country.value !== "string:US") {
	            address2.value = findComponentType(components, 'neighborhood', 'long');
	            $(address2).change();
	          }
	
	          $(address).change();
	          $(city).change();
	          $(zip).change();
	          $(state).change();
	        }, 100);
	      };
	
	      appendGoogleAddressTag();
	    }
	  };
	}];

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _store = __webpack_require__(107);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _cuiIndex = __webpack_require__(120);
	
	var _cuiIndex2 = _interopRequireDefault(_cuiIndex);
	
	var _clientStore = __webpack_require__(121);
	
	var _clientStore2 = _interopRequireDefault(_clientStore);
	
	var _checkout = __webpack_require__(123);
	
	var _checkout2 = _interopRequireDefault(_checkout);
	
	var _amazonCheckout = __webpack_require__(124);
	
	var _amazonCheckout2 = _interopRequireDefault(_amazonCheckout);
	
	var _paypalCheckout = __webpack_require__(125);
	
	var _paypalCheckout2 = _interopRequireDefault(_paypalCheckout);
	
	var _trackOrder = __webpack_require__(126);
	
	var _trackOrder2 = _interopRequireDefault(_trackOrder);
	
	var _orderSummary = __webpack_require__(127);
	
	var _orderSummary2 = _interopRequireDefault(_orderSummary);
	
	var _contact = __webpack_require__(128);
	
	var _contact2 = _interopRequireDefault(_contact);
	
	var _privacyPolicy = __webpack_require__(129);
	
	var _privacyPolicy2 = _interopRequireDefault(_privacyPolicy);
	
	var _cookiePolicy = __webpack_require__(130);
	
	var _cookiePolicy2 = _interopRequireDefault(_cookiePolicy);
	
	var _termsOfService = __webpack_require__(131);
	
	var _termsOfService2 = _interopRequireDefault(_termsOfService);
	
	var _resetPassword = __webpack_require__(132);
	
	var _resetPassword2 = _interopRequireDefault(_resetPassword);
	
	var _upsell = __webpack_require__(133);
	
	var _upsell2 = _interopRequireDefault(_upsell);
	
	var _upsell3 = __webpack_require__(134);
	
	var _upsell4 = _interopRequireDefault(_upsell3);
	
	var _thankYou = __webpack_require__(135);
	
	var _thankYou2 = _interopRequireDefault(_thankYou);
	
	var _careers = __webpack_require__(136);
	
	var _careers2 = _interopRequireDefault(_careers);
	
	var _myAccount = __webpack_require__(137);
	
	var _myAccount2 = _interopRequireDefault(_myAccount);
	
	var _orderHistory = __webpack_require__(138);
	
	var _orderHistory2 = _interopRequireDefault(_orderHistory);
	
	var _defaultAddress = __webpack_require__(139);
	
	var _defaultAddress2 = _interopRequireDefault(_defaultAddress);
	
	var _paymentMethods = __webpack_require__(140);
	
	var _paymentMethods2 = _interopRequireDefault(_paymentMethods);
	
	var _trendingProducts = __webpack_require__(141);
	
	var _trendingProducts2 = _interopRequireDefault(_trendingProducts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('cui.pages', ['cui.pages.sales']).controller('IndexCtrl', _cuiIndex2.default).controller('ClientStoreCtrl', _clientStore2.default).controller('UpsellCtrl', _upsell2.default).directive('campaignUpsell', _upsell4.default).controller('CheckoutCtrl', _checkout2.default).controller('AmazonCheckoutCtrl', _amazonCheckout2.default).controller('PayPalCheckoutCtrl', _paypalCheckout2.default).controller('TrackOrderCtrl', _trackOrder2.default).controller('TrendingProductsCtrl', _trendingProducts2.default).controller('OrderSummaryCtrl', _orderSummary2.default).controller('ContactCtrl', _contact2.default).controller('CookiePolicyCtrl', _cookiePolicy2.default).controller('PrivacyPolicyCtrl', _privacyPolicy2.default).controller('TermsController', _termsOfService2.default).controller('ResetPasswordCtrl', _resetPassword2.default).controller('ThankYouCtrl', _thankYou2.default).controller('CareersController', _careers2.default).controller('MyAccountCtrl', _myAccount2.default).controller('OrderHistoryCtrl', _orderHistory2.default).controller('DefaultAddressCtrl', _defaultAddress2.default).controller('PaymentMethodsCtrl', _paymentMethods2.default);

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _productDisplay = __webpack_require__(108);
	
	var _productDisplay2 = _interopRequireDefault(_productDisplay);
	
	var _campaignStates = __webpack_require__(110);
	
	var _campaignStates2 = _interopRequireDefault(_campaignStates);
	
	var _productCarousel = __webpack_require__(113);
	
	var _productCarousel2 = _interopRequireDefault(_productCarousel);
	
	var _productColorTransition = __webpack_require__(114);
	
	var _productColorTransition2 = _interopRequireDefault(_productColorTransition);
	
	var _productDetails = __webpack_require__(116);
	
	var _productDetails2 = _interopRequireDefault(_productDetails);
	
	var _productZoom = __webpack_require__(118);
	
	var _productZoom2 = _interopRequireDefault(_productZoom);
	
	var _store = __webpack_require__(119);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('cui.pages.sales', []).controller('StoreCtrl', _store2.default).directive('productDisplay', _productDisplay2.default).directive('campaignStates', _campaignStates2.default).directive('productCarousel', _productCarousel2.default).directive('productColorTransition', _productColorTransition2.default).directive('productDetails', _productDetails2.default).directive('productZoom', _productZoom2.default);

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ProductDisplay;
	
	var _cdnPreprocessor = __webpack_require__(56);
	
	function ProductDisplay() {
	  return {
	    restrict: 'E',
	    replace: true,
	    scope: {
	      product: '=',
	      storeRef: '='
	    },
	    template: __webpack_require__(109)(_cdnPreprocessor.jadeLocals),
	    link: function link(scope) {
	      scope.colorChangingMug = false;
	
	      scope.$watch(function () {
	        return scope.product;
	      }, function (p) {
	        if (typeof p == 'undefined' || !p) {
	          scope.colorChangingMug = false;
	          return;
	        }
	        scope.colorChangingMug = p.render_type === 'COLOR_CHANGING_MUGS';
	      });
	
	      scope.changeView = function (val) {
	        scope.storeRef.view = val;
	        scope.storeRef.productGroups(true);
	      };
	    }
	  };
	};

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var jade = __webpack_require__(58);
	
	module.exports = function template(locals) {
	  var buf = [];
	  var jade_mixins = {};
	  var jade_interp;
	
	  jade_mixins["social"] = jade_interp = function jade_interp() {
	    var block = this && this.block,
	        attributes = this && this.attributes || {};
	    buf.push("<div class=\"social-widgets\"><div class=\"social-share-button facebook-share\"></div><div class=\"social-share-button twitter-share\"></div></div>");
	  };
	  jade_mixins["thumbnails"] = jade_interp = function jade_interp() {
	    var block = this && this.block,
	        attributes = this && this.attributes || {};
	    buf.push("<div ng-if=\"product.product.backView === &quot;SHOW&quot;\" class=\"thumbnail-links row\"><div class=\"col-sm-3 col-sm-offset-3 col-xs-4 col-xs-offset-2\"><a ng-class=\"{ active: storeRef.view == &quot;front&quot;}\" ng-click=\"changeView(&quot;front&quot;)\" class=\"thumbnail-link\"><img ng-src=\"{{product.assets.front_thumbnail | protocolRelative}}\" alt=\"\" class=\"hidden-xs\"><div class=\"text-center\">Front</div></a></div><div class=\"col-sm-3 col-xs-4\"><a ng-class=\"{ active: storeRef.view == &quot;back&quot;}\" ng-click=\"changeView(&quot;back&quot;)\" class=\"thumbnail-link\"><img ng-src=\"{{product.assets.back_thumbnail | protocolRelative}}\" alt=\"\" class=\"hidden-xs\"><div class=\"text-center\">Back</div></a></div></div>");
	  };
	  jade_mixins["flair"] = jade_interp = function jade_interp() {
	    var block = this && this.block,
	        attributes = this && this.attributes || {};
	    buf.push("<div ng-if=\"storeRef.campaign.flair.seal_url &amp;&amp; storeRef.campaign.flair.seal_url != &quot;&quot;\" class=\"flair flair-seal\"><img ng-src=\"{{storeRef.campaign.flair.seal_url}}\" alt=\"campaign seal flair image\"></div>");
	  };
	  buf.push("<div><product-zoom ng-if=\"!colorChangingMug\"><div class=\"zoom-display\"></div><product-carousel view=\"storeRef.view\" product=\"product\" ng-if=\"product.product.backView === &quot;SHOW&quot;\"></product-carousel>");
	  jade_mixins["flair"]();
	  jade_mixins["thumbnails"]();
	  buf.push("<div ng-if=\"product.product.backView != &quot;SHOW&quot;\"><img ng-src=\"{{product.assets.front_display_url | protocolRelative}}\" alt=\"Product Image\" class=\"zoom standalone-slide\"></div>");
	  jade_mixins["social"]();
	  buf.push("</product-zoom><product-color-transition ng-if=\"colorChangingMug\" product=\"product\" view=\"storeRef.view\">");
	  jade_mixins["flair"]();
	  jade_mixins["thumbnails"]();
	  jade_mixins["social"]();
	  buf.push("</product-color-transition></div>");;return buf.join("");
	};

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = CampaignStatesDir;
	
	var _cdnPreprocessor = __webpack_require__(56);
	
	function CampaignStatesDir() {
	  return {
	    restrict: 'E',
	    replace: true,
	    template: __webpack_require__(111)(_cdnPreprocessor.jadeLocals),
	    scope: {
	      campaign: '&',
	      copyright: '&',
	      state: '='
	    },
	    link: function link(scope) {
	      scope.state = 'loading';
	      scope.$watch(function () {
	        return scope.campaign();
	      }, function () {
	
	        if (scope.copyright() === true) {
	          scope.state = 'copyright';
	          return;
	        }
	
	        if (scope.campaign() == null) {
	          scope.state = 'loading';
	          return;
	        }
	
	        if (scope.campaign().is_closed === true) {
	          scope.state = 'ended';
	          return;
	        }
	
	        if (scope.campaign().is_pending === true) {
	          scope.state = 'pending';
	          return;
	        }
	
	        if (Array.isArray(scope.campaign().products) && scope.campaign().products.length === 0) {
	          scope.state = 'empty-campaign';
	          return;
	        }
	
	        scope.state = 'ready';
	      });
	    }
	  };
	};

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var jade = __webpack_require__(58);
	
	module.exports = function template(locals) {
	  var buf = [];
	  var jade_mixins = {};
	  var jade_interp;
	  ;var locals_for_with = locals || {};(function (undefined) {
	    buf.push("<div class=\"campaign-states container-fluid\"><div ng-if=\"state === &quot;loading&quot;\" class=\"container-fluid product-page-placeholder\"><cui-loading-overlay toggle=\"true\"></cui-loading-overlay>" + (null == (jade_interp = __webpack_require__(112).call(this, locals)) ? "" : jade_interp) + "</div><div ng-if=\"state === &quot;copyright&quot;\" class=\"container-fluid product-page-placeholder\"><h1 class=\"text-center\">Copyright Violation</h1><div class=\"row\"><div class=\"col-sm-6 col-sm-offset-3\"><p>This campaign has been removed in response to a report of potential\ninfringement of intellectual property rights and is no longer taking orders.</p></div></div></div><div ng-if=\"state === &quot;ended&quot;\" class=\"container-fluid product-page-placeholder\"><h1 class=\"text-center\">Campaign Ended</h1><div class=\"row\"><div class=\"col-sm-6 col-sm-offset-3\"><p>You have reached an campaign that has ended, \nwe may relaunch this campaign, please check back soon.</p></div></div></div><div ng-if=\"state === &quot;pending&quot; || state === &quot;empty-campaign&quot;\" class=\"container-fluid product-page-placeholder\"><h1 class=\"text-center\">Check back soon!</h1><div class=\"row\"><div class=\"col-sm-6 col-sm-offset-3\"><p>We're processing images and generating the sales page for this \ncampaign, please check back soon.</p></div></div></div></div>");
	  }).call(this, "undefined" in locals_for_with ? locals_for_with.undefined :  false ? undefined : undefined);;return buf.join("");
	};

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var jade = __webpack_require__(58);
	
	module.exports = function template(locals) {
	  var buf = [];
	  var jade_mixins = {};
	  var jade_interp;
	  ;var locals_for_with = locals || {};(function (cdn) {
	    buf.push("<div class=\"container-fluid placeholder\"><div class=\"row\"><div class=\"col-md-6 col-md-offset-1 col-sm-8 col-sm-offset-2\"><img" + jade.attr("src", '' + cdn.asset("/shirt-silhouette.png") + '', true, true) + " class=\"silhouette\"></div><div class=\"col-md-4 col-md-offset-1\"><div class=\"widget-box campaign-stats hidden-md hidden-lg\"><div class=\"campaign-countdown-timer\"><div class=\"countdown-component\"><div class=\"amount\"><div class=\"placeholder-text big\"></div></div><div class=\"unit\">Days</div></div><div class=\"countdown-component\"><div class=\"amount\"><div class=\"placeholder-text big\"></div></div><div class=\"unit\">Hrs</div></div><div class=\"countdown-component\"><div class=\"amount\"><div class=\"placeholder-text big\"></div></div><div class=\"unit\">Mins</div></div><div class=\"countdown-component\"><div class=\"amount\"><div class=\"placeholder-text big\"></div></div><div class=\"unit\">Secs</div></div></div><div class=\"campaign-progress\"><div class=\"sold-percentage-bar\"><div style=\"width: 50%;\" class=\"progress-bar\"></div><div class=\"inside-count\"></div></div></div></div><div class=\"cart\"><div class=\"cart__controls\"><div class=\"placeholder-text big\"></div><div class=\"row\"><div class=\"col-xs-3\"><div class=\"placeholder-text hightlight\"></div></div><div class=\"col-xs-1\"><div class=\"placeholder-text accent\"></div></div></div><div class=\"row-form\"><ul class=\"color-list\"><li class=\"color\"><span style=\"background-color: #ccc;\"></span></li><li class=\"color\"><span style=\"background-color: #ccc;\"></span></li><li class=\"color\"><span style=\"background-color: #ccc;\"></span></li><li class=\"color\"><span style=\"background-color: #ccc;\"></span></li><li class=\"color\"><span style=\"background-color: #ccc;\"></span></li></ul></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"placeholder-text white big\"></div></div></div><div class=\"row\"><div class=\"col-xs-6\"><div class=\"placeholder-text white big\"></div></div><div class=\"col-xs-6\"><div class=\"placeholder-text white big\"></div></div></div></div><div class=\"cart__buttons\"><button id=\"AddToCart\" disabled class=\"btn btn-secondary\"><span class=\"icons-cart\"></span> ADD TO CART</button></div></div></div><div class=\"col-md-4 cart-container\"><div class=\"widget-box campaign-stats hidden-xs hidden-sm\"><div class=\"campaign-countdown-timer\"><div class=\"countdown-component\"><img src=\"//assets.viralstyle.com/images/time_dark.png\" class=\"clock-icon\"></div><div class=\"countdown-component\"><div class=\"amount\"><div class=\"placeholder-text big\"></div></div><div class=\"unit\">Days</div></div><div class=\"countdown-component\"><div class=\"amount\"><div class=\"placeholder-text big\"></div></div><div class=\"unit\">Hrs</div></div><div class=\"countdown-component\"><div class=\"amount\"><div class=\"placeholder-text big\"></div></div><div class=\"unit\">Mins</div></div><div class=\"countdown-component\"><div class=\"amount\"><div class=\"placeholder-text big\"></div></div><div class=\"unit\">Secs</div></div></div><div class=\"campaign-progress\"><div class=\"sold-percentage-bar\"><div style=\"width: 50%;\" class=\"progress-bar\"></div><div class=\"inside-count\"></div></div></div></div></div><div class=\"col-md-8\"><div class=\"product-tabs placeholder\"><!-- Nav tabs--><ul class=\"nav nav-tabs tabset\"><li class=\"active\"><a>Description</a></li><li><a>Product Details</a></li></ul><!-- Tab panes--><div class=\"tab-content tab-product\"><div id=\"tab-1\" style=\"display: block;\" class=\"tab-pane\"><div style=\"width: 33%;\" class=\"placeholder-text\"></div><div class=\"placeholder-text accent\"></div><div class=\"placeholder-text accent\"></div><div class=\"placeholder-text accent\"></div></div></div></div></div></div></div>");
	  }).call(this, "cdn" in locals_for_with ? locals_for_with.cdn : typeof cdn !== "undefined" ? cdn : undefined);;return buf.join("");
	};

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cdnPreprocessor = __webpack_require__(56);
	
	exports.default = ['$interval', function productCarousel($interval) {
	  return {
	    restrict: 'E',
	    replace: true,
	    scope: {
	      view: '=',
	      product: '='
	    },
	    templateUrl: (0, _cdnPreprocessor.cdnTemplate)('/product-carousel.html'),
	    link: function link(scope, element) {
	      var currentIndex = void 0,
	          $owl = $(element),
	          imageLoadedCount = 0,
	          owlInitialized = false;
	
	      function updateScope(e) {
	        currentIndex = e.item.index;
	        if (e.item.index && e.item.index % 2 === 0) {
	          scope.view = 'front';
	        } else if (e.item.index) {
	          scope.view = 'back';
	        }
	      };
	
	      function initializeOwl() {
	        $owl.owlCarousel({
	          startPosition: scope.view === 'back' ? 1 : 0,
	          autoplay: false,
	          loop: true,
	          items: 1,
	          dots: true,
	          responsive: {
	            0: { nav: false },
	            768: { nav: true }
	          }
	        }).on('changed.owl.carousel', updateScope).on('dragged.owl.carousel', updateScope);
	        owlInitialized = true;
	      }
	
	      scope.$watch('view', function (n, o) {
	        if (n == o) return;
	        var to = scope.view == 'front' ? 0 : 1;
	        if (currentIndex % 2 != to) $owl.trigger('to.owl.carousel', [to]);
	      });
	
	      scope.$on('smart-img:loaded', function () {
	        // count will be 1 when both images have loaded
	        if (imageLoadedCount === 1 && !owlInitialized) {
	          initializeOwl();
	          imageLoadedCount = 0;
	        } else if (imageLoadedCount === 1 && owlInitialized) {
	          $owl.off('changed.owl.carousel', updateScope);
	          $owl.off('dragged.owl.carousel', updateScope);
	          $owl.trigger('destroy.owl.carousel');
	          initializeOwl();
	          imageLoadedCount = 0;
	        } else {
	          imageLoadedCount++;
	        }
	      });
	    }
	  };
	}];

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cdnPreprocessor = __webpack_require__(56);
	
	var ANIMATION_LENGTH = 5.5;
	var FULL_HEIGHT = 630;
	var MUG_TOP_PERCENT = 21.4;
	var MUG_BOTTOM_PERCENT = 76.2;
	var MUG_HEIGHT_PERCENT = 54.8;
	var DRAG_HANDLE_HEIGHT = 55;
	
	var COLD = { r: 24, g: 127, b: 255 },
	    MID = { r: 255, g: 198, b: 0 },
	    HOT = { r: 255, g: 0, b: 0 };
	
	function lerp(min, max, value) {
	  return min * (1 - value) + max * value;
	}
	
	function inverseLerp(min, max, value) {
	  return (value - min) / (max - min);
	}
	
	exports.default = ['$window', '$timeout', function ProductColorTransition($window, $timeout) {
	  return {
	    restrict: 'E',
	    transclude: true,
	    scope: {
	      product: '=',
	      view: '&'
	    },
	    template: __webpack_require__(115)(_cdnPreprocessor.jadeLocals),
	    link: function link(scope, el) {
	      var $el = $(el),
	          $handle = $el.find('.demo-handle'),
	          $targets = $el.find('.color-target'),
	          $mug = $el.find('canvas#display'),
	          $img = $el.find('img.design.front'),
	          $mask = $el.find('img.mask.front');
	
	      var canvas = $mug.get(0),
	          ctx = canvas.getContext('2d'),
	          images = {
	        grade: $el.find('img.mask.gradient').get(0),
	        front: $img.get(0),
	        back: $el.find('img.design.back').get(0),
	        coldFront: $mask.get(0),
	        coldBack: $el.find('img.mask.back').get(0)
	      };
	
	      var animating = false;
	      scope.dragging = false;
	      scope.heatLevel = 'fa-thermometer-4';
	      $handle.css({ backgroundColor: 'rgb(' + HOT.r + ', ' + HOT.g + ', ' + HOT.b + ')' });
	
	      function updateTransition(e, y) {
	        if (typeof e != 'undefined' && e != null) e.preventDefault();
	
	        var mugTop = $mug.offset().top,
	            //55
	        mugBottom = mugTop + $mug.height(),
	            //630
	        handleTop = mugTop + 25,
	            handleBottom = mugBottom * 0.82,
	            dragPercent = (y - mugTop) / $mug.height() * 100;
	
	        // Inside bounds.
	        if (y > mugTop && y < mugBottom) {
	
	          if (dragPercent < MUG_TOP_PERCENT) dragPercent = MUG_TOP_PERCENT;else if (dragPercent > MUG_BOTTOM_PERCENT) dragPercent = MUG_BOTTOM_PERCENT;
	          if (!animating) $handle.css({ top: dragPercent + '%', transform: 'translateY(-50%)' }); // Only update the handle position if we're not animating it ourselves.
	
	          var bottom = mugBottom - mugTop,
	              percent = (y - mugTop) / bottom,
	              // roughly clamped between 10% and 80% by the above checking
	          lerpPercent = (dragPercent - MUG_TOP_PERCENT) / (MUG_BOTTOM_PERCENT - MUG_TOP_PERCENT),
	              proportion = inverseLerp(9, 81, lerpPercent * 100),
	              gradeOffset = percent * FULL_HEIGHT - FULL_HEIGHT,
	              gradientPercent = (Math.abs(gradeOffset) / FULL_HEIGHT - .205) / (.836 - .205),
	              topGradientTransition = DRAG_HANDLE_HEIGHT / 1.5 * (gradientPercent - .5 - 0) / (.5 - 0),
	              bottomGradientTransition = DRAG_HANDLE_HEIGHT / 2 * (gradientPercent - .5) / (0 - .5);
	
	          gradeOffset = gradientPercent > .5 ? gradeOffset - topGradientTransition : gradeOffset + bottomGradientTransition;
	
	          var design = scope.view() == 'front' ? images.front : images.back,
	              cold = scope.view() == 'front' ? images.coldFront : images.coldBack;
	
	          // Render canvas.
	          ctx.clearRect(0, 0, canvas.width, canvas.height);
	          ctx.globalCompositeOperation = 'source-over';
	          ctx.drawImage(cold, 0, 0, 530, 630);
	          ctx.globalCompositeOperation = 'destination-in';
	          ctx.drawImage(images.grade, 0, gradeOffset, 530, 1260);
	          ctx.globalCompositeOperation = 'destination-over';
	          ctx.drawImage(design, 0, 0, 530, 630);
	
	          // Thermometer icon.
	          if (proportion < 0.2) scope.heatLevel = 'fa-thermometer-4';else if (proportion < 0.4) scope.heatLevel = 'fa-thermometer-3';else if (proportion < 0.6) scope.heatLevel = 'fa-thermometer-2';else if (proportion < 0.8) scope.heatLevel = 'fa-thermometer-1';else scope.heatLevel = 'fa-thermometer-0';
	
	          // Color interpolation.
	          var r = void 0,
	              g = void 0,
	              b = void 0,
	              midProp = void 0;
	          if (proportion < 0.5) {
	            // Warm half
	            midProp = inverseLerp(0, 0.5, proportion);
	            r = lerp(HOT.r, MID.r, midProp);
	            g = lerp(HOT.g, MID.g, midProp);
	            b = lerp(HOT.b, MID.b, midProp);
	          } else {
	            // Cold half
	            midProp = inverseLerp(0.5, 1, proportion);
	            r = lerp(MID.r, COLD.r, midProp);
	            g = lerp(MID.g, COLD.g, midProp);
	            b = lerp(MID.b, COLD.b, midProp);
	          }
	          r = Math.floor(r);
	          g = Math.floor(g);
	          b = Math.floor(b);
	          var newColor = 'rgb(' + r + ', ' + g + ', ' + b + ')';
	          $handle.css({ backgroundColor: newColor });
	          $targets.css({ color: newColor });
	        }
	      }
	
	      // Only resize to fit once the image has loaded.
	      $img.one('load', function () {
	        return updateTransition(null, $handle.offset().top + DRAG_HANDLE_HEIGHT / 2);
	      });
	      scope.$watch(function () {
	        return scope.view();
	      }, function (v) {
	        // Empty timeout so our digest cycle finishes and the new svg renders properly.
	        $timeout(function () {
	          return updateTransition(null, $handle.offset().top + DRAG_HANDLE_HEIGHT / 2);
	        });
	      });
	
	      var lockFrame = false;
	
	      scope.move = function (e) {
	        if (lockFrame || !scope.dragging) return;
	        lockFrame = true;
	        var position = e.pageY || e.originalEvent.touches[0].pageY;
	        $window.requestAnimationFrame(function () {
	          updateTransition(e, position);
	          lockFrame = false;
	        });
	      };
	
	      scope.moved = function (e) {
	        scope.dragging = false;
	      };
	
	      scope.startMove = function (e) {
	        scope.dragging = true;
	        e.preventDefault();
	      };
	
	      $el.on('touchmove', scope.move).on('touchend', scope.moved);
	      $handle.on('touchstart', scope.startMove);
	      $($window).on('resize', function () {
	        updateTransition(null, $handle.offset().top + DRAG_HANDLE_HEIGHT / 2);
	      });
	      $($window).on('mouseup', scope.moved);
	
	      // Opening Animation
	      animating = true;
	      var start = null,
	          finished = false;
	
	      function pageLoadAnimation(timestamp) {
	        if (scope.dragging) {
	          // if the user starts dragging - stop immediately
	          animating = false;
	          return;
	        }
	
	        if (start === null) start = timestamp;
	        var elapsed = timestamp - start,
	            progress = elapsed / (ANIMATION_LENGTH * 1000),
	            clampCos = Math.abs((Math.cos(progress * 2 * Math.PI) / 2 + 1 / 2) * 100 - 100);
	        $handle.css({ top: MUG_HEIGHT_PERCENT / 100 * clampCos + MUG_TOP_PERCENT + '%', transform: 'translateY(-50%)' });
	
	        var handleOffset = DRAG_HANDLE_HEIGHT / 2 / 100 * clampCos + DRAG_HANDLE_HEIGHT / 5;
	
	        updateTransition(null, $handle.offset().top + handleOffset);
	        if (progress < 1) {
	          $window.requestAnimationFrame(pageLoadAnimation);
	        } else {
	          animating = false;
	        }
	      }
	      $window.requestAnimationFrame(pageLoadAnimation);
	
	      scope.$on('$destroy', function () {
	        $el.off();
	        $handle.off();
	        $($window).off('resize');
	        $($window).off('mouseup');
	      });
	    }
	  };
	}];

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var jade = __webpack_require__(58);
	
	module.exports = function template(locals) {
	  var buf = [];
	  var jade_mixins = {};
	  var jade_interp;
	  ;var locals_for_with = locals || {};(function (cdn) {
	    buf.push("<div ng-mousemove=\"move($event)\" ng-mouseup=\"moved($event)\"><div class=\"mug-container\"><div ng-class=\"{ grabbed: dragging }\" ng-mousedown=\"startMove($event)\" class=\"demo-handle\"><div class=\"demo-handle-hitbox\"></div><i class=\"fa fa-chevron-up color-target\"></i><i ng-class=\"heatLevel\" class=\"fa\"></i><i class=\"fa fa-chevron-down color-target\"></i></div><img ng-src=\"{{product.assets.front_display_url | protocolRelative}}\" alt=\"\" class=\"design front\"><img ng-src=\"{{product.assets.back_display_url | protocolRelative}}\" alt=\"\" class=\"design back\"><img" + jade.attr("src", '' + cdn.asset("/transition-mug-cold-front.png") + '', true, true) + " alt=\"\" class=\"mask front\"><img" + jade.attr("src", '' + cdn.asset("/transition-mug-cold-back.png") + '', true, true) + " alt=\"\" class=\"mask back\"><img" + jade.attr("src", '' + cdn.asset("/transition-mug-gradient.png") + '', true, true) + " alt=\"\" class=\"mask gradient\"><canvas id=\"display\" width=\"530\" height=\"630\"></canvas></div><ng-transclude></ng-transclude></div>");
	  }).call(this, "cdn" in locals_for_with ? locals_for_with.cdn : typeof cdn !== "undefined" ? cdn : undefined);;return buf.join("");
	};

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _cdnPreprocessor = __webpack_require__(56);
	
	var _lodash = __webpack_require__(7);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = [function productDetails() {
	  return {
	    restrict: 'E',
	    replace: false,
	    scope: {
	      name: '@',
	      sizing: '&',
	      description: '&'
	    },
	    template: __webpack_require__(117)(_cdnPreprocessor.jadeLocals),
	    link: function link(scope) {
	      scope.measurements = null;
	
	      scope.$watch(function () {
	        return scope.sizing();
	      }, function (s) {
	        if ((typeof s === 'undefined' ? 'undefined' : _typeof(s)) != 'object' || !s.sizes) return;
	
	        if (s.sizes.length > 0) {
	          var sizeKeys = Object.keys(s.sizes);
	          var measurementKeys = Object.keys(s.sizes[sizeKeys[0]]);
	
	          scope.measurements = {};
	          _lodash2.default.forEach(measurementKeys, function (key) {
	            if (key === 'size') return;
	            scope.measurements[key] = key.replace('_', ' ');
	          });
	        }
	      });
	    }
	  };
	}];

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var jade = __webpack_require__(58);
	
	module.exports = function template(locals) {
	  var buf = [];
	  var jade_mixins = {};
	  var jade_interp;
	
	  buf.push("<div><div ng-if=\"!description() &amp;&amp; !sizing()\" class=\"text-center\"><p>No product details available.</p></div><div ng-if=\"!!sizing()\" class=\"visual pull-right\"><img ng-src=\"{{sizing().sample_image | protocolRelative}}\" alt=\"\"></div><div ng-if=\"!!description()\"><h2>{{name}}</h2><div ng-bind-html=\"description()\"></div></div><div ng-if=\"!!sizing().sizes.length\"><h2>PRODUCT SPECIFICATIONS</h2><div class=\"table-box table-responsive\"><table class=\"table-size\"><thead><tr><th></th><th ng-repeat=\"size in sizing().sizes\"><span class=\"circle\">{{size.size}}</span></th></tr></thead><tbody><tr ng-repeat=\"(key, name) in measurements\"><td>{{name}}</td><td ng-repeat=\"size in sizing().sizes\">{{size[key]}}\"</td></tr></tbody></table></div></div></div>");;return buf.join("");
	};

/***/ }),
/* 118 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ProductZoom;
	function ProductZoom() {
	  return {
	    restrict: 'E',
	    link: function link(scope, element) {
	      var zoom = 200;
	      var $el = $(element),
	          $zd = $el.find('.zoom-display'),
	          $win = $(window);
	
	      $el.on('mouseenter', 'img.zoom:not(.smart-img-loading)', function (e) {
	        if ($win.width() < 1024) return;
	        var $target = $(e.currentTarget);
	
	        $zd.addClass('show-zoom').css({
	          backgroundImage: 'url(' + $target.attr('src') + ')',
	          backgroundSize: zoom + '%',
	          width: $target.width() + 'px',
	          height: $target.height() + 'px'
	        });
	      }).on('mousemove', function (e) {
	        if ($win.width() < 1024) {
	          $zd.removeClass('show-zoom');
	          return;
	        }
	        var offset = $el.offset();
	        var mx = e.pageX - offset.left,
	            my = e.pageY - offset.top;
	
	        $zd.css({
	          backgroundPosition: '-' + mx + 'px -' + my + 'px'
	        });
	      }).on('mouseenter', '.owl-prev, .owl-next, .thumbnail-links, .owl-dots', function () {
	        return $zd.removeClass('show-zoom');
	      }).on('mouseleave', function () {
	        return $zd.removeClass('show-zoom');
	      });
	    }
	  };
	};

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(7);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _analytics = __webpack_require__(13);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	var _product = __webpack_require__(22);
	
	var _product2 = _interopRequireDefault(_product);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function CopyrightViolation(campaign) {
	  this.campaign = campaign;
	}
	
	exports.default = ['$rootScope', '$state', '$scope', '$interval', '$window', '$sce', '$location', '$filter', 'CampaignService', 'UrlHashParams', 'CartService', 'CampaignHistory', 'ProductsService', 'CurrencyService', 'AuthService', 'AbandonedCartService', function () {
	  function StoreCtrl($rootScope, $state, $scope, $interval, $window, $sce, $location, $filter, CampaignService, UrlHashParams, cartService, campaignHistory, productsService, CurrencyService, AuthService, AbandonedCartService) {
	    var _this = this;
	
	    var analytics = arguments.length > 16 && arguments[16] !== undefined ? arguments[16] : new _analytics2.default();
	
	    _classCallCheck(this, StoreCtrl);
	
	    this._$rootScope = $rootScope;
	    this._$scope = $scope;
	    this._$window = $window;
	    this._$sce = $sce;
	    this._$location = $location;
	    this._$filter = $filter;
	    this._hash = UrlHashParams;
	    this._productsService = productsService;
	    this._preApplyCoupon = $state.params.coupon;
	    this._abandonedCart = AbandonedCartService;
	    this.analytics = analytics;
	    this.username = $state.params.username;
	    this.slug = $state.params.campaignSlug;
	    this.campaign = null;
	    this.endTime = {};
	    this.copyrightViolation = false;
	    this.descriptions = {};
	    this.clockSizes = [{ val: "M", text: '8"' }, { val: "L", text: '11"' }];
	    this.productChangedSize = false;
	
	    $location.search('token', null);
	
	    CampaignService.initializeSession(this.username, this.slug, $location.search());
	    AuthService.getCurrentUser().then(function (res) {
	      return _this.currentUser = res.user;
	    });
	    this._handleOptOut($state.params.opt_out);
	
	    this.cart = cartService;
	    this.currency = CurrencyService;
	    this.currency.init().then(function () {
	      if (_this.campaign) _this.productGroups(true);
	    });
	
	    this.productQuantities = ['1', '2', '3', '4', '5'];
	
	    this.cart.init(this.username, this.slug).then(function (data) {
	      _this.campaign = data.campaign;
	      _this.copyrightViolation = data.violating_copyright;
	
	      if (!_this.copyrightViolation) {
	        _this._initCampaign(data);
	        _this._setEndTime($interval);
	        _this._setDefaultSelections();
	        _this._watchForGroupChange();
	        _this._watchForProductChange();
	        _this._watchForViewChange();
	        _this._watchForSizeChange();
	        _this._watchForQtyChange();
	        campaignHistory.addItem(_this.campaign, _this.selectedProduct);
	
	        if (_this.campaign.status === 'ONLINE' && !_this.campaign.has_expired) {
	          _this.analytics.sales(_this.campaign, _this.selectedProduct, _this.hashCoupon);
	        }
	      }
	    });
	
	    $rootScope.$on('$stateChangeStart', function (e, to, toParams, from, fromParams) {
	      if (to.name === 'sales-store' && from.name === 'checkout') {
	        // hard reload if back button pressed from checkout page
	        e.preventDefault();
	        $window.location.href = toParams.username + '/' + toParams.campaignSlug;
	      }
	    });
	
	    this.ticking = false;
	    this.testBottom = 0;
	
	    $(window).on('scroll', function () {
	      return _this._handleScroll();
	    });
	    $(window).on('touchmove', function () {
	      return _this._handleScroll();
	    });
	    $(window).on('resize', function () {
	      return _this._scrollUpdate();
	    });
	
	    $scope.$on('$destroy', function () {
	      $(window).off('scroll', function () {
	        return _this._handleScroll();
	      });
	      $(window).off('touchmove', function () {
	        return _this._handleScroll();
	      });
	      $(window).off('resize', function () {
	        return _this._scrollUpdate();
	      });
	    });
	
	    if (document.referrer && document.referrer.indexOf('/store/' + this.username) !== -1) this.showBackButton = true;
	  }
	
	  _createClass(StoreCtrl, [{
	    key: '_handleScroll',
	    value: function _handleScroll() {
	      var _this2 = this;
	
	      if (!this.ticking) {
	        window.requestAnimationFrame(function () {
	          return _this2._scrollUpdate();
	        });
	      }
	      this.ticking = true;
	    }
	  }, {
	    key: '_scrollUpdate',
	    value: function _scrollUpdate() {
	      var cartControls = $('.cart__controls:first'),
	          cartButtons = $('.cart__buttons:first'),
	          windowBottom = $(window).scrollTop() + window.innerHeight;
	
	      if (cartControls.length && cartButtons.length) {
	        var cartFormBottom = cartControls.outerHeight() + cartControls.offset().top + cartButtons.height();
	
	        if (windowBottom - cartFormBottom >= 0) cartButtons.addClass('cart__buttons--static');else cartButtons.removeClass('cart__buttons--static');
	      }
	
	      this.ticking = false;
	    }
	  }, {
	    key: 'goBackToStore',
	    value: function goBackToStore() {
	      this._$window.history.back();
	    }
	  }, {
	    key: 'campaignDescription',
	    value: function campaignDescription() {
	      return this._$sce.trustAsHtml(this.campaign.description);
	    }
	  }, {
	    key: 'campaignProgress',
	    value: function campaignProgress() {
	      var percentage = this.campaign.current_order_count / this.campaign.order_count_goal * 100;
	      if (percentage > 100) {
	        percentage = 100;
	      }
	      return percentage + '%';
	    }
	  }, {
	    key: 'productGroups',
	    value: function productGroups(forceUpdate) {
	      var _this3 = this;
	
	      var selectedThumbnail = void 0;
	
	      this.groups = this.groups || [];
	
	      if (forceUpdate) this.groups.length = 0;
	
	      if (this.groups.length == 0) {
	        _lodash2.default.each(_lodash2.default.unique(this.campaign.products, 'product.id'), function (product) {
	          var thumbnail = void 0,
	              view = void 0;
	
	          if (_this3.selectedProduct && product.product.id === _this3.selectedProduct.product.id) {
	            view = _this3.view || _this3.selectedProduct.default_side_to_display.toLowerCase();
	            thumbnail = view === 'front' ? _this3.selectedProduct.assets.front_thumbnail : _this3.selectedProduct.assets.back_thumbnail;
	          } else {
	            view = _this3.view || product.default_side_to_display.toLowerCase();
	            thumbnail = view === 'front' ? product.assets.front_thumbnail : product.assets.back_thumbnail;
	          }
	
	          _this3.groups.push({
	            label: product.product.name + ' - ' + _this3._$filter('currency')(_this3.productPrice(product) * _this3.currency.info.conversion_rate, _this3.currency.info.currency_symbol),
	            id: product.product.id,
	            thumbnail: thumbnail,
	            group: product.product.group
	          });
	        });
	      }
	
	      return this.groups;
	    }
	  }, {
	    key: 'handleClickProductThumbnail',
	    value: function handleClickProductThumbnail(group) {
	      this.selectedGroup = group;
	    }
	  }, {
	    key: 'productColors',
	    value: function productColors() {
	      var productID = this.selectedProduct.product.id;
	      var products = _lodash2.default.filter(this.campaign.products, function (p) {
	        return _lodash2.default.has(p, 'product.id') && p.product.id === productID;
	      });
	
	      return products;
	    }
	  }, {
	    key: 'productSizes',
	    value: function productSizes() {
	      if (_lodash2.default.has(this, 'selectedProduct.product.sizes') && Array.isArray(this.selectedProduct.product.sizes)) {
	        return this.selectedProduct.product.sizes;
	      }
	      return [];
	    }
	  }, {
	    key: 'productPrice',
	    value: function productPrice(product) {
	      var p = product || this.selectedProduct || {};
	      if (_typeof(p.product) === 'object') {
	        var upcharge = p.product.upcharges[this.selectedSize] || 0;
	        return parseFloat(p.selling_price) + parseFloat(upcharge);
	      }
	    }
	  }, {
	    key: 'productMsrpPrice',
	    value: function productMsrpPrice(product) {
	      var p = product || this.selectedProduct || {};
	      if (_typeof(p.product) === 'object') {
	        var upcharge = p.product.upcharges[this.selectedSize] || 0;
	        return parseFloat(p.msrp) + parseFloat(upcharge);
	      }
	    }
	  }, {
	    key: 'productSavings',
	    value: function productSavings() {
	      var savings = 100 - this.productPrice() / this.productMsrpPrice() * 100;
	      return Math.floor(savings);
	    }
	  }, {
	    key: 'addToCart',
	    value: function addToCart(isValid) {
	      if (isValid) {
	        this.analytics.addToCart(this.campaign, this.selectedProduct, this.selectedQty, this.selectedSize);
	        this.cart.add(this.selectedProduct, this.selectedSize, this.selectedQty);
	        if (this._trackNewCart !== true) {
	          this._abandonedCart.trackNewCart();
	          this._trackNewCart = true;
	        }
	      } else {
	        $('html,body').animate({
	          scrollTop: $('.cart:first').offset().top
	        }, 300);
	      }
	    }
	  }, {
	    key: 'getShareURI',
	    value: function getShareURI() {
	      return this._$location.absUrl();
	    }
	  }, {
	    key: 'selectedProductSizing',
	    value: function selectedProductSizing() {
	      if (!_lodash2.default.has(this, 'selectedProduct.product.id')) return false;
	      var sd = this.descriptions[this.selectedProduct.product.id];
	      if (!sd || sd.error || !sd.sizing) return false;
	      return sd.sizing;
	    }
	  }, {
	    key: 'selectedProductDescription',
	    value: function selectedProductDescription() {
	      if (!_lodash2.default.has(this, 'selectedProduct.product.id')) return false;
	      var sd = this.descriptions[this.selectedProduct.product.id];
	      if (!sd || sd.error || !sd.description || sd.description == '') return false;
	      return this._$sce.trustAsHtml(sd.description);
	    }
	  }, {
	    key: 'colorChangeEvent',
	    value: function colorChangeEvent(product) {
	      this.selectedProduct = product;
	      this.analytics.changeColor(this.selectedProduct.product_color.name);
	      this.productGroups(true);
	    }
	  }, {
	    key: 'isProductClock',
	    value: function isProductClock() {
	      return _product2.default.isProductClock(this.selectedProduct.product);
	    }
	  }, {
	    key: 'usOnlyProductInCart',
	    value: function usOnlyProductInCart() {
	      var _this4 = this;
	
	      var usOnlyProduct = false;
	
	      _lodash2.default.each(this.cart.contents(), function (cartProduct) {
	        _lodash2.default.each(_this4.campaign.products, function (campaignProduct) {
	          if (cartProduct.cpid === campaignProduct.id) {
	            if (campaignProduct.product.us_only) usOnlyProduct = true;
	            return false;
	          }
	        });
	        if (usOnlyProduct) return false;
	      });
	
	      return usOnlyProduct;
	    }
	  }, {
	    key: '_initCampaign',
	    value: function _initCampaign(data) {
	      var _this5 = this;
	
	      // Ended?
	      var end = moment.utc(this.campaign.end_date);
	      var now = moment(new Date());
	      this.ended = end - now <= 0;
	      this.currency.init().then(function () {
	        return _this5.cart.setCountry(_this5.currency.info.country_code);
	      });
	
	      if (this.campaign.cobrand_id) {
	        this._$scope.$emit('partnership:showLogo', {
	          pid: this.campaign.cobrand_id
	        });
	      }
	    }
	  }, {
	    key: '_setEndTime',
	    value: function _setEndTime($interval) {
	      var _this6 = this;
	
	      var end = moment.utc(this.campaign.end_date);
	      var timer = void 0;
	
	      timer = $interval(function () {
	        var now = moment(new Date());
	        if (end - now <= 0) {
	          _this6.ended = true;
	          $interval.cancel(timer);
	          _this6.endTime = {
	            days: 0,
	            hours: 0,
	            minutes: 0,
	            seconds: 0
	          };
	          return;
	        }
	
	        var days = (end - now) / (1000 * 60 * 60 * 24);
	        var hours = (days - Math.floor(days)) * 24;
	        var minutes = (hours - Math.floor(hours)) * 60;
	        var seconds = (minutes - Math.floor(minutes)) * 60;
	
	        _this6.ended = false;
	        _this6.endTime.days = Math.floor(days);
	        _this6.endTime.hours = Math.floor(hours);
	        _this6.endTime.minutes = Math.floor(minutes);
	        _this6.endTime.seconds = Math.floor(seconds);
	      }, 1001);
	    }
	  }, {
	    key: '_setDefaultSelections',
	    value: function _setDefaultSelections() {
	      var _this7 = this;
	
	      var hash = this._hash.get();
	      var search;
	
	      var couponCode = this._$location.search().coupon;
	
	      //
	      // Coupon pre-apply
	      if (hash['coupon']) {
	        this.hashCoupon = decodeURIComponent(hash['coupon']);
	        this.cart.applyCoupon(this.hashCoupon);
	        this._hash.set('coupon', null);
	      } else if (typeof this._preApplyCoupon === 'string' && this._preApplyCoupon !== '') {
	        this.cart.applyCoupon(this._preApplyCoupon);
	      }
	
	      //
	      // Product Selections
	      if (hash['pid'] && hash['cid']) {
	        search = _lodash2.default.find(this.campaign.products, function (p) {
	          return _lodash2.default.get(p, 'product.id') == hash['pid'] && (_lodash2.default.get(p, 'color.id') == hash['cid'] || p.id == hash['cid']);
	        });
	      } else if (hash['pid']) {
	        search = _lodash2.default.find(this.campaign.products, function (p) {
	          return _lodash2.default.get(p, 'product.id') == hash['pid'];
	        });
	      } else if (hash['cid']) {
	        search = _lodash2.default.find(this.campaign.products, function (p) {
	          return _lodash2.default.get(p, 'color.id') == hash['cid'];
	        }) || p.id == hash['cid'];
	      }
	
	      this.view = _product2.default.defaultProduct(this.campaign.products).default_side_to_display === 'BACK' ? 'back' : 'front';
	      if (hash['sid'] === 'back' || hash['sid'] === 'front') this.view = hash['sid'];
	
	      this.selectedProduct = search !== undefined ? search : _product2.default.defaultProduct(this.campaign.products);
	      this.selectedSize = this.selectedProduct.product.sizes.length > 1 ? null : this.selectedProduct.product.sizes[0];
	      this.selectedQty = '1';
	      this.selectedGroup = _lodash2.default.find(this.productGroups(), function (group) {
	        return group.id === _this7.selectedProduct.product.id;
	      });
	    }
	  }, {
	    key: '_watchForGroupChange',
	    value: function _watchForGroupChange() {
	      var _this8 = this;
	
	      this._$scope.$watch(function () {
	        return _this8.selectedGroup;
	      }, function (group, oldGroup) {
	        // Prevent resetting product when watcher is first set.
	        if (group.id === oldGroup.id) return;
	        _this8.selectedProduct = _lodash2.default.find(_this8.campaign.products, function (product) {
	          return product.product.id === group.id;
	        });
	
	        // Select same size
	        if (!_this8._sizeExists(_this8.selectedSize, _this8.productSizes())) {
	          _this8.productChangedSize = true;
	          _this8.selectedSize = _this8.selectedProduct.product.sizes.length > 1 ? null : _this8.selectedProduct.product.sizes[0];
	        }
	
	        _this8.productGroups(true);
	      });
	    }
	  }, {
	    key: '_watchForProductChange',
	    value: function _watchForProductChange() {
	      var _this9 = this;
	
	      this._$scope.$watch(function () {
	        return _this9.selectedProduct;
	      }, function (product) {
	        _this9._hash.set('pid', product.product.id);
	        _this9._hash.set('cid', product.color.id);
	
	        // Get Product Sizing Details
	        if (typeof _this9.descriptions[product.product.id] === 'undefined') {
	          _this9.descriptions[product.product.id] = {
	            error: true
	          };
	
	          _this9._productsService.getSizingAndDescription(product.product.id).then(function (res) {
	            return _this9.descriptions[product.product.id] = res;
	          });
	        }
	      });
	    }
	  }, {
	    key: '_watchForSizeChange',
	    value: function _watchForSizeChange() {
	      var _this10 = this;
	
	      var set = false;
	
	      this._$scope.$watch(function () {
	        return _this10.selectedSize;
	      }, function () {
	        if (!set) set = true;else {
	          if (!_this10.productChangedSize) _this10.analytics.changeSize(_this10.selectedSize);
	          _this10.productChangedSize = false;
	        }
	
	        _this10.productGroups(true);
	      });
	    }
	  }, {
	    key: '_watchForQtyChange',
	    value: function _watchForQtyChange() {
	      var _this11 = this;
	
	      var set = false;
	      this._$scope.$watch(function () {
	        return _this11.selectedQty;
	      }, function () {
	        if (!set) set = true;else _this11.analytics.changeQuantity(_this11.selectedQty);
	      });
	    }
	  }, {
	    key: '_watchForViewChange',
	    value: function _watchForViewChange() {
	      var _this12 = this;
	
	      this._$scope.$watch(function () {
	        return _this12.view;
	      }, function (view) {
	        return _this12._hash.set('sid', view);
	      });
	    }
	  }, {
	    key: '_sizeExists',
	    value: function _sizeExists(size, sizeSet) {
	      return !!_lodash2.default.find(sizeSet, function (s) {
	        return size == s;
	      });
	    }
	  }, {
	    key: '_handleOptOut',
	    value: function _handleOptOut(hash) {
	      var _this13 = this;
	
	      if (!hash) return;
	      this._abandonedCart.optOutCart(hash).then(function () {
	        return _this13.optOutSuccess = true;
	      });
	    }
	
	    //- holiday message
	
	  }, {
	    key: 'holidayBusinessLogic',
	    value: function holidayBusinessLogic() {
	      return moment.utc(this.campaign.end_date).isBefore(moment.utc("2016-12-15 12:00:00"));
	    }
	    //- end holiday message
	
	  }]);
	
	  return StoreCtrl;
	}()];

/***/ }),
/* 120 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var maxDisplayCampaigns = 4;
	
	exports.default = ['$rootScope', 'CampaignService', 'CampaignHistory', 'OffersService', function () {
	  function IndexController($rootScope, campaignService, campaignHistory, offersService) {
	    _classCallCheck(this, IndexController);
	
	    this._$rootScope = $rootScope;
	    this._campaignService = campaignService;
	    this._history = campaignHistory;
	    this._offersService = offersService;
	
	    this.featuredCampaigns = [];
	    this.trendingCampaigns = [];
	    this.campaignHistory = [];
	    this.getFeaturedCampaigns();
	    this.getTrendingCampaigns();
	    this.getRecentlyViewedCampaigns();
	
	    this._email = '';
	    this.subscribeState = null;
	  }
	
	  _createClass(IndexController, [{
	    key: 'getFeaturedCampaigns',
	    value: function getFeaturedCampaigns() {
	      var _this = this;
	
	      this._campaignService.getFeatured(maxDisplayCampaigns).then(function (data) {
	        return _this.featuredCampaigns = data;
	      });
	    }
	  }, {
	    key: 'getRecentlyViewedCampaigns',
	    value: function getRecentlyViewedCampaigns() {
	      this.campaignHistory = this._history.getHistory(maxDisplayCampaigns);
	    }
	  }, {
	    key: 'getTrendingCampaigns',
	    value: function getTrendingCampaigns() {
	      var _this2 = this;
	
	      this._campaignService.getTrending(8).then(function (data) {
	        return _this2.trendingCampaigns = data;
	      });
	    }
	  }, {
	    key: 'emailSubscribe',
	    value: function emailSubscribe(isValid) {
	      var _this3 = this;
	
	      if (isValid) {
	        this.subscribeState = 'loading';
	        this._offersService.subscribe(this.email, this._email).then(function (res) {
	          _this3.subscribeState = 'success';
	          _this3.email = '';
	          _this3.subscribeForm.$setPristine();
	        }).catch(function (err) {
	          return _this3.subscribeState = 'error';
	        });
	      }
	    }
	  }]);
	
	  return IndexController;
	}()];

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(7);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _webstoragePolyfill = __webpack_require__(10);
	
	var _webstoragePolyfill2 = _interopRequireDefault(_webstoragePolyfill);
	
	var _storeHistory = __webpack_require__(122);
	
	var _storeHistory2 = _interopRequireDefault(_storeHistory);
	
	var _analytics = __webpack_require__(13);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var perPage = 25;
	var _categories = ['ALL', 'HOBBIES', 'ANIMALS', 'OCCUPATION', 'SPORTS', 'MILITARY', 'HOLIDAYS', 'BUSINESS', 'OTHER'];
	
	exports.default = ['$stateParams', '$sce', '$q', '$scope', 'ClientService', 'CurrencyService', 'ErrorHandler', function () {
	  function ClientStoreCtrl($stateParams, $sce, $q, $scope, clientService, CurrencyService, errorHandler) {
	    var webstorage = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : new _webstoragePolyfill2.default();
	
	    var _this = this;
	
	    var storeHistory = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : new _storeHistory2.default();
	    var analytics = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : new _analytics2.default();
	
	    _classCallCheck(this, ClientStoreCtrl);
	
	    this._$stateParams = $stateParams;
	    this._$sce = $sce;
	    this._$q = $q;
	    this._$scope = $scope;
	    this._clientService = clientService;
	    this._errorHandler = errorHandler;
	    this._storage = webstorage;
	    this._storeHistory = storeHistory;
	    this.analytics = analytics;
	
	    this.clientName = $stateParams.publicName;
	    this.storeName = $stateParams.storeName;
	
	    this.currency = CurrencyService;
	    this.currency.init();
	
	    this.store = {};
	    this.campaigns = {};
	    this.categoryCounts = {};
	    this.category = _categories[0];
	    _lodash2.default.forEach(_categories, function (category) {
	      return _this.campaigns[category] = [];
	    });
	
	    this.firstLoad = true;
	    this.loading = false;
	
	    this.storeCoupon = typeof $stateParams.coupon === 'string' && $stateParams.coupon !== '' ? "?coupon=" + $stateParams.coupon : '';
	
	    this._getStoreDetails().finally(function () {
	      return _this.firstLoad = false;
	    });
	  }
	
	  _createClass(ClientStoreCtrl, [{
	    key: "storeDescription",
	    value: function storeDescription() {
	      return this._$sce.trustAsHtml(this.store.description);
	    }
	  }, {
	    key: "categories",
	    value: function categories() {
	      return _categories;
	    }
	  }, {
	    key: "nextPage",
	    value: function nextPage() {
	      var _this2 = this;
	
	      if (this.lazyLoadDisabled()) return;
	
	      var currentPage = 0;
	      if (this.categoryCounts[this.category] > 0) {
	        currentPage = this.campaigns[this.category].length / perPage;
	      }
	
	      this._getPage(currentPage).then(function (res) {
	        _this2.campaigns[_this2.category].push(res.results);
	        _this2.campaigns[_this2.category] = _lodash2.default.flatten(_this2.campaigns[_this2.category]);
	      });
	    }
	  }, {
	    key: "lazyLoadDisabled",
	    value: function lazyLoadDisabled() {
	      if (this.loading || this.firstLoad) return true;
	      if (this.campaigns[this.category].length >= this.categoryCounts[this.category]) return true;
	      return false;
	    }
	  }, {
	    key: "_getStoreDetails",
	    value: function _getStoreDetails(client, store) {
	      var _this3 = this;
	
	      var storeInfo = void 0,
	          campaigns = void 0;
	
	      storeInfo = this._clientService.getStore(this.clientName, this.storeName).then(function (res) {
	        return _this3._saveStore(res);
	      }).catch(function (err) {
	        return _this3._errorHandler.throwError('Store Info Error', err && err.data && err.data.message ? err.data.message : 'Could not load store details, please try again.');
	      });
	
	      campaigns = this._getPage(0);
	
	      return this._$q.all([storeInfo, campaigns]).then(function (res) {
	        if (_this3.store.is_tag_based) {
	          _this3.campaigns.ALL = res[1].results;
	        } else {
	          _this3.campaigns.ALL = _lodash2.default.sortBy(res[1].results, function (result) {
	            return parseInt(result.priority);
	          });
	        }
	      }).catch(function () {
	        _this3.storeNotFound = true;
	        _this3.loading = false;
	      });
	    }
	  }, {
	    key: "_saveStore",
	    value: function _saveStore(res) {
	      this.store = res;
	
	      if (res.status === 'ONLINE') {
	        this._storeHistory.setLastStore(res, this.clientName, this.storeName);
	        this.analytics.store(res, this._$stateParams.publicName + "/" + this._$stateParams.storeName);
	      }
	
	      if (res.cobrand_id) {
	        this._$scope.$emit('partnership:showLogo', {
	          pid: res.cobrand_id
	        });
	      }
	    }
	  }, {
	    key: "_getPage",
	    value: function _getPage(page) {
	      var _this4 = this;
	
	      this.loading = true;
	      var query = {
	        from: page * perPage,
	        per_page: perPage
	      };
	
	      if (this.category !== _categories[0]) {
	        query.category = this.category;
	      }
	
	      var promise = this._clientService.getCampaignsForStore(this.clientName, this.storeName, query);
	
	      promise.then(function (res) {
	        if (typeof _this4.categoryCounts[_this4.category] === 'undefined') {
	          _this4.categoryCounts[_this4.category] = res.total_hits;
	        }
	        _this4.loading = false;
	      }).catch(function (err) {
	        return _this4._errorHandler.throwError('Store Campaigns Error', err && err.data && err.data.message ? err.data.message : 'Could not load campaigns belonging to this store, please try again.');
	      });
	
	      return promise;
	    }
	  }]);
	
	  return ClientStoreCtrl;
	}()];

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _webstoragePolyfill = __webpack_require__(10);
	
	var _webstoragePolyfill2 = _interopRequireDefault(_webstoragePolyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var StoreHistory = function () {
	  function StoreHistory() {
	    var webstorage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _webstoragePolyfill2.default();
	
	    _classCallCheck(this, StoreHistory);
	
	    this._storage = webstorage;
	  }
	
	  _createClass(StoreHistory, [{
	    key: 'getLastStoreUrl',
	    value: function getLastStoreUrl() {
	      var lastStore = JSON.parse(this._storage.getLocalItem('last-store'));
	
	      if (lastStore) {
	        var duration = moment.duration(moment().diff(lastStore.time));
	        var hours = duration.asHours();
	        return hours <= 24 ? lastStore.url : '/marketplace';
	      } else {
	        return '/marketplace';
	      }
	    }
	  }, {
	    key: 'setLastStore',
	    value: function setLastStore(res, clientName, storeName) {
	      this._storage.setLocalItem('last-store', JSON.stringify({
	        url: '/store/' + clientName + '/' + storeName,
	        time: moment()
	      }));
	    }
	  }]);
	
	  return StoreHistory;
	}();
	
	exports.default = StoreHistory;

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(7);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _config = __webpack_require__(2);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _webstoragePolyfill = __webpack_require__(10);
	
	var _webstoragePolyfill2 = _interopRequireDefault(_webstoragePolyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = ['$window', '$state', '$stateParams', '$http', '$q', '$timeout', '$scope', 'StateTerritoryData', 'CartService', 'CampaignHistory', 'CurrencyService', 'ErrorHandler', 'AuthService', 'UserDataService', 'UserService', 'AbandonedCartService', function () {
	  function StripeCheckoutController($window, $state, $params, $http, $q, $timeout, $scope, stateTerritoryData, cartService, campaignHistory, CurrencyService, errorHandler, authService, userDataService, userService, abandonedCart) {
	    var webstorage = arguments.length > 16 && arguments[16] !== undefined ? arguments[16] : new _webstoragePolyfill2.default();
	
	    _classCallCheck(this, StripeCheckoutController);
	
	    this._$window = $window;
	    this._$state = $state;
	    this._$http = $http;
	    this._$q = $q;
	    this._$timeout = $timeout;
	    this._$window = $window;
	    this._$scope = $scope;
	    this._stateTerritoryData = stateTerritoryData;
	    this._campaignHistory = campaignHistory;
	    this._errorHandler = errorHandler;
	    this._authService = authService;
	    this._userDataService = userDataService;
	    this._userService = userService;
	    this._abandonedCart = abandonedCart;
	    this._storage = webstorage;
	    this._username = $params.pn;
	    this._campaignSlug = $params.sl;
	    this.popoverPath = 'assets/customer-ui/templates/cvv-help.html';
	
	    this.customer = {};
	    this.customer.apt = '';
	    this.card = {};
	
	    // init for masked inputs;
	    this.customer.email = '';
	    this.customer.mobile = '';
	    this.customer.zip = '';
	    this.password = '';
	    this.passwordConfirm = '';
	    this.card.cc_cvc = '';
	    this.card.cc_num = '';
	    this.validateEmailTimeout = null;
	    this.validateEmailPromise = null;
	    this.emailValid = true;
	    this.emailError = false;
	    this.paymentMethod = 'saved';
	
	    this.monthRange = [];
	    this.yearRange = [];
	
	    this.processing = true;
	
	    this.card.cc_expiry_mm = '';
	    this.card.cc_expiry_yy = '';
	    this.customer.state = '';
	
	    this.currency = CurrencyService;
	    this.cart = cartService;
	
	    if (!this._username || !this._campaignSlug) {
	      this.backToProductDetails(false);
	    } else {
	      this._initSelectOptions();
	      this._initCheckout();
	    }
	  }
	
	  _createClass(StripeCheckoutController, [{
	    key: 'completeOrder',
	    value: function completeOrder(isValid) {
	      var _this = this;
	
	      if (isValid && this._creditCardValid() && !this.completeOrderDisabled) {
	        this.processing = true;
	        this.completeOrderDisabled = true;
	        if (this.validateEmailPromise) {
	          this.validateEmailPromise.then(function () {
	            return _this.compleOrderHelper();
	          }).catch(function () {
	            _this.processing = false;
	            _this.completeOrderDisabled = false;
	          }).finally(function () {
	            return _this.validateEmailPromise = null;
	          });
	        } else {
	          this.compleOrderHelper();
	        }
	      }
	    }
	  }, {
	    key: 'compleOrderHelper',
	    value: function compleOrderHelper() {
	      var _this2 = this;
	
	      if (this.customer.country === 'US' && _config2.default.SmartyStreets.enabled) {
	        this._$http({
	          url: 'https://api.smartystreets.com/street-address',
	          method: "GET",
	          params: {
	            'auth-id': _config2.default.SmartyStreets.ID,
	            street: this.customer.address,
	            city: this.customer.city,
	            state: this.customer.state
	          }
	        }).then(function (res) {
	          if (res.data.length === 0) {
	            _this2._errorHandler.throwError('Address Error', 'Your shipping address seems to be invalid. Please update it to be sure that we can deliver your purchase.');
	            _this2.processing = false;
	            _this2.completeOrderDisabled = false;
	          } else {
	            _this2.processPaymentHelper();
	          }
	        });
	      } else {
	        this.processPaymentHelper();
	      }
	    }
	  }, {
	    key: 'processPaymentHelper',
	    value: function processPaymentHelper() {
	      var _this3 = this;
	
	      this.cart.validateCouponBeforeCheckout().then(function () {
	        return _this3.processPayment();
	      }).catch(function (err) {
	        _this3.showCouponInvalidModal = err && typeof err.valid !== 'undefined';
	        _this3.processing = false;
	        _this3.completeOrderDisabled = false;
	      });
	    }
	  }, {
	    key: 'processPayment',
	    value: function processPayment() {
	      this.processing = true;
	      this.showCouponInvalidModal = false;
	
	      if (this.savedPaymentInfo && this.paymentMethod === 'saved') {
	        this._savedTokenPayment();
	      } else {
	        this._newTokenPayment();
	      }
	    }
	  }, {
	    key: '_creditCardValid',
	    value: function _creditCardValid() {
	      //this should not be needed, but just incase
	      var returnVal = true;
	      if ((!this.card.cc_num || !this.card.cc_expiry_yy || !this.card.cc_expiry_mm || !this.card.cc_cvc) && !this.savedPaymentInfo && this.paymentMethod !== 'saved') {
	        this._errorHandler.throwError('Payment Info Error', 'Please correct missing payment info and try again.');
	        returnVal = false;
	      }
	      return returnVal;
	    }
	  }, {
	    key: '_newTokenPayment',
	    value: function _newTokenPayment() {
	      var _this4 = this;
	
	      this.cart.createCCTokenCart(this.card, this.customer).then(function (res) {
	        return _this4.cart.processCCPayment(res.token, _this4.customer, _this4.card);
	      }).then(function (res) {
	        return _this4.paymentProcessed(res);
	      }).catch(function () {
	        return _this4.completeOrderDisabled = false;
	      }).finally(function () {
	        return _this4.processing = false;
	      });
	    }
	  }, {
	    key: '_savedTokenPayment',
	    value: function _savedTokenPayment() {
	      var _this5 = this;
	
	      this.cart.processSavedPayment(this.savedPaymentInfo.customer_id, this.customer).then(function (res) {
	        return _this5.paymentProcessed(res);
	      }).catch(function () {
	        return _this5.completeOrderDisabled = false;
	      }).finally(function () {
	        return _this5.processing = false;
	      });
	    }
	  }, {
	    key: 'paymentProcessed',
	    value: function paymentProcessed(res) {
	      if (this.rememberAddress) this._rememberAddress(this.customer);
	
	      this._storage.removeLocalItem('order-credentials');
	      this._storage.setLocalItem('order-credentials', res.order_num + ':' + this.customer.zip);
	      this._$state.go('thank-you', {
	        username: this._username,
	        campaign: this._campaignSlug
	        // password: this.password
	      });
	    }
	  }, {
	    key: 'validateEmail',
	    value: function validateEmail() {
	      var _this6 = this;
	
	      var deferred = this._$q.defer();
	      this.validateEmailPromise = deferred.promise;
	      this._$timeout.cancel(this.validateEmailTimeout);
	
	      this.validateEmailTimeout = this._$timeout(function () {
	        if (!_this6.customer.email || typeof _this6.customer.email == 'string' && _this6.customer.email.length == 0) {
	          _this6._invalidEmail({}, deferred);
	        } else {
	          _this6._authService.verifyEmailAddress(_this6.customer.email).then(function () {
	            return _this6._validEmail(deferred);
	          }).catch(function (err) {
	            return _this6._invalidEmail(err, deferred);
	          });
	        }
	      }, 500);
	    }
	  }, {
	    key: '_validEmail',
	    value: function _validEmail(deferred) {
	      this.emailValid = true;
	      this.existingEmail = false;
	      this.emailError = false;
	      this._abandonedCart.trackAbandonedCart(this.customer.email);
	      deferred.resolve();
	    }
	  }, {
	    key: '_invalidEmail',
	    value: function _invalidEmail() {
	      var err = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var deferred = arguments[1];
	
	      if (err.data && err.data.message && err.data.message === "Email has already been registered.") {
	        this.existingEmail = true;
	        this.emailError = false;
	        this._abandonedCart.trackAbandonedCart(this.customer.email);
	        deferred.resolve();
	      } else {
	        this.existingEmail = false;
	        this.emailError = true;
	        deferred.reject();
	      }
	      this.emailValid = false;
	      this.rememberAddress = false;
	      this.password = '';
	      this.passwordConfirm = '';
	    }
	  }, {
	    key: 'backToProductDetails',
	    value: function backToProductDetails(hasSlug) {
	      if (hasSlug || typeof this._username == 'string' && typeof this._campaignSlug == 'string') {
	        this._$window.location.href = this._username + '/' + this._campaignSlug;
	      } else {
	        var history = this._campaignHistory.getHistory();
	
	        if (history.length) {
	          this._$window.location.href = history[0].uri;
	        } else {
	          this._$window.location.href = '/';
	        }
	      }
	    }
	  }, {
	    key: 'stateChanged',
	    value: function stateChanged() {
	      this.cart.setCountry(this.customer.country, this.customer.state);
	    }
	  }, {
	    key: 'countryChanged',
	    value: function countryChanged() {
	      this.customer.state = '';
	      this.customer.zip = '';
	      this.cart.setCountry(this.customer.country);
	      this.currency.setCountry(this.customer.country);
	    }
	  }, {
	    key: '_initCheckout',
	    value: function _initCheckout() {
	      var _this7 = this;
	
	      this.customer.country = this.usOnly ? 'US' : this.currency.info.country_code;
	
	      var cartPromise = this.cart.init(this._username, this._campaignSlug);
	      var loggedInCustomerPromise = this._initLoggedInCustomer();
	
	      this._$q.all([cartPromise, loggedInCustomerPromise]).then(function (res) {
	        if (_this7.cart.size() === 0) {
	          _this7.backToProductDetails(true);
	        } else {
	          _this7._initCampaign(res[0]);
	        }
	      }).then(function () {
	        return _this7._initCountryInfo();
	      }).finally(function () {
	        return _this7.processing = false;
	      });
	
	      this._$scope.$on('login:success', function () {
	        return _this7._handleLoginLogout();
	      });
	      this._$scope.$on('logout:success', function () {
	        return _this7._handleLoginLogout();
	      });
	    }
	  }, {
	    key: '_initCampaign',
	    value: function _initCampaign(data) {
	      var _this8 = this;
	
	      this.campaign = data.campaign;
	
	      if (this.campaign.cobrand_id) {
	        this._$scope.$emit('partnership:showLogo', {
	          pid: this.campaign.cobrand_id
	        });
	      }
	
	      _lodash2.default.each(this.cart.contents(), function (cartProduct) {
	        _lodash2.default.each(_this8.campaign.products, function (campaignProduct) {
	          if (cartProduct.cpid === campaignProduct.id) {
	            if (campaignProduct.product.us_only) _this8.usOnly = true;
	            return false;
	          }
	        });
	        if (_this8.usOnly) return false;
	      });
	
	      if (this.usOnly && this.customer.country !== 'US') {
	        this.customer.country = 'US';
	        this.customer.state = '';
	        this.customer.zip = '';
	      }
	    }
	  }, {
	    key: '_initSelectOptions',
	    value: function _initSelectOptions() {
	      for (var i = 1; i < 13; i++) {
	        this.monthRange.push({
	          key: i,
	          value: i
	        });
	      }
	
	      var year = new Date().getFullYear();
	      this.yearRange.push({
	        key: year,
	        value: year
	      });
	      for (var _i = 1; _i < 10; _i++) {
	        this.yearRange.push({
	          key: year + _i,
	          value: year + _i
	        });
	      }
	
	      this.countries = this._stateTerritoryData.getCountries();
	      this.states = this._stateTerritoryData.getExtendedStates();
	      this.provinces = this._stateTerritoryData.getProvinces();
	    }
	  }, {
	    key: '_initLoggedInCustomer',
	    value: function _initLoggedInCustomer() {
	      var _this9 = this;
	
	      return this._userDataService.getUserData().then(function (customerInfo) {
	        if (customerInfo.user) customerInfo = customerInfo.user;
	
	        var name = customerInfo.name.split(' ');
	        _this9.existingEmail = true;
	        _this9.emailValid = false;
	        _this9.emailError = false;
	        _this9.customerLoggedIn = true;
	        _this9.customer.id = customerInfo.id;
	        _this9.customer.email = customerInfo.email;
	        _this9.customer.firstName = name[0];
	        _this9.customer.lastName = name[name.length - 1];
	        _this9.customer.name = customerInfo.name;
	        _this9.customer.slug = customerInfo.user_info.public_name;
	        _this9.customer.originalZip = customerInfo.user_info.shipping_details.zip || '00000';
	        _this9.customer.address = customerInfo.user_info.shipping_details.street_1;
	        _this9.customer.apt = customerInfo.user_info.shipping_details.street_2;
	        _this9.customer.city = customerInfo.user_info.shipping_details.city;
	        _this9.customer.zip = customerInfo.user_info.shipping_details.zip;
	        _this9.customer.mobile = customerInfo.user_info.shipping_details.mobile;
	
	        if (_this9.usOnly) {
	          if (customerInfo.user_info.shipping_details.country === 'US') {
	            _this9.customer.state = customerInfo.user_info.shipping_details.state;
	          } else {
	            _this9.customer.state = '';
	            _this9.customer.zip = '';
	          }
	          _this9.customer.country = 'US';
	        } else {
	          _this9.customer.state = customerInfo.user_info.shipping_details.state;
	          _this9.customer.country = customerInfo.user_info.shipping_details.country;
	        }
	
	        _this9._userService.getSavedPayment(_this9.customer.slug).then(function (res) {
	          _this9.paymentMethod = 'saved';
	          _this9.savedPaymentInfo = res;
	        }).catch(function (err) {
	          _this9.savedPaymentInfo = null;
	          _this9.paymentMethod = 'new';
	        });
	      }).catch(function (err) {
	        _this9.customerLoggedIn = false;
	        _this9.savedPaymentInfo = null;
	        _this9.paymentMethod = 'new';
	        if (_this9._$window.localStorage.getItem('address')) {
	          _this9.customer = JSON.parse(_this9._$window.localStorage.getItem('address'));
	        }
	      });
	    }
	  }, {
	    key: '_rememberAddress',
	    value: function _rememberAddress(customer) {
	      var _this10 = this;
	
	      // Unauthenticated:
	      if (!this.customerLoggedIn) {
	        customer.email = null;
	        this._$window.localStorage.setItem('address', JSON.stringify(customer));
	      }
	      // Authenticated:
	      else {
	          this._userService.updateAddress(customer.slug, customer.firstName + ' ' + customer.lastName, customer.address, customer.city, customer.state, customer.zip, customer.country, customer.mobile, customer.apt).catch(function (res) {
	            return _this10._errorHandler.logError('Update Customer Address', 'Failed to update customer address on checkout.', res);
	          });
	        }
	    }
	  }, {
	    key: '_initCountryInfo',
	    value: function _initCountryInfo() {
	      var _this11 = this;
	
	      var deferred = this._$q.defer(),
	          cartPromise = void 0,
	          currencyPromise = void 0;
	
	      if (this.customer.address) {
	        if (this.usOnly || this.customer.country === 'US') {
	          if (this.customer.country === 'US') {
	            cartPromise = this.cart.setCountry('US', this.customer.state);
	          } else {
	            this.customer.state = '';
	            this.customer.zip = '';
	            cartPromise = this.cart.setCountry('US');
	          }
	        } else {
	          cartPromise = this.cart.setCountry(this.customer.country);
	        }
	
	        currencyPromise = this.currency.setCountry(this.customer.country);
	      } else {
	        currencyPromise = this.currency.init().then(function () {
	          if (_this11.usOnly || _this11.currency.info.country_code === 'US') {
	            _this11.customer.country = 'US';
	            _this11.cart.setCountry('US');
	          } else {
	            _this11.customer.country = _this11.currency.info.country_code;
	            cartPromise = _this11.cart.setCountry(_this11.customer.country);
	          }
	        });
	      }
	
	      if (cartPromise) {
	        this._$q.all([cartPromise, currencyPromise]).then(function () {
	          return deferred.resolve();
	        }).catch(function () {
	          return deferred.reject();
	        });
	      } else {
	        currencyPromise.then(function () {
	          return deferred.resolve();
	        }).catch(function () {
	          return deferred.reject();
	        });
	      }
	
	      return deferred.promise;
	    }
	  }, {
	    key: '_handleLoginLogout',
	    value: function _handleLoginLogout() {
	      var _this12 = this;
	
	      this.processing = true;
	      this._initLoggedInCustomer().then(function () {
	        return _this12._initCountryInfo();
	      }).finally(function () {
	        return _this12.processing = false;
	      });
	    }
	  }]);
	
	  return StripeCheckoutController;
	}()];

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _config = __webpack_require__(2);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _webstoragePolyfill = __webpack_require__(10);
	
	var _webstoragePolyfill2 = _interopRequireDefault(_webstoragePolyfill);
	
	var _analytics = __webpack_require__(13);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = ['$q', '$state', '$stateParams', '$window', '$scope', 'CartService', 'UpsellCartService', 'username', 'campaignSlug', 'ErrorHandler', function () {
	  function AmazonCheckoutController($q, $state, $stateParams, $window, $scope, cartService, upsellCartService, username, slug, ErrorHandler) {
	    var _this = this;
	
	    var webstorage = arguments.length > 10 && arguments[10] !== undefined ? arguments[10] : new _webstoragePolyfill2.default();
	    var analytics = arguments.length > 11 && arguments[11] !== undefined ? arguments[11] : new _analytics2.default();
	
	    _classCallCheck(this, AmazonCheckoutController);
	
	    this._$q = $q;
	    this._$state = $state;
	    this._$params = $stateParams;
	    this._$window = $window;
	    this._$scope = $scope;
	    this._errorHandler = ErrorHandler;
	    this._storage = webstorage;
	    this.analytics = analytics;
	
	    this.isProcessing = true;
	
	    this.couponCode = null;
	
	    this.addressSelected = false;
	    this.paymentSelected = false;
	
	    this.amazonReferenceId = this._$params.session;
	    this.orderReferenceID = null;
	
	    this.upsell = this._$params.upsell;
	    this.upsellArray = [this._$params.upsellProduct];
	
	    var cartPromise = void 0;
	    if (this.upsell === true) {
	      this.cart = upsellCartService;
	      cartPromise = this._initializeAmazonWidgets().then(function () {
	        return _this.cart.initAmazon(_this.amazonReferenceId, _this.orderReferenceID, _this.upsellArray);
	      });
	    } else {
	      this.cart = cartService;
	      this._initializeAmazonWidgets();
	      cartPromise = this.cart.init(username, slug);
	    }
	
	    cartPromise.then(function (data) {
	      _this.cartTotals = _this.cart.getTotals();
	      _this.campaign = data.campaign;
	    }).finally(function () {
	      return _this.isProcessing = false;
	    });
	  }
	
	  _createClass(AmazonCheckoutController, [{
	    key: 'checkoutItems',
	    value: function checkoutItems() {
	      if (this.upsell === true) {
	        return this.upsellArray;
	      }
	
	      return this.cart.contents();
	    }
	  }, {
	    key: 'processPayment',
	    value: function processPayment() {
	      var _this2 = this;
	
	      this.isProcessing = true;
	
	      if (this.upsell) {
	        this.analytics.placeOrder({ option: 'Amazon', upsell: true });
	      } else {
	        this.analytics.placeOrder({ option: 'Amazon', upsell: false, cart: this.cart.contentsAsCampaignProducts() });
	      }
	
	      this.cart.processAmazonPaymentCart(this._$params.id, this.orderReferenceID).then(function (res) {
	        _this2._storage.removeLocalItem('order-credentials');
	        _this2._storage.setLocalItem('order-credentials', res.order_id + ':' + res.zip_code);
	        _this2._$window.location.href = '/purchase/thank-you';
	      }).catch(function (res) {
	        _this2._errorHandler.throwError('Payment Processing', res && res.message ? res.message : 'Error processing Amazon payment.');
	        _this2.isProcessing = false;
	      });
	    }
	  }, {
	    key: 'goBack',
	    value: function goBack() {
	      this._$window.history.back();
	    }
	  }, {
	    key: '_initializeAmazonWidgets',
	    value: function _initializeAmazonWidgets() {
	      var _this3 = this;
	
	      var initDeferred = this._$q.defer();
	
	      new OffAmazonPayments.Widgets.AddressBook({
	        sellerId: _config2.default['Amazon']['sellerID'],
	        design: {
	          designMode: 'responsive'
	        },
	        onOrderReferenceCreate: function onOrderReferenceCreate(orderRef) {
	          _this3.orderReferenceID = orderRef.getAmazonOrderReferenceId();
	          initDeferred.resolve();
	        },
	        onAddressSelect: function onAddressSelect() {
	          _this3.addressSelected = true;
	          _this3.cart.getAmazonTotals(_this3.amazonReferenceId, _this3.orderReferenceID);
	        },
	        onError: function onError(error) {
	          _this3._errorHandler.logError('Amazon Address Error', error.getErrorCode() + ' - ' + error.getErrorMessage(), error);
	          _this3._$window.location.href = _this3._$params.csl;
	        }
	      }).bind('amazon_address_book');
	
	      new OffAmazonPayments.Widgets.Wallet({
	        sellerId: _config2.default['Amazon']['sellerID'],
	        design: {
	          designMode: 'responsive'
	        },
	        onPaymentSelect: function onPaymentSelect() {
	          return _this3.paymentSelected = true;
	        },
	        onError: function onError(error) {
	          _this3._errorHandler.logError('Amazon Wallet Error', error.getErrorCode() + ' - ' + error.getErrorMessage(), error);
	          _this3._$window.location.href = _this3._$params.csl;
	        }
	      }).bind("amazon_wallet_widget");
	
	      return initDeferred.promise;
	    }
	  }]);
	
	  return AmazonCheckoutController;
	}()];

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(7);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _webstoragePolyfill = __webpack_require__(10);
	
	var _webstoragePolyfill2 = _interopRequireDefault(_webstoragePolyfill);
	
	var _config = __webpack_require__(2);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = ['$q', '$stateParams', '$location', '$window', '$scope', 'CartService', 'CartAPIService', 'UpsellCartService', 'StateTerritoryData', 'CurrencyService', 'ErrorHandler', function () {
	  function PayPalCheckoutCtrl($q, $params, $location, $window, $scope, cartService, cartAPIService, upsellCartService, stateTerritoryData, currency, errorHandler) {
	    var _this = this;
	
	    _classCallCheck(this, PayPalCheckoutCtrl);
	
	    this._$window = $window;
	    this._$location = $location;
	    this._$scope = $scope;
	    this._cartAPI = cartAPIService;
	    this._storage = new _webstoragePolyfill2.default();
	    this._stateTerritoryData = stateTerritoryData;
	    this._username = $params.pn;
	    this._campaignSlug = $params.sl;
	    this.upsell = $params.upsell === 'true';
	    this._errorHandler = errorHandler;
	
	    this._payerID = $location.search().PayerID;
	    this._paymentID = $location.search().paymentId;
	
	    this.currency = currency;
	
	    if (!this._payerID || !this._paymentID || !this._username || !this._campaignSlug) {
	      this.goBack();
	      return;
	    }
	
	    $params.pn = null;
	    $params.sl = null;
	    $location.search('PayerID', null);
	    $location.search('paymentId', null);
	    $location.search('token', null);
	    $location.replace();
	
	    this.isProcessing = true;
	
	    var cartPromise = void 0;
	    if (this.upsell) {
	      var upsellPayload = JSON.parse(this._storage.getLocalItem('paypal-upsell'));
	      this._storage.removeLocalItem('paypal-upsell');
	      this.cart = upsellCartService;
	      cartPromise = this.cart.initPaypal(this._username, this._campaignSlug, [upsellPayload.product], upsellPayload.originalID);
	    } else {
	      this.cart = cartService;
	      cartPromise = this.cart.init(this._username, this._campaignSlug);
	    }
	
	    cartPromise.then(function (data) {
	      _this.cartTotals = _this.cart.getTotals();
	      _this.campaign = data.campaign;
	    }).catch(function () {
	      return _this.goBack();
	    });
	
	    var paypalPromise = this._cartAPI.paypalPaymentResource(this._paymentID);
	    paypalPromise.catch(function () {
	      return _this.goBack();
	    });
	
	    var currencyInit = this.currency.init();
	
	    $q.all([cartPromise, paypalPromise, currencyInit]).then(function (res) {
	      // if there is nothing returned from the paypalPromise, then an error has occurred.
	      if (Object.keys(res[1]).length) {
	
	        _this.shippingAddress = res[1].shipping_address;
	        var country = _this.shippingAddress.country_code;
	        _this.currency.setCountry(country);
	
	        _this.campaign = res[0].campaign;
	        if (country !== 'US') {
	          _lodash2.default.each(_this.cart.contents(), function (cartProduct) {
	            _lodash2.default.each(_this.campaign.products, function (campaignProduct) {
	              if (cartProduct.cpid === campaignProduct.id) {
	                if (campaignProduct.product.us_only) _this.usOnly = true;
	                return false;
	              }
	            });
	            if (_this.usOnly) return false;
	          });
	        }
	
	        return country === 'US' ? _this.cart.setCountry(country, _this.shippingAddress.state) : _this.cart.setCountry(country);
	      } else _this.goBack();
	    }).then(function () {
	      return _this.cartTotals = _this.cart.getTotals();
	    }).finally(function () {
	      return _this.isProcessing = false;
	    });
	  }
	
	  _createClass(PayPalCheckoutCtrl, [{
	    key: 'goBack',
	    value: function goBack() {
	      var cancel = this._storage.getLocalItem('paypal-cancel');
	      if (!cancel) this._$window.history.back();else this._$window.location.href = cancel;
	    }
	  }, {
	    key: 'confirm',
	    value: function confirm() {
	      var _this2 = this;
	
	      this.isProcessing = true;
	
	      if (this.upsell) {
	        this.placeOrder();
	      } else {
	        this.cart.validateCouponBeforeCheckout().then(function () {
	          return _this2.placeOrder();
	        }).catch(function (err) {
	          _this2.showCouponInvalidModal = err && typeof err.valid !== 'undefined';
	          _this2.isProcessing = false;
	        });
	      }
	    }
	  }, {
	    key: 'placeOrder',
	    value: function placeOrder() {
	      var _this3 = this;
	
	      this.isProcessing = true;
	
	      this._cartAPI.placePaypalOrder({
	        payer_id: this._payerID,
	        payment_id: this._paymentID
	      }).then(function (res) {
	        _this3._storage.removeLocalItem('order-credentials');
	        _this3._storage.setLocalItem('order-credentials', res.order_num + ':' + res.zip);
	        _this3._$location.search('pn', null);
	        _this3._$location.search('sl', null);
	        _this3._$location.search('upsell', null);
	        _this3._$location.path('/purchase/thank-you').replace();
	      }).catch(function (err) {
	        _this3._errorHandler.throwError('PayPal Payment Error', 'An error occurred while attempting to process PayPal order.', { err: err });
	        _this3.goBack();
	      });
	    }
	  }, {
	    key: 'fullCountry',
	    value: function fullCountry() {
	      var countries = this._stateTerritoryData.getCountries();
	      return _lodash2.default.find(countries, 'code', this.shippingAddress.country_code).country;
	    }
	  }, {
	    key: 'fullState',
	    value: function fullState() {
	      var states = this._stateTerritoryData.getExtendedStates(),
	          provinces = this._stateTerritoryData.getProvinces();
	
	      if (this.shippingAddress.country_code === 'US') {
	        var state = _lodash2.default.find(states, 'StateCode', this.shippingAddress.state);
	        return state ? state.Name : this.shippingAddress.state;
	      }
	      if (this.shippingAddress.country_code === 'CA') {
	        var province = _lodash2.default.find(provinces, 'StateCode', this.shippingAddress.state);
	        return province ? province.Name : this.shippingAddress.state;
	      }
	
	      return this.shippingAddress.state;
	    }
	  }]);
	
	  return PayPalCheckoutCtrl;
	}()];

/***/ }),
/* 126 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = ['$state', 'OrderService', 'ErrorHandler', function () {
	  function TrackOrderController($state, orderService, errorHandler) {
	    _classCallCheck(this, TrackOrderController);
	
	    this._orderService = orderService;
	    this._errorHandler = errorHandler;
	    this._$state = $state;
	
	    this.orderNumber = '';
	    this.billingZip = '';
	  }
	
	  _createClass(TrackOrderController, [{
	    key: 'getOrderDetails',
	    value: function getOrderDetails(isValid) {
	      var _this = this;
	
	      if (isValid) {
	        this.submitState = 'loading';
	        this._orderService.getBaseOrder('VS' + this.orderNumber, this.billingZip).then(function (res) {
	          return _this.lookupSuccess(res);
	        }).catch(function (err) {
	          return _this.lookupError(err);
	        });
	      }
	    }
	  }, {
	    key: 'lookupSuccess',
	    value: function lookupSuccess(res) {
	      this.submitState = 'success';
	
	      this._$state.go('order-summary', { order: res });
	    }
	  }, {
	    key: 'lookupError',
	    value: function lookupError(err) {
	      var message = err && err.data && err.data.message ? err.data.message : 'Encountered an error while attempting to retrieve order.';
	      this.submitState = 'error';
	      this._errorHandler.throwError('Order Lookup Error', message, { orderNumber: this.orderNumber, billingZip: this.billingZip, rawError: err });
	    }
	  }, {
	    key: 'setOrderNumPrefix',
	    value: function setOrderNumPrefix() {
	      if (this.orderNumber.indexOf('VS') === -1) {
	        this.orderNumber += 'VS';
	      }
	    }
	  }]);
	
	  return TrackOrderController;
	}()];

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _product = __webpack_require__(22);
	
	var _product2 = _interopRequireDefault(_product);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = ['$q', '$window', '$stateParams', '$state', '$scope', 'OrderService', 'CurrencyService', 'ErrorHandler', function () {
	  function OrderSummaryController($q, $window, $params, $state, $scope, OrderService, CurrencyService, ErrorHandler) {
	    var _this = this;
	
	    _classCallCheck(this, OrderSummaryController);
	
	    this._$q = $q;
	    this._$window = $window;
	    this._$scope = $scope;
	    this.order = $params.order;
	    this._orderService = OrderService;
	    this._errorHandler = ErrorHandler;
	    this.currency = CurrencyService;
	
	    this.activeStatuses = [];
	    this.processing = true;
	
	    if ($params.order_num && $params.zip) {
	      this._orderService.getBaseOrder($params.order_num, $params.zip).then(function (res) {
	        _this.orderObj = res;
	        _this.order = res.base;
	        _this.upsells = res.upsells;
	        _this._initOrderSummary();
	        _.defer(function () {
	          if ($params.ca) _this.changeAddress($params.order_num);
	        });
	        $state.go('order-summary', { order_num: null, zip: null, ca: null }, { notify: false, reload: false, location: 'replace' });
	      }).catch(function (err) {
	        return _this._errorHandler.throwError('Order Lookup Error', err && err.data && err.data.message ? err.data.message : 'Encountered an error while attempting to retrieve order.');
	      });
	    } else if ($params.order) {
	      this.orderObj = $params.order;
	      this.order = $params.order.base;
	      this.upsells = $params.order.upsells;
	      this._initOrderSummary();
	    } else {
	      $state.go('track-order');
	    }
	  }
	
	  _createClass(OrderSummaryController, [{
	    key: '_initOrderSummary',
	    value: function _initOrderSummary() {
	      var _this2 = this;
	
	      this.currency.setCountry(this.order.order_customer.address.country);
	
	      this._setActiveStatuses();
	      this._calculateDiscount();
	
	      this._fetchOrderHistoryAndShipmentDetails().finally(function () {
	        return _this2.processing = false;
	      });
	    }
	  }, {
	    key: '_fetchOrderHistoryAndShipmentDetails',
	    value: function _fetchOrderHistoryAndShipmentDetails() {
	      var _this3 = this;
	
	      var historyPromise = void 0,
	          shipmentPromise = void 0,
	          tempHistoryPromise = void 0,
	          tempShipmentPromise = void 0,
	          upsellHistoryPromises = [],
	          upsellShipmentPromises = [];
	
	      historyPromise = this._orderService.getTrackingHistoryByOrderNumber(this.order.order_num);
	      historyPromise.then(function (res) {
	        return _this3.order.history = res;
	      }).catch(function (err) {
	        return _this3._errorHandler.throwError('Tracking History Error', 'An error occurred while looking up tracking history.', {
	          rawError: err
	        });
	      });
	
	      shipmentPromise = this._orderService.getShipmentDetailsByOrderNumber(this.order.order_num);
	      shipmentPromise.then(function (res) {
	        _this3.order.shipment = res;
	
	        if (_this3.order.shipment && _this3.order.shipment.courier_tracking_code) {
	          _this3.order.shipment.courier_tracking_code = _this3.order.shipment.courier_tracking_code.trim();
	        }
	      }).catch(function (err) {
	        return _this3._errorHandler.throwError('Shipment Error', 'An error occurred while looking up shipment information.', {
	          rawError: err
	        });
	      });
	
	      if (this.upsells.length) {
	        _.forEach(this.upsells, function (order) {
	          tempHistoryPromise = _this3._orderService.getTrackingHistoryByOrderNumber(order.order_num);
	          tempHistoryPromise.then(function (res) {
	            return order.history = res;
	          }).catch(function (err) {
	            return _this3._errorHandler.throwError('Tracking History Error', 'An error occurred while looking up tracking history.', {
	              rawError: err
	            });
	          });
	
	          tempShipmentPromise = _this3._orderService.getShipmentDetailsByOrderNumber(order.order_num);
	          tempShipmentPromise.then(function (res) {
	            order.shipment = res;
	
	            if (order.shipment && order.shipment.courier_tracking_code) {
	              order.shipment.courier_tracking_code = order.shipment.courier_tracking_code.trim();
	            }
	          }).catch(function (err) {
	            return _this3._errorHandler.throwError('Shipment Error', 'An error occurred while looking up shipment information.', {
	              rawError: err
	            });
	          });
	          upsellHistoryPromises.push(tempHistoryPromise);
	          upsellShipmentPromises.push(tempShipmentPromise);
	        });
	      }
	
	      return this.upsells.length ? this._$q.all(_.flatten([historyPromise, shipmentPromise, upsellHistoryPromises, upsellShipmentPromises])) : this._$q.all([historyPromise, shipmentPromise]);
	    }
	  }, {
	    key: 'formatDate',
	    value: function formatDate(date) {
	      return this._$window.moment(date).format('MM/DD/YY');
	    }
	  }, {
	    key: 'print',
	    value: function print() {
	      this._$window.print();
	    }
	  }, {
	    key: 'sizeDisplay',
	    value: function sizeDisplay(product) {
	      return _product2.default.sizeDisplay(product.campaign_product.product, product.size);
	    }
	  }, {
	    key: 'changeAddress',
	    value: function changeAddress(index) {
	      this._$scope.$broadcast('show:changeAddress', index);
	    }
	  }, {
	    key: '_calculateDiscount',
	    value: function _calculateDiscount() {
	      if (this.order && this.order.coupon) {
	        var discount = parseFloat(this.order.coupon.discount);
	        var discountTotal = 0.0;
	
	        switch (this.order.coupon.discount_type) {
	          case 'PERCENTAGE':
	            for (var i = 0, product; product = this.order.order_products[i++];) {
	              discountTotal += product.price * product.quantity * (discount / 100);
	            }
	            break;
	          case 'MONEY':
	            discountTotal = discount;
	            break;
	        }
	
	        this.order.discount = discountTotal;
	      }
	    }
	  }, {
	    key: '_setActiveStatuses',
	    value: function _setActiveStatuses() {
	      switch (this.order.status) {
	        case 'ORDER_PLACED':
	          this.activeStatuses = ['APPROVED'];
	          break;
	        case 'PRINTING':
	          this.activeStatuses = ['APPROVED', 'PRINTING'];
	          break;
	        case 'SHIPPED':
	          this.activeStatuses = ['APPROVED', 'PRINTING', 'SHIPPED'];
	          break;
	        case 'DELIVERED':
	          this.activeStatuses = ['APPROVED', 'PRINTING', 'SHIPPED', 'DELIVERED'];
	          break;
	        default:
	          this.activeStatuses = [];
	          break;
	      }
	    }
	  }]);
	
	  return OrderSummaryController;
	}()];

/***/ }),
/* 128 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = ['ApplicationConfigData', function ContactController(applicationConfigData) {
	  _classCallCheck(this, ContactController);
	
	  this.config = applicationConfigData.getConfig();
	}];

/***/ }),
/* 129 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = ['ApplicationConfigData', function PrivacyPolicyController(applicationConfigData) {
	  _classCallCheck(this, PrivacyPolicyController);
	
	  this.config = applicationConfigData.getConfig();
	}];

/***/ }),
/* 130 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = ['ApplicationConfigData', function CookiePolicyController(applicationConfigData) {
	  _classCallCheck(this, CookiePolicyController);
	
	  this.config = applicationConfigData.getConfig();
	}];

/***/ }),
/* 131 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = ['ApplicationConfigData', function TermsController(applicationConfigData) {
	  _classCallCheck(this, TermsController);
	
	  this.config = applicationConfigData.getConfig();
	}];

/***/ }),
/* 132 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = ['AuthService', '$location', '$window', 'ErrorHandler', function () {
	  function ResetPasswordController(authService, $location, $window, errorHandler) {
	    _classCallCheck(this, ResetPasswordController);
	
	    this._authService = authService;
	    this._$location = $location;
	    this._$window = $window;
	    this._errorHandler = errorHandler;
	
	    this.token = this._$location.path().split('/')[2];
	  }
	
	  _createClass(ResetPasswordController, [{
	    key: 'resetPassword',
	    value: function resetPassword(isValid) {
	      var _this = this;
	
	      if (isValid) {
	        this.submitState = 'loading';
	        this._authService.resetPassword(this.password, this.token).then(function (res) {
	          return _this.resetPasswordSuccess(res);
	        }).catch(function (err) {
	          return _this.resetPasswordError(err);
	        });
	      }
	    }
	  }, {
	    key: 'resetPasswordSuccess',
	    value: function resetPasswordSuccess(res) {
	      this.submitState = 'success';
	      this._$window.location.href = '/';
	    }
	  }, {
	    key: 'resetPasswordError',
	    value: function resetPasswordError(err) {
	      this.submitState = 'error';
	      this._errorHandler.throwError('Reset Password Error', err && err.data && err.data.message ? err.data.message : 'Error resetting password. Please contact support.');
	    }
	  }]);
	
	  return ResetPasswordController;
	}()];

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(7);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _webstoragePolyfill = __webpack_require__(10);
	
	var _webstoragePolyfill2 = _interopRequireDefault(_webstoragePolyfill);
	
	var _analytics = __webpack_require__(13);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	var _product = __webpack_require__(22);
	
	var _product2 = _interopRequireDefault(_product);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = ['$scope', '$q', '$window', '$sce', '$interval', '$state', '$filter', 'CampaignService', 'ResourceService', 'ErrorHandler', 'CurrencyService', function () {
	  function UpsellCtrl($scope, $q, $window, $sce, $interval, $state, $filter, CampaignService, ResourceService, ErrorHandler, CurrencyService) {
	    var webstorage = arguments.length > 11 && arguments[11] !== undefined ? arguments[11] : new _webstoragePolyfill2.default();
	    var analytics = arguments.length > 12 && arguments[12] !== undefined ? arguments[12] : new _analytics2.default();
	
	    _classCallCheck(this, UpsellCtrl);
	
	    this._$scope = $scope;
	    this._$q = $q;
	    this._$window = $window;
	    this._$sce = $sce;
	    this._$interval = $interval;
	    this._$state = $state;
	    this._$filter = $filter;
	    this._campaignService = CampaignService;
	    this._resourceService = ResourceService;
	    this._errorHandler = ErrorHandler;
	    this._storage = webstorage;
	    this.campaign = null;
	    this.processing = false;
	    this.discount = 0;
	    this.formattedProduct = { quantity: 1, qty: 1 };
	    this.previousUpsells = [];
	    this.endTime = {};
	    this.ended = false;
	    this.currency = CurrencyService;
	    this.analytics = analytics;
	  }
	
	  _createClass(UpsellCtrl, [{
	    key: 'init',
	    value: function init(campaignID, country) {
	      var _this = this;
	
	      this.disableButton = false;
	      this.upsellStorage = 'upsells-' + campaignID;
	      this.previousUpsells = JSON.parse(this._storage.getLocalItem(this.upsellStorage)) || [];
	      if (!Array.isArray(this.previousUpsells)) this.previousUpsells = [];
	
	      var deferred = this._$q.defer();
	
	      if (this.previousUpsells.length < 2) {
	        this._campaignService.getUpsells(campaignID, this.previousUpsells, country).then(function (data) {
	          _this.discount = data.discount;
	          _this.campaign = data.campaign;
	          _this.campaign.products = _product2.default.filterInactiveProducts(_this.campaign.products);
	          _this.previousUpsells.push(data.id);
	          _this.campaignsProductId = data.campaigns_product_id;
	          _this.defaultSide = data.default_side;
	          _this.shipping = data.upsell_shipping_cost;
	
	          _this._setCountdown();
	          _this._setDefaultSelections();
	          _this._watchForGroupChange();
	          _this.viewedUpsell();
	
	          deferred.resolve();
	        });
	      } else {
	        deferred.reject();
	      }
	
	      return deferred.promise;
	    }
	  }, {
	    key: 'campaignDescription',
	    value: function campaignDescription() {
	      return this._$sce.trustAsHtml(this.campaign.description);
	    }
	  }, {
	    key: 'paypalCheckout',
	    value: function paypalCheckout() {
	      if (!this.selectedSize) {
	        this.upsellSubmitted = true;
	      } else {
	        this.disableButton = true;
	      }
	    }
	  }, {
	    key: 'checkout',
	    value: function checkout() {
	      var _this2 = this;
	
	      if (!this.selectedSize) {
	        this.upsellSubmitted = true;
	      } else {
	        if (this.paymentMethod !== 'STRIPE' && this.paymentMethod !== 'BRAINTREE' && this.paymentMethod !== 'WORLDPAY') return;
	        if (this.disableButton) return;
	        this.disableButton = true;
	
	        var method = void 0;
	        switch (this.paymentMethod) {
	          case 'STRIPE':
	            method = 'Stripe';
	            break;
	          case 'BRAINTREE':
	            method = 'Braintree';
	            break;
	          case 'WORLDPAY':
	            method = 'Worldpay';
	            break;
	        }
	
	        this.analytics.checkout({ option: method, upsell: true });
	
	        var payload = {
	          product_id: this.selectedProduct.id,
	          size: this.selectedSize,
	          quantity: 1,
	          discount: this.discount,
	          campaign_id: this.campaignId,
	          upsell_campaign_id: this.campaign.id,
	          original_order_id: this.orderId
	        };
	
	        this._resourceService.legacyGet('/token').then(function (res) {
	          return payload._token = res.token;
	        }).then(function () {
	          return _this2._resourceService.legacyPost('/purchase/checkout-upsell', payload);
	        }).then(function (res) {
	          _this2._storage.removeLocalItem('order-credentials');
	          _this2._storage.setLocalItem('order-credentials', res.order_num + ':' + res.customer.zip);
	          _this2.analytics.placeOrder({ option: method, upsell: true });
	
	          _this2._$state.go('thank-you', {
	            password: null //prevents duplicate login
	          }, { reload: true });
	        }).catch(function () {
	          _this2._errorHandler.throwError('Order Error', 'There was an error adding this item to your order.');
	          _this2.disableButton = false;
	        });
	      }
	    }
	  }, {
	    key: 'formatSelectedProduct',
	    value: function formatSelectedProduct() {
	      this.formattedProduct.cid = this.campaign.id;
	      this.formattedProduct.product_id = this.selectedProduct.id;
	      this.formattedProduct.cpid = this.selectedProduct.id;
	      this.formattedProduct.size = this.selectedSize;
	      this.formattedProduct.name = this.selectedProduct.product.name;
	      this.formattedProduct.thumbnail = this.selectedProduct.assets.front_thumbnail;
	
	      if (this.selectedProduct.color.name != null && this.selectedProduct.color.name != '') {
	        this.formattedProduct.name = this.selectedProduct.color.name + ' ' + this.formattedProduct.name;
	      }
	
	      return this.formattedProduct;
	    }
	  }, {
	    key: 'productGroups',
	    value: function productGroups() {
	      var _this3 = this;
	
	      var unique = _lodash2.default.uniq(this.campaign.products, function (p) {
	        return p.product.id;
	      });
	      var groups = [];
	
	      _lodash2.default.forEach(unique, function (u) {
	        var displayPrice = _this3.productDiscountedPrice(u) * _this3.currency.info.conversion_rate;
	
	        groups.push({
	          label: u.product.name + ' - ' + _this3._$filter('currency')(displayPrice, _this3.currency.info.currency_symbol),
	          id: u.product.id
	        });
	      });
	
	      return groups;
	    }
	  }, {
	    key: 'productColors',
	    value: function productColors() {
	      var productID = this.selectedProduct.product.id;
	      var products = _lodash2.default.filter(this.campaign.products, function (p) {
	        return _lodash2.default.has(p, 'product.id') && p.product.id === productID;
	      });
	
	      return products;
	    }
	  }, {
	    key: 'productSizes',
	    value: function productSizes() {
	      return this.selectedProduct.product.sizes;
	    }
	  }, {
	    key: 'productPrice',
	    value: function productPrice(product) {
	      var p = product || this.selectedProduct;
	      var upcharge = p.product.upcharges[this.selectedSize] || 0;
	      return parseFloat(p.selling_price) + parseFloat(upcharge);
	    }
	  }, {
	    key: 'productDiscountedPrice',
	    value: function productDiscountedPrice(product) {
	      return this.productPrice(product) - parseFloat(this.discount);
	    }
	  }, {
	    key: 'productImage',
	    value: function productImage(product) {
	      var p = product || this.selectedProduct;
	      if (this.defaultSide === 'BACK') {
	        return p.assets.back_url;
	      }
	      return p.assets.front_url;
	    }
	  }, {
	    key: '_setCountdown',
	    value: function _setCountdown() {
	      var _this4 = this;
	
	      var end = moment(new Date()).add(5, 'minutes');
	      this._setCountdownDisplay(end);
	
	      this.countdown = this._$interval(function () {
	        var now = moment(new Date());
	        if (end - now <= 0) {
	          _this4._$interval.cancel(_this4.countdown);
	          _this4.ended = true;
	          if (typeof _this4.closeUpsell === 'function') {
	            _this4.closeUpsell();
	          }
	          return;
	        }
	        _this4._setCountdownDisplay(end);
	      }, 251);
	    }
	  }, {
	    key: 'stopCountdown',
	    value: function stopCountdown() {
	      if (this.countdown) {
	        this._$interval.cancel(this.countdown);
	      }
	    }
	  }, {
	    key: '_setCountdownDisplay',
	    value: function _setCountdownDisplay(end) {
	      var now = moment(new Date());
	
	      var days = (end - now) / (1000 * 60 * 60 * 24);
	      var hours = (days - Math.floor(days)) * 24;
	      var minutes = (hours - Math.floor(hours)) * 60;
	      var seconds = (minutes - Math.floor(minutes)) * 60;
	
	      this.ended = false;
	      this.endTime.days = Math.floor(days);
	      this.endTime.hours = Math.floor(hours);
	      this.endTime.minutes = Math.floor(minutes);
	      this.endTime.seconds = Math.floor(seconds);
	
	      if (this.endTime.seconds < 10) {
	        this.endTime.seconds = '0' + this.endTime.seconds;
	      }
	    }
	  }, {
	    key: '_setDefaultSelections',
	    value: function _setDefaultSelections() {
	      var _this5 = this;
	
	      this.selectedProduct = _product2.default.defaultUpsellProduct(this.campaign.products, this.campaignsProductId);
	      this.selectedSize = this.selectedProduct.product.sizes.length > 1 ? null : this.selectedProduct.product.sizes[0];
	      this.selectedGroup = _lodash2.default.find(this.productGroups(), function (group) {
	        return group.id === _this5.selectedProduct.product.id;
	      });
	    }
	  }, {
	    key: '_watchForGroupChange',
	    value: function _watchForGroupChange() {
	      var _this6 = this;
	
	      this._$scope.$watch(function () {
	        return _this6.selectedGroup;
	      }, function (group, oldGroup) {
	        if (group.id === oldGroup.id) return;
	
	        _this6.selectedProduct = _lodash2.default.find(_this6.campaign.products, function (product) {
	          return product.product.id === group.id;
	        });
	        if (!_lodash2.default.find(_this6.productSizes(), _this6.selectedSize)) {
	          _this6.selectedSize = _this6.selectedProduct.product.sizes.length > 1 ? null : _this6.selectedProduct.product.sizes[0];
	        }
	      });
	    }
	  }, {
	    key: '_preferredProduct',
	    value: function _preferredProduct() {
	      var _this7 = this;
	
	      var preferred = _lodash2.default.find(this.campaign.products, function (p) {
	        return _lodash2.default.includes(_this7.preferredProducts(), p.product.id);
	      });
	      if (!preferred) preferred = _product2.default.defaultUpsellProduct(this.campaign.products, this.campaignsProductId);
	      return preferred;
	    }
	  }, {
	    key: 'viewedUpsell',
	    value: function viewedUpsell() {
	      this._storage.setLocalItem(this.upsellStorage, JSON.stringify(this.previousUpsells));
	    }
	  }, {
	    key: 'isProductClock',
	    value: function isProductClock() {
	      return _product2.default.isProductClock(this.selectedProduct.product);
	    }
	  }, {
	    key: 'sizeDisplay',
	    value: function sizeDisplay(size) {
	      return _product2.default.sizeDisplay(this.selectedProduct.product, size);
	    }
	  }]);
	
	  return UpsellCtrl;
	}()];

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cdnPreprocessor = __webpack_require__(56);
	
	exports.default = [function campaignUpsell() {
	  return {
	    restrict: 'E',
	    scope: {
	      shippingCountry: '@',
	      campaignId: '@',
	      originalCampaignId: '@',
	      paymentMethod: '@',
	      orderId: '@'
	    },
	    bindToController: true,
	    controller: 'UpsellCtrl',
	    controllerAs: 'upsell',
	    templateUrl: (0, _cdnPreprocessor.cdnTemplate)('/upsell.html'),
	    link: function link(scope, el, attrs, ctrl) {
	      var initUpsellModal = function initUpsellModal() {
	        ctrl.init(scope.upsell.campaignId, scope.upsell.shippingCountry).then(function () {
	          return scope.upsellOpen = true;
	        });
	      };
	
	      scope.upsell.closeUpsell = function () {
	        scope.upsellOpen = false;
	        scope.upsell.stopCountdown();
	        initUpsellModal();
	      };
	
	      initUpsellModal();
	    }
	  };
	}];

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(7);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _webstoragePolyfill = __webpack_require__(10);
	
	var _webstoragePolyfill2 = _interopRequireDefault(_webstoragePolyfill);
	
	var _storeHistory = __webpack_require__(122);
	
	var _storeHistory2 = _interopRequireDefault(_storeHistory);
	
	var _product = __webpack_require__(22);
	
	var _product2 = _interopRequireDefault(_product);
	
	var _analytics = __webpack_require__(13);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	var _config = __webpack_require__(2);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = ['$rootScope', '$q', '$state', '$stateParams', '$location', '$window', 'OrderService', 'CampaignService', 'CustomerService', 'CartService', 'CartAPIService', 'ErrorHandler', 'AuthService', 'UserService', 'UserDataService', 'username', 'campaignSlug', 'CurrencyService', 'AbandonedCartService', function () {
	  function ThankYouController($rootScope, $q, $state, $params, $location, $window, orderService, campaignService, customerService, cartService, cartAPIService, errorHandler, authService, userService, userDataService, username, campaignSlug, CurrencyService, AbandonedCartService) {
	    var webstorage = arguments.length > 19 && arguments[19] !== undefined ? arguments[19] : new _webstoragePolyfill2.default();
	
	    var _this = this;
	
	    var storeHistory = arguments.length > 20 && arguments[20] !== undefined ? arguments[20] : new _storeHistory2.default();
	    var analytics = arguments.length > 21 && arguments[21] !== undefined ? arguments[21] : new _analytics2.default();
	
	    _classCallCheck(this, ThankYouController);
	
	    this._$rootScope = $rootScope;
	    this._$q = $q;
	    this._$state = $state;
	    this._$params = $params;
	    this._$location = $location;
	    this._$window = $window;
	    this._orderService = orderService;
	    this._campaignService = campaignService;
	    this._customerService = customerService;
	    this._cart = cartService;
	    this._cartAPIService = cartAPIService;
	    this.currency = CurrencyService;
	    this._errorHandler = errorHandler;
	    this._authService = authService;
	    this._userService = userService;
	    this._userDataService = userDataService;
	    this._username = username;
	    this._campaignSlug = campaignSlug;
	    this._abandonedCart = AbandonedCartService;
	    this._storage = webstorage;
	    this._storeHistory = storeHistory;
	    this.analytics = analytics;
	
	    this.months = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
	    this.orderID = $params.order_num;
	
	    this.isNotUpsell = false;
	    this.showChangeAddress = false;
	    this.phoneSaved = false;
	    this.isProcessing = true;
	    this.trackingCode = null;
	
	    this.promoOrders = [];
	    this.phone = '';
	
	    var numAndZip = this._storage.getLocalItem('order-credentials') || null;
	    if ($params.order_num && $params.zip) {
	      this.order_num = $params.order_num;
	      this.zip = $params.zip;
	      // this.password = $params.password;
	
	      this._$params.order_num = null;
	      this._$params.zip = null;
	    } else if (numAndZip !== null) {
	      numAndZip = numAndZip.split(':');
	      this.order_num = numAndZip[0];
	      this.zip = numAndZip[1];
	    }
	
	    this.firstThankYouView = !this._viewedThisThankYou();
	    this._initThankYou();
	
	    this.grecaptchaInterval = setInterval(function () {
	      if (_this._$window.grecaptcha && _this._$window.grecaptcha.render) {
	        _this.recaptchaRegisterId = _this._$window.grecaptcha.render('google_recaptcha_ty_register', {
	          sitekey: _config2.default.GOOGLE_RECAPTCHA_SITEKEY,
	          size: 'invisible',
	          callback: function callback(token) {
	            return _this.quickRegister(token);
	          }
	        });
	
	        _this.recaptchaLoginId = _this._$window.grecaptcha.render('google_recaptcha_ty_login', {
	          sitekey: _config2.default.GOOGLE_RECAPTCHA_SITEKEY,
	          size: 'invisible',
	          callback: function callback(token) {
	            return _this.linkOrder(token);
	          }
	        });
	
	        clearInterval(_this.grecaptchaInterval);
	
	        $('.g-recaptcha-response').attr('aria-label', 'google recaptcha');
	        $('.g-recaptcha-response').attr('aria-label', 'google recaptcha');
	      }
	    }, 100);
	  }
	
	  _createClass(ThankYouController, [{
	    key: '_initThankYou',
	    value: function _initThankYou() {
	      this.continueUrl = this._storeHistory.getLastStoreUrl();
	
	      if (this.order_num && this.zip) {
	        this._getThankYouDetails();
	      } else {
	        this._$window.location.href = this.continueUrl;
	      }
	    }
	  }, {
	    key: '_getThankYouDetails',
	    value: function _getThankYouDetails() {
	      var _this2 = this;
	
	      var promiseArray = [];
	
	      var fetchOrder = this._orderService.getBaseOrder(this.order_num, this.zip).then(function (res) {
	        return _this2.initOrder(res);
	      }).catch(function () {
	        return _this2._errorHandler.throwError('Order Error', 'We encountered an error while looking up your order, please try again.');
	      });
	      promiseArray.push(fetchOrder);
	
	      var fetchEstimatedDates = this._orderService.getFulfillmentDatesByOrderNumber(this.order_num).then(function (res) {
	        return _this2.initEstimatedDates(res);
	      }).catch(function () {
	        return _this2._errorHandler.throwError('Order Error:', 'We encountered an error while estimating dates for your order, please try again.');
	      });
	      promiseArray.push(fetchEstimatedDates);
	
	      this._$q.all(promiseArray).finally(function () {
	        return _this2.isProcessing = false;
	      });
	    }
	  }, {
	    key: 'initOrder',
	    value: function initOrder(res) {
	      var _this3 = this;
	
	      this.orderObj = res;
	      this.order = res.base;
	      this.promoOrders = res.upsells;
	
	      if (this.order_num === this.order['order_num']) {
	        this.isNotUpsell = true;
	      }
	
	      this.customer = this.order['order_customer'];
	      this.currency.setCountry(this.customer.address.country);
	
	      if (!this._username || !this._campaignSlug) {
	        this._username = this.order.campaign.creator.user_info.public_name;
	        this._campaignSlug = this.order.campaign.slug;
	      }
	
	      if (this.firstThankYouView) {
	        if (!res.upsells.length) {
	          this.analytics.thankYou(res.base);
	        } else {
	          if (this.order.transaction.payment_type === 'PAYPAL') this.analytics.placeOrder({ option: 'PayPal', upsell: true });
	          var upsellOrder = _lodash2.default.find(res.upsells, function (upsell) {
	            return upsell.order_num === _this3.order_num;
	          });
	          this.analytics.thankYou(null, upsellOrder);
	        }
	      }
	
	      this._abandonedCart.convertTrackedCart(this.customer.email, this.order_num);
	      this._cart.init(this._username, this._campaignSlug).then(function () {
	        _this3._cart.setCountry(_this3.customer.address.country);
	        if (_this3.order.transaction.payment_type === 'PAYPAL' && _this3.firstThankYouView && !res.upsells.length) _this3.analytics.placeOrder({ option: 'PayPal', cart: _this3._cart.contentsAsCampaignProducts() });
	      });
	      this.upsell = {
	        country: this.customer.address.country,
	        campaignId: this.order.campaign_id,
	        paymentMethod: this.order.transaction.payment_type,
	        orderId: res.base.order_num
	      };
	      this._cart.clearCart(this._username + '/' + this._campaignSlug);
	
	      this.analyticsOrder = _lodash2.default.find(_lodash2.default.flatten([this.order, this.promoOrders]), function (order) {
	        return order.order_num == _this3.order_num;
	      }) || this.order;
	
	      if (this.order.campaign.cobrand_id) {
	        this._$rootScope.$broadcast('partnership:showLogo', {
	          pid: this.order.campaign.cobrand_id
	        });
	      }
	
	      this._viewedThisThankYou(true);
	    }
	  }, {
	    key: 'initEstimatedDates',
	    value: function initEstimatedDates(res) {
	      this.estEnd = this._$window.moment(res.dates.campaign_end_date).format('MMM Do');
	      this.estPrint = this._$window.moment(res.dates.estimated_print_date).format('MMM Do');
	      this.estShip = this._$window.moment(res.dates.estimated_shipping_date).format('MMM Do');
	    }
	  }, {
	    key: 'updatePhone',
	    value: function updatePhone() {
	      var _this4 = this;
	
	      if (!_lodash2.default.has(this, 'customer.id')) {
	        this._errorHandler.throwError('Error Saving Phone', 'An error occurred while trying to save phone number. Please contact support.');
	        return;
	      }
	
	      this.isProcessing = true;
	
	      this._customerService.updatePhone(this.customer.id, this.phone, this.zip).then(function (data) {
	        _this4.customer = data;
	        _this4.phoneSaved = true;
	      }).catch(function () {
	        _this4._errorHandler.throwError('Error Saving Phone', 'An error occurred while trying to save phone number. Please contact support.');
	        _this4.phoneSaved = false;
	      }).finally(function () {
	        return _this4.isProcessing = false;
	      });
	    }
	  }, {
	    key: 'realProductPrice',
	    value: function realProductPrice(product) {
	      return product.campaign_product.selling_price + product.campaign_product.product.upcharges[product.size];
	    }
	  }, {
	    key: 'print',
	    value: function print() {
	      this._$window.print();
	    }
	  }, {
	    key: 'submitLogin',
	    value: function submitLogin(isValid) {
	      if (isValid) this._$window.grecaptcha.execute(this.recaptchaLoginId);
	    }
	  }, {
	    key: 'linkOrder',
	    value: function linkOrder(recaptchaToken) {
	      var _this5 = this;
	
	      this._$window.grecaptcha.reset(this.recaptchaLoginId);
	
	      this.isProcessing = true;
	
	      this._authService.login(this.customer.email, this.existingPassword, false, recaptchaToken).then(function (res) {
	        _this5._userDataService.setUserData(res, true);
	        _this5.existingCustomerLoggedIn = true;
	        _this5.userSlug = res.user.user_info.public_name;
	      }).then(function () {
	        return _this5._userService.linkOrder(_this5.userSlug, _this5.order_num, _this5.customer.email);
	      }).catch(function () {
	        return _this5._errorHandler.throwError('Login Error', 'An error has occurred while trying to log in. Please try again later.');
	      }).finally(function () {
	        return _this5.isProcessing = false;
	      });
	    }
	  }, {
	    key: 'goToSummary',
	    value: function goToSummary() {
	      this._$state.go('order-summary', {
	        order: this.orderObj
	      });
	    }
	  }, {
	    key: 'submitQuickRegister',
	    value: function submitQuickRegister(isValid) {
	      if (isValid) this._$window.grecaptcha.execute(this.recaptchaRegisterId);
	    }
	  }, {
	    key: 'quickRegister',
	    value: function quickRegister(recaptchaToken) {
	      var _this6 = this;
	
	      this._$window.grecaptcha.reset(this.recaptchaRegisterId);
	
	      this.isProcessing = true;
	      this._authService.quickRegister(this.order_num, this.password, recaptchaToken).then(function (res) {
	        _this6._userDataService.setUserData(res);
	        _this6.existingCustomerLoggedIn = true;
	        _this6.password = null;
	        _this6.userRegistered = true;
	      }).catch(function (err) {
	        return _this6._errorHandler.throwError('Registration Error', 'We encountered an error while attempting to register your account.', {
	          rawError: err
	        });
	      }).finally(function () {
	        return _this6.isProcessing = false;
	      });
	    }
	  }, {
	    key: 'sizeDisplay',
	    value: function sizeDisplay(product) {
	      return _product2.default.sizeDisplay(product.campaign_product.product, product.size);
	    }
	  }, {
	    key: '_viewedThisThankYou',
	    value: function _viewedThisThankYou(setValue) {
	      if (setValue === true) {
	        this._storage.setLocalItem('thank-you:' + this.order_num, 'true');
	      }
	      return this._storage.getLocalItem('thank-you:' + this.order_num) === 'true';
	    }
	  }]);
	
	  return ThankYouController;
	}()];

/***/ }),
/* 136 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = ['$window', function CareersController($window) {
	  _classCallCheck(this, CareersController);
	
	  var test = $window.whr_embed(7366, {
	    detail: 'titles',
	    base: 'jobs',
	    zoom: 'state',
	    grouping: 'none'
	  });
	}];

/***/ }),
/* 137 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = ['$state', '$rootScope', 'AuthService', function () {
	  function MyAccountCtrl($state, $rootScope, authService) {
	    _classCallCheck(this, MyAccountCtrl);
	
	    this._$state = $state;
	
	    authService.getCurrentUser().catch(function () {
	      return $rootScope.$broadcast('login:open', { route: '/my-account', cancelRedirect: '/' });
	    });
	  }
	
	  _createClass(MyAccountCtrl, [{
	    key: 'currentView',
	    value: function currentView() {
	      if (this._$state.is('my-account.default-address')) return 'address';
	      if (this._$state.is('my-account.payment-methods')) return 'payment';
	
	      return 'orders';
	    }
	  }, {
	    key: 'selectTab',
	    value: function selectTab(tab) {
	      if (tab === 'address') {
	        this._$state.go('my-account.default-address');
	      } else if (tab === 'payment') {
	        this._$state.go('my-account.payment-methods');
	      } else {
	        this._$state.go('my-account.order-history');
	      }
	    }
	  }]);
	
	  return MyAccountCtrl;
	}()];

/***/ }),
/* 138 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
	
	exports.default = ['$state', 'CustomerService', 'UserDataService', 'OrderService', 'ErrorHandler', function () {
	  function OrderHistoryCtrl($state, customerService, userData, orderService, errorHandler) {
	    var _this = this;
	
	    _classCallCheck(this, OrderHistoryCtrl);
	
	    this._$state = $state;
	    this._orderService = orderService;
	    this._errorHandler = errorHandler;
	
	    this.orders = [];
	    this.loading = true;
	    userData.getUserData().then(function (res) {
	      return _this.currentUser = res.user;
	    }).then(function () {
	      return customerService.getOrderHistory(_this.currentUser.user_info.public_name);
	    }).then(function (res) {
	      return _this.orders = res.results;
	    }).finally(function () {
	      return _this.loading = false;
	    });
	  }
	
	  _createClass(OrderHistoryCtrl, [{
	    key: 'viewDetails',
	    value: function viewDetails(order) {
	      var _this2 = this;
	
	      this._orderService.getBaseOrder(order.order_num, order.order_customer.address.zip).then(function (res) {
	        return _this2._$state.go('order-summary', { order: res });
	      }).catch(function (err) {
	        return _this2._errorHandler.throwError('Order Lookup Error', err && err.data && err.data.message ? err.data.message : 'Encountered an error while attempting to retrieve order.', {
	          rawError: err
	        });
	      });
	    }
	  }, {
	    key: 'itemss',
	    value: function itemss(items) {
	      if (items === 1) {
	        return items + ' item';
	      }
	      return items + ' items';
	    }
	  }, {
	    key: 'formatDate',
	    value: function formatDate(date) {
	      var d = new Date(date);
	      return months[d.getMonth()] + ' ' + d.getDate() + ', ' + d.getFullYear();
	    }
	  }, {
	    key: 'paymentMethod',
	    value: function paymentMethod(transaction) {
	      if (transaction.payment_type == 'PAYPAL') {
	        return 'PayPal';
	      }
	      if (transaction.payment_type == 'AMAZON') {
	        return 'Amazon';
	      }
	      return 'Credit Card';
	    }
	  }, {
	    key: 'formatAddress',
	    value: function formatAddress(address) {
	      var addrString = '';
	
	      addrString += address.street_1;
	      if (address.street_2) addrString += ' ' + address.street_2;
	      addrString += ', ' + address.city;
	      if (address.state) addrString += ', ' + address.state;
	      if (address.zip) addrString += ' ' + address.zip;
	      if (address.country && address.country != 'US') addrString += ' ' + address.country;
	
	      return addrString;
	    }
	  }]);
	
	  return OrderHistoryCtrl;
	}()];

/***/ }),
/* 139 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = ['UserService', 'UserDataService', 'StateTerritoryData', 'ErrorHandler', function () {
	  function DefaultAddressCtrl(userService, userData, states, errorHandler) {
	    var _this = this;
	
	    _classCallCheck(this, DefaultAddressCtrl);
	
	    this._userService = userService;
	    this._errors = errorHandler;
	
	    this.currentUser = {};
	    this.loading = true;
	    this.address = {};
	    this.edit = false;
	    this.noAddress = true;
	    this.thankYou = false;
	    this.originalZip = '00000';
	
	    this.countries = states.getCountries();
	    this.states = states.getExtendedStates();
	    this.provinces = states.getProvinces();
	
	    userData.getUserData().then(function (customer) {
	      _this.currentUser = customer.user;
	      if (customer.user.user_info.shipping_details.street_1) {
	        _this.address = customer.user.user_info.shipping_details;
	        _this.noAddress = false;
	        _this.originalZip = _this.address.zip;
	      } else {
	        _this.address.country = 'US';
	      }
	    }).catch(function () {
	      return _this._errors.throwError('Data Error', 'Unable to retrieve your saved address. Please try again in a few minutes.');
	    }).finally(function () {
	      return _this.loading = false;
	    });
	  }
	
	  _createClass(DefaultAddressCtrl, [{
	    key: 'submit',
	    value: function submit(valid) {
	      var _this2 = this;
	
	      if (valid) {
	        this.loading = true;
	        this._userService.updateAddress(this.currentUser.user_info.public_name, this.address.name, this.address.street_1, this.address.city, this.address.state, this.address.zip, this.address.country, this.address.mobile, this.address.street_2).then(function () {
	          _this2.thankYou = true;
	          _this2.noAddress = false;
	          _this2.edit = false;
	        }).catch(function () {
	          return _this2._errors.throwError('Save Address Error', 'We were unable to save your new address. Please try again in a few minutes.');
	        }).finally(function () {
	          return _this2.loading = false;
	        });
	      }
	    }
	  }, {
	    key: 'countryChanged',
	    value: function countryChanged() {
	      this.address.zip = '';
	      this.address.state = '';
	    }
	  }]);
	
	  return DefaultAddressCtrl;
	}()];

/***/ }),
/* 140 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = ['$window', 'CustomerService', 'UserDataService', 'CartService', function () {
	  function PaymentMethodsCtrl($window, customerService, userData, cartService) {
	    _classCallCheck(this, PaymentMethodsCtrl);
	
	    this._$window = $window;
	    this._customerService = customerService;
	    this._userData = userData;
	    this.cart = cartService;
	
	    this.monthRange = [];
	    this.yearRange = [];
	    this.popoverPath = 'assets/customer-ui/templates/cvv-help.html';
	
	    this._initCardData();
	    this._initSelectOptions();
	  }
	
	  _createClass(PaymentMethodsCtrl, [{
	    key: 'save',
	    value: function save(valid) {
	      var _this = this;
	
	      if (valid) {
	        var newCCToken;
	
	        this.loading = true;
	        this.cart.createCCTokenCart(this.card, this.currentUser.user_info.shipping_details).then(function (res) {
	          newCCToken = res.token;
	          if (_this.savedCard.id) {
	            return _this._customerService.removeSavedPaymentMethod(_this.currentUser.user_info.public_name, _this.savedCard.id);
	          }
	        }).then(function () {
	          return _this._customerService.updateSavedPaymentMethod(_this.currentUser.user_info.public_name, newCCToken, _this._cardLast4(), _this._cardBin());
	        }).then(function () {
	          return _this._initCardData();
	        }).finally(function () {
	          _this.loading = false;
	        });
	      }
	    }
	  }, {
	    key: 'delete',
	    value: function _delete() {
	      var _this2 = this;
	
	      var confirm = this._$window.confirm('Are you sure you want to delete this card?');
	      if (!confirm) return;
	
	      this.loading = true;
	      this._customerService.removeSavedPaymentMethod(this.currentUser.user_info.public_name, this.savedCard.id).then(function () {
	        return _this2._initCardData();
	      }).finally(function () {
	        _this2.loading = false;
	      });
	    }
	  }, {
	    key: '_initCardData',
	    value: function _initCardData() {
	      var _this3 = this;
	
	      this.savedCard = {};
	      this.none = false;
	      this.edit = false;
	
	      this.loading = true;
	      this._userData.getUserData().then(function (res) {
	        _this3.currentUser = res.user;
	        _this3.noAddress = !res.user.user_info.shipping_details.street_1;
	      }).then(function () {
	        return _this3._customerService.getSavedPaymentMethod(_this3.currentUser.user_info.public_name);
	      }).then(function (res) {
	        _this3.savedCard.last4 = res.last4;
	        _this3.savedCard.id = res.customer_id;
	      }).catch(function (error) {
	        if (error.status === 400) {
	          _this3.none = true;
	        }
	      }).finally(function () {
	        _this3.loading = false;
	      });
	    }
	  }, {
	    key: '_cardBin',
	    value: function _cardBin() {
	      return this._cleanNum().substr(0, 6);
	    }
	  }, {
	    key: '_cardLast4',
	    value: function _cardLast4() {
	      return this._cleanNum().substr(this._cleanNum().length - 4);
	    }
	  }, {
	    key: '_cleanNum',
	    value: function _cleanNum() {
	      return this.card.cc_num.replace(/\s/g, '');
	    }
	  }, {
	    key: '_initSelectOptions',
	    value: function _initSelectOptions() {
	      for (var i = 1; i < 13; i++) {
	        this.monthRange.push({
	          key: i,
	          value: i
	        });
	      }
	
	      var year = new Date().getFullYear();
	      this.yearRange.push({
	        key: year,
	        value: year
	      });
	      for (var _i = 1; _i < 10; _i++) {
	        this.yearRange.push({
	          key: year + _i,
	          value: year + _i
	        });
	      }
	    }
	  }]);
	
	  return PaymentMethodsCtrl;
	}()];

/***/ }),
/* 141 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = ['MarketplaceService', 'CampaignService', function () {
	  function TrendingProductsCtrl(marketplaceService, campaignService) {
	    var _this = this;
	
	    _classCallCheck(this, TrendingProductsCtrl);
	
	    this._campaignService = campaignService;
	    this.loading = true;
	
	    marketplaceService.productTypes().then(function (res) {
	      return _this._initProductTypes(res);
	    }).then(function () {
	      return _this._initAllTrendingTypes();
	    });
	  }
	
	  _createClass(TrendingProductsCtrl, [{
	    key: 'hasProducts',
	    value: function hasProducts(type) {
	      return Array.isArray(type.products) && type.products.length > 0;
	    }
	  }, {
	    key: '_initProductTypes',
	    value: function _initProductTypes(res) {
	      var productTypeArray = [];
	      productTypeArray.push({
	        id: null,
	        name: 'ALL'
	      });
	      for (var key in res) {
	        productTypeArray.push({
	          id: key,
	          name: res[key]
	        });
	      }
	      this.types = productTypeArray;
	    }
	  }, {
	    key: '_initAllTrendingTypes',
	    value: function _initAllTrendingTypes() {
	      var _this2 = this;
	
	      var _loop = function _loop() {
	        var type = _this2.types[i];
	        _this2._campaignService.getTrending(4, type.id).then(function (res) {
	          type.products = res;
	          _this2.loading = false;
	        });
	      };
	
	      for (var i = 0; i < this.types.length; i++) {
	        _loop();
	      }
	    }
	  }]);
	
	  return TrendingProductsCtrl;
	}()];

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _config = __webpack_require__(2);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _cdnPreprocessor = __webpack_require__(56);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = ['$stateProvider', '$locationProvider', '$sceDelegateProvider', 'uiMask.ConfigProvider', '$urlRouterProvider', function ($stateProvider, $locationProvider, $sceDelegateProvider, uiMaskConfigProvider, $urlRouterProvider) {
	  $urlRouterProvider.otherwise('/error');
	
	  $stateProvider.state('home', { url: '/' }).state('contact', { url: '/contact-us' }).state('faq', { url: '/faq' }).state('about', { url: '/about-us' }).state('partnerships', { url: '/partnership' }).state('press', { url: '/press' }).state('privacy', { url: '/privacy' }).state('terms', { url: '/terms' }).state('how-it-works', { url: '/how-it-works' }).state('features', { url: '/features' }).state('unsupported-browser', { url: '/unsupported-browser' }).state('careers', { url: '/careers' }).state('trending', { url: '/trending' }).state('featured', { url: '/featured' }).state('login', { url: '/login' }).state('register', { url: '/register' }).state('forgot-password', { url: '/forgot-password' }).state('my-account', {
	    abstract: true,
	    templateUrl: (0, _cdnPreprocessor.cdnTemplate)('/my-account.html'),
	    url: '/my-account'
	  }).state('my-account.order-history', {
	    url: '',
	    controller: 'OrderHistoryCtrl as history',
	    templateUrl: (0, _cdnPreprocessor.cdnTemplate)('/order-history.html')
	  }).state('my-account.default-address', {
	    url: '/default-address',
	    controller: 'DefaultAddressCtrl as default',
	    templateUrl: (0, _cdnPreprocessor.cdnTemplate)('/default-address.html')
	  }).state('my-account.payment-methods', {
	    url: '/payment-methods',
	    controller: 'PaymentMethodsCtrl as payment',
	    templateUrl: (0, _cdnPreprocessor.cdnTemplate)('/payment-methods.html')
	  }).state('password-reset', {
	    url: '/password-reset/{token}'
	  }).state('track-order', {
	    templateUrl: (0, _cdnPreprocessor.cdnTemplate)('/track-order.html'),
	    controller: 'TrackOrderCtrl as trackOrder',
	    url: '/track-order'
	  }).state('order-summary', {
	    templateUrl: (0, _cdnPreprocessor.cdnTemplate)('/order-summary.html'),
	    controller: 'OrderSummaryCtrl as summary',
	    url: '/order-summary?order_num&zip&ca',
	    params: {
	      order: null,
	      order_num: null,
	      zip: null,
	      ca: null
	    }
	  }).state('client-store', {
	    controller: 'ClientStoreCtrl as client',
	    url: '/store/{publicName}/{storeName}?coupon',
	    templateUrl: (0, _cdnPreprocessor.cdnTemplate)('/client-store.html')
	  }).state('checkout', {
	    controller: 'CheckoutCtrl as checkout',
	    url: '/purchase/checkout?pn&sl',
	    templateUrl: (0, _cdnPreprocessor.cdnTemplate)('/checkout.html'),
	    params: {
	      'pn': null,
	      'sl': null
	    }
	  }).state('amazon-checkout', {
	    controller: 'AmazonCheckoutCtrl as checkout',
	    url: '/purchase/amazon-checkout?id&session&csl',
	    templateUrl: (0, _cdnPreprocessor.cdnTemplate)('/amazon-checkout.html'),
	    params: {
	      'id': '',
	      'session': '',
	      'upsell': false,
	      'upsellProduct': null,
	      'username': null,
	      'campaign': null,
	      'csl': ''
	    },
	    resolve: {
	      username: ['$stateParams', function ($stateParams) {
	        return $stateParams.username;
	      }],
	      campaignSlug: ['$stateParams', function ($stateParams) {
	        return $stateParams.campaign;
	      }]
	    }
	  }).state('paypal-checkout', {
	    controller: 'PayPalCheckoutCtrl as checkout',
	    url: '/purchase/paypal-checkout?pn&sl&upsell',
	    templateUrl: (0, _cdnPreprocessor.cdnTemplate)('/paypal-checkout.html'),
	    params: {
	      'pn': null,
	      'sl': null,
	      'upsell': 'false'
	    }
	  }).state('thank-you', {
	    controller: 'ThankYouCtrl as thankYou',
	    url: '/purchase/thank-you?order_num&zip?paymentId?PayerID',
	    params: {
	      'order_num': null,
	      'zip': null,
	      'paymentId': null,
	      'PayerID': null,
	      'username': null,
	      'campaign': null
	      // 'password': null
	    },
	    templateUrl: (0, _cdnPreprocessor.cdnTemplate)('/thank-you.html'),
	    resolve: {
	      username: ['$stateParams', function ($stateParams) {
	        return $stateParams.username;
	      }],
	      campaignSlug: ['$stateParams', function ($stateParams) {
	        return $stateParams.campaign;
	      }]
	    }
	  }).state('sales-store', {
	    url: '/:username/:campaignSlug?coupon&opt_out',
	    template: __webpack_require__(143)(_cdnPreprocessor.jadeLocals),
	    controller: 'StoreCtrl as store',
	    resolve: {
	      username: ['$stateParams', function ($stateParams) {
	        return $stateParams.username;
	      }],
	      campaignSlug: ['$stateParams', function ($stateParams) {
	        return $stateParams.campaignSlug;
	      }]
	    }
	  }).state('error', { url: '/error' });
	
	  $locationProvider.html5Mode({
	    enabled: true,
	    rewriteLinks: false
	  });
	
	  $.ajaxSetup({
	    cache: true
	  });
	
	  var whitelist = ['self'];
	  if (_config2.default['Environment'] === 'Production') {
	    whitelist.push("https://a." + _config2.default['TemplatesUrl'] + "/**");
	    whitelist.push("https://b." + _config2.default['TemplatesUrl'] + "/**");
	    whitelist.push("https://c." + _config2.default['TemplatesUrl'] + "/**");
	  }
	  if (_config2.default['Environment'] === 'Staging') {
	    whitelist.push("https://dev-a." + _config2.default['TemplatesUrl'] + "/**");
	    whitelist.push("https://dev-b." + _config2.default['TemplatesUrl'] + "/**");
	    whitelist.push("https://dev-c." + _config2.default['TemplatesUrl'] + "/**");
	  }
	
	  $sceDelegateProvider.resourceUrlWhitelist(whitelist);
	
	  uiMaskConfigProvider.clearOnBlur(false);
	  uiMaskConfigProvider.allowInvalidValue(true);
	}];

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var jade = __webpack_require__(58);
	
	module.exports = function template(locals) {
	  var buf = [];
	  var jade_mixins = {};
	  var jade_interp;
	
	  buf.push("<section class=\"product-detail\"><campaign-states campaign=\"store.campaign\" copyright=\"store.copyrightViolation\" state=\"page.state\"></campaign-states><div ng-if=\"page.state === &quot;ready&quot;\" class=\"container-fluid\"><a ng-show=\"store.showBackButton\" href=\"\" ng-click=\"store.goBackToStore()\" class=\"back-to-store\"> <i class=\"fa fa-angle-left\"></i>&nbsp;Back to Store</a><div ng-if=\"store.cart.getCouponInfo().type === &quot;PERCENTAGE&quot;\" role=\"alert\" class=\"alert alert-vs hidden-xs hidden-sm coupon-animate\">Congratulations, a {{store.cart.getCouponInfo().amount}}% discount will be applied to your order.</div><div ng-if=\"store.cart.getCouponInfo().type === &quot;MONEY&quot;\" role=\"alert\" class=\"alert alert-vs hidden-xs hidden-sm coupon-animate\">Congratulations, a {{store.cart.getCouponInfo().amount * store.currency.info.conversion_rate | currency : store.currency.info.currency_symbol}} discount will be applied to your order.</div><div ng-if=\"store.optOutSuccess\" role=\"alert\" class=\"alert alert-vs coupon-animate\">You will no longer receive cart reminders for this product.</div><div ng-if=\"(store.selectedProduct.product.us_only || store.usOnlyProductInCart()) &amp;&amp; store.currency.info.country_code !== &quot;US&quot;\" role=\"alert\" class=\"alert alert-vs hidden-xs hidden-sm coupon-animate\">This {{store.usOnlyProductInCart() ? 'order' : 'product'}} is only available for delivery within the United States.</div><h1 class=\"page-title hidden-md hidden-lg\">{{store.campaign.name}}</h1><div class=\"rating hidden-md hidden-lg\"><ul class=\"list-star\"><li><span class=\"icons-star\"></span></li><li><span class=\"icons-star\"></span></li><li><span class=\"icons-star\"></span></li><li><span class=\"icons-star\"></span></li><li><span class=\"icons-star grey-star\"></span></li></ul><a>(1,481 Reviews)</a></div><div style=\"position:relative;\" class=\"row\"><div ng-if=\"store.campaign.flair.banner_url &amp;&amp; store.campaign.flair.banner_url != &quot;&quot;\" ng-style=\"{ backgroundColor: store.campaign.flair.background_color }\" class=\"flair flair-banner col-xs-12\"><img ng-src=\"{{store.campaign.flair.banner_url}}\" alt=\"campaign flair banner image\"></div><div class=\"price-banner hidden-md hidden-lg\">{{store.productPrice() * store.currency.info.conversion_rate | currency : store.currency.info.currency_symbol}}</div><product-display product=\"store.selectedProduct\" store-ref=\"store\" class=\"col-md-6 col-md-offset-1 col-sm-8 col-sm-offset-2\"></product-display><div class=\"col-md-4 col-md-offset-1\"><div ng-if=\"!!store.campaign.show_sales_timer || !!store.campaign.show_goal\" class=\"widget-box campaign-stats hidden-md hidden-lg\"><div ng-if=\"!!store.campaign.show_sales_timer\" class=\"campaign-countdown-timer\"><div class=\"countdown-component\"><div class=\"amount\">{{store.endTime.days}}</div><div class=\"unit\">Days</div></div><div class=\"countdown-component\"><div class=\"amount\">{{store.endTime.hours}}</div><div class=\"unit\">Hrs</div></div><div class=\"countdown-component\"><div class=\"amount\">{{store.endTime.minutes}}</div><div class=\"unit\">Mins</div></div><div class=\"countdown-component\"><div class=\"amount\">{{store.endTime.seconds}}</div><div class=\"unit\">Secs</div></div></div><div ng-if=\"store.campaign.show_goal &amp;&amp; !!store.campaign.order_count_goal\" class=\"campaign-progress\"><div class=\"sold-percentage-bar\"><div ng-style=\"{ width: store.campaignProgress() }\" class=\"progress-bar\"></div><div class=\"inside-count\">{{store.campaign.current_order_count}} of {{store.campaign.order_count_goal}} Sold</div></div></div></div><div class=\"cart\"><div class=\"cart__controls\"><h2 class=\"hidden-xs hidden-sm\">{{store.campaign.name}}</h2><span class=\"inc\"><span ng-if=\"store.selectedProduct.msrp &amp;&amp; store.selectedProduct.msrp &gt; store.selectedProduct.selling_price\"><span class=\"msrp-price\">{{store.productMsrpPrice() * store.currency.info.conversion_rate | currency : store.currency.info.currency_symbol}}</span><span>&nbsp;</span></span><div ng-class=\"{ &quot;hidden-xs&quot;: store.groups.length &gt; 1, &quot;hidden-sm&quot;: store.groups.length &gt; 1, &quot;msrp-visible&quot;: store.selectedProduct.msrp &amp;&amp; store.selectedProduct.msrp &gt; store.selectedProduct.selling_price }\"><span class=\"product-price\">{{store.productPrice() * store.currency.info.conversion_rate | currency : store.currency.info.currency_symbol}}&nbsp;</span><span class=\"value\">{{store.currency.info.iso_code}}</span><span ng-if=\"store.selectedProduct.msrp &amp;&amp; store.selectedProduct.msrp &gt; store.selectedProduct.selling_price &amp;&amp; store.productSavings() &gt; 0\" class=\"pull-right msrp-savings\">Save {{store.productSavings()}}%</span></div></span><div class=\"rating hidden-sm hidden-xs\"><ul class=\"list-star\"><li><span class=\"icons-star\"></span></li><li><span class=\"icons-star\"></span></li><li><span class=\"icons-star\"></span></li><li><span class=\"icons-star\"></span></li><li><span class=\"icons-star grey-star\"></span></li></ul><a>(102 Reviews)</a></div><div ng-if=\"store.productColors().length &gt; 1\" class=\"row-form\"><ul class=\"color-list\"><li ng-repeat=\"product in store.productColors()\" ng-click=\"store.colorChangeEvent(product)\" ng-class=\"{ active: product.id == store.selectedProduct.id }\" class=\"color\"><span ng-style=\"{ backgroundColor: product.product_color.hex }\" title=\"{{product.product_color.name}}\"></span></li></ul></div><div ng-show=\"store.groups.length &gt; 1 &amp;&amp; store.groups[0].group === &quot;Apparel&quot;\" class=\"row-form\"><div class=\"thumbnails\"><div class=\"thumbnails__container\"><div ng-repeat=\"group in store.groups\" ng-click=\"store.handleClickProductThumbnail(group)\" ng-class=\"{ &quot;thumbnails__item--active&quot;: store.selectedGroup.id === group.id }\" class=\"thumbnails__item\"><div class=\"thumbnails__overlay\"></div><img ng-src=\"{{group.thumbnail}}\" class=\"thumbnails__image\"></div></div></div></div><div ng-show=\"store.groups.length &gt; 1\" class=\"row-form\"><select ng-class=\"{ 'group-label-small-widescreen': store.selectedGroup.label.length &gt; 29, 'group-label-small-desktop': store.selectedGroup.label.length &gt; 24 }\" float-label-select small-size placeholder=\"Style\" ng-model=\"store.selectedGroup\" ng-options=\"group as group.label for group in store.groups track by group.id\"></select></div><div ng-show=\"store.groups.length === 1\" class=\"row-form\"><div class=\"product__name\">{{store.selectedProduct.product.name}}</div></div><form id=\"product_form\" novalidate ng-show=\"!store.ended\" name=\"store.productForm\" class=\"row-form\"><div class=\"two-columns\"><div ng-if=\"store.productSizes().length &gt; 1\" ng-class=\"{ &quot;has-error&quot;: store.productForm.size.$invalid &amp;&amp; store.productForm.$submitted }\" class=\"col\"><select id=\"size_select\" ng-if=\"!store.isProductClock()\" float-label-select small-size placeholder=\"Size\" ng-model=\"store.selectedSize\" ng-options=\"size for size in store.selectedProduct.product.sizes\" name=\"size\" required></select><select id=\"size_select\" ng-if=\"store.isProductClock()\" float-label-select small-size placeholder=\"Size\" ng-model=\"store.selectedSize\" ng-options=\"size.val as size.text for size in store.clockSizes\" name=\"size\" required></select><div ng-show=\"store.productForm.size.$invalid &amp;&amp; store.productForm.$submitted\" class=\"help-block form-text\">Choose a size.</div></div><div class=\"col\"><select float-label-select small-size placeholder=\"Qty\" ng-model=\"store.selectedQty\" ng-options=\"qty for qty in store.productQuantities\"></select></div></div></form></div><div class=\"cart__buttons\"><button id=\"AddToCart\" type=\"submit\" form=\"product_form\" ng-click=\"store.addToCart(store.productForm.$valid)\" ng-show=\"!store.ended\" class=\"btn btn-secondary\"><span class=\"icons-cart\"></span> ADD TO CART</button><button ng-show=\"store.ended\" disabled class=\"btn btn-secondary\">ENDED</button></div></div></div><div class=\"col-md-4 col-md-offset-1 visible-xs visible-sm alert__row--mobile\"><div ng-if=\"store.cart.getCouponInfo().type === &quot;PERCENTAGE&quot;\" role=\"alert\" class=\"alert alert-vs coupon-animate\">Congratulations, a {{store.cart.getCouponInfo().amount}}% discount will be applied to your order.</div><div ng-if=\"store.cart.getCouponInfo().type === &quot;MONEY&quot;\" role=\"alert\" class=\"alert alert-vs coupon-animate\">Congratulations, a {{store.cart.getCouponInfo().amount * store.currency.info.conversion_rate | currency : store.currency.info.currency_symbol}} discount will be applied to your order.</div><div ng-if=\"(store.selectedProduct.product.us_only || store.usOnlyProductInCart()) &amp;&amp; store.currency.info.country_code !== &quot;US&quot;\" role=\"alert\" class=\"alert alert-vs coupon-animate\">This {{store.usOnlyProductInCart() ? 'order' : 'product'}} is only available for delivery within the United States.</div></div><div class=\"col-md-4 cart-container\"><p ng-if=\"store.holidayBusinessLogic()\" style=\"font-size:14px;\">Guaranteed delivery by&nbsp;<strong>Dec. 24th&nbsp;</strong>anywhere in the US.</p><a id=\"cart-anchor\"></a><div ng-show=\"store.cart.size() &gt; 0 &amp;&amp; store.ended === false\" class=\"widget-box\"><shopping-cart scroll-to=\"a#cart-anchor\" class=\"cart-form\"></shopping-cart></div><div ng-if=\"!!store.campaign.show_sales_timer || !!store.campaign.show_goal\" class=\"widget-box campaign-stats hidden-xs hidden-sm\"><div ng-if=\"!!store.campaign.show_sales_timer\" class=\"campaign-countdown-timer\"><div class=\"countdown-component\"><img src=\"//assets.viralstyle.com/images/time_dark.png\" class=\"clock-icon\"></div><div class=\"countdown-component\"><div class=\"amount\">{{store.endTime.days}}</div><div class=\"unit\">Days</div></div><div class=\"countdown-component\"><div class=\"amount\">{{store.endTime.hours}}</div><div class=\"unit\">Hrs</div></div><div class=\"countdown-component\"><div class=\"amount\">{{store.endTime.minutes}}</div><div class=\"unit\">Mins</div></div><div class=\"countdown-component\"><div class=\"amount\">{{store.endTime.seconds}}</div><div class=\"unit\">Secs</div></div></div><div ng-if=\"store.campaign.show_goal &amp;&amp; !!store.campaign.order_count_goal\" class=\"campaign-progress\"><div class=\"sold-percentage-bar\"><div ng-style=\"{ width: store.campaignProgress() }\" class=\"progress-bar\"></div><div class=\"inside-count\">{{store.campaign.current_order_count}} of {{store.campaign.order_count_goal}} Sold</div></div><p class=\"sold-percentage-explanation\">{{store.campaign.current_order_count}} have been sold (towards the original goal of {{store.campaign.order_count_goal}}).\nYou can keep buying until the campaign ends.</p></div></div></div><div class=\"col-md-8\"><div class=\"product-tabs\"><!-- Nav tabs--><ul role=\"tablist\" ng-init=\"tab.active = &quot;desc&quot;\" class=\"nav nav-tabs tabset\"><li role=\"presentation\" ng-class=\"{ active: tab.active == &quot;desc&quot; }\"><a aria-controls=\"tab-1\" role=\"tab\" ng-click=\"tab.active = &quot;desc&quot;\">Description</a></li><li role=\"presentation\" ng-class=\"{ active: tab.active == &quot;details&quot; }\"><a aria-controls=\"tab-2\" role=\"tab\" ng-click=\"tab.active = &quot;details&quot;\">Product Details</a></li></ul><!-- Tab panes--><div class=\"tab-content tab-product\"><div id=\"tab-1\" role=\"tabpanel\" ng-class=\"{ active: tab.active == &quot;desc&quot; }\" class=\"tab-pane\"><h2>{{store.campaign.name}}</h2><div ng-bind-html=\"store.campaignDescription()\"></div></div><div id=\"tab-2\" role=\"tabpanel\" ng-class=\"{ active: tab.active == &quot;details&quot; }\" class=\"tab-pane\"><product-details name=\"{{store.selectedProduct.product.name}}\" sizing=\"store.selectedProductSizing()\" description=\"store.selectedProductDescription()\"></product-details></div></div></div></div></div></div></section><div id=\"campaign-support-id\"><span>{{store.campaign.id}}</span><a ng-if=\"store.currentUser.roles.indexOf('ADMIN') &gt; -1\" ng-href=\"/admin/campaigns/{{store.campaign.id}}\" target=\"_blank\" class=\"btn btn-secondary\">Admin for {{store.campaign.id}}</a></div>");;return buf.join("");
	};

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _marketplace = __webpack_require__(145);
	
	var _marketplace2 = _interopRequireDefault(_marketplace);
	
	var _marketplace3 = __webpack_require__(146);
	
	var _marketplace4 = _interopRequireDefault(_marketplace3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('cui.marketplace', ['ui.router']).controller('MarketplaceCtrl', _marketplace2.default).config(_marketplace4.default);

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(7);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _config = __webpack_require__(2);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _webstoragePolyfill = __webpack_require__(10);
	
	var _webstoragePolyfill2 = _interopRequireDefault(_webstoragePolyfill);
	
	var _analytics = __webpack_require__(13);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = ['$q', '$scope', '$state', '$timeout', 'MarketplaceService', 'CampaignService', 'ErrorHandler', 'UserDataService', function () {
	  function MarketplaceController($q, $scope, $state, $timeout, marketplaceService, CampaignService, errorHandler, UserDataService) {
	    _classCallCheck(this, MarketplaceController);
	
	    this._$q = $q;
	    this._$scope = $scope;
	    this._$state = $state;
	    this._$timeout = $timeout;
	    this._marketplaceService = marketplaceService;
	    this._campaignService = CampaignService;
	    this._errorHandler = errorHandler;
	    this._userDataService = UserDataService;
	    this.storage = new _webstoragePolyfill2.default();
	    this.analytics = new _analytics2.default();
	
	    this._initState();
	    this._fetchData();
	    this._trackCSDC();
	    window.scrollTo(0, 0);
	  }
	
	  _createClass(MarketplaceController, [{
	    key: 'inputChanged',
	    value: function inputChanged() {
	      this.page = 1;
	      this._refresh({ page: this.page === 1 ? null : this.page, search: this.search ? this.search : null });
	      this._performSearch();
	    }
	  }, {
	    key: 'changeCategory',
	    value: function changeCategory() {
	      var _this = this;
	
	      this.page = 1;
	      this._refresh({ page: this.page === 1 ? null : this.page, category: this.category === 'ALL' ? null : this.category, sub_category: null });
	      this.subCategory = 'ALL';
	      var categoryObj = _lodash2.default.find(this.categories, function (category) {
	        return category.category === _this.category;
	      });
	      this.subCategories = categoryObj ? categoryObj.subCategories : null;
	      this._performSearch();
	    }
	  }, {
	    key: 'changeSubCategory',
	    value: function changeSubCategory() {
	      this.page = 1;
	      this._refresh({ page: this.page === 1 ? null : this.page, sub_category: this.subCategory === 'ALL' ? null : this.subCategory });
	      this._performSearch();
	    }
	  }, {
	    key: 'changeProductType',
	    value: function changeProductType() {
	      this.page = 1;
	      this._refresh({ page: this.page === 1 ? null : this.page, product_type: this.productType === '0' ? null : this.productType });
	      this._performSearch();
	    }
	  }, {
	    key: 'sliderChange',
	    value: function sliderChange() {
	      this.page = 1;
	      this._refresh({ page: this.page === 1 ? null : this.page, min_price: this.minPrice <= 0 ? null : this.minPrice, max_price: this.maxPrice >= 80 ? null : this.maxPrice });
	      this._performSearch();
	    }
	  }, {
	    key: 'pageChanged',
	    value: function pageChanged() {
	      this._refresh({ page: this.page === 1 ? null : this.page });
	      this._performSearch();
	    }
	  }, {
	    key: 'scrollToTop',
	    value: function scrollToTop(event) {
	      event.preventDefault();
	      angular.element('html, body').animate({
	        scrollTop: 0
	      }, 200);
	    }
	  }, {
	    key: 'isUserAdmin',
	    value: function isUserAdmin() {
	      return this._userDataService.isInAdminRole();
	    }
	  }, {
	    key: 'hideCampaignFromMarketplace',
	    value: function hideCampaignFromMarketplace(event, id) {
	      var _this2 = this;
	
	      event.preventDefault();
	      var lock = !this[id + '-hide'];
	      this._campaignService.toggleCampaignLockFromMarketplace(id, lock, !lock).then(function () {
	        _this2[id + '-hide'] = lock;
	      }).catch(function (err) {
	        return _this2._marketplaceError(err, 'Encountered an error while attempting to lock/unlock campaign from marketplace.');
	      });
	    }
	  }, {
	    key: 'insertUTM',
	    value: function insertUTM(uri) {
	      var splitUri = uri.split('#');
	      return splitUri.length > 1 ? splitUri[0] + '?utm_source=marketplace#' + splitUri[1] : uri + '?utm_source=marketplace';
	    }
	  }, {
	    key: '_initState',
	    value: function _initState() {
	      this.processing = true;
	      this.campaigns = [];
	      this.totalCampaigns = 0;
	      this.searchTimeout = null;
	      this.priceTimeout = null;
	      this.showFilter = false;
	      this.maxPaginationPages = 5;
	      this.itemsPerPage = _config2.default.Marketplace.LIMIT;
	
	      this.page = parseInt(this._$state.params.page) > 0 ? parseInt(this._$state.params.page) : 1;
	      this.search = this._$state.params.search;
	      this.category = this._$state.params.category || 'ALL';
	      this.subCategory = this._$state.params.sub_category || 'ALL';
	      this.productType = this._$state.params.product_type || '0';
	
	      this._initSliderState();
	    }
	  }, {
	    key: '_initSliderState',
	    value: function _initSliderState() {
	      var _this3 = this;
	
	      var min_price = parseInt(this._$state.params.min_price) || null,
	          max_price = parseInt(this._$state.params.max_price) || null;
	
	      this.minPrice = min_price > _config2.default.Marketplace.MIN_PRICE && min_price <= _config2.default.Marketplace.MAX_PRICE ? min_price : _config2.default.Marketplace.MIN_PRICE;
	      this.maxPrice = max_price > _config2.default.Marketplace.MIN_PRICE && max_price < _config2.default.Marketplace.MAX_PRICE ? max_price : _config2.default.Marketplace.MAX_PRICE;
	      this.sliderOptions = { floor: _config2.default.Marketplace.MIN_PRICE, ceil: _config2.default.Marketplace.MAX_PRICE, translate: function translate(value) {
	          return '$' + value;
	        } };
	
	      if (this.minPrice && this.maxPrice && this.minPrice > this.maxPrice) this.minPrice = this.maxPrice;
	
	      this._$scope.$on('slideEnded', function () {
	        return _this3.sliderChange();
	      });
	
	      this._refresh({
	        min_price: this.minPrice === _config2.default.Marketplace.MIN_PRICE ? null : min_price,
	        max_price: this.maxPrice === _config2.default.Marketplace.MAX_PRICE ? null : max_price,
	        page: this.page === 1 ? null : this.page
	      });
	    }
	  }, {
	    key: '_fetchData',
	    value: function _fetchData() {
	      var _this4 = this;
	
	      var categoriesPromise = this._marketplaceService.categoriesTree().then(function (res) {
	        return _this4._initCategories(res.categories);
	      });
	
	      var productTypesPromise = this._marketplaceService.productTypes().then(function (res) {
	        return _this4._initProductTypes(res);
	      });
	
	      this._$q.all([categoriesPromise, productTypesPromise]).then(function () {
	        return _this4._performSearch();
	      }).catch(function (err) {
	        return _this4._marketplaceError(err);
	      }).finally(function () {
	        _this4.processing = false;
	        _this4.initialized = true;
	      });
	    }
	  }, {
	    key: '_initCategories',
	    value: function _initCategories(categories) {
	      var _this5 = this;
	
	      var categoriesArray = [{ category: 'ALL', subCategories: [] }];
	
	      for (var key in categories) {
	        categories[key].unshift({ name: 'ALL' });
	        categoriesArray.push({ category: key, subCategories: categories[key] });
	      }
	      this.categories = categoriesArray;
	
	      if (this.category !== 'ALL' && !_lodash2.default.find(this.categories, function (category) {
	        return category.category === _this5.category;
	      })) {
	        this.category = 'ALL';
	        this._refresh({ category: null, sub_category: null });
	      }
	
	      var categoryObj = _lodash2.default.find(this.categories, function (category) {
	        return category.category === _this5.category;
	      });
	      this.subCategories = _lodash2.default.get(categoryObj, 'subCategories');
	
	      if (this.subCategory !== 'ALL' && !_lodash2.default.find(this.subCategories, function (category) {
	        return category.name === _this5.subCategory;
	      })) {
	        this.subCategory = 'ALL';
	        this._refresh({ sub_category: null });
	      }
	    }
	  }, {
	    key: '_initProductTypes',
	    value: function _initProductTypes(res) {
	      var _this6 = this;
	
	      var productTypeArray = [{ id: '0', type: 'ALL' }];
	
	      for (var key in res) {
	        productTypeArray.push({ id: key, type: res[key] });
	      }
	      this.productTypes = productTypeArray;
	
	      if (this.productType !== '0' && !_lodash2.default.find(this.productTypes, function (type) {
	        return type.id === _this6.productType;
	      })) {
	        this.productType = '0';
	        this._refresh({ product_type: null });
	      }
	    }
	  }, {
	    key: '_performSearch',
	    value: function _performSearch() {
	      var _this7 = this;
	
	      var promise = void 0;
	
	      if (this.subCategory && this.subCategory !== 'ALL') {
	        promise = this._marketplaceService.searchMarketplace(this.page, this.productType, this.minPrice, this.maxPrice, this.subCategory, this.search);
	      } else {
	        promise = this._marketplaceService.searchMarketplace(this.page, this.productType, this.minPrice, this.maxPrice, this.category, this.search);
	      }
	
	      this.processing = true;
	      promise.then(function (res) {
	        _this7.campaigns = res.results;
	        _this7.totalCampaigns = res.total_hits;
	        window.scrollTo(0, 0);
	      }).catch(function (err) {
	        return _this7._marketplaceError(err);
	      }).finally(function () {
	        return _this7.processing = false;
	      });
	
	      return promise;
	    }
	  }, {
	    key: '_marketplaceError',
	    value: function _marketplaceError(err) {
	      var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Sorry we encountered a problem searching the marketplace, please try again.';
	
	      return this._errorHandler.throwError('Marketplace Error', message, {
	        query: this.search,
	        category: this.category,
	        subCategory: this.subCategory,
	        minPrice: this.minPrice,
	        maxPrice: this.maxPrice,
	        productType: this.productType,
	        paginationPage: this.page,
	        campaignsLength: this.campaigns ? this.campaigns.length : 'null',
	        rawError: err
	      });
	    }
	  }, {
	    key: '_refresh',
	    value: function _refresh(params) {
	      var notify = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      this._$state.go('marketplace-page', params, { notify: notify });
	    }
	  }, {
	    key: '_trackCSDC',
	    value: function _trackCSDC() {
	      if (this._$state.params.csdc && this._$state.params.csdc_email) {
	        var prevDiscountHash = 'csdc:' + this._$state.params.csdc,
	            hasPrevDiscount = this.storage.getLocalItem(prevDiscountHash);
	
	        if (!hasPrevDiscount) {
	          this.storage.setLocalItem(prevDiscountHash, true);
	          this.analytics.applyCoupon(this._$state.params.csdc);
	        }
	      }
	    }
	  }]);
	
	  return MarketplaceController;
	}()];

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cdnPreprocessor = __webpack_require__(56);
	
	var params = {
	  search: null,
	  category: null,
	  sub_category: null,
	  product_type: null,
	  min_price: null,
	  max_price: null,
	  csdc: null,
	  csdc_email: null
	},
	    template = __webpack_require__(147)(_cdnPreprocessor.jadeLocals),
	    url = function url(fragment) {
	  return '/' + fragment + '?search&category&sub_category&product_type&min_price&max_price&csdc&csdc_email';
	};
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  $stateProvider.state('marketplace', { url: url('marketplace'), template: template, params: params }).state('marketplace-page', { url: url('marketplace/:page'), template: template, params: params });
	}];

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var jade = __webpack_require__(58);
	
	module.exports = function template(locals) {
	  var buf = [];
	  var jade_mixins = {};
	  var jade_interp;
	
	  buf.push("<article id=\"marketplace\" ng-controller=\"MarketplaceCtrl as market\" aria-label=\"marketplace\"><a ng-click=\"market.scrollToTop($event)\" class=\"back-to-top\"><i class=\"icons icons-arrow-top\"></i></a><div class=\"page-header marketplace-header animated\"><div class=\"container-fluid\"><h1>MARKETPLACE</h1></div></div><div aria-label=\"marketplace search\" class=\"market-search\"><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-12\"><form action=\".\" ng-submit=\"$event.preventDefault();market.inputChanged()\"><i class=\"icons icons-search\"></i><input placeholder=\"Search Marketplace...\" type=\"search\" ng-model=\"market.search\" ng-disabled=\"market.processing\" aria-label=\"search marketplace\" role=\"searchbox\" class=\"form-control market-search-input\"></form></div></div></div></div><section aria-label=\"marketplace content\" class=\"section large\"><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"heading mobile-category\"><h1><div class=\"category-heading\">{{market.category}}</div><span ng-show=\"market.category !== &quot;ALL&quot;\">&nbsp;/</span><div class=\"subcategory-heading\"><span ng-show=\"market.category !== &quot;ALL&quot;\">{{market.subCategory}}</span></div><i aria-label=\"filter menu\" ng-click=\"market.showFilter = !market.showFilter\" ng-class=\"{ &quot;glyphicon-filter&quot;: !market.showFilter, &quot;glyphicon-remove&quot;: market.showFilter }\" class=\"glyphicon visible-xs\"></i></h1></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><ul class=\"product-list four-product\"><li ng-class=\"{ closed: !market.showFilter }\" class=\"filter-group\"><div class=\"widget-box sorter animated\"><form action=\"#\" class=\"sorter-form\"><div class=\"form-group\"><select float-label-select placeholder=\"Category\" ng-model=\"market.category\" ng-options=\"category.category as category.category for category in market.categories\" ng-change=\"market.changeCategory()\" ng-disabled=\"market.processing\" aria-label=\"category\"></select></div><div ng-if=\"market.category !== &quot;ALL&quot;\" class=\"form-group\"><select float-label-select placeholder=\"Sub Category\" ng-model=\"market.subCategory\" ng-options=\"category.name as category.name for category in market.subCategories\" ng-change=\"market.changeSubCategory()\" ng-disabled=\"market.processing\" aria-label=\"sub category\"></select></div><div class=\"form-group\"><select float-label-select placeholder=\"Product Type\" ng-model=\"market.productType\" ng-options=\"type.id as type.type for type in market.productTypes\" ng-change=\"market.changeProductType()\" ng-disabled=\"market.processing\"></select></div><div class=\"slider-group text-left\"><h5>PRICE RANGE</h5><rzslider rz-slider-model=\"market.minPrice\" rz-slider-high=\"market.maxPrice\" rz-slider-options=\"market.sliderOptions\"></rzslider></div></form></div></li><li ng-repeat=\"campaign in market.campaigns\"><a ng-href=\"{{market.insertUTM(campaign.uri)}}\" aria-label=\"{{campaign.name}}. {{campaign.selling_price | currency}}\"><strong class=\"img\"><i ng-if=\"market.isUserAdmin()\" ng-click=\"market.hideCampaignFromMarketplace($event, campaign.campaign_id)\" ng-class=\"{ &quot;glyphicon-eye-close&quot;: market[campaign.campaign_id + &quot;-hide&quot;], &quot;glyphicon-eye-open&quot;: !market[campaign.campaign_id + &quot;-hide&quot;] }\" class=\"glyphicon\"></i><img lazy-img=\"{{campaign.default_side === &quot;FRONT&quot; ? campaign.front_image : campaign.back_image}}\" src=\"/assets/customer-ui/images/ring.gif\" height=\"284\" width=\"274\" alt=\"product {{campaign.name}} design\" class=\"img-responsive\"></strong><div class=\"footer-box\"><strong class=\"title text-uppercase\">{{campaign.name}}</strong><span class=\"info\"><span class=\"category pull-left hide\">{{campaign.categories[0].name}}</span><span class=\"price\">{{campaign.selling_price | currency}}</span></span></div></a></li><li ng-show=\"market.campaigns !== null &amp;&amp; !market.campaigns.length\" class=\"no-results ng-hide\">No Results Found...</li></ul></div></div><div ng-if=\"market.initialized\" class=\"row\"><div class=\"col-xs-12 text-center\"><nav><ul uib-pagination total-items=\"market.totalCampaigns\" items-per-page=\"market.itemsPerPage\" ng-model=\"market.page\" max-size=\"market.maxPaginationPages\" boundary-links=\"true\" ng-change=\"market.pageChanged()\" previous-text=\"&lt;\" next-text=\"&gt;\" first-text=\"&lt;&lt;\" last-text=\"&gt;&gt;\" class=\"pagination-sm\"></ul></nav></div></div></div><cui-loading-overlay toggle=\"market.processing\"></cui-loading-overlay></section></article>");;return buf.join("");
	};

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _openShop = __webpack_require__(149);
	
	var _openShop2 = _interopRequireDefault(_openShop);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('cui.openShop', ['ui.router']).config(_openShop2.default);

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cdnPreprocessor = __webpack_require__(56);
	
	exports.default = ['$stateProvider', function ($stateProvider) {
	  $stateProvider.state('open-shop', {
	    abstract: true,
	    template: '<ui-view></ui-view>',
	    url: '/open-shop'
	  }).state('open-shop.overview', {
	    url: '',
	    templateUrl: (0, _cdnPreprocessor.cdnTemplate)('/overview.html')
	  }).state('open-shop.artists', {
	    url: '/artists',
	    templateUrl: (0, _cdnPreprocessor.cdnTemplate)('/artists.html')
	  }).state('open-shop.bloggers', {
	    url: '/bloggers',
	    templateUrl: (0, _cdnPreprocessor.cdnTemplate)('/bloggers.html')
	  }).state('open-shop.brands', {
	    url: '/brands',
	    templateUrl: (0, _cdnPreprocessor.cdnTemplate)('/brands.html')
	  }).state('open-shop.sports', {
	    url: '/sports',
	    templateUrl: (0, _cdnPreprocessor.cdnTemplate)('/sports.html')
	  }).state('open-shop.esports', {
	    url: '/esports',
	    templateUrl: (0, _cdnPreprocessor.cdnTemplate)('/esports.html')
	  }).state('open-shop.affiliates', {
	    url: '/affiliates',
	    templateUrl: (0, _cdnPreprocessor.cdnTemplate)('/affiliates.html')
	  }).state('open-shop.musicians', {
	    url: '/musicians',
	    templateUrl: (0, _cdnPreprocessor.cdnTemplate)('/musicians.html')
	  }).state('open-shop.youtubers', {
	    url: '/youtubers',
	    templateUrl: (0, _cdnPreprocessor.cdnTemplate)('/youtubers.html')
	  });
	}];

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cobrandRegister = __webpack_require__(151);
	
	var _cobrandRegister2 = _interopRequireDefault(_cobrandRegister);
	
	var _cobrandAdmin = __webpack_require__(152);
	
	var _cobrandAdmin2 = _interopRequireDefault(_cobrandAdmin);
	
	var _cobrandAdminImport = __webpack_require__(153);
	
	var _cobrandAdminImport2 = _interopRequireDefault(_cobrandAdminImport);
	
	var _cdnPreprocessor = __webpack_require__(56);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('cui.cobrand', ['ui.router']).controller('CobrandCtrl', _cobrandRegister2.default).controller('CobrandAdminCtrl', _cobrandAdmin2.default).controller('CobrandImportCtrl', _cobrandAdminImport2.default).config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
	  $urlRouterProvider.when('/cobrand-admin', '/cobrand-admin/import');
	
	  $stateProvider.state('cobrand-register', {
	    url: '/register/partner?pid',
	    controller: 'CobrandCtrl as cobrand',
	    templateUrl: (0, _cdnPreprocessor.cdnTemplate)('/cobrand-register.html'),
	    params: {
	      'pid': null
	    }
	  }).state('cobrand-admin', {
	    url: '/cobrand-admin',
	    abstract: true,
	    controller: 'CobrandAdminCtrl as cobrandAdmin',
	    templateUrl: (0, _cdnPreprocessor.cdnTemplate)('/cobrand-admin.html')
	  }).state('cobrand-admin.import', {
	    url: '/import',
	    controller: 'CobrandImportCtrl as import',
	    templateUrl: (0, _cdnPreprocessor.cdnTemplate)('/cobrand-admin-import.html')
	  });
	}]);

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _config = __webpack_require__(2);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _cdnImagePreprocessor = __webpack_require__(49);
	
	var _cdnImagePreprocessor2 = _interopRequireDefault(_cdnImagePreprocessor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = ['$sce', '$stateParams', 'CobrandedAPISerice', 'ErrorHandler', function () {
	  function CobrandController($sce, $stateParams, CobrandedAPISerice, ErrorHandler) {
	    _classCallCheck(this, CobrandController);
	
	    this._$sce = $sce;
	    this._$stateParams = $stateParams;
	    this._cobrandedAPIService = CobrandedAPISerice;
	    this._errorHandler = ErrorHandler;
	    this._init();
	  }
	
	  _createClass(CobrandController, [{
	    key: '_init',
	    value: function _init() {
	      var _this = this;
	
	      this.pid = this._$stateParams.pid;
	
	      this.logoPath = (0, _cdnImagePreprocessor2.default)(_config2.default).asset('/' + this.pid + '/inverted.png');
	
	      this._initConfigData(this.pid).then(function (res) {
	        return _this._setConfigData(res);
	      }).catch(function (err) {
	        return _this._configError(err);
	      });
	    }
	  }, {
	    key: '_initConfigData',
	    value: function _initConfigData(pid) {
	      return this._cobrandedAPIService.getRegistrationData(pid);
	    }
	  }, {
	    key: '_setConfigData',
	    value: function _setConfigData(res) {
	      this.headlineHtml = this._$sce.trustAsHtml(res.headline);
	      this.subheaderHtml = this._$sce.trustAsHtml(res.subheader);
	      this.paragraphHtml = this._$sce.trustAsHtml(res.paragraph);
	    }
	  }, {
	    key: '_configError',
	    value: function _configError(err) {
	      this._errorHandler.throwError('Partner Error', 'An error occurred while attempting to retrieve partner data. Please try again.', { rawError: err });
	    }
	  }]);
	
	  return CobrandController;
	}()];

/***/ }),
/* 152 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = ['$scope', '$window', 'UserDataService', function () {
	  function CobrandAdminCtrl($scope, $window, UserDataService) {
	    _classCallCheck(this, CobrandAdminCtrl);
	
	    this._$scope = $scope;
	    this._$window = $window;
	    this._userDataService = UserDataService;
	    this._checkIfUserLoggedIn();
	    this._initEvents();
	  }
	
	  _createClass(CobrandAdminCtrl, [{
	    key: '_checkIfUserLoggedIn',
	    value: function _checkIfUserLoggedIn() {
	      var _this = this;
	
	      this._userDataService.getUserData().then(function (res) {
	        if (res.user.roles !== 'COBRAND-ADMIN') {
	          _this._$window.location.href = '/';
	        }
	      }).catch(function (err) {
	        return _this._$window.location.href = '/login?returnUrl=%2Fcobrand-admin';
	      });
	    }
	  }, {
	    key: '_initEvents',
	    value: function _initEvents() {
	      var _this2 = this;
	
	      this._$scope.$on('logout:success', function () {
	        _this2._$window.location.href = '/';
	      });
	    }
	  }]);
	
	  return CobrandAdminCtrl;
	}()];

/***/ }),
/* 153 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = ['$scope', '$timeout', 'UserDataService', 'CobrandedAPISerice', 'ErrorHandler', function () {
	  function CobrandImportCtrl($scope, $timeout, UserDataService, CobrandedAPISerice, ErrorHandler) {
	    _classCallCheck(this, CobrandImportCtrl);
	
	    this._$scope = $scope;
	    this._$timeout = $timeout;
	    this._cobrandedAPIService = CobrandedAPISerice;
	    this._errorHandler = ErrorHandler;
	    this._userDataService = UserDataService;
	
	    this._checkIfUserLoggedIn();
	    this._initFileEvents();
	    this.failuresArray = {};
	  }
	
	  _createClass(CobrandImportCtrl, [{
	    key: 'uploadFile',
	    value: function uploadFile(file) {
	      var formData = new FormData();
	      formData.append('import_csv', file);
	      return this._cobrandedAPIService.uploadFile(this._userDataService.user.cobranding_partner_id, formData);
	    }
	  }, {
	    key: 'formatDate',
	    value: function formatDate(date) {
	      return moment.utc(date).local().format('MM/DD/YY h:mm');
	    }
	  }, {
	    key: '_checkIfUserLoggedIn',
	    value: function _checkIfUserLoggedIn() {
	      var _this = this;
	
	      this.processing = true;
	      this._userDataService.getUserData().then(function (res) {
	        if (res.user.roles === 'COBRAND-ADMIN') {
	          _this._getImportHistory();
	        }
	      }).finally(function (err) {
	        return _this.processing = false;
	      });
	    }
	  }, {
	    key: '_getImportHistory',
	    value: function _getImportHistory() {
	      var _this2 = this;
	
	      this._cobrandedAPIService.getImportHistory(this._userDataService.user.cobranding_partner_id).then(function (res) {
	        _this2.jobHistory = res.imports;
	
	        _.forEach(_this2.jobHistory, function (job) {
	          if (job.status === "DONE_WITH_ERRORS" && !_this2.failuresArray[job.id]) {
	            _this2._getImportHistoryDetails(job);
	          } else if (job.status === "PROCESSING") {
	            _this2._$timeout(function () {
	              return _this2._getImportHistoryDetails(job);
	            }, 1000);
	          }
	        });
	      }).catch(function (err) {
	        return _this2._errorHandler.throwError('Import History Error', 'An error occurred while attempting to retrieve import history. Please try again later.', { rawError: err });
	      });
	    }
	  }, {
	    key: '_getImportHistoryDetails',
	    value: function _getImportHistoryDetails(job) {
	      var _this3 = this;
	
	      this._cobrandedAPIService.getImportStatus(this._userDataService.user.cobranding_partner_id, job.id).then(function (res) {
	        _this3.failuresArray[job.id] = res.failures;
	        job.status = res.status;
	        if (job.status === "PROCESSING") {
	          _this3._$timeout(function () {
	            return _this3._getImportHistoryDetails(job);
	          }, 1000);
	        }
	      }).catch(function (err) {
	        return _this3._errorHandler.throwError('Import History Details Error', 'An error occurred while attempting to retireve import history details. Please try agian later.', { rawError: err });
	      });
	    }
	  }, {
	    key: '_initFileEvents',
	    value: function _initFileEvents() {
	      var _this4 = this;
	
	      this._$scope.$on('file-upload:file-selected', function (e, file) {
	        _this4.processing = true;
	        _this4.uploadFile(file).then(function (res) {
	          return _this4._getImportHistory();
	        }).catch(function (err) {
	          return _this4._errorHandler.throwError('File Upload Error', 'An error occurred while attempting to upload file. Please try again later.', { rawError: err });
	        }).finally(function () {
	          return _this4.processing = false;
	        });
	      });
	    }
	  }]);
	
	  return CobrandImportCtrl;
	}()];

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  window.fbAsyncInit = function () {
	    FB.init({
	      appId: _config2.default.SocialAuth.facebookID,
	      status: true,
	      cookie: true,
	      xfbml: true,
	      version: 'v2.4'
	    });
	  };
	  (function (d, s, id) {
	    var js,
	        fjs = d.getElementsByTagName(s)[0];
	    if (d.getElementById(id)) {
	      return;
	    }
	    js = d.createElement(s);
	    js.id = id;
	    js.src = "//connect.facebook.net/en_US/sdk.js";
	    fjs.parentNode.insertBefore(js, fjs);
	  })(document, 'script', 'facebook-jssdk');
	};
	
	var _config = __webpack_require__(2);
	
	var _config2 = _interopRequireDefault(_config);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = sentryConfigWithFilters;
	
	var _lodash = __webpack_require__(7);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Buffer requests to prevent consuming the entire rate limit.
	// https://docs.sentry.io/clients/javascript/config/
	
	var ERROR_LIMIT = 10;
	var ravenErrorBuffer = {};
	
	function shouldSendError(errorKey) {
	  if (typeof ravenErrorBuffer[errorKey] == 'number') {
	    ravenErrorBuffer[errorKey]++;
	  } else {
	    ravenErrorBuffer[errorKey] = 1;
	  }
	
	  return ravenErrorBuffer[errorKey] < ERROR_LIMIT;
	}
	
	function sentryConfigWithFilters(sentryConfig) {
	  return _lodash2.default.extend(sentryConfig, {
	    shouldSendCallback: function shouldSendCallback(data) {
	      return shouldSendError(data.message || data.exception.values[0].value);
	    }
	  });
	};

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// app.js